// Generated by @nucleus-commerce/docs-gen from the storefront OpenAPI spec. Do not edit.

// The shapes of the generated docs data. This file is copied verbatim to the top of the
// generated reference.ts, so the admin gets the types without depending on this package:
// keep it free of imports.

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

/** Mirrors the backend's `ApiKeyScope`; `scopeForPath` derives it from the first path segment and the method. */
export type ApiKeyScope =
  | 'catalog:read'
  | 'content:read'
  | 'cart:write'
  | 'checkout:write'
  | 'customers:write'
  | 'orders:read'
  | 'analytics:write'
  | 'chat:write'
  | 'auctions:write';

export type SchemaKind = 'object' | 'array' | 'primitive' | 'enum' | 'oneOf';

export type SchemaValue = string | number | boolean | null;

export interface SchemaConstraints {
  minimum?: number;
  maximum?: number;
  minLength?: number;
  maxLength?: number;
  minItems?: number;
  maxItems?: number;
  pattern?: string;
}

/**
 * A dereferenced JSON Schema, cut down to what the schema viewer renders.
 * `name` is the property name inside the parent object; `required` is relative to that parent
 * (for a request body: whether the body is required). `ref` is the component name when the
 * node came from a `$ref`; `circular` marks a `$ref` that points back at an ancestor, where the
 * tree stops (no properties, items or variants).
 */
export interface SchemaNode {
  kind: SchemaKind;
  /** Display type: `string`, `integer`, `object`, `array`, `oneOf`, `any`, `never`. */
  type: string;
  required: boolean;
  nullable: boolean;
  name?: string;
  format?: string;
  description?: string;
  example?: unknown;
  default?: unknown;
  deprecated?: boolean;
  /** Allowed values of an `enum` node (a `const` becomes a one-value enum). */
  enum?: SchemaValue[];
  constraints?: SchemaConstraints;
  /** Object properties, in spec order. */
  properties?: SchemaNode[];
  /** Value schema of a map-like object (`additionalProperties`). */
  additionalProperties?: SchemaNode;
  items?: SchemaNode;
  /** Alternatives of a `oneOf` / `anyOf` node, `null` variants folded into `nullable`. */
  variants?: SchemaNode[];
  ref?: string;
  circular?: boolean;
}

export interface DocsParam {
  name: string;
  in: 'path' | 'query' | 'header';
  required: boolean;
  description: string;
  schema: SchemaNode;
  example?: unknown;
}

export interface DocsResponse {
  description: string;
  /** How the body reads: JSON, plain text (sitemaps, robots.txt) or no body. */
  body: 'json' | 'text' | 'empty';
  schema: SchemaNode | null;
  /** Recorded example, when the backend merged one into the spec. */
  example?: unknown;
}

export interface DocsExampleRequest {
  params: Record<string, unknown>;
  query: Record<string, unknown>;
  headers: Record<string, unknown>;
  body?: unknown;
}

export interface DocsExamples {
  /** Null until the backend records examples for this operation. */
  request: DocsExampleRequest | null;
  /** Recorded response bodies by status. */
  responses: Record<string, unknown>;
}

export interface DocsOperation {
  id: string;
  /** kebab-case of the id: `addCartLine` → `add-cart-line`. */
  slug: string;
  method: HttpMethod;
  path: string;
  /** Tag key: `Storefront: Cart` → `cart`; the page is `/docs/api/<tag>/<slug>`. */
  tag: string;
  summary: string;
  /** Markdown, as in the spec. */
  description: string;
  /** `description` pre-rendered to HTML so the admin needs no markdown parser. */
  descriptionHtml: string;
  deprecated: boolean;
  security: 'storeApiKey';
  scope: ApiKeyScope | null;
  /** Needs `X-Customer-Token` (`x-nucleus-customer: required`). */
  customerToken: boolean;
  /** Declares an `Idempotency-Key` header. */
  idempotent: boolean;
  /** Changes data in the store (`x-nucleus-mutates`). */
  mutates: boolean;
  /** Takes a `country` query param or an `X-Nucleus-Country` header. */
  country: boolean;
  parameters: DocsParam[];
  requestBody: SchemaNode | null;
  responses: Record<string, DocsResponse>;
  examples: DocsExamples;
}

export interface DocsTag {
  /** `Storefront: Cart` → `cart`. */
  key: string;
  /** Spec tag name without the surface prefix, `Cart`. */
  title: string;
  description: string;
  /** Operation ids in spec order. */
  operations: string[];
}

export interface DocsReference {
  /** In `TAG_DEFINITIONS` order, as the spec lists them. */
  tags: DocsTag[];
  operations: Record<string, DocsOperation>;
}

/** Code templates with `{{baseUrl}}`, `{{apiKey}}`, `{{customerToken}}`, `{{idempotencyKey}}`. */
export interface OperationSnippets {
  curl: string;
  fetch: string;
  sdk: string;
}

export interface SearchEntry {
  id: string;
  kind: 'operation' | 'guide';
  title: string;
  /** `GET /storefront/v1/...` for operations, the guide title or description for guides. */
  subtitle: string;
  href: string;
}

const schema_StorefrontMedia: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "kind",
      "enum": [
        "image",
        "video",
        "model_3d",
        "document"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "url",
      "format": "uri"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "mimeType"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "renditions",
      "description": "WebP renditions generated on the worker: thumb 200, medium 800, large 1600 (longest edge)",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": false,
          "name": "thumb",
          "format": "uri"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": false,
          "name": "medium",
          "format": "uri"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": false,
          "name": "large",
          "format": "uri"
        }
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "alt"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "width"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "height"
    }
  ],
  "ref": "StorefrontMedia"
};
const schema_StorefrontStoreMarket: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "A market the store sells to; send one of its countries as `country` or X-Nucleus-Country to price in its currency",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "countries",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false,
        "description": "ISO 3166-1 alpha-2 country code",
        "example": "US",
        "constraints": {
          "pattern": "^[A-Z]{2}$"
        }
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "currency",
      "description": "ISO 4217 currency code",
      "example": "USD",
      "constraints": {
        "pattern": "^[A-Z]{3}$"
      }
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "isDefault"
    }
  ],
  "ref": "StorefrontStoreMarket"
};
const schema_CheckoutSettings: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "guestCheckout",
      "description": "Allow checkout without a customer account",
      "default": true
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "requirePhone",
      "default": false
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "termsUrl",
      "format": "uri",
      "constraints": {
        "maxLength": 500
      },
      "description": "https URL of the terms the shopper accepts at checkout",
      "example": "https://aurora-jewels.com/terms"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "requireTermsAcceptance",
      "description": "Shoppers must tick the terms (PATCH /checkouts/{token} acceptsTerms) before a payment can start; the order records when they did",
      "default": false
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "codEnabled",
      "description": "Offer cash on delivery",
      "default": false
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "codMaxAmount",
      "description": "Largest order total eligible for cash on delivery, in minor units. Null means no cap"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "codFeeAmount",
      "description": "Fee added to cash-on-delivery orders, in minor units",
      "default": 0
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "unpaidOrderHoldDays",
      "description": "Days an order placed with a manual payment method may stay unpaid before the worker cancels it; a reminder goes out at the halfway point",
      "default": 7,
      "constraints": {
        "minimum": 1,
        "maximum": 60
      }
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "abandonmentMinutes",
      "description": "Minutes without activity after the address step before a checkout counts as abandoned and gets a recovery email",
      "default": 60,
      "constraints": {
        "minimum": 15,
        "maximum": 10080
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "recoveryUrlTemplate",
      "constraints": {
        "maxLength": 500,
        "pattern": "^https?:\\/\\/[^\\s{}]+(?:\\{token\\}[^\\s{}]*)+$"
      },
      "description": "Storefront page that reopens a checkout; `{token}` is replaced. Defaults to https://<primaryDomain>/checkout/recover/{token}",
      "example": "https://shop.example/checkout/recover/{token}"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "orderStatusUrlTemplate",
      "constraints": {
        "maxLength": 500,
        "pattern": "^https?:\\/\\/[^\\s{}]+(?:\\{token\\}[^\\s{}]*)+$"
      },
      "description": "Guest order status page; `{token}` is replaced. Defaults to https://<primaryDomain>/orders/status/{token}"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "customerLinkUrlTemplate",
      "constraints": {
        "maxLength": 500
      },
      "description": "Storefront origin for every emailed customer link without its own template (workflow confirmation and review pages, design approval); `{path}` is replaced by the page path. Defaults to https://<primaryDomain>/{path}",
      "example": "https://shop.example/{path}"
    }
  ],
  "ref": "CheckoutSettings"
};
const schema_TaxProviderKind: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "none",
    "manual"
  ],
  "ref": "TaxProviderKind"
};
const schema_TaxSettings: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_TaxProviderKind, required: true, name: "provider", description: "none charges no tax; manual applies the store's tax rates by address" },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "pricesIncludeTax",
      "description": "When true the tax is carved out of the price instead of added on top",
      "default": false
    }
  ],
  "ref": "TaxSettings"
};
const schema_ReturnsSettings: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "windowDays",
      "description": "Days after shipping during which a shopper may request a return; 0 disables shopper requests",
      "default": 30,
      "constraints": {
        "minimum": 0,
        "maximum": 365
      }
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "allowedByDefault",
      "description": "Products without their own returnable flag follow this",
      "default": true
    },
    {
      "kind": "primitive",
      "type": "number",
      "required": true,
      "nullable": false,
      "name": "restockingFeePercent",
      "description": "Suggested restocking fee; staff confirm it at resolution",
      "default": 0,
      "constraints": {
        "minimum": 0,
        "maximum": 100
      }
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "returnShippingPaidBy",
      "default": "customer",
      "enum": [
        "customer",
        "store"
      ]
    }
  ],
  "ref": "ReturnsSettings"
};
const schema_TrackingSettings: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "Analytics and ad pixel ids the storefront should load",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "ga4Id",
      "example": "G-ABC123DEF4",
      "default": null
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "metaPixelId",
      "default": null
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "tiktokPixelId",
      "default": null
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "pinterestTagId",
      "default": null
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "googleAdsId",
      "default": null
    }
  ],
  "ref": "TrackingSettings"
};
const schema_SeoSettings: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "titleTemplate",
      "description": "Page title pattern. `{title}` and `{store}` are replaced by the storefront",
      "default": "{title} | {store}"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "defaultMetaDescription",
      "default": null
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "robots",
      "description": "Value for the robots meta tag",
      "example": "index, follow",
      "default": null
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "indexable",
      "description": "Off makes every storefront page noindex and empties the sitemap; for staging stores",
      "default": true
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "organizationLegalName",
      "constraints": {
        "maxLength": 200
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "socialProfiles",
      "description": "sameAs links in the Organization graph",
      "default": [],
      "constraints": {
        "maxItems": 20
      },
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false,
        "format": "uri"
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "twitterHandle",
      "constraints": {
        "maxLength": 60
      },
      "example": "@aurorajewels"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "logoMediaId",
      "description": "Media id of the logo used in the Organization graph",
      "default": null
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "indexNowKey",
      "description": "Set by POST /seo/indexnow-key; the storefront serves it at /{key}.txt and the worker pings IndexNow on publishes",
      "default": null
    }
  ],
  "ref": "SeoSettings"
};
const schema_CrawlerSettings: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "allowTraining",
      "description": "Off blocks the AI training crawlers (GPTBot, ClaudeBot, CCBot, Bytespider, Google-Extended) in robots.txt; search and AI search bots stay allowed",
      "default": true
    }
  ],
  "ref": "CrawlerSettings"
};
const schema_PolicySettings: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "shipping",
      "properties": [
        {
          "kind": "primitive",
          "type": "integer",
          "required": true,
          "nullable": true,
          "name": "freeOverCents",
          "constraints": {
            "minimum": 0
          },
          "description": "Order subtotal in minor units of the store currency from which shipping is free; 0 means always free, null means no free shipping"
        },
        {
          "kind": "object",
          "type": "object",
          "required": true,
          "nullable": true,
          "name": "processingDays",
          "description": "Business days between order and dispatch for products without their own lead time",
          "properties": [
            {
              "kind": "primitive",
              "type": "integer",
              "required": true,
              "nullable": false,
              "name": "min",
              "constraints": {
                "minimum": 0
              }
            },
            {
              "kind": "primitive",
              "type": "integer",
              "required": true,
              "nullable": false,
              "name": "max",
              "constraints": {
                "minimum": 0
              }
            }
          ]
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "regionsNote",
          "constraints": {
            "maxLength": 300
          },
          "description": "Short note on where the store ships",
          "example": "Ships to the US and Canada"
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "returns",
      "properties": [
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "exclusions",
          "description": "What cannot be returned",
          "example": [
            "Engraved pieces",
            "Custom designs"
          ],
          "default": [],
          "constraints": {
            "maxItems": 20
          },
          "items": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          }
        },
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "refundType",
          "description": "How an accepted return is settled",
          "default": "full_refund",
          "enum": [
            "full_refund",
            "store_credit",
            "exchange"
          ]
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "warranty",
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "kind",
          "default": "none",
          "enum": [
            "none",
            "limited",
            "lifetime"
          ]
        },
        {
          "kind": "primitive",
          "type": "integer",
          "required": true,
          "nullable": true,
          "name": "years",
          "constraints": {
            "minimum": 1,
            "maximum": 100
          },
          "description": "Length of a limited warranty; ignored for none and lifetime"
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "exclusions",
          "default": [],
          "constraints": {
            "maxItems": 20
          },
          "items": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          }
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "resizing",
      "properties": [
        {
          "kind": "primitive",
          "type": "integer",
          "required": true,
          "nullable": true,
          "name": "freeWithinMonths",
          "constraints": {
            "minimum": 0,
            "maximum": 120
          },
          "description": "Months after delivery during which a resize is free; 0 means no time limit, null means resizing is not free"
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "exclusions",
          "example": [
            "Eternity bands"
          ],
          "default": [],
          "constraints": {
            "maxItems": 20
          },
          "items": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          }
        }
      ]
    }
  ],
  "ref": "PolicySettings"
};
const schema_AuctionConditionGrade: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "key",
      "description": "Stored on the lot as conditionGrade",
      "constraints": {
        "pattern": "^[a-z0-9_]{1,40}$"
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "label",
      "example": "Excellent",
      "constraints": {
        "minLength": 1,
        "maxLength": 60
      }
    }
  ],
  "ref": "AuctionConditionGrade"
};
const schema_AuctionSettings: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "conditionScale",
      "description": "The condition grades a lot may carry, best first; a lot's conditionGrade must be one of these keys",
      "default": [
        {
          "key": "unworn",
          "label": "Unworn"
        },
        {
          "key": "excellent",
          "label": "Excellent"
        },
        {
          "key": "very_good",
          "label": "Very good"
        },
        {
          "key": "good",
          "label": "Good"
        },
        {
          "key": "fair",
          "label": "Fair"
        }
      ],
      "constraints": {
        "minItems": 1,
        "maxItems": 12
      },
      "items": schema_AuctionConditionGrade
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "privateAttributeKeys",
      "description": "Attribute keys (serial, case number, certificate number) left out of storefront specifications and JSON-LD; staff and the winner's paperwork keep them",
      "default": [],
      "constraints": {
        "maxItems": 20
      },
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false,
        "constraints": {
          "minLength": 1,
          "maxLength": 60
        }
      }
    }
  ],
  "ref": "AuctionSettings"
};
const schema_PolicyKind: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "terms",
    "privacy",
    "shipping",
    "returns",
    "warranty",
    "resizing",
    "auction",
    "custom"
  ],
  "ref": "PolicyKind"
};
const schema_PolicyLink: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "A published policy the footer and checkout link to at /policies/{handle}",
  "properties": [
    { ...schema_PolicyKind, required: true, name: "kind" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    }
  ],
  "ref": "PolicyLink"
};
const schema_JsonLd: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "A schema.org graph to embed verbatim in a script type=application/ld+json",
  "properties": [
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "@context",
      "enum": [
        "https://schema.org"
      ]
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "@graph",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "additionalProperties": {
          "kind": "primitive",
          "type": "any",
          "required": false,
          "nullable": false
        }
      }
    }
  ],
  "ref": "JsonLd"
};
const schema_StorefrontStore: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "Public profile and settings of the store bound to the API key",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name",
      "example": "Aurora Jewels"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "slug",
      "example": "main"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "description": "draft and paused stores can be browsed but refuse carts, checkouts, sign-ups and newsletter sign-ups with 409 STORE_NOT_ACCEPTING_ORDERS; a closed store answers 404 to every call",
      "enum": [
        "draft",
        "active",
        "paused",
        "closed"
      ]
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "acceptsOrders",
      "description": "True only while the store is active"
    },
    { ...schema_StorefrontMedia, required: true, nullable: true, name: "logo", description: "The media behind seo.logoMediaId, resolved for the header" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "markets",
      "description": "Active markets, default first",
      "items": schema_StorefrontStoreMarket
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "defaultCurrency",
      "description": "ISO 4217 currency code",
      "example": "USD",
      "constraints": {
        "pattern": "^[A-Z]{3}$"
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "supportedCurrencies",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false,
        "description": "ISO 4217 currency code",
        "example": "USD",
        "constraints": {
          "pattern": "^[A-Z]{3}$"
        }
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "defaultLocale",
      "description": "BCP 47 language tag, language or language-REGION",
      "example": "en-US",
      "constraints": {
        "pattern": "^[a-z]{2}(?:-[A-Z]{2})?$"
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "supportedLocales",
      "example": [
        "en-US",
        "en-GB"
      ],
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "timezone",
      "description": "IANA time zone",
      "example": "America/New_York"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "countryCode",
      "description": "ISO 3166-1 alpha-2 country code",
      "example": "US",
      "constraints": {
        "pattern": "^[A-Z]{2}$"
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "contactEmail"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "supportEmail"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "supportPhone"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "primaryDomain",
      "example": "shop.aurora-jewels.com"
    },
    { ...schema_CheckoutSettings, required: true, name: "checkout" },
    { ...schema_TaxSettings, required: true, name: "tax" },
    { ...schema_ReturnsSettings, required: true, name: "returns" },
    { ...schema_TrackingSettings, required: true, name: "tracking" },
    { ...schema_SeoSettings, required: true, name: "seo" },
    { ...schema_CrawlerSettings, required: true, name: "crawlers" },
    { ...schema_PolicySettings, required: true, name: "policies" },
    { ...schema_AuctionSettings, required: true, name: "auctions", description: "The condition scale lots are graded on, so a lot's conditionGrade key renders with the store's own label" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "policyHighlights",
      "description": "Shopper-facing bullets derived from the policy settings, the same ones a product detail carries",
      "example": [
        "Free shipping over $500",
        "30-day returns",
        "Free resizing within 12 months"
      ],
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "policyLinks",
      "description": "Published policy documents in footer order. When a `terms` policy is listed and `checkout.termsUrl` is null, link the checkout consent to /policies/{handle}",
      "items": schema_PolicyLink
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "signInProviders",
      "description": "Which shopper sign-in methods this platform offers; shoppers who cannot sign in write to supportEmail",
      "properties": [
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "password"
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "magicLink"
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "google"
        }
      ]
    },
    { ...schema_JsonLd, required: true, name: "jsonld", description: "Organization and WebSite nodes for every page" }
  ],
  "ref": "StorefrontStore"
};
const schema_FieldError: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "field",
      "description": "Dot path prefixed by its source",
      "example": "body.values.0.value"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "code",
      "example": "too_small"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "message"
    }
  ],
  "ref": "FieldError"
};
const schema_ErrorResponse: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "Envelope returned by every non-2xx response",
  "properties": [
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "error",
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "code",
          "description": "Stable machine-readable code from the error catalog. Switch on this, never on `message`",
          "example": "NOT_FOUND",
          "enum": [
            "VALIDATION_ERROR",
            "INVALID_JSON",
            "INVALID_CURSOR",
            "IDEMPOTENCY_KEY_REQUIRED",
            "UNAUTHORIZED",
            "INVALID_CREDENTIALS",
            "TOKEN_INVALID",
            "TOKEN_EXPIRED",
            "INVALID_API_KEY",
            "INVITATION_REQUIRES_LOGIN",
            "SUPPORT_SESSION_ENDED",
            "FORBIDDEN",
            "PERMISSION_DENIED",
            "TWO_FACTOR_REQUIRED",
            "ACCOUNT_LOCKED",
            "ORGANIZATION_SUSPENDED",
            "STORE_CLOSED",
            "VISITOR_BANNED",
            "ORGANIZATION_CLOSED",
            "INVITATION_PENDING",
            "SUPPORT_SESSION_READ_ONLY",
            "ORIGIN_NOT_ALLOWED",
            "SECRET_KEY_IN_BROWSER",
            "SECRET_KEY_REQUIRED",
            "AUCTION_REGISTRATION_REQUIRED",
            "BIDDER_BLOCKED",
            "BIDDER_IS_STAFF",
            "NOT_FOUND",
            "ROUTE_NOT_FOUND",
            "CHAT_DISABLED",
            "CONFLICT",
            "ALREADY_EXISTS",
            "RESOURCE_IN_USE",
            "LAST_OWNER",
            "INSUFFICIENT_STOCK",
            "VARIANT_NOT_TRACKED",
            "PAYMENT_PROVIDER_UNAVAILABLE",
            "PAYMENT_NOT_COMPLETED",
            "PAYMENT_AMOUNT_MISMATCH",
            "STORE_NOT_ACCEPTING_ORDERS",
            "GOOGLE_SIGN_IN_UNAVAILABLE",
            "GOOGLE_ACCOUNT_UNKNOWN",
            "GOOGLE_EMAIL_UNVERIFIED",
            "ACCOUNT_INACTIVE",
            "PAYMENT_PROVIDER_REJECTED",
            "PASSWORD_ALREADY_SET",
            "TWO_FACTOR_REQUIRED_BY_ORGANIZATION",
            "OPEN_ORDERS",
            "IDEMPOTENCY_KEY_IN_PROGRESS",
            "CHAT_OFFLINE",
            "CONVERSATION_CLOSED",
            "TRIGGER_NOT_ELIGIBLE",
            "WORKFLOW_STAGE_NOT_ACTIVE",
            "ORDER_APPROVAL_PENDING",
            "ORDER_LINE_PRICE_WOULD_CHANGE",
            "STORE_READ_ONLY",
            "STORE_CURRENCY_LOCKED",
            "STORE_NOT_READY",
            "WORKFLOW_OWNS_APPROVAL",
            "WORKFLOW_OWNS_FULFILMENT",
            "SOCIAL_NOT_CONNECTED",
            "SOCIAL_CONNECTION_EXPIRED",
            "SOCIAL_BUSINESS_ACCOUNT_REQUIRED",
            "SOCIAL_ADS_NOT_CONNECTED",
            "SOCIAL_SCOPE_MISSING",
            "SOCIAL_WEBSITE_DOMAIN_MISSING",
            "SOCIAL_WEBSITE_NOT_CLAIMED",
            "SOCIAL_POST_DUPLICATE",
            "SOCIAL_POST_LOCKED",
            "SOCIAL_POST_NOT_PUBLISHABLE",
            "PRODUCT_TYPE_CLAIMED",
            "SKU_ALLOCATION_FAILED",
            "SKU_RETIRED",
            "PRODUCT_IN_AUCTION",
            "AUCTION_NOT_LIVE",
            "AUCTION_NOT_EDITABLE",
            "AUCTION_TERMS_CHANGED",
            "AUCTION_BUY_NOW_UNAVAILABLE",
            "AUCTION_SECOND_CHANCE_UNAVAILABLE",
            "AUCTION_OFFER_UNAVAILABLE",
            "SCHEDULE_NOT_ACTIVE",
            "SELECTION_CHANGED",
            "BULK_ACTION_BUSY",
            "SALE_NOT_EDITABLE",
            "SALE_EMPTY",
            "AUCTION_QUESTIONS_CLOSED",
            "AUCTION_QUESTION_ANSWERED",
            "LOT_IN_SALE",
            "TRANSACTION_CONFLICT",
            "PAYLOAD_TOO_LARGE",
            "UNSUPPORTED_MEDIA_TYPE",
            "INVALID_INPUT",
            "CANNOT_CHANGE_SELF",
            "OWNER_ACCESS_FIXED",
            "INVALID_REFERENCE",
            "LIMIT_EXCEEDED",
            "EXCHANGE_RATE_MISSING",
            "DISCOUNT_NOT_APPLICABLE",
            "TERMS_NOT_ACCEPTED",
            "DELAY_REASON_REQUIRED",
            "CHAT_CONSENT_REQUIRED",
            "STORE_LINK_UNAVAILABLE",
            "SOCIAL_PROVIDER_REJECTED",
            "BID_TOO_LOW",
            "IDEMPOTENCY_KEY_REUSED",
            "SKU_TEMPLATE_INVALID",
            "SKU_CODE_MISSING",
            "SKU_TOO_LONG",
            "SCHEDULE_CONFLICT",
            "SELECTION_TOO_LARGE",
            "BULK_ACTION_TIMEOUT",
            "RATE_LIMITED",
            "SOCIAL_RATE_LIMITED",
            "INTERNAL_ERROR",
            "SERVICE_UNAVAILABLE",
            "UPSTREAM_UNAVAILABLE"
          ]
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "message",
          "description": "Human-readable explanation, safe to show to a user",
          "example": "Attribute not found"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "requestId",
          "description": "Same value as the x-request-id header. Quote it when reporting a problem",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "array",
          "type": "array",
          "required": false,
          "nullable": false,
          "name": "details",
          "description": "Field-level problems. Always present on VALIDATION_ERROR, sometimes on 409 and 422 codes",
          "items": schema_FieldError
        },
        {
          "kind": "object",
          "type": "object",
          "required": false,
          "nullable": false,
          "name": "meta",
          "description": "Code-specific structured extras documented per code, e.g. retryAfterSeconds on RATE_LIMITED",
          "additionalProperties": {
            "kind": "primitive",
            "type": "any",
            "required": false,
            "nullable": false
          }
        }
      ]
    }
  ],
  "ref": "ErrorResponse"
};
const schema_Money: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "amount",
      "description": "Integer minor units of the currency",
      "example": 219000
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "currency",
      "description": "ISO 4217 currency code",
      "example": "USD",
      "constraints": {
        "pattern": "^[A-Z]{3}$"
      }
    }
  ],
  "ref": "Money"
};
const schema_StoneMedia: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "image"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "video"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "v360"
    }
  ],
  "ref": "StoneMedia"
};
const schema_StorefrontStone: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "stoneType",
      "enum": [
        "natural_diamond",
        "lab_diamond",
        "gemstone"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "shape"
    },
    {
      "kind": "primitive",
      "type": "number",
      "required": true,
      "nullable": false,
      "name": "carat"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "color"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "clarity"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "cut"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "polish"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "symmetry"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "fluorescence"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "measurements"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "lab"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "certificateNumber"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "certificateUrl"
    },
    { ...schema_Money, required: true, name: "price" },
    { ...schema_StoneMedia, required: true, nullable: true, name: "media" }
  ],
  "ref": "StorefrontStone"
};
const schema_StonePickerFacets: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "shapes",
      "items": {
        "kind": "enum",
        "type": "string",
        "required": false,
        "nullable": false,
        "enum": [
          "round",
          "oval",
          "emerald",
          "cushion",
          "pear",
          "marquise",
          "princess",
          "radiant",
          "asscher",
          "heart",
          "rose"
        ]
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "colors",
      "description": "Ordered low to high",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "clarities",
      "description": "Ordered low to high",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "cuts",
      "description": "Ordered low to high",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "caratRange",
      "properties": [
        {
          "kind": "primitive",
          "type": "number",
          "required": true,
          "nullable": false,
          "name": "min"
        },
        {
          "kind": "primitive",
          "type": "number",
          "required": true,
          "nullable": false,
          "name": "max"
        }
      ],
      "description": "Null when no stone fits"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "priceRange",
      "properties": [
        { ...schema_Money, required: true, name: "min" },
        { ...schema_Money, required: true, name: "max" }
      ],
      "description": "Shopper prices of the pool; null when no stone fits or the stones are priced in more than one currency"
    }
  ],
  "ref": "StonePickerFacets"
};
const schema_StorefrontConfigurator: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "acceptedShapes",
      "items": {
        "kind": "enum",
        "type": "string",
        "required": false,
        "nullable": false,
        "enum": [
          "round",
          "oval",
          "emerald",
          "cushion",
          "pear",
          "marquise",
          "princess",
          "radiant",
          "asscher",
          "heart",
          "rose"
        ]
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "acceptedStoneTypes",
      "items": {
        "kind": "enum",
        "type": "string",
        "required": false,
        "nullable": false,
        "enum": [
          "natural_diamond",
          "lab_diamond",
          "gemstone"
        ]
      }
    },
    {
      "kind": "primitive",
      "type": "number",
      "required": true,
      "nullable": true,
      "name": "caratMin"
    },
    {
      "kind": "primitive",
      "type": "number",
      "required": true,
      "nullable": true,
      "name": "caratMax"
    }
  ],
  "ref": "StorefrontConfigurator"
};
const schema_StoneShopResponse: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "items",
      "items": schema_StorefrontStone
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "nextCursor",
      "description": "Cursor for the next page, null on the last page"
    },
    { ...schema_StonePickerFacets, required: true, name: "facets" },
    { ...schema_StorefrontConfigurator, required: true, name: "accepts" }
  ],
  "ref": "StoneShopResponse"
};
const schema_StorefrontAvailability: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "in_stock",
    "low_stock",
    "backorder",
    "made_to_order",
    "out_of_stock"
  ],
  "ref": "StorefrontAvailability"
};
const schema_StorefrontProductSummary: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "Store product id; stable per store",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "productId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "subtitle"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "tags",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "vendor"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "productType",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "slug"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "name"
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "categoryCollection",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "handle"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "title"
        }
      ],
      "description": "The active category collection linked to the product's type, for breadcrumbs and category tabs"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "designCollection",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "handle"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "title"
        }
      ],
      "description": "The first active design collection (by title) the product is a member of: its collection line on cards and the detail page"
    },
    { ...schema_StorefrontMedia, required: true, nullable: true, name: "featuredMedia" },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "price",
      "description": "Null when no variant can be priced in this market yet",
      "properties": [
        { ...schema_Money, required: true, name: "min" },
        { ...schema_Money, required: true, name: "max" }
      ]
    },
    { ...schema_Money, required: true, nullable: true, name: "compareAtMin" },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "fulfillmentMode",
      "enum": [
        "stocked",
        "made_to_order",
        "mixed"
      ]
    },
    { ...schema_StorefrontAvailability, required: true, name: "availability", description: "Best state among the sellable variants: what a card can promise before the shopper picks one" },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "leadTimeDaysMin"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "leadTimeDaysMax"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "publishedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "StorefrontProductSummary"
};
const schema_StoneSettingsResponse: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_StorefrontStone, required: true, name: "stone" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "items",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          { ...schema_StorefrontProductSummary, required: true, name: "product" },
          { ...schema_Money, required: true, nullable: true, name: "total" }
        ]
      }
    }
  ],
  "ref": "StoneSettingsResponse"
};
const schema_StorefrontMarket: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "The market the prices in this response are for",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "currency",
      "description": "ISO 4217 currency code",
      "example": "USD",
      "constraints": {
        "pattern": "^[A-Z]{3}$"
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "countries",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false,
        "description": "ISO 3166-1 alpha-2 country code",
        "example": "US",
        "constraints": {
          "pattern": "^[A-Z]{2}$"
        }
      }
    }
  ],
  "ref": "StorefrontMarket"
};
const schema_SearchFacet: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "Fields: `product_type`, `tags`, `vendor`, `fulfillment_mode`, `price_cents` (values `min` and `max`, counts 0), `collections` (search only) and `attr.<key>`",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "field",
      "example": "attr.metal"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "label",
      "example": "Metal"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "values",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "value"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "label"
          },
          {
            "kind": "primitive",
            "type": "integer",
            "required": true,
            "nullable": false,
            "name": "count"
          }
        ]
      }
    }
  ],
  "ref": "SearchFacet"
};
const schema_StorefrontProductListResponse: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "items",
      "items": schema_StorefrontProductSummary
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "nextCursor",
      "description": "Cursor for the next page, null on the last page"
    },
    { ...schema_StorefrontMarket, required: true, nullable: true, name: "market" },
    {
      "kind": "array",
      "type": "array",
      "required": false,
      "nullable": false,
      "name": "facets",
      "description": "Present when `facets=true`",
      "items": schema_SearchFacet
    }
  ],
  "ref": "StorefrontProductListResponse"
};
const schema_FaqItem: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "question",
      "constraints": {
        "minLength": 1,
        "maxLength": 300
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "answer",
      "constraints": {
        "minLength": 1,
        "maxLength": 4000
      }
    }
  ],
  "ref": "FaqItem"
};
const schema_Specification: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "One human-readable product fact, in the product type's attribute order",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "attributeKey"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "label"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "value"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "unit"
    }
  ],
  "ref": "Specification"
};
const schema_SeoImage: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "url",
      "format": "uri"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "width"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "height"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "alt"
    }
  ],
  "ref": "SeoImage"
};
const schema_SeoWarning: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "title_too_long",
    "title_missing",
    "description_missing",
    "description_too_long",
    "image_missing",
    "alt_missing"
  ],
  "ref": "SeoWarning"
};
const schema_ResolvedSeo: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title",
      "description": "At most 60 characters, cut on a word boundary"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "description",
      "description": "At most 160 characters"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "canonical",
      "description": "Absolute URL on the store's primary domain; null until the store has one"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "robots",
      "example": "index, follow"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "openGraph",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "title"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "description"
        },
        { ...schema_SeoImage, required: true, nullable: true, name: "image" },
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "type",
          "enum": [
            "website",
            "product",
            "article"
          ]
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "twitter",
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "card",
          "enum": [
            "summary",
            "summary_large_image"
          ]
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "site"
        }
      ]
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "warnings",
      "description": "What the admin should fix; empty when the entity is well described",
      "items": schema_SeoWarning
    }
  ],
  "ref": "ResolvedSeo"
};
const schema_Swatch: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "How a select value is drawn in an option picker",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "color",
      "example": "#F3D27A",
      "constraints": {
        "pattern": "^#[0-9a-fA-F]{6}$"
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "mediaId",
      "format": "uuid",
      "description": "Image to show instead of a flat color",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    }
  ],
  "ref": "Swatch"
};
const schema_StorefrontAttribute: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "key"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "label"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "dataType"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "unit"
    },
    {
      "kind": "primitive",
      "type": "string | number | boolean",
      "required": true,
      "nullable": true,
      "name": "value",
      "description": "Scalar value for text, number, boolean and dimension attributes"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "values",
      "description": "Selected dictionary values for select attributes",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "value"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "label"
          },
          { ...schema_Swatch, required: true, nullable: true, name: "swatch" }
        ]
      }
    }
  ],
  "ref": "StorefrontAttribute"
};
const schema_StorefrontOption: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "key",
      "description": "Attribute key; matches the keys of variant optionValues"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "values",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "value"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "label"
          },
          { ...schema_Swatch, required: true, nullable: true, name: "swatch" }
        ]
      }
    }
  ],
  "ref": "StorefrontOption"
};
const schema_StorefrontVariant: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "sku",
      "description": "The store's skuOverride when set, else the variant's SKU. Staff can regenerate SKUs, so key your own records on id, not on sku"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "optionValues",
      "description": "Option key to value code",
      "additionalProperties": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    { ...schema_Money, required: true, nullable: true, name: "price" },
    { ...schema_Money, required: true, nullable: true, name: "compareAt" },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "isAvailable"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "fulfillmentMode",
      "enum": [
        "stocked",
        "made_to_order",
        "mixed"
      ]
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "leadTimeDaysMin"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "leadTimeDaysMax"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "mediaId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    }
  ],
  "ref": "StorefrontVariant"
};
const schema_CustomizationOption: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "value",
      "description": "Immutable stored value: lowercase letters, digits, underscores, dots and hyphens",
      "example": "script",
      "constraints": {
        "minLength": 1,
        "maxLength": 120,
        "pattern": "^[a-z0-9][a-z0-9_.-]*$"
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "label",
      "example": "Script",
      "constraints": {
        "minLength": 1,
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": false,
      "nullable": false,
      "name": "priceDeltaCents",
      "description": "Added on top of the customization's own priceDeltaCents when this option is chosen, in minor units of the store currency",
      "constraints": {
        "minimum": 0
      }
    }
  ],
  "ref": "CustomizationOption"
};
const schema_CustomerUploadContentType: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/heic",
    "image/heif",
    "application/pdf"
  ],
  "ref": "CustomerUploadContentType"
};
const schema_Customization: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "An order-line input such as ring size or engraving. Never creates stock",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "key",
      "example": "engraving"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "label",
      "example": "Engraving"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "inputType",
      "enum": [
        "select",
        "text",
        "number",
        "boolean",
        "file"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "sizeSetId",
      "format": "uuid",
      "description": "Size set a select draws its options from",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": true,
      "name": "options",
      "items": schema_CustomizationOption,
      "description": "Inline options of a select that does not use a size set"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "isRequired"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "priceDeltaCents",
      "description": "Added to the line price, in minor units of the store currency"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "maxLength",
      "description": "Character limit of a text input"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "pattern",
      "description": "Regular expression a text input must match"
    },
    {
      "kind": "array",
      "type": "array",
      "required": false,
      "nullable": true,
      "name": "accept",
      "items": schema_CustomerUploadContentType,
      "description": "File inputs only: content types the shopper may upload; null means every type the platform accepts"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "helpText",
      "example": "Up to 20 characters, engraved inside the band"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "affectsLeadTimeDays",
      "description": "Days added to the fulfillment lead time"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "position"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "createdAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "Customization"
};
const schema_StorefrontProductAuction: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "scheduled",
        "live"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "variantId",
      "format": "uuid",
      "description": "The variant that is the lot",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "startsAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "endsAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    { ...schema_Money, required: true, name: "startingPrice" },
    { ...schema_Money, required: true, nullable: true, name: "currentPrice", description: "Null until the first bid; in the store currency whatever the market" }
  ],
  "ref": "StorefrontProductAuction"
};
const schema_StorefrontProduct: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "Store product id; stable per store",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "productId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "subtitle"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "tags",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "vendor"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "productType",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "slug"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "name"
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "categoryCollection",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "handle"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "title"
        }
      ],
      "description": "The active category collection linked to the product's type, for breadcrumbs and category tabs"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "designCollection",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "handle"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "title"
        }
      ],
      "description": "The first active design collection (by title) the product is a member of: its collection line on cards and the detail page"
    },
    { ...schema_StorefrontMedia, required: true, nullable: true, name: "featuredMedia" },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "price",
      "description": "Null when no variant can be priced in this market yet",
      "properties": [
        { ...schema_Money, required: true, name: "min" },
        { ...schema_Money, required: true, name: "max" }
      ]
    },
    { ...schema_Money, required: true, nullable: true, name: "compareAtMin" },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "fulfillmentMode",
      "enum": [
        "stocked",
        "made_to_order",
        "mixed"
      ]
    },
    { ...schema_StorefrontAvailability, required: true, name: "availability", description: "Best state among the sellable variants: what a card can promise before the shopper picks one" },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "leadTimeDaysMin"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "leadTimeDaysMax"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "publishedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "descriptionHtml"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "summary"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "faq",
      "items": schema_FaqItem
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "specifications",
      "items": schema_Specification
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "policyHighlights",
      "description": "Store policy bullets for the detail page: free shipping threshold, processing time, returns, warranty, resizing",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "careGuideHandle",
      "description": "Handle of the store's published care_guide page, whose text is the care copy for every product, at /pages/{handle}; null when the store has none"
    },
    { ...schema_ResolvedSeo, required: true, name: "seo" },
    { ...schema_JsonLd, required: true, name: "jsonld" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "attributes",
      "items": schema_StorefrontAttribute
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "options",
      "items": schema_StorefrontOption
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "variants",
      "items": schema_StorefrontVariant
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "media",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "enum",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "kind",
            "enum": [
              "image",
              "video",
              "model_3d",
              "document"
            ]
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "url",
            "format": "uri"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "mimeType"
          },
          {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": true,
            "name": "renditions",
            "description": "WebP renditions generated on the worker: thumb 200, medium 800, large 1600 (longest edge)",
            "properties": [
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": false,
                "name": "thumb",
                "format": "uri"
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": false,
                "name": "medium",
                "format": "uri"
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": false,
                "name": "large",
                "format": "uri"
              }
            ]
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "alt"
          },
          {
            "kind": "primitive",
            "type": "integer",
            "required": true,
            "nullable": true,
            "name": "width"
          },
          {
            "kind": "primitive",
            "type": "integer",
            "required": true,
            "nullable": true,
            "name": "height"
          },
          {
            "kind": "primitive",
            "type": "integer",
            "required": true,
            "nullable": false,
            "name": "position"
          },
          {
            "kind": "array",
            "type": "array",
            "required": true,
            "nullable": false,
            "name": "variantIds",
            "items": {
              "kind": "primitive",
              "type": "string",
              "required": false,
              "nullable": false,
              "format": "uuid",
              "description": "UUID v7",
              "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
            }
          }
        ]
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "customizations",
      "items": schema_Customization
    },
    { ...schema_StorefrontConfigurator, required: true, nullable: true, name: "configurator", description: "Present when the product is a diamond setting; the storefront shows the picker locked to these constraints" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "related",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "enum",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "relationType",
            "enum": [
              "upsell",
              "cross_sell",
              "matching",
              "similar"
            ]
          },
          { ...schema_StorefrontProductSummary, required: true, name: "product" }
        ]
      }
    },
    { ...schema_StorefrontMarket, required: true, nullable: true, name: "market" },
    { ...schema_StorefrontProductAuction, required: true, nullable: true, name: "auction", description: "Set while the product is a lot in a scheduled or live auction: render the bid panel from GET /auctions/{id} instead of add to bag, which answers 409 PRODUCT_IN_AUCTION" }
  ],
  "ref": "StorefrontProduct"
};
const schema_SizeSetValue: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "value",
      "example": "6.5"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "label",
      "example": "6½"
    },
    {
      "kind": "primitive",
      "type": "number",
      "required": true,
      "nullable": true,
      "name": "numericValue",
      "description": "Sortable number behind the label"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "equivalents",
      "description": "Same size in other systems, keyed by system",
      "additionalProperties": {
        "kind": "primitive",
        "type": "any",
        "required": false,
        "nullable": false
      },
      "example": {
        "uk": "M",
        "eu": "53"
      }
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "position"
    }
  ],
  "ref": "SizeSetValue"
};
const schema_StorefrontSizeSet: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "The sizes a size customization offers, with their equivalents in other systems",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "key",
      "example": "ring_size_us"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name",
      "example": "US ring sizes"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "system",
      "enum": [
        "us",
        "uk",
        "eu",
        "in",
        "jp",
        "custom"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "unit",
      "example": "mm"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "sizeGuideHandle",
      "description": "Handle of the store's published size_guide page, for a \"find your size\" link at /pages/{handle}; null when the store has none"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "values",
      "items": schema_SizeSetValue
    }
  ],
  "ref": "StorefrontSizeSet"
};
const schema_PageTemplate: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "default",
    "faq",
    "policy",
    "size_guide",
    "stone_education",
    "care_guide",
    "contact"
  ],
  "ref": "PageTemplate"
};
const schema_PageBlocks: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "array",
      "type": "array",
      "required": false,
      "nullable": false,
      "name": "faq",
      "constraints": {
        "maxItems": 100
      },
      "items": schema_FaqItem
    },
    {
      "kind": "array",
      "type": "array",
      "required": false,
      "nullable": false,
      "name": "steps",
      "description": "size_guide: a HowTo in the graph",
      "constraints": {
        "maxItems": 50
      },
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "name",
            "constraints": {
              "minLength": 1,
              "maxLength": 200
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "text",
            "constraints": {
              "minLength": 1,
              "maxLength": 4000
            }
          }
        ]
      }
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "name": "hero",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "heading",
          "constraints": {
            "maxLength": 200
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "subheading",
          "constraints": {
            "maxLength": 400
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "mediaId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        }
      ]
    }
  ],
  "ref": "PageBlocks"
};
const schema_StorefrontPage: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "bodyHtml"
    },
    { ...schema_PageTemplate, required: true, name: "template" },
    { ...schema_PageBlocks, required: true, nullable: true, name: "blocks" },
    { ...schema_ResolvedSeo, required: true, name: "seo" },
    { ...schema_JsonLd, required: true, name: "jsonld" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "publishedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "StorefrontPage"
};
const schema_RedirectLookup: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "toPath"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "statusCode"
    }
  ],
  "ref": "RedirectLookup"
};
const schema_StorefrontPolicySummary: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_PolicyKind, required: true, name: "kind" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "summary"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "StorefrontPolicySummary"
};
const schema_StorefrontPolicy: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_PolicyKind, required: true, name: "kind" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "summary"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "bodyHtml"
    },
    { ...schema_ResolvedSeo, required: true, name: "seo" },
    { ...schema_JsonLd, required: true, name: "jsonld", description: "WebPage, BreadcrumbList and the store Organization; a returns policy adds MerchantReturnPolicy built from the store settings" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "publishedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "StorefrontPolicy"
};
const schema_StorefrontBlogCategory: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "description"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "position"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "postCount"
    }
  ],
  "ref": "StorefrontBlogCategory"
};
const schema_BlogCategoryRef: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    }
  ],
  "ref": "BlogCategoryRef"
};
const schema_StorefrontBlogPostSummary: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "excerpt"
    },
    { ...schema_StorefrontMedia, required: true, nullable: true, name: "featuredMedia" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "authorName"
    },
    { ...schema_BlogCategoryRef, required: true, nullable: true, name: "category" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "tags",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "publishedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "StorefrontBlogPostSummary"
};
const schema_StorefrontBlogPost: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "excerpt"
    },
    { ...schema_StorefrontMedia, required: true, nullable: true, name: "featuredMedia" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "authorName"
    },
    { ...schema_BlogCategoryRef, required: true, nullable: true, name: "category" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "tags",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "publishedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "bodyHtml"
    },
    { ...schema_ResolvedSeo, required: true, name: "seo" },
    { ...schema_JsonLd, required: true, name: "jsonld" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "StorefrontBlogPost"
};
const schema_StorefrontMenuItem: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "url"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "openInNewTab"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "children",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "title"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "url"
          },
          {
            "kind": "primitive",
            "type": "boolean",
            "required": true,
            "nullable": false,
            "name": "openInNewTab"
          },
          {
            "kind": "array",
            "type": "array",
            "required": true,
            "nullable": false,
            "name": "children",
            "items": {
              "kind": "object",
              "type": "object",
              "required": false,
              "nullable": false,
              "properties": [
                {
                  "kind": "primitive",
                  "type": "string",
                  "required": true,
                  "nullable": false,
                  "name": "id",
                  "format": "uuid",
                  "description": "UUID v7",
                  "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
                },
                {
                  "kind": "primitive",
                  "type": "string",
                  "required": true,
                  "nullable": false,
                  "name": "title"
                },
                {
                  "kind": "primitive",
                  "type": "string",
                  "required": true,
                  "nullable": false,
                  "name": "url"
                },
                {
                  "kind": "primitive",
                  "type": "boolean",
                  "required": true,
                  "nullable": false,
                  "name": "openInNewTab"
                },
                {
                  "kind": "array",
                  "type": "array",
                  "required": true,
                  "nullable": false,
                  "name": "children",
                  "items": {
                    "kind": "primitive",
                    "type": "never",
                    "required": false,
                    "nullable": false
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ],
  "ref": "StorefrontMenuItem"
};
const schema_StorefrontMenu: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "items",
      "items": schema_StorefrontMenuItem
    }
  ],
  "ref": "StorefrontMenu"
};
const schema_MoneyInput: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "amount",
      "description": "Integer minor units of the currency",
      "example": 219000
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "currency",
      "description": "ISO 4217 currency code",
      "example": "USD",
      "constraints": {
        "pattern": "^[A-Z]{3}$"
      }
    }
  ],
  "ref": "MoneyInput"
};
const schema_AnalyticsItemInput: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "productId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "variantId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "sku",
      "constraints": {
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "title",
      "constraints": {
        "maxLength": 300
      }
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": false,
      "nullable": false,
      "name": "quantity",
      "default": 1,
      "constraints": {
        "minimum": 1,
        "maximum": 10000
      }
    },
    { ...schema_MoneyInput, nullable: true, name: "price" }
  ],
  "ref": "AnalyticsItemInput"
};
const schema_StorefrontEventsRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "events",
      "constraints": {
        "minItems": 1,
        "maxItems": 100
      },
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "enum",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "name",
            "enum": [
              "page_view",
              "view_item",
              "view_item_list",
              "search",
              "add_to_cart",
              "remove_from_cart",
              "view_cart",
              "begin_checkout",
              "add_shipping_info",
              "add_payment_info",
              "sign_up",
              "login"
            ]
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "eventId",
            "description": "Client id shared with the browser pixel so the platform deduplicates; generated when omitted",
            "constraints": {
              "minLength": 1,
              "maxLength": 100
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "occurredAt",
            "format": "date-time",
            "description": "Defaults to now; clamped to the last 7 days",
            "example": "2026-09-27T10:15:30.000Z"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "sessionId",
            "constraints": {
              "minLength": 1,
              "maxLength": 100
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "anonymousId",
            "description": "Stable per browser; GA4 client id",
            "constraints": {
              "minLength": 1,
              "maxLength": 100
            }
          },
          { ...schema_MoneyInput, nullable: true, name: "value" },
          {
            "kind": "array",
            "type": "array",
            "required": false,
            "nullable": false,
            "name": "items",
            "default": [],
            "constraints": {
              "maxItems": 50
            },
            "items": schema_AnalyticsItemInput
          },
          {
            "kind": "object",
            "type": "object",
            "required": false,
            "nullable": false,
            "name": "context",
            "default": {
              "page": null,
              "referrer": null,
              "utm": {},
              "consent": {
                "analytics": false,
                "marketing": false
              },
              "searchQuery": null,
              "checkoutId": null
            },
            "properties": [
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": true,
                "name": "page",
                "constraints": {
                  "maxLength": 2000
                },
                "description": "Full URL of the page the event happened on"
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": true,
                "name": "referrer",
                "constraints": {
                  "maxLength": 2000
                }
              },
              {
                "kind": "object",
                "type": "object",
                "required": false,
                "nullable": false,
                "name": "utm",
                "default": {},
                "properties": [
                  {
                    "kind": "primitive",
                    "type": "string",
                    "required": false,
                    "nullable": false,
                    "name": "source",
                    "constraints": {
                      "maxLength": 200
                    }
                  },
                  {
                    "kind": "primitive",
                    "type": "string",
                    "required": false,
                    "nullable": false,
                    "name": "medium",
                    "constraints": {
                      "maxLength": 200
                    }
                  },
                  {
                    "kind": "primitive",
                    "type": "string",
                    "required": false,
                    "nullable": false,
                    "name": "campaign",
                    "constraints": {
                      "maxLength": 200
                    }
                  },
                  {
                    "kind": "primitive",
                    "type": "string",
                    "required": false,
                    "nullable": false,
                    "name": "term",
                    "constraints": {
                      "maxLength": 200
                    }
                  },
                  {
                    "kind": "primitive",
                    "type": "string",
                    "required": false,
                    "nullable": false,
                    "name": "content",
                    "constraints": {
                      "maxLength": 200
                    }
                  }
                ]
              },
              {
                "kind": "object",
                "type": "object",
                "required": false,
                "nullable": false,
                "name": "consent",
                "default": {
                  "analytics": false,
                  "marketing": false
                },
                "properties": [
                  {
                    "kind": "primitive",
                    "type": "boolean",
                    "required": false,
                    "nullable": false,
                    "name": "analytics",
                    "description": "Measurement destinations (GA4) receive the event",
                    "default": false
                  },
                  {
                    "kind": "primitive",
                    "type": "boolean",
                    "required": false,
                    "nullable": false,
                    "name": "marketing",
                    "description": "Ad destinations (Meta) receive the event",
                    "default": false
                  }
                ]
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": true,
                "name": "searchQuery",
                "constraints": {
                  "maxLength": 200
                }
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": true,
                "name": "checkoutId",
                "format": "uuid",
                "description": "On checkout-stage events: lets the server-side purchase inherit this session and consent",
                "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
              }
            ]
          }
        ]
      }
    }
  ],
  "ref": "StorefrontEventsRequest"
};
const schema_StorefrontEventsAccepted: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "accepted"
    }
  ],
  "ref": "StorefrontEventsAccepted"
};
const schema_StorefrontCollection: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "descriptionHtml"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "role",
      "description": "merchandising: a curated or seasonal edit. category: the browse page for one kind of piece (Rings), linked to a product type. design: a design family (a product's collection line on cards and the detail page)",
      "enum": [
        "merchandising",
        "category",
        "design"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "eyebrow",
      "description": "Short kicker shown above the title"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "productType",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "slug"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "name"
        }
      ],
      "description": "Category collections: the product type they stand for, so a product type facet can be labelled and linked by its category"
    },
    { ...schema_StorefrontMedia, required: true, nullable: true, name: "media" },
    { ...schema_ResolvedSeo, required: true, name: "seo" },
    { ...schema_JsonLd, required: true, name: "jsonld" },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "sortOrder",
      "enum": [
        "manual",
        "best_selling",
        "price_asc",
        "price_desc",
        "newest",
        "title_asc"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "sortBasis",
      "description": "What the default order of the products is computed from; best_selling ranks by units sold in this store over the last 90 days",
      "enum": [
        "manual",
        "sales_90d",
        "price",
        "newest",
        "title"
      ]
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "productCount"
    }
  ],
  "ref": "StorefrontCollection"
};
const schema_StorefrontCollectionProductsResponse: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "items",
      "items": schema_StorefrontProductSummary
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "nextCursor"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "total",
      "description": "Members left after the filters, before paging"
    },
    {
      "kind": "array",
      "type": "array",
      "required": false,
      "nullable": false,
      "name": "facets",
      "description": "Present when `facets=true`",
      "items": schema_SearchFacet
    }
  ],
  "ref": "StorefrontCollectionProductsResponse"
};
const schema_StorefrontContentMedia: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "id",
      "format": "uuid",
      "description": "Null for URL media",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "kind",
      "enum": [
        "image",
        "video"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "url",
      "format": "uri"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "mimeType"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "alt"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "width"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "height"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "renditions",
      "description": "Null for URL media and for video",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": false,
          "name": "thumb",
          "format": "uri"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": false,
          "name": "medium",
          "format": "uri"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": false,
          "name": "large",
          "format": "uri"
        }
      ]
    }
  ],
  "ref": "StorefrontContentMedia"
};
const schema_StorefrontCta: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "label"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "href",
      "description": "Ready-to-use path or URL; null when the target no longer exists in this store"
    },
    {
      "kind": "oneOf",
      "type": "oneOf",
      "required": true,
      "nullable": true,
      "name": "target",
      "variants": [
        {
          "kind": "object",
          "type": "object",
          "required": false,
          "nullable": false,
          "properties": [
            {
              "kind": "enum",
              "type": "string",
              "required": true,
              "nullable": false,
              "name": "type",
              "enum": [
                "url"
              ]
            }
          ]
        },
        {
          "kind": "object",
          "type": "object",
          "required": false,
          "nullable": false,
          "properties": [
            {
              "kind": "enum",
              "type": "string",
              "required": true,
              "nullable": false,
              "name": "type",
              "enum": [
                "product"
              ]
            },
            {
              "kind": "primitive",
              "type": "string",
              "required": true,
              "nullable": false,
              "name": "id",
              "format": "uuid",
              "description": "UUID v7",
              "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
            },
            {
              "kind": "primitive",
              "type": "string",
              "required": true,
              "nullable": false,
              "name": "handle"
            },
            {
              "kind": "primitive",
              "type": "string",
              "required": true,
              "nullable": false,
              "name": "title"
            }
          ]
        },
        {
          "kind": "object",
          "type": "object",
          "required": false,
          "nullable": false,
          "properties": [
            {
              "kind": "enum",
              "type": "string",
              "required": true,
              "nullable": false,
              "name": "type",
              "enum": [
                "collection"
              ]
            },
            {
              "kind": "primitive",
              "type": "string",
              "required": true,
              "nullable": false,
              "name": "id",
              "format": "uuid",
              "description": "UUID v7",
              "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
            },
            {
              "kind": "primitive",
              "type": "string",
              "required": true,
              "nullable": false,
              "name": "handle"
            },
            {
              "kind": "primitive",
              "type": "string",
              "required": true,
              "nullable": false,
              "name": "title"
            }
          ]
        }
      ],
      "description": "Null when a product or collection target is gone"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "openInNewTab"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "style"
    }
  ],
  "ref": "StorefrontCta"
};
const schema_StorefrontBannerItem: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_StorefrontContentMedia, required: true, nullable: true, name: "media" },
    { ...schema_StorefrontContentMedia, required: true, nullable: true, name: "mobileMedia" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "eyebrow"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "subtitle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "descriptionHtml"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "ctas",
      "items": schema_StorefrontCta
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "custom",
      "description": "Free key/value data passed to the storefront verbatim, 16 KB at most",
      "additionalProperties": {
        "kind": "primitive",
        "type": "any",
        "required": false,
        "nullable": false
      }
    }
  ],
  "ref": "StorefrontBannerItem"
};
const schema_StorefrontContentBlock: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "key",
      "description": "URL-safe handle: lowercase letters, digits and hyphens",
      "example": "aurora-jewels",
      "constraints": {
        "minLength": 1,
        "maxLength": 120,
        "pattern": "^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$"
      }
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "kind",
      "enum": [
        "banner",
        "rail"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "description": "Always active outside preview",
      "enum": [
        "draft",
        "active"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "startsAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "endsAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "custom",
      "description": "Free key/value data passed to the storefront verbatim, 16 KB at most",
      "additionalProperties": {
        "kind": "primitive",
        "type": "any",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "banner",
      "properties": [
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "items",
          "items": schema_StorefrontBannerItem
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "rail",
      "properties": [
        { ...schema_StorefrontBannerItem, required: true, nullable: true, name: "header" },
        {
          "kind": "oneOf",
          "type": "oneOf",
          "required": true,
          "nullable": false,
          "name": "source",
          "variants": [
            {
              "kind": "object",
              "type": "object",
              "required": false,
              "nullable": false,
              "properties": [
                {
                  "kind": "enum",
                  "type": "string",
                  "required": true,
                  "nullable": false,
                  "name": "type",
                  "enum": [
                    "collection"
                  ]
                },
                {
                  "kind": "object",
                  "type": "object",
                  "required": true,
                  "nullable": true,
                  "name": "collection",
                  "properties": [
                    {
                      "kind": "primitive",
                      "type": "string",
                      "required": true,
                      "nullable": false,
                      "name": "id",
                      "format": "uuid",
                      "description": "UUID v7",
                      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
                    },
                    {
                      "kind": "primitive",
                      "type": "string",
                      "required": true,
                      "nullable": false,
                      "name": "handle"
                    },
                    {
                      "kind": "primitive",
                      "type": "string",
                      "required": true,
                      "nullable": false,
                      "name": "title"
                    }
                  ]
                }
              ]
            },
            {
              "kind": "object",
              "type": "object",
              "required": false,
              "nullable": false,
              "properties": [
                {
                  "kind": "enum",
                  "type": "string",
                  "required": true,
                  "nullable": false,
                  "name": "type",
                  "enum": [
                    "products"
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "primitive",
          "type": "integer",
          "required": true,
          "nullable": false,
          "name": "limit"
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "products",
          "description": "Empty when ?products=false",
          "items": schema_StorefrontProductSummary
        }
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "StorefrontContentBlock"
};
const schema_StorefrontContentSection: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle",
      "description": "URL-safe handle: lowercase letters, digits and hyphens",
      "example": "aurora-jewels",
      "constraints": {
        "minLength": 1,
        "maxLength": 120,
        "pattern": "^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$"
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "description"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "draft",
        "active"
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "custom",
      "description": "Free key/value data passed to the storefront verbatim, 16 KB at most",
      "additionalProperties": {
        "kind": "primitive",
        "type": "any",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "blocks",
      "items": schema_StorefrontContentBlock
    },
    { ...schema_StorefrontMarket, required: true, nullable: true, name: "market", description: "Market the rail prices are for" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "Latest of the section and its visible blocks; drives the ETag",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "StorefrontContentSection"
};
const schema_SuggestedProduct: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "description": "Store product id"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "productId"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    { ...schema_StorefrontMedia, required: true, nullable: true, name: "image" },
    { ...schema_Money, required: true, nullable: true, name: "price", description: "Lowest sellable variant price in the shopper's market" }
  ],
  "ref": "SuggestedProduct"
};
const schema_SuggestedEntry: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    }
  ],
  "ref": "SuggestedEntry"
};
const schema_SearchSuggestResponse: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "Typeahead: the top five products, collections and pages for a prefix, answered within a 100 ms budget (a group that misses it comes back empty)",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "query"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "products",
      "constraints": {
        "maxItems": 5
      },
      "items": schema_SuggestedProduct
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "collections",
      "description": "Live at /collections/{handle}",
      "constraints": {
        "maxItems": 5
      },
      "items": schema_SuggestedEntry
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "pages",
      "description": "Live at /pages/{handle}",
      "constraints": {
        "maxItems": 5
      },
      "items": schema_SuggestedEntry
    },
    { ...schema_StorefrontMarket, required: true, nullable: true, name: "market" },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "processingTimeMs"
    }
  ],
  "ref": "SearchSuggestResponse"
};
const schema_StorefrontSearchResponse: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "hits",
      "items": schema_StorefrontProductSummary
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "total"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "page"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "limit"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "facets",
      "items": schema_SearchFacet
    },
    { ...schema_StorefrontMarket, required: true, nullable: true, name: "market" },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "processingTimeMs"
    }
  ],
  "ref": "StorefrontSearchResponse"
};
const schema_VariantAvailability: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "variantId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "trackInventory"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "available",
      "description": "Null when the variant does not track inventory"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "inStock",
      "description": "Sellable now: untracked, available > 0, or backorders allowed"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "backorder",
      "description": "True when inStock only because backorders are allowed"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "leadTimeDaysMin"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "leadTimeDaysMax"
    }
  ],
  "ref": "VariantAvailability"
};
const schema_StorefrontShippingZone: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "countries",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false,
        "description": "ISO 3166-1 alpha-2 country code",
        "example": "US",
        "constraints": {
          "pattern": "^[A-Z]{2}$"
        }
      }
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "regions",
      "additionalProperties": {
        "kind": "array",
        "type": "array",
        "required": false,
        "nullable": false,
        "items": {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": false
        }
      },
      "description": "Country code to region codes when a zone covers part of a country; null means the whole country"
    }
  ],
  "ref": "StorefrontShippingZone"
};
const schema_CustomerRegisterRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "email",
      "format": "email",
      "description": "Email address, stored lower-cased"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "password",
      "description": "12 to 200 characters",
      "example": "correct-horse-battery-staple",
      "constraints": {
        "minLength": 12,
        "maxLength": 200
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "firstName",
      "constraints": {
        "minLength": 1,
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "lastName",
      "constraints": {
        "minLength": 1,
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "phone",
      "example": "+14155550123",
      "constraints": {
        "pattern": "^\\+[1-9]\\d{6,14}$"
      }
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": false,
      "nullable": false,
      "name": "acceptsMarketing",
      "default": false
    }
  ],
  "ref": "CustomerRegisterRequest"
};
const schema_CustomerProfile: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "email"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "firstName"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "lastName"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "phone"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "guest",
        "active",
        "disabled"
      ]
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "acceptsMarketing"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "locale"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "currency"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "savedRingSize"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "defaultAddressId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "doNotSell",
      "description": "Set by a do_not_sell privacy request; storefronts honour it for ad forwarding"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "createdAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "CustomerProfile"
};
const schema_CustomerTokenResponse: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "accessToken",
      "description": "Send as X-Customer-Token next to the store key"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "tokenType",
      "enum": [
        "Bearer"
      ]
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "expiresIn",
      "description": "Access token lifetime in seconds"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "refreshToken",
      "description": "Single use; exchange it at /customers/refresh before the access token expires. Absent when the request carried X-Nucleus-Client: the token is then in the HttpOnly nucleus_customer cookie"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "refreshExpiresAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    { ...schema_CustomerProfile, required: true, name: "customer" }
  ],
  "ref": "CustomerTokenResponse"
};
const schema_CustomerLoginRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "email",
      "format": "email",
      "description": "Email address, stored lower-cased"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "password",
      "constraints": {
        "minLength": 1,
        "maxLength": 200
      }
    }
  ],
  "ref": "CustomerLoginRequest"
};
const schema_CustomerGoogleStart: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "url",
      "description": "Send the browser here; Google returns it to the API, which sends it on to redirectUrl with ?code= or ?error="
    }
  ],
  "ref": "CustomerGoogleStart"
};
const schema_CustomerAddress: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "label",
      "constraints": {
        "maxLength": 60
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "firstName",
      "constraints": {
        "minLength": 1,
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "lastName",
      "constraints": {
        "minLength": 1,
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "company",
      "constraints": {
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "line1",
      "constraints": {
        "minLength": 1,
        "maxLength": 200
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "line2",
      "constraints": {
        "maxLength": 200
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "city",
      "constraints": {
        "minLength": 1,
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "region",
      "constraints": {
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "postalCode",
      "constraints": {
        "maxLength": 20
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "countryCode",
      "description": "ISO 3166-1 alpha-2 country code",
      "example": "US",
      "constraints": {
        "pattern": "^[A-Z]{2}$"
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "phone",
      "example": "+14155550123",
      "constraints": {
        "pattern": "^\\+[1-9]\\d{6,14}$"
      }
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "isDefaultShipping"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "isDefaultBilling"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "createdAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "CustomerAddress"
};
const schema_WishlistVariant: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "sku"
    },
    { ...schema_Money, required: true, nullable: true, name: "price" },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "isAvailable"
    }
  ],
  "ref": "WishlistVariant"
};
const schema_WishlistItem: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "productId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "variantId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "customizations",
      "description": "Saved as given; validated when the item goes into a cart",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "description": "A shopper's answer to one product customization",
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "key",
            "example": "ring_size",
            "constraints": {
              "minLength": 1,
              "maxLength": 60
            }
          },
          {
            "kind": "oneOf",
            "type": "oneOf",
            "required": true,
            "nullable": false,
            "name": "value",
            "example": "6.5",
            "variants": [
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxLength": 500
                }
              },
              {
                "kind": "primitive",
                "type": "number",
                "required": false,
                "nullable": false
              },
              {
                "kind": "primitive",
                "type": "boolean",
                "required": false,
                "nullable": false
              }
            ]
          }
        ]
      }
    },
    { ...schema_StorefrontProductSummary, required: true, nullable: true, name: "product", description: "null when the product is no longer published in the store" },
    { ...schema_WishlistVariant, required: true, nullable: true, name: "variant" },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "available",
      "description": "The product is published and the variant, when saved, is still for sale"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "position"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "createdAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "WishlistItem"
};
const schema_Wishlist: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "isDefault"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "shareToken",
      "description": "Set by POST /customers/me/wishlist/share; anyone with it can read the list at /wishlists/{shareToken}"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "itemCount"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "items",
      "items": schema_WishlistItem
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "createdAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "Wishlist"
};
const schema_SharedWishlist: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "ownerFirstName"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "itemCount"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "items",
      "items": schema_WishlistItem
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "SharedWishlist"
};
const schema_PrivacyRequestKind: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "export",
    "delete",
    "do_not_sell"
  ],
  "ref": "PrivacyRequestKind"
};
const schema_PrivacyRequestStatus: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "received",
    "in_progress",
    "completed",
    "rejected"
  ],
  "ref": "PrivacyRequestStatus"
};
const schema_PrivacyRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "customerId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "email",
      "description": "The email at the time of the request; kept after a deletion anonymizes the customer"
    },
    { ...schema_PrivacyRequestKind, required: true, name: "kind" },
    { ...schema_PrivacyRequestStatus, required: true, name: "status" },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "exportReady",
      "description": "An export request whose bundle can be downloaded"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "requestedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "completedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "PrivacyRequest"
};
const schema_PrivacyRequestKindInput: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "export",
    "delete",
    "do_not_sell"
  ],
  "ref": "PrivacyRequestKindInput"
};
const schema_PrivacyExportBundle: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "generatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "store",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "id",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "name"
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "customer",
      "additionalProperties": {
        "kind": "primitive",
        "type": "any",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "consents",
      "additionalProperties": {
        "kind": "primitive",
        "type": "any",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "addresses",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "additionalProperties": {
          "kind": "primitive",
          "type": "any",
          "required": false,
          "nullable": false
        }
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "orders",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "additionalProperties": {
          "kind": "primitive",
          "type": "any",
          "required": false,
          "nullable": false
        }
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "wishlistItems",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "additionalProperties": {
          "kind": "primitive",
          "type": "any",
          "required": false,
          "nullable": false
        }
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "privacyRequests",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "additionalProperties": {
          "kind": "primitive",
          "type": "any",
          "required": false,
          "nullable": false
        }
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": false,
      "nullable": false,
      "name": "conversations",
      "description": "Chat conversations with their shopper-visible messages; absent from bundles built before live chat",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "additionalProperties": {
          "kind": "primitive",
          "type": "any",
          "required": false,
          "nullable": false
        }
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": false,
      "nullable": false,
      "name": "helpFeedback",
      "description": "\"Was this helpful?\" votes and comments on help articles cast from the shopper's chat sessions; absent from bundles built before the help centre",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "additionalProperties": {
          "kind": "primitive",
          "type": "any",
          "required": false,
          "nullable": false
        }
      }
    }
  ],
  "ref": "PrivacyExportBundle"
};
const schema_CartLineCustomizationFile: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "Upload id; staff download it at /admin/v1/stores/{storeId}/uploads/{id}",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "filename"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "contentType"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "bytes"
    }
  ],
  "ref": "CartLineCustomizationFile"
};
const schema_CartLineCustomization: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "key"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "label"
    },
    {
      "kind": "oneOf",
      "type": "oneOf",
      "required": true,
      "nullable": false,
      "name": "value",
      "description": "For a file customization: the upload token in shopper payloads, the upload id in staff payloads",
      "variants": [
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": false,
          "constraints": {
            "maxLength": 500
          }
        },
        {
          "kind": "primitive",
          "type": "number",
          "required": false,
          "nullable": false
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": false,
          "nullable": false
        }
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "valueLabel",
      "description": "Option label for selects, the file name for files, null otherwise"
    },
    { ...schema_Money, required: true, name: "priceDelta" },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "leadTimeDeltaDays"
    },
    { ...schema_CartLineCustomizationFile, nullable: true, name: "file", description: "Set for file customizations" }
  ],
  "ref": "CartLineCustomization"
};
const schema_CartLineStone: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "stoneType"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "shape"
    },
    {
      "kind": "primitive",
      "type": "number",
      "required": true,
      "nullable": false,
      "name": "carat"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "color"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "clarity"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "cut"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "lab"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "certificateNumber"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "certificateUrl"
    },
    { ...schema_Money, required: true, name: "price", description: "The chosen diamond's marked-up price for the cart's market" }
  ],
  "ref": "CartLineStone"
};
const schema_CartLine: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "productId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "variantId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "variantTitle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "sku"
    },
    { ...schema_StorefrontMedia, required: true, nullable: true, name: "image" },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "quantity"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "customizations",
      "items": schema_CartLineCustomization
    },
    { ...schema_CartLineStone, required: true, nullable: true, name: "stone", description: "The chosen diamond on a configured line; null for a plain line" },
    { ...schema_Money, required: true, name: "unitPrice", description: "Variant price for the cart's market, plus customization deltas and any chosen stone" },
    { ...schema_Money, required: true, nullable: true, name: "compareAt" },
    { ...schema_Money, required: true, name: "linePrice" },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "available",
      "description": "False when the variant can no longer be bought at this quantity; the line stays so the storefront can explain"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "unavailableReason",
      "enum": [
        "unpublished",
        "not_priced",
        "out_of_stock",
        "unavailable",
        "stone_unavailable"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "fulfillmentMode",
      "enum": [
        "stocked",
        "made_to_order",
        "mixed"
      ]
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "leadTimeDaysMin"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "leadTimeDaysMax"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "requiresDesignApproval"
    }
  ],
  "ref": "CartLine"
};
const schema_DiscountKind: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "code",
    "automatic"
  ],
  "ref": "DiscountKind"
};
const schema_DiscountMethod: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "percentage",
    "fixed_amount",
    "free_shipping"
  ],
  "ref": "DiscountMethod"
};
const schema_DiscountClass: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "order",
    "product",
    "shipping"
  ],
  "ref": "DiscountClass"
};
const schema_DiscountApplication: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "A discount as applied to this cart, checkout or order",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "discountId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "code"
    },
    { ...schema_DiscountKind, required: true, name: "kind" },
    { ...schema_DiscountMethod, required: true, name: "method" },
    {
      "kind": "primitive",
      "type": "number",
      "required": true,
      "nullable": true,
      "name": "percentage"
    },
    { ...schema_DiscountClass, required: true, name: "target" },
    { ...schema_Money, required: true, name: "amount" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "allocations",
      "description": "How the amount is split over lines; empty for shipping",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "lineId",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          { ...schema_Money, required: true, name: "amount" }
        ]
      }
    }
  ],
  "ref": "DiscountApplication"
};
const schema_RejectedCodeReason: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "unknown",
    "inactive",
    "not_started",
    "expired",
    "usage_limit",
    "conditions",
    "does_not_combine",
    "nothing_eligible"
  ],
  "ref": "RejectedCodeReason"
};
const schema_RejectedCode: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "code"
    },
    { ...schema_RejectedCodeReason, required: true, name: "reason" }
  ],
  "ref": "RejectedCode"
};
const schema_Cart: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "Always fully priced by the API; a storefront never computes a price",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "token",
      "description": "Opaque; the storefront keeps it in a cookie or local storage"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "active",
        "converted",
        "abandoned",
        "expired"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "currency",
      "description": "ISO 4217 currency code",
      "example": "USD",
      "constraints": {
        "pattern": "^[A-Z]{3}$"
      }
    },
    { ...schema_StorefrontMarket, required: true, nullable: true, name: "market" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "email"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "customerId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "locale"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "lines",
      "items": schema_CartLine
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "lineCount",
      "description": "Sum of quantities"
    },
    { ...schema_Money, required: true, name: "subtotal" },
    { ...schema_Money, required: true, name: "discount" },
    { ...schema_Money, required: true, name: "total", description: "Subtotal minus discounts; shipping and tax are computed at checkout" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "discountCodes",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "discountApplications",
      "description": "Discounts in effect; shipping discounts appear once a rate is chosen at checkout",
      "items": schema_DiscountApplication
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "rejectedCodes",
      "description": "Applied codes that do not work right now and why",
      "items": schema_RejectedCode
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "attributes",
      "description": "Free-form JSON object for tenant use",
      "additionalProperties": {
        "kind": "primitive",
        "type": "any",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "hasUnavailableLines"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "expiresAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "Cart"
};
const schema_CustomerUpload: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "A file a shopper uploaded for a `file` customization. The bytes are sniffed; the declared Content-Type must match",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "token",
      "description": "Capability for the file: the value of a `file` customization in a cart line, and the key to GET the upload back. Never shown to staff"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "filename"
    },
    { ...schema_CustomerUploadContentType, required: true, name: "contentType" },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "bytes"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "expiresAt",
      "format": "date-time",
      "description": "Until when the upload is kept if no order references it",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "CustomerUpload"
};
const schema_StorefrontRegion: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "code",
      "example": "NY"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name",
      "example": "New York"
    }
  ],
  "ref": "StorefrontRegion"
};
const schema_StorefrontRegions: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "country",
      "description": "ISO 3166-1 alpha-2 country code",
      "example": "US",
      "constraints": {
        "pattern": "^[A-Z]{2}$"
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "label",
      "description": "What the subdivision is called in this country (State, Province, Prefecture); null when the country has no list and region is free text"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "regions",
      "description": "ISO 3166-2 subdivisions; addresses must carry one of these codes. Empty when the country has no list",
      "items": schema_StorefrontRegion
    }
  ],
  "ref": "StorefrontRegions"
};
const schema_PostalAddress: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "firstName",
      "constraints": {
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "lastName",
      "constraints": {
        "minLength": 1,
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "company",
      "constraints": {
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "line1",
      "constraints": {
        "minLength": 1,
        "maxLength": 200
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "line2",
      "constraints": {
        "maxLength": 200
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "city",
      "constraints": {
        "minLength": 1,
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "region",
      "constraints": {
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "postalCode",
      "constraints": {
        "maxLength": 20
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "countryCode",
      "description": "ISO 3166-1 alpha-2 country code",
      "example": "US",
      "constraints": {
        "pattern": "^[A-Z]{2}$"
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "phone",
      "constraints": {
        "maxLength": 40
      }
    }
  ],
  "ref": "PostalAddress"
};
const schema_AvailableShippingRate: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "A rate the checkout may pick, priced in the checkout currency",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name"
    },
    { ...schema_Money, required: true, name: "price" },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "deliveryDaysMin"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "deliveryDaysMax"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "requiresSignature"
    }
  ],
  "ref": "AvailableShippingRate"
};
const schema_TaxLine: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "number",
      "required": true,
      "nullable": false,
      "name": "rate",
      "description": "Fraction, e.g. 0.08875 for 8.875 %",
      "constraints": {
        "minimum": 0,
        "maximum": 1
      }
    },
    { ...schema_Money, required: true, name: "amount" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "jurisdiction",
      "example": "US-NY"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "lineIndex",
      "description": "Index of the line the tax belongs to; null for shipping"
    }
  ],
  "ref": "TaxLine"
};
const schema_GiftCardApplication: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "last4"
    },
    { ...schema_Money, required: true, name: "amount", description: "Part of the total this card covers" }
  ],
  "ref": "GiftCardApplication"
};
const schema_CheckoutBlocker: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "email",
    "shipping_address",
    "shipping_rate",
    "no_shipping_rate",
    "unavailable_lines",
    "empty",
    "terms"
  ],
  "ref": "CheckoutBlocker"
};
const schema_CompletedOrderRef: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "Where a polling client goes once the webhook or the confirm call placed the order",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name",
      "example": "#1001"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "statusToken",
      "description": "Signed token for GET /orders/status/{token}"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "statusUrl",
      "description": "The store's guest order-status link; null when the store has no domain or template"
    }
  ],
  "ref": "CompletedOrderRef"
};
const schema_Checkout: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "One attempt to pay for a cart. Fully priced by the API on every call",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "token"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "cartToken"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "open",
        "awaiting_payment",
        "completed",
        "expired",
        "cancelled"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "currency"
    },
    { ...schema_StorefrontMarket, required: true, nullable: true, name: "market" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "email"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "phone"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "customerId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    { ...schema_PostalAddress, required: true, nullable: true, name: "shippingAddress" },
    { ...schema_PostalAddress, required: true, nullable: true, name: "billingAddress" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "lines",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "productId",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "variantId",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "handle"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "title"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "variantTitle"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "sku"
          },
          { ...schema_StorefrontMedia, required: true, nullable: true, name: "image" },
          {
            "kind": "primitive",
            "type": "integer",
            "required": true,
            "nullable": false,
            "name": "quantity"
          },
          {
            "kind": "array",
            "type": "array",
            "required": true,
            "nullable": false,
            "name": "customizations",
            "items": schema_CartLineCustomization
          },
          { ...schema_CartLineStone, required: true, nullable: true, name: "stone", description: "The chosen diamond on a configured line; null for a plain line" },
          { ...schema_Money, required: true, name: "unitPrice", description: "Variant price for the cart's market, plus customization deltas and any chosen stone" },
          { ...schema_Money, required: true, nullable: true, name: "compareAt" },
          { ...schema_Money, required: true, name: "linePrice" },
          {
            "kind": "enum",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "fulfillmentMode",
            "enum": [
              "stocked",
              "made_to_order",
              "mixed"
            ]
          },
          {
            "kind": "primitive",
            "type": "integer",
            "required": true,
            "nullable": true,
            "name": "leadTimeDaysMin"
          },
          {
            "kind": "primitive",
            "type": "integer",
            "required": true,
            "nullable": true,
            "name": "leadTimeDaysMax"
          },
          {
            "kind": "primitive",
            "type": "boolean",
            "required": true,
            "nullable": false,
            "name": "requiresDesignApproval"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "estimatedShipDateMin",
            "description": "ISO date; lead time plus customization deltas in working days"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "estimatedShipDateMax"
          }
        ]
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "availableShippingRates",
      "description": "Empty until a shipping address is set; empty with an address means no rate serves that country",
      "items": schema_AvailableShippingRate
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "shippingLine",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "rateId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "title"
        },
        { ...schema_Money, required: true, name: "price" }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "paymentFeeLine",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "rateId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "title"
        },
        { ...schema_Money, required: true, name: "price" }
      ],
      "description": "Fee of the chosen manual payment method, when any"
    },
    { ...schema_Money, required: true, name: "subtotal" },
    { ...schema_Money, required: true, name: "discount" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "discountApplications",
      "items": schema_DiscountApplication
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "rejectedCodes",
      "items": schema_RejectedCode
    },
    { ...schema_Money, required: true, name: "shipping" },
    { ...schema_Money, required: true, name: "tax" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "taxLines",
      "description": "Empty while the store charges no tax or the address is unknown",
      "items": schema_TaxLine
    },
    { ...schema_Money, required: true, name: "total" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "giftCardApplications",
      "items": schema_GiftCardApplication
    },
    { ...schema_Money, required: true, name: "amountDue", description: "Total minus the applied gift cards; what the payment method has to collect" },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "requiresDesignApproval"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "estimatedShipDateMin"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "estimatedShipDateMax"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "readyForPayment",
      "description": "Email, shipping address and a shipping rate are set, every line is buyable and the terms are accepted when the store requires it"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "shippingRequired",
      "description": "False when the store has no shipping zones: nothing is charged for shipping and no rate needs choosing"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "blockers",
      "items": schema_CheckoutBlocker
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "acceptsMarketing",
      "description": "The shopper asked for news; a subscribed newsletter row is written when the order is placed"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "termsAcceptedAt",
      "format": "date-time",
      "description": "When the shopper ticked the terms; required before payment when checkout.requireTermsAcceptance is on",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "expiresAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "completedOrderId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    { ...schema_CompletedOrderRef, required: true, nullable: true, name: "completedOrder", description: "Set once status is completed; poll GET /checkouts/{token} after a redirect payment until it appears" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "Checkout"
};
const schema_PostalAddressInput: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "firstName",
      "constraints": {
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "lastName",
      "constraints": {
        "minLength": 1,
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "company",
      "constraints": {
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "line1",
      "constraints": {
        "minLength": 1,
        "maxLength": 200
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "line2",
      "constraints": {
        "maxLength": 200
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "city",
      "constraints": {
        "minLength": 1,
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "region",
      "constraints": {
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "postalCode",
      "constraints": {
        "maxLength": 20
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "countryCode",
      "description": "ISO 3166-1 alpha-2 country code",
      "example": "US",
      "constraints": {
        "pattern": "^[A-Z]{2}$"
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "phone",
      "constraints": {
        "maxLength": 40
      }
    }
  ],
  "ref": "PostalAddressInput"
};
const schema_CheckoutPaymentMethod: SchemaNode = {
  "kind": "oneOf",
  "type": "oneOf",
  "required": false,
  "nullable": false,
  "variants": [
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "type",
          "enum": [
            "stripe"
          ]
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "wallets",
          "items": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "enum": [
              "apple_pay",
              "google_pay"
            ]
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "publishableKey"
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "type",
          "enum": [
            "gift_card"
          ]
        },
        { ...schema_Money, required: true, name: "amount", description: "Covered by the applied gift cards; offered alone when it equals the total" }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "type",
          "enum": [
            "manual"
          ]
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "id",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "key"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "name"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "description"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "instructions",
          "description": "What the shopper has to do after placing the order (bank details, who to pay); also on the placed order"
        },
        { ...schema_Money, required: true, name: "fee" },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "available",
          "description": "False when the checkout total is outside the method's limits"
        }
      ]
    }
  ],
  "ref": "CheckoutPaymentMethod"
};
const schema_PaymentIntentResponse: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "paymentIntentId"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "clientSecret",
      "description": "Mount Stripe's Payment Element with this; never store it"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "publishableKey"
    },
    { ...schema_Money, required: true, name: "amount", description: "What the intent charges: the checkout total minus applied gift cards" },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "captureMethod",
      "description": "manual when a line needs design approval: authorized now, captured on approval",
      "enum": [
        "automatic",
        "manual"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status"
    }
  ],
  "ref": "PaymentIntentResponse"
};
const schema_OrderLabel: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "delayed",
    "confirmation_not_received",
    "review_not_answered",
    "changes_requested"
  ],
  "ref": "OrderLabel"
};
const schema_OrderWorkflowSummary: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "stageKey"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "stageName"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "active",
        "completed",
        "stopped"
      ]
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "labels",
      "items": schema_OrderLabel
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "dueAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "OrderWorkflowSummary"
};
const schema_OrderLineStone: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "The diamond chosen for a configured line, as it was when the order was placed",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "id",
      "format": "uuid",
      "description": "The stone row; null when the stone was removed after the order",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "shape"
    },
    {
      "kind": "primitive",
      "type": "number",
      "required": true,
      "nullable": false,
      "name": "carat"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "color"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "clarity"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "cut"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "certificate",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "lab"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "number"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "url"
        }
      ]
    }
  ],
  "ref": "OrderLineStone"
};
const schema_OrderLine: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "productId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "variantId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "variantTitle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "sku"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "optionValues",
      "additionalProperties": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "customizations",
      "items": schema_CartLineCustomization
    },
    { ...schema_OrderLineStone, required: true, nullable: true, name: "stone" },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "quantity"
    },
    { ...schema_Money, required: true, name: "unitPrice" },
    { ...schema_Money, required: true, name: "discount" },
    { ...schema_Money, required: true, name: "tax" },
    { ...schema_Money, required: true, name: "total" },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "fulfillmentMode",
      "enum": [
        "stocked",
        "made_to_order",
        "mixed"
      ]
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "leadTimeDaysMin"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "leadTimeDaysMax"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "requiresDesignApproval"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "fulfilledQuantity"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "cancelledQuantity"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "mediaUrl"
    }
  ],
  "ref": "OrderLine"
};
const schema_OrderPayment: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "provider",
      "enum": [
        "stripe",
        "cod",
        "manual"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "pending",
        "requires_action",
        "authorized",
        "captured",
        "failed",
        "cancelled"
      ]
    },
    { ...schema_Money, required: true, name: "amount" },
    { ...schema_Money, required: true, name: "amountCaptured" },
    { ...schema_Money, required: true, name: "amountRefunded" },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "methodSnapshot",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "id",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "key"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "name"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "description"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "instructions"
        },
        { ...schema_Money, required: true, name: "fee" }
      ],
      "description": "Manual method as shown to the shopper at checkout"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "manualReference"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "providerPaymentIntentId"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "card",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "brand"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "last4"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "wallet"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "funding"
        }
      ],
      "description": "Sanitized payment method details from the provider; null for manual payments"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "failure",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "code"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "message"
        }
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "capturedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "createdAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "OrderPayment"
};
const schema_FulfillmentState: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "pending",
    "shipped",
    "delivered",
    "cancelled"
  ],
  "ref": "FulfillmentState"
};
const schema_OrderFulfillment: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    { ...schema_FulfillmentState, required: true, name: "status" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "locationId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "carrier"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "trackingNumber"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "trackingUrl"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "shippedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "deliveredAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "note",
      "description": "Staff only; never in storefront responses"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "lines",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "orderLineId",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "primitive",
            "type": "integer",
            "required": true,
            "nullable": false,
            "name": "quantity"
          }
        ]
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "createdAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "OrderFulfillment"
};
const schema_OrderRefund: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "paymentId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "kind",
      "enum": [
        "provider",
        "manual",
        "gift_card"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "pending",
        "succeeded",
        "failed"
      ]
    },
    { ...schema_Money, required: true, name: "amount" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "reason"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "note",
      "description": "Staff only; never in storefront responses"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "restock"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "lines",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "orderLineId",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "primitive",
            "type": "integer",
            "required": true,
            "nullable": false,
            "name": "quantity"
          },
          { ...schema_Money, required: true, name: "amount" }
        ]
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "processedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "createdAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "OrderRefund"
};
const schema_ReturnStatus: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "requested",
    "approved",
    "rejected",
    "in_transit",
    "received",
    "inspected",
    "resolved",
    "cancelled"
  ],
  "ref": "ReturnStatus"
};
const schema_ReturnResolution: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "refund",
    "store_credit",
    "exchange",
    "repair",
    "resize"
  ],
  "ref": "ReturnResolution"
};
const schema_ReturnLineCondition: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "unopened",
    "good",
    "damaged"
  ],
  "ref": "ReturnLineCondition"
};
const schema_ReturnLine: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "orderLineId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "quantity"
    },
    { ...schema_ReturnLineCondition, required: true, nullable: true, name: "condition", description: "Recorded at inspection" },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "restock"
    }
  ],
  "ref": "ReturnLine"
};
const schema_Return: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "orderId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "orderName",
      "example": "#1001"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "rmaNumber",
      "example": "RMA-1001"
    },
    { ...schema_ReturnStatus, required: true, name: "status" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "reason"
    },
    { ...schema_ReturnResolution, required: true, nullable: true, name: "resolution", description: "Preset to resize for resize requests, otherwise decided at resolution" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "customerNote"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "staffNote",
      "description": "Staff only; never in storefront responses"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "returnShippingPaidBy",
      "enum": [
        "customer",
        "store"
      ]
    },
    { ...schema_Money, required: true, name: "restockingFee" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "refundId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "lines",
      "items": schema_ReturnLine
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "requestedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "resolvedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "Return"
};
const schema_OrderEvent: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "kind",
      "example": "placed"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "message"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "data",
      "additionalProperties": {
        "kind": "primitive",
        "type": "any",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "actorType"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "visibleToCustomer"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "createdAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "OrderEvent"
};
const schema_OrderProgressStep: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "state",
      "enum": [
        "done",
        "current",
        "upcoming",
        "skipped"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "completedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "OrderProgressStep"
};
const schema_PlacedOrder: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "number"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name",
      "example": "#1001"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "email",
      "description": "Null for a walk-in draft completed without an email; no shopper emails go out"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "customerId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "open",
        "completed",
        "cancelled",
        "archived"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "financialStatus",
      "enum": [
        "pending",
        "authorized",
        "paid",
        "partially_paid",
        "partially_refunded",
        "refunded",
        "voided",
        "cod_pending",
        "unpaid"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "fulfillmentStatus",
      "enum": [
        "unfulfilled",
        "partially_fulfilled",
        "fulfilled",
        "on_hold",
        "in_production"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "approvalStatus",
      "enum": [
        "awaiting_design",
        "design_sent",
        "approved",
        "changes_requested"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "currency"
    },
    { ...schema_Money, required: true, name: "total" },
    { ...schema_Money, required: true, name: "paid" },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "paymentMethod",
      "enum": [
        "card",
        "wallet",
        "cod",
        "gift_card_only",
        "manual",
        "auction"
      ]
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "lineCount"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "placedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "estimatedShipDateMin"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "estimatedShipDateMax"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "tags",
      "description": "Staff only; always empty in storefront responses",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    { ...schema_OrderWorkflowSummary, required: true, nullable: true, name: "workflow", description: "Staff responses only: the production stage the order is at and its labels; null before payment and on storefront responses" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "phone"
    },
    { ...schema_PostalAddress, required: true, nullable: true, name: "shippingAddress" },
    { ...schema_PostalAddress, required: true, nullable: true, name: "billingAddress" },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "shippingMethod",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "rateId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "title"
        },
        { ...schema_Money, required: true, name: "price" }
      ]
    },
    { ...schema_Money, required: true, name: "subtotal" },
    { ...schema_Money, required: true, name: "discount" },
    { ...schema_Money, required: true, name: "shipping" },
    { ...schema_Money, required: true, name: "tax" },
    { ...schema_Money, required: true, name: "refunded" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "lines",
      "items": schema_OrderLine
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "payments",
      "items": schema_OrderPayment
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "giftCardApplications",
      "description": "Gift cards redeemed at placement",
      "items": schema_GiftCardApplication
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "discountCodes",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "discountApplications",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "title"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "code"
          },
          { ...schema_DiscountMethod, required: true, name: "method" },
          {
            "kind": "primitive",
            "type": "number",
            "required": true,
            "nullable": true,
            "name": "percentage"
          },
          { ...schema_DiscountClass, required: true, name: "target" },
          { ...schema_Money, required: true, name: "amount" },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "discountId",
            "format": "uuid",
            "description": "Null for a manual discount typed on a draft order",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "enum",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "kind",
            "enum": [
              "code",
              "automatic",
              "manual"
            ]
          },
          {
            "kind": "array",
            "type": "array",
            "required": true,
            "nullable": false,
            "name": "allocations",
            "items": {
              "kind": "object",
              "type": "object",
              "required": false,
              "nullable": false,
              "properties": [
                {
                  "kind": "primitive",
                  "type": "string",
                  "required": true,
                  "nullable": false,
                  "name": "orderLineId",
                  "format": "uuid",
                  "description": "UUID v7",
                  "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
                },
                { ...schema_Money, required: true, name: "amount" }
              ]
            }
          }
        ]
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "taxLines",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "title"
          },
          {
            "kind": "primitive",
            "type": "number",
            "required": true,
            "nullable": false,
            "name": "rate",
            "description": "Fraction, e.g. 0.08875 for 8.875 %",
            "constraints": {
              "minimum": 0,
              "maximum": 1
            }
          },
          { ...schema_Money, required: true, name: "amount" },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "jurisdiction",
            "example": "US-NY"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "orderLineId",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          }
        ]
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "fulfillments",
      "items": schema_OrderFulfillment
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "refunds",
      "items": schema_OrderRefund
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "returns",
      "items": schema_Return
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "events",
      "description": "Timeline; storefront responses only include events visible to the customer",
      "items": schema_OrderEvent
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "note"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "staffNotes",
      "description": "Staff only; never in storefront responses"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "termsAcceptedAt",
      "format": "date-time",
      "description": "When the shopper ticked the terms at checkout; null for orders placed without the checkbox",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "cancelledAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "cancelReason"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "paymentInstructions",
      "description": "Instructions of the manual method while the order is unpaid"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "auction",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "id",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        { ...schema_Money, required: true, name: "hammerPrice" },
        { ...schema_Money, required: true, name: "buyerPremium" }
      ],
      "description": "Set on the order placed for a won auction lot: the winning bid and the buyer's premium added to it"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "progress",
      "description": "Production stages the shopper may see, in order; empty before the order is paid",
      "items": schema_OrderProgressStep
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "returnWindow",
      "description": "What POST /customers/me/orders/{id}/returns would accept right now, so a client never mirrors the rule",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "closesAt",
          "format": "date-time",
          "description": "Latest shipment plus the store's returns.windowDays; null while nothing shipped or the store takes no online returns",
          "example": "2026-09-27T10:15:30.000Z"
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "eligible",
          "description": "The window is open and at least one line has returnable units"
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "lines",
          "items": {
            "kind": "object",
            "type": "object",
            "required": false,
            "nullable": false,
            "properties": [
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": false,
                "name": "lineId",
                "format": "uuid",
                "description": "UUID v7",
                "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
              },
              {
                "kind": "primitive",
                "type": "integer",
                "required": true,
                "nullable": false,
                "name": "returnableQuantity",
                "description": "Shipped units not already inside a live or resolved return"
              }
            ]
          }
        }
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "statusToken",
      "description": "Signed token for GET /orders/status/{token}; a storefront without a domain builds its own status link from it"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "statusUrl",
      "description": "Signed guest order-status link (the store's template or https://{primaryDomain}/orders/status/{token}); null when the store has neither"
    }
  ],
  "ref": "PlacedOrder"
};
const schema_PaymentIntentCompleted: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "The checkout's current intent had already been paid for the amount due, so the order was placed instead of a new intent being issued",
  "properties": [
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "completed"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "orderId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    { ...schema_PlacedOrder, required: true, name: "order" }
  ],
  "ref": "PaymentIntentCompleted"
};
const schema_StartPaymentRequest: SchemaNode = {
  "kind": "oneOf",
  "type": "oneOf",
  "required": false,
  "nullable": false,
  "variants": [
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "type",
          "enum": [
            "stripe"
          ]
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "paymentIntentId",
          "description": "The intent from POST /checkouts/{token}/payment-intent, after the Payment Element confirmed it",
          "constraints": {
            "minLength": 1,
            "maxLength": 200
          }
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "type",
          "enum": [
            "manual"
          ]
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "manualPaymentMethodId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "description": "Only when the applied gift cards cover the whole total",
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "type",
          "enum": [
            "gift_card"
          ]
        }
      ]
    }
  ],
  "ref": "StartPaymentRequest"
};
const schema_NewsletterReceived: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "Always the same answer, whether the address was new, pending or already subscribed",
  "properties": [
    {
      "kind": "enum",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "received",
      "enum": [
        true
      ]
    }
  ],
  "ref": "NewsletterReceived"
};
const schema_NewsletterStatus: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "pending",
    "subscribed",
    "unsubscribed"
  ],
  "ref": "NewsletterStatus"
};
const schema_NewsletterSubscription: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "email"
    },
    { ...schema_NewsletterStatus, required: true, name: "status" }
  ],
  "ref": "NewsletterSubscription"
};
const schema_StorefrontAuctionLot: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "storeProductId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "variantId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "variantTitle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "imageUrl"
    }
  ],
  "ref": "StorefrontAuctionLot"
};
const schema_AuctionEstimate: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_Money, required: true, name: "low" },
    { ...schema_Money, required: true, name: "high" }
  ],
  "ref": "AuctionEstimate"
};
const schema_AuctionBadge: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "description": "authenticated: authentication.status is not none; papers_match: authenticated and the papers are present; full_set: box and papers; no_reserve: the lot sells to the highest bid whatever it is",
  "enum": [
    "authenticated",
    "papers_match",
    "full_set",
    "no_reserve"
  ],
  "ref": "AuctionBadge"
};
const schema_StorefrontAuctionSummary: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "scheduled",
        "live",
        "ended",
        "cancelled"
      ]
    },
    { ...schema_StorefrontAuctionLot, required: true, name: "lot" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "startsAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "endsAt",
      "format": "date-time",
      "description": "Moves later when a late bid triggers anti-sniping; count down against serverTime, never the device clock",
      "example": "2026-09-27T10:15:30.000Z"
    },
    { ...schema_Money, required: true, name: "startingPrice" },
    { ...schema_Money, required: true, nullable: true, name: "currentPrice", description: "Null until the first bid" },
    { ...schema_Money, required: true, name: "nextMinimumBid", description: "The lowest amount (or maximum) a new bid may name" },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "bidCount"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "bidderCount"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "hasReserve"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "reserveMet",
      "description": "The reserve amount itself is never shown"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "buyerPremiumBps"
    },
    { ...schema_Money, required: true, nullable: true, name: "buyNowPrice", description: "Present only while buy now is available: live, before the first bid (or before the reserve is met)" },
    { ...schema_AuctionEstimate, required: true, nullable: true, name: "estimate", description: "The house estimate, store currency; null when the lot has none" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "conditionGrade",
      "description": "A key of the store's auctions.conditionScale (GET /store), whose label is the wording to show"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "badges",
      "items": schema_AuctionBadge
    },
    { ...schema_Money, required: true, nullable: true, name: "approximatePrice", description: "The current price (else the starting price) converted to the shopper's market currency at the platform rate, for display only; bids stay in the store currency. Null in the store currency or without a rate" },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "sale",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "id",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "handle"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "title"
        },
        {
          "kind": "primitive",
          "type": "integer",
          "required": true,
          "nullable": false,
          "name": "lotNumber"
        }
      ],
      "description": "The sale this lot belongs to (GET /sales/{handle}); null for a standalone lot"
    }
  ],
  "ref": "StorefrontAuctionSummary"
};
const schema_AuctionTerms: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "version",
      "description": "Send this back on register; it changes whenever the text changes"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "bodyHtml"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "source",
      "description": "store: the store's published auction policy; default: Nucleus's standard terms",
      "enum": [
        "default",
        "store"
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "registration",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "termsVersion"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "acceptedAt",
          "format": "date-time",
          "description": "ISO 8601 timestamp in UTC",
          "example": "2026-09-27T10:15:30.000Z"
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "blocked"
        }
      ],
      "description": "The signed-in shopper's registration; null without X-Customer-Token or before registering"
    }
  ],
  "ref": "AuctionTerms"
};
const schema_AuctionRegistrationStatus: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "termsVersion"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "acceptedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "blocked"
    }
  ],
  "ref": "AuctionRegistrationStatus"
};
const schema_AuctionAuthenticationStatus: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "description": "none: not authenticated; house_expert: checked by the store's own specialist; third_party: a lab, grader or brand service issued a report",
  "enum": [
    "none",
    "house_expert",
    "third_party"
  ],
  "ref": "AuctionAuthenticationStatus"
};
const schema_AuctionAuthentication: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_AuctionAuthenticationStatus, required: true, name: "status" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "by"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "at"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "certificateNumber"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "certificateMediaId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "notes"
    }
  ],
  "ref": "AuctionAuthentication"
};
const schema_AuctionProvenanceEntry: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "period"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "source"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "note"
    }
  ],
  "ref": "AuctionProvenanceEntry"
};
const schema_AuctionAccessories: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "box"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "papers"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "warrantyCard"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "tags"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "dustBag"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "receipt"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "extras",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    }
  ],
  "ref": "AuctionAccessories"
};
const schema_AuctionLotDetails: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_Money, required: true, nullable: true, name: "estimateLow" },
    { ...schema_Money, required: true, nullable: true, name: "estimateHigh" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "conditionGrade",
      "description": "The key; conditionLabel is the store's wording for it"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "conditionLabel"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "conditionReport"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "conditionMediaIds",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false,
        "format": "uuid",
        "description": "UUID v7",
        "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
      }
    },
    { ...schema_AuctionAuthentication, required: true, nullable: true, name: "authentication" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "provenance",
      "items": schema_AuctionProvenanceEntry
    },
    { ...schema_AuctionAccessories, required: true, nullable: true, name: "accessories" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "serviceHistory"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "essay"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "literature"
    }
  ],
  "ref": "AuctionLotDetails"
};
const schema_AuctionBidKind: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "description": "bid: a single amount the shopper placed; max: a proxy maximum the shopper set (the row shows the price it reached); proxy: an automatic bid Nucleus placed for a shopper's maximum; raise: the leader raised their own maximum, which moves nothing public and is never shown on the storefront; buy_now: the shopper bought the lot at the buy-now price, which ended the auction",
  "enum": [
    "bid",
    "max",
    "proxy",
    "raise",
    "buy_now"
  ],
  "ref": "AuctionBidKind"
};
const schema_AuctionViewerState: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "none",
    "leading",
    "outbid",
    "won",
    "lost"
  ],
  "ref": "AuctionViewerState"
};
const schema_StorefrontAuction: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "scheduled",
        "live",
        "ended",
        "cancelled"
      ]
    },
    { ...schema_StorefrontAuctionLot, required: true, name: "lot" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "startsAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "endsAt",
      "format": "date-time",
      "description": "Moves later when a late bid triggers anti-sniping; count down against serverTime, never the device clock",
      "example": "2026-09-27T10:15:30.000Z"
    },
    { ...schema_Money, required: true, name: "startingPrice" },
    { ...schema_Money, required: true, nullable: true, name: "currentPrice", description: "Null until the first bid" },
    { ...schema_Money, required: true, name: "nextMinimumBid", description: "The lowest amount (or maximum) a new bid may name" },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "bidCount"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "bidderCount"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "hasReserve"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "reserveMet",
      "description": "The reserve amount itself is never shown"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "buyerPremiumBps"
    },
    { ...schema_Money, required: true, nullable: true, name: "buyNowPrice", description: "Present only while buy now is available: live, before the first bid (or before the reserve is met)" },
    { ...schema_AuctionEstimate, required: true, nullable: true, name: "estimate", description: "The house estimate, store currency; null when the lot has none" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "conditionGrade",
      "description": "A key of the store's auctions.conditionScale (GET /store), whose label is the wording to show"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "badges",
      "items": schema_AuctionBadge
    },
    { ...schema_Money, required: true, nullable: true, name: "approximatePrice", description: "The current price (else the starting price) converted to the shopper's market currency at the platform rate, for display only; bids stay in the store currency. Null in the store currency or without a rate" },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "sale",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "id",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "handle"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "title"
        },
        {
          "kind": "primitive",
          "type": "integer",
          "required": true,
          "nullable": false,
          "name": "lotNumber"
        }
      ],
      "description": "The sale this lot belongs to (GET /sales/{handle}); null for a standalone lot"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "serverTime",
      "format": "date-time",
      "description": "The server clock when this response was built",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "antiSnipeMinutes"
    },
    { ...schema_AuctionLotDetails, required: true, name: "details" },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "outcome",
      "enum": [
        "sold",
        "no_sale"
      ]
    },
    { ...schema_Money, required: true, nullable: true, name: "hammerPrice", description: "The winning price once sold" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "recentBids",
      "description": "The latest 10 standing bids, newest first",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "bidderLabel",
            "description": "Stable per auction; real names are never shown",
            "example": "Bidder 4"
          },
          { ...schema_Money, required: true, name: "amount" },
          { ...schema_AuctionBidKind, required: true, name: "kind" },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "createdAt",
            "format": "date-time",
            "description": "ISO 8601 timestamp in UTC",
            "example": "2026-09-27T10:15:30.000Z"
          }
        ]
      }
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "viewer",
      "properties": [
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "registered"
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "blocked"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "bidderLabel"
        },
        { ...schema_AuctionViewerState, required: true, name: "state" },
        { ...schema_Money, required: true, nullable: true, name: "maxAmount", description: "The shopper's own highest maximum; only they see it" },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "watching",
          "description": "Whether the shopper watches the lot"
        }
      ],
      "description": "Present with X-Customer-Token"
    }
  ],
  "ref": "StorefrontAuction"
};
const schema_PlaceBidResponse: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_StorefrontAuction, required: true, name: "auction" },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "bid",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "id",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        { ...schema_AuctionBidKind, required: true, name: "kind" },
        { ...schema_Money, required: true, name: "amount" },
        { ...schema_Money, required: true, nullable: true, name: "maxAmount" }
      ]
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "leading",
      "description": "Whether the shopper leads after the bid"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "extended",
      "description": "Whether the bid extended the end time"
    }
  ],
  "ref": "PlaceBidResponse"
};
const schema_MyAuctionState: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "leading",
    "outbid",
    "won",
    "lost",
    "reserve_not_met",
    "cancelled"
  ],
  "ref": "MyAuctionState"
};
const schema_MyAuction: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_StorefrontAuctionSummary, required: true, name: "auction" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "bidderLabel"
    },
    { ...schema_MyAuctionState, required: true, name: "state" },
    { ...schema_Money, required: true, name: "myHighestBid" },
    { ...schema_Money, required: true, nullable: true, name: "myMaxAmount" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "orderId",
      "format": "uuid",
      "description": "The order for a won lot",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "lastBidAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "MyAuction"
};
const schema_BuyNowResponse: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_StorefrontAuction, required: true, name: "auction" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "orderId",
      "format": "uuid",
      "description": "The shopper's order, placed unpaid like a won lot",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    }
  ],
  "ref": "BuyNowResponse"
};
const schema_AuctionWatch: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "auctionId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "watching"
    }
  ],
  "ref": "AuctionWatch"
};
const schema_WatchedAuction: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_StorefrontAuctionSummary, required: true, name: "auction" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "watchedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "WatchedAuction"
};
const schema_AuctionOfferStatus: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "pending",
    "accepted",
    "declined",
    "expired",
    "withdrawn"
  ],
  "ref": "AuctionOfferStatus"
};
const schema_StorefrontAuctionOffer: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_AuctionOfferStatus, required: true, name: "status" },
    { ...schema_StorefrontAuctionLot, required: true, name: "lot" },
    { ...schema_Money, required: true, name: "amount" },
    { ...schema_Money, required: true, nullable: true, name: "buyerPremium" },
    { ...schema_Money, required: true, name: "total" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "expiresAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "orderId",
      "format": "uuid",
      "description": "Set once accepted",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    }
  ],
  "ref": "StorefrontAuctionOffer"
};
const schema_AuctionSocketTicket: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "Opens the auction WebSocket: browsers cannot send headers on a handshake, so the socket authenticates with this ticket",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "ticket",
      "description": "Single use, valid for 30 seconds"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "url",
      "description": "wss:// URL with the ticket in the query string; open it before expiresAt"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "expiresAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "AuctionSocketTicket"
};
const schema_StorefrontAuctionSaleSummary: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "subtitle"
    },
    { ...schema_StorefrontMedia, required: true, nullable: true, name: "cover" },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "scheduled",
        "live",
        "ended"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "startsAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "firstCloseAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "lastCloseAt",
      "format": "date-time",
      "description": "The last lot's scheduled close; anti-sniping may move single lots later",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "lotIntervalSeconds"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "lotCount"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "soldCount"
    },
    { ...schema_Money, required: true, nullable: true, name: "hammerTotal", description: "Once the sale ended: the hammer prices of its sold lots" },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "buyerPremiumBps"
    }
  ],
  "ref": "StorefrontAuctionSaleSummary"
};
const schema_StorefrontAuctionSale: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "subtitle"
    },
    { ...schema_StorefrontMedia, required: true, nullable: true, name: "cover" },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "scheduled",
        "live",
        "ended"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "startsAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "firstCloseAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "lastCloseAt",
      "format": "date-time",
      "description": "The last lot's scheduled close; anti-sniping may move single lots later",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "lotIntervalSeconds"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "lotCount"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "soldCount"
    },
    { ...schema_Money, required: true, nullable: true, name: "hammerTotal", description: "Once the sale ended: the hammer prices of its sold lots" },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "buyerPremiumBps"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "essay"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "viewing"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "lots",
      "description": "Every lot in lot number order; a sale has tens of lots, not thousands",
      "items": schema_StorefrontAuctionSummary
    },
    { ...schema_ResolvedSeo, required: true, name: "seo" },
    { ...schema_JsonLd, required: true, name: "jsonld" }
  ],
  "ref": "StorefrontAuctionSale"
};
const schema_StorefrontAuctionSaleResult: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "lotNumber"
    },
    { ...schema_StorefrontAuctionSummary, required: true, name: "auction" },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "outcome",
      "description": "open while the lot is still scheduled or live",
      "enum": [
        "sold",
        "no_sale",
        "cancelled",
        "open"
      ]
    },
    { ...schema_Money, required: true, nullable: true, name: "hammerPrice" }
  ],
  "ref": "StorefrontAuctionSaleResult"
};
const schema_StorefrontAuctionQuestion: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "auctionId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "askerLabel",
      "description": "\"Bidder N\" when the asker has bid on the lot, else \"A bidder\""
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "question"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "answer"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "answeredAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "createdAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "StorefrontAuctionQuestion"
};
const schema_AuctionQuestionStatus: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "pending",
    "answered",
    "hidden"
  ],
  "ref": "AuctionQuestionStatus"
};
const schema_MyAuctionQuestion: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "lot",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "auctionId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "handle"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "title"
        }
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "question"
    },
    { ...schema_AuctionQuestionStatus, required: true, name: "status", description: "hidden questions read as pending to the asker" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "answer"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "answeredAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "createdAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "MyAuctionQuestion"
};
const schema_PushDevice: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "host",
      "description": "The push service the browser registered with; the endpoint itself is a credential and never leaves the server",
      "example": "fcm.googleapis.com"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "userAgent"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "lastSuccessAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "createdAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "PushDevice"
};
const schema_PushSettings: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "publicKey",
      "description": "VAPID public key: pass it as applicationServerKey to PushManager.subscribe"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "delivery",
      "description": "push: messages reach the device; log: this server records them instead (development)",
      "enum": [
        "push",
        "log"
      ]
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "devices",
      "description": "The member's devices, newest first",
      "items": schema_PushDevice
    }
  ],
  "ref": "PushSettings"
};
const schema_Order: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "number"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name",
      "example": "#1001"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "email",
      "description": "Null for a walk-in draft completed without an email; no shopper emails go out"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "customerId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "open",
        "completed",
        "cancelled",
        "archived"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "financialStatus",
      "enum": [
        "pending",
        "authorized",
        "paid",
        "partially_paid",
        "partially_refunded",
        "refunded",
        "voided",
        "cod_pending",
        "unpaid"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "fulfillmentStatus",
      "enum": [
        "unfulfilled",
        "partially_fulfilled",
        "fulfilled",
        "on_hold",
        "in_production"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "approvalStatus",
      "enum": [
        "awaiting_design",
        "design_sent",
        "approved",
        "changes_requested"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "currency"
    },
    { ...schema_Money, required: true, name: "total" },
    { ...schema_Money, required: true, name: "paid" },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "paymentMethod",
      "enum": [
        "card",
        "wallet",
        "cod",
        "gift_card_only",
        "manual",
        "auction"
      ]
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "lineCount"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "placedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "estimatedShipDateMin"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "estimatedShipDateMax"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "tags",
      "description": "Staff only; always empty in storefront responses",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    { ...schema_OrderWorkflowSummary, required: true, nullable: true, name: "workflow", description: "Staff responses only: the production stage the order is at and its labels; null before payment and on storefront responses" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "phone"
    },
    { ...schema_PostalAddress, required: true, nullable: true, name: "shippingAddress" },
    { ...schema_PostalAddress, required: true, nullable: true, name: "billingAddress" },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "shippingMethod",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "rateId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "title"
        },
        { ...schema_Money, required: true, name: "price" }
      ]
    },
    { ...schema_Money, required: true, name: "subtotal" },
    { ...schema_Money, required: true, name: "discount" },
    { ...schema_Money, required: true, name: "shipping" },
    { ...schema_Money, required: true, name: "tax" },
    { ...schema_Money, required: true, name: "refunded" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "lines",
      "items": schema_OrderLine
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "payments",
      "items": schema_OrderPayment
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "giftCardApplications",
      "description": "Gift cards redeemed at placement",
      "items": schema_GiftCardApplication
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "discountCodes",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "discountApplications",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "title"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "code"
          },
          { ...schema_DiscountMethod, required: true, name: "method" },
          {
            "kind": "primitive",
            "type": "number",
            "required": true,
            "nullable": true,
            "name": "percentage"
          },
          { ...schema_DiscountClass, required: true, name: "target" },
          { ...schema_Money, required: true, name: "amount" },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "discountId",
            "format": "uuid",
            "description": "Null for a manual discount typed on a draft order",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "enum",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "kind",
            "enum": [
              "code",
              "automatic",
              "manual"
            ]
          },
          {
            "kind": "array",
            "type": "array",
            "required": true,
            "nullable": false,
            "name": "allocations",
            "items": {
              "kind": "object",
              "type": "object",
              "required": false,
              "nullable": false,
              "properties": [
                {
                  "kind": "primitive",
                  "type": "string",
                  "required": true,
                  "nullable": false,
                  "name": "orderLineId",
                  "format": "uuid",
                  "description": "UUID v7",
                  "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
                },
                { ...schema_Money, required: true, name: "amount" }
              ]
            }
          }
        ]
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "taxLines",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "title"
          },
          {
            "kind": "primitive",
            "type": "number",
            "required": true,
            "nullable": false,
            "name": "rate",
            "description": "Fraction, e.g. 0.08875 for 8.875 %",
            "constraints": {
              "minimum": 0,
              "maximum": 1
            }
          },
          { ...schema_Money, required: true, name: "amount" },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "jurisdiction",
            "example": "US-NY"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "orderLineId",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          }
        ]
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "fulfillments",
      "items": schema_OrderFulfillment
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "refunds",
      "items": schema_OrderRefund
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "returns",
      "items": schema_Return
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "events",
      "description": "Timeline; storefront responses only include events visible to the customer",
      "items": schema_OrderEvent
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "note"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "staffNotes",
      "description": "Staff only; never in storefront responses"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "termsAcceptedAt",
      "format": "date-time",
      "description": "When the shopper ticked the terms at checkout; null for orders placed without the checkbox",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "cancelledAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "cancelReason"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "paymentInstructions",
      "description": "Instructions of the manual method while the order is unpaid"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "auction",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "id",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        { ...schema_Money, required: true, name: "hammerPrice" },
        { ...schema_Money, required: true, name: "buyerPremium" }
      ],
      "description": "Set on the order placed for a won auction lot: the winning bid and the buyer's premium added to it"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "progress",
      "description": "Production stages the shopper may see, in order; empty before the order is paid",
      "items": schema_OrderProgressStep
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "returnWindow",
      "description": "What POST /customers/me/orders/{id}/returns would accept right now, so a client never mirrors the rule",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "closesAt",
          "format": "date-time",
          "description": "Latest shipment plus the store's returns.windowDays; null while nothing shipped or the store takes no online returns",
          "example": "2026-09-27T10:15:30.000Z"
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "eligible",
          "description": "The window is open and at least one line has returnable units"
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "lines",
          "items": {
            "kind": "object",
            "type": "object",
            "required": false,
            "nullable": false,
            "properties": [
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": false,
                "name": "lineId",
                "format": "uuid",
                "description": "UUID v7",
                "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
              },
              {
                "kind": "primitive",
                "type": "integer",
                "required": true,
                "nullable": false,
                "name": "returnableQuantity",
                "description": "Shipped units not already inside a live or resolved return"
              }
            ]
          }
        }
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "Order"
};
const schema_OrderSummary: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "number"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name",
      "example": "#1001"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "email",
      "description": "Null for a walk-in draft completed without an email; no shopper emails go out"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "customerId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "open",
        "completed",
        "cancelled",
        "archived"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "financialStatus",
      "enum": [
        "pending",
        "authorized",
        "paid",
        "partially_paid",
        "partially_refunded",
        "refunded",
        "voided",
        "cod_pending",
        "unpaid"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "fulfillmentStatus",
      "enum": [
        "unfulfilled",
        "partially_fulfilled",
        "fulfilled",
        "on_hold",
        "in_production"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "approvalStatus",
      "enum": [
        "awaiting_design",
        "design_sent",
        "approved",
        "changes_requested"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "currency"
    },
    { ...schema_Money, required: true, name: "total" },
    { ...schema_Money, required: true, name: "paid" },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "paymentMethod",
      "enum": [
        "card",
        "wallet",
        "cod",
        "gift_card_only",
        "manual",
        "auction"
      ]
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "lineCount"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "placedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "estimatedShipDateMin"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "estimatedShipDateMax"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "tags",
      "description": "Staff responses only; empty on storefront responses",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    { ...schema_OrderWorkflowSummary, required: true, nullable: true, name: "workflow", description: "Staff responses only: the production stage the order is at and its labels; null before payment and on storefront responses" }
  ],
  "ref": "OrderSummary"
};
const schema_ReorderResult: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_Cart, required: true, name: "cart" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "skipped",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "orderLineId",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "title"
          },
          {
            "kind": "enum",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "reason",
            "enum": [
              "not_for_sale",
              "invalid_customizations",
              "variant_gone"
            ]
          }
        ]
      }
    }
  ],
  "ref": "ReorderResult"
};
const schema_DesignApproval: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "orderId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "orderName"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "approvalStatus",
      "enum": [
        "awaiting_design",
        "design_sent",
        "approved",
        "changes_requested"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "state",
      "description": "open: this design awaits the answer; answered: approved or changes requested on this design; closed: the order is no longer open",
      "enum": [
        "open",
        "answered",
        "closed"
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "design",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "mediaId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "url"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "mimeType"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "alt"
        }
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "message"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "sentAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "expiresAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "response",
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "decision",
          "enum": [
            "approve",
            "request_changes"
          ]
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "message"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "respondedAt",
          "format": "date-time",
          "description": "ISO 8601 timestamp in UTC",
          "example": "2026-09-27T10:15:30.000Z"
        }
      ]
    }
  ],
  "ref": "DesignApproval"
};
const schema_WorkflowFile: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "mediaId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "url"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "mimeType"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "bytes"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "alt"
    }
  ],
  "ref": "WorkflowFile"
};
const schema_CustomerResponse: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "action",
      "enum": [
        "confirm",
        "approve",
        "request_changes"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "message"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "respondedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "CustomerResponse"
};
const schema_WorkflowAction: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "orderId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "orderName"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "stage",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "key"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "name"
        },
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "type",
          "enum": [
            "customer_confirmation",
            "customer_review"
          ]
        }
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "state",
      "description": "open: waiting for the answer; answered: this link was answered; closed: the time limit passed or staff closed it",
      "enum": [
        "open",
        "answered",
        "closed"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "outcome"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "attempt"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "respondBy",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "message"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "files",
      "description": "Review: the video and images to approve",
      "items": schema_WorkflowFile
    },
    { ...schema_CustomerResponse, required: true, nullable: true, name: "response" },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "lines",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "title"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "variantTitle"
          },
          {
            "kind": "primitive",
            "type": "integer",
            "required": true,
            "nullable": false,
            "name": "quantity"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "mediaUrl"
          },
          {
            "kind": "array",
            "type": "array",
            "required": true,
            "nullable": false,
            "name": "customizations",
            "items": {
              "kind": "object",
              "type": "object",
              "required": false,
              "nullable": false,
              "properties": [
                {
                  "kind": "primitive",
                  "type": "string",
                  "required": true,
                  "nullable": false,
                  "name": "label"
                },
                {
                  "kind": "primitive",
                  "type": "string",
                  "required": true,
                  "nullable": false,
                  "name": "value"
                }
              ]
            }
          }
        ]
      }
    },
    { ...schema_Money, required: true, name: "total" }
  ],
  "ref": "WorkflowAction"
};
const schema_ChatTriggerCondition: SchemaNode = {
  "kind": "oneOf",
  "type": "oneOf",
  "required": false,
  "nullable": false,
  "description": "One fact about the shopper. url, referrer, timeOnPageSeconds, timeOnSiteSeconds, pageViews (this visit), cart*, viewingProduct*, exitIntent and checkoutStep come from the storefront. visits, previousChats, isCustomer, hasOrderInProduction, country, region and city are the visitor's (the API re-checks them, and geo is never trusted from the browser). hourOfDay (0-23) and dayOfWeek are in the store's chat timezone. agentsOnline is true when the chat status is online. A fact that is not known makes its condition false",
  "variants": [
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "field",
          "enum": [
            "url",
            "referrer"
          ]
        },
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "op",
          "description": "Case-insensitive. matches: a pattern where * stands for any run of characters, e.g. */products/*-ring",
          "enum": [
            "contains",
            "not_contains",
            "equals",
            "starts_with",
            "matches"
          ]
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "value",
          "constraints": {
            "minLength": 1,
            "maxLength": 500
          }
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "field",
          "enum": [
            "timeOnPageSeconds",
            "timeOnSiteSeconds",
            "pageViews",
            "visits",
            "previousChats",
            "cartTotalMinor",
            "hourOfDay"
          ]
        },
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "op",
          "enum": [
            "eq",
            "neq",
            "gt",
            "gte",
            "lt",
            "lte"
          ]
        },
        {
          "kind": "primitive",
          "type": "integer",
          "required": true,
          "nullable": false,
          "name": "value",
          "constraints": {
            "minimum": 0,
            "maximum": 1000000000000
          }
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "field",
          "enum": [
            "agentsOnline",
            "isCustomer",
            "hasOrderInProduction",
            "exitIntent"
          ]
        },
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "op",
          "enum": [
            "is"
          ]
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "value"
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "field",
          "enum": [
            "cartHasProductTag",
            "cartHasProductType",
            "viewingProductTag",
            "checkoutStep",
            "region",
            "city"
          ]
        },
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "op",
          "description": "in: the fact is one of the values. not_in: it is none of them",
          "enum": [
            "in",
            "not_in"
          ]
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "value",
          "constraints": {
            "minItems": 1,
            "maxItems": 30
          },
          "items": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "constraints": {
              "minLength": 1,
              "maxLength": 100
            }
          }
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "field",
          "enum": [
            "dayOfWeek"
          ]
        },
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "op",
          "description": "in: the fact is one of the values. not_in: it is none of them",
          "enum": [
            "in",
            "not_in"
          ]
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "value",
          "constraints": {
            "minItems": 1,
            "maxItems": 7
          },
          "items": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "enum": [
              "mon",
              "tue",
              "wed",
              "thu",
              "fri",
              "sat",
              "sun"
            ]
          }
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "field",
          "enum": [
            "device"
          ]
        },
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "op",
          "description": "in: the fact is one of the values. not_in: it is none of them",
          "enum": [
            "in",
            "not_in"
          ]
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "value",
          "constraints": {
            "minItems": 1,
            "maxItems": 3
          },
          "items": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "enum": [
              "desktop",
              "tablet",
              "mobile"
            ]
          }
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "field",
          "enum": [
            "country"
          ]
        },
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "op",
          "description": "in: the fact is one of the values. not_in: it is none of them",
          "enum": [
            "in",
            "not_in"
          ]
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "value",
          "constraints": {
            "minItems": 1,
            "maxItems": 250
          },
          "items": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "description": "ISO 3166-1 alpha-2 country code",
            "example": "US",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          }
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "field",
          "enum": [
            "viewingProductAttribute"
          ]
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "key",
          "description": "The attribute handle, e.g. carat",
          "constraints": {
            "minLength": 1,
            "maxLength": 60
          }
        },
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "op",
          "description": "gt, gte, lt and lte compare numbers; eq and neq compare numbers when both sides are numbers, else text",
          "enum": [
            "eq",
            "neq",
            "gt",
            "gte",
            "lt",
            "lte",
            "contains"
          ]
        },
        {
          "kind": "oneOf",
          "type": "oneOf",
          "required": true,
          "nullable": false,
          "name": "value",
          "variants": [
            {
              "kind": "primitive",
              "type": "number",
              "required": false,
              "nullable": false
            },
            {
              "kind": "primitive",
              "type": "string",
              "required": false,
              "nullable": false,
              "constraints": {
                "minLength": 1,
                "maxLength": 100
              }
            }
          ]
        }
      ]
    }
  ],
  "ref": "ChatTriggerCondition"
};
const schema_StorefrontChatTriggerAction: SchemaNode = {
  "kind": "oneOf",
  "type": "oneOf",
  "required": false,
  "nullable": false,
  "description": "What the widget can preview before it fires; tags and discount codes happen only on the server",
  "variants": [
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "type",
          "enum": [
            "message"
          ]
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "body"
        },
        {
          "kind": "object",
          "type": "object",
          "required": true,
          "nullable": true,
          "name": "author",
          "properties": [
            {
              "kind": "primitive",
              "type": "string",
              "required": true,
              "nullable": false,
              "name": "displayName"
            },
            {
              "kind": "primitive",
              "type": "string",
              "required": true,
              "nullable": true,
              "name": "avatarUrl"
            }
          ],
          "description": "Who the message comes from; null: the store"
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "suggestedReplies",
          "items": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false
          }
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "type",
          "enum": [
            "wait"
          ]
        },
        {
          "kind": "primitive",
          "type": "integer",
          "required": true,
          "nullable": false,
          "name": "seconds"
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "type",
          "enum": [
            "product_card"
          ]
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "productId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "variantId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        }
      ]
    }
  ],
  "ref": "StorefrontChatTriggerAction"
};
const schema_StorefrontChatTrigger: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "kind",
      "enum": [
        "site",
        "page",
        "widget_opened",
        "advanced"
      ]
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "conditions",
      "items": schema_ChatTriggerCondition
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "actions",
      "items": schema_StorefrontChatTriggerAction
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "oncePerVisitor"
    }
  ],
  "ref": "StorefrontChatTrigger"
};
const schema_ChatTriggerConfig: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "timezone",
      "description": "IANA zone for hourOfDay and dayOfWeek"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "items",
      "description": "Enabled triggers the widget evaluates, by position; rescuers are left out",
      "items": schema_StorefrontChatTrigger
    }
  ],
  "ref": "ChatTriggerConfig"
};
const schema_ChatConfig: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "Everything the widget needs to render before the shopper writes",
  "properties": [
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "description": "online: an agent is online. away: agents are connected but away (or nobody is and the store keeps chat open): chat works, show the away greeting. offline: outside business hours, or nobody connected while hours.offlineWhenNoAgentOnline is on: show the offline form",
      "enum": [
        "online",
        "away",
        "offline"
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "appearance",
      "properties": [
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "shape",
          "default": "round",
          "enum": [
            "round",
            "pill"
          ]
        },
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "position",
          "default": "right",
          "enum": [
            "right",
            "left"
          ]
        },
        {
          "kind": "enum",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "mobilePosition",
          "default": "right",
          "enum": [
            "right",
            "left"
          ]
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "primaryColor",
          "constraints": {
            "pattern": "^#[0-9a-fA-F]{6}$"
          },
          "description": "Null uses the storefront's own accent colour"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "headerTitle",
          "constraints": {
            "maxLength": 80
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "greetingOnline",
          "default": "Hi! How can we help you today?",
          "constraints": {
            "maxLength": 300
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "greetingAway",
          "default": "We're a little busy; we'll answer as soon as we can.",
          "constraints": {
            "maxLength": 300
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "greetingOffline",
          "default": "We're away right now. Leave a message and we'll email you back.",
          "constraints": {
            "maxLength": 300
          }
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "showAgentAvatars",
          "default": true
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "logoUrl"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "attentionGrabberUrl"
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "preChat",
      "properties": [
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "enabled",
          "default": false
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "fields",
          "default": [
            {
              "key": "name",
              "kind": "text",
              "label": "Name",
              "required": false
            },
            {
              "key": "email",
              "kind": "email",
              "label": "Email",
              "required": false
            }
          ],
          "constraints": {
            "maxItems": 10
          },
          "items": {
            "kind": "object",
            "type": "object",
            "required": false,
            "nullable": false,
            "properties": [
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": false,
                "name": "key",
                "description": "name, email and phone fill the visitor's identity; any other key becomes a visitor attribute",
                "constraints": {
                  "pattern": "^[a-z][a-z0-9_]{0,39}$"
                }
              },
              {
                "kind": "enum",
                "type": "string",
                "required": true,
                "nullable": false,
                "name": "kind",
                "enum": [
                  "text",
                  "email",
                  "phone",
                  "select",
                  "textarea",
                  "department",
                  "file"
                ]
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": false,
                "name": "label",
                "constraints": {
                  "minLength": 1,
                  "maxLength": 120
                }
              },
              {
                "kind": "primitive",
                "type": "boolean",
                "required": true,
                "nullable": false,
                "name": "required",
                "default": false
              },
              {
                "kind": "array",
                "type": "array",
                "required": false,
                "nullable": false,
                "name": "options",
                "description": "Choices of a select field",
                "constraints": {
                  "maxItems": 50
                },
                "items": {
                  "kind": "primitive",
                  "type": "string",
                  "required": false,
                  "nullable": false,
                  "constraints": {
                    "minLength": 1,
                    "maxLength": 120
                  }
                }
              }
            ]
          }
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "offlineForm",
      "properties": [
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "enabled",
          "default": true
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "fields",
          "default": [
            {
              "key": "name",
              "kind": "text",
              "label": "Name",
              "required": false
            },
            {
              "key": "email",
              "kind": "email",
              "label": "Email",
              "required": true
            }
          ],
          "constraints": {
            "maxItems": 10
          },
          "items": {
            "kind": "object",
            "type": "object",
            "required": false,
            "nullable": false,
            "properties": [
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": false,
                "name": "key",
                "description": "name, email and phone fill the visitor's identity; any other key becomes a visitor attribute",
                "constraints": {
                  "pattern": "^[a-z][a-z0-9_]{0,39}$"
                }
              },
              {
                "kind": "enum",
                "type": "string",
                "required": true,
                "nullable": false,
                "name": "kind",
                "enum": [
                  "text",
                  "email",
                  "phone",
                  "select",
                  "textarea",
                  "department",
                  "file"
                ]
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": false,
                "name": "label",
                "constraints": {
                  "minLength": 1,
                  "maxLength": 120
                }
              },
              {
                "kind": "primitive",
                "type": "boolean",
                "required": true,
                "nullable": false,
                "name": "required",
                "default": false
              },
              {
                "kind": "array",
                "type": "array",
                "required": false,
                "nullable": false,
                "name": "options",
                "description": "Choices of a select field",
                "constraints": {
                  "maxItems": 50
                },
                "items": {
                  "kind": "primitive",
                  "type": "string",
                  "required": false,
                  "nullable": false,
                  "constraints": {
                    "minLength": 1,
                    "maxLength": 120
                  }
                }
              }
            ]
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "confirmationText",
          "default": "Thanks! We'll get back to you by email.",
          "constraints": {
            "maxLength": 300
          }
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "consent",
      "properties": [
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "enabled",
          "description": "Show a privacy notice the shopper accepts before the first message",
          "default": false
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "text",
          "constraints": {
            "maxLength": 1000
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "privacyPolicyHandle",
          "constraints": {
            "maxLength": 120
          }
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "usStateNotice",
          "description": "Adds the two-party-consent notice some US states require for recorded chats",
          "default": false
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "identifyOnLoad",
          "description": "On (the default): the storefront creates the visitor on page load, so the live visitor list and returning-visitor triggers see every shopper; the identifier is a functional cookie the store's own consent banner should cover. Off: nothing is stored until the shopper opens the widget, and the visitor list shows only shoppers who chatted",
          "default": true
        }
      ]
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "behaviour",
      "properties": [
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "soundEnabled",
          "default": true
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "allowUploads",
          "default": true
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "allowRating",
          "default": true
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "allowTranscript",
          "default": true
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "suggestedRepliesEnabled",
          "default": true
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "showTypingToStaff",
          "description": "Sneak peek: staff see what the shopper is typing before it is sent. Relayed live, never stored",
          "default": true
        }
      ]
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "departments",
      "description": "Offered in a department field of the pre-chat form",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "name"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "description"
          }
        ]
      }
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "sizeGuide",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "handle"
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "sizes",
          "items": {
            "kind": "object",
            "type": "object",
            "required": false,
            "nullable": false,
            "properties": [
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": false,
                "name": "value"
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": false,
                "name": "label"
              }
            ]
          }
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "freeSizer"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "freeSizerText"
        }
      ],
      "description": "Ring size help; null when the store set neither a size guide page nor a size set"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "customDesign",
      "properties": [
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "metals",
          "items": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false
          }
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "stoneTypes",
          "items": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false
          }
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "shapes",
          "items": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false
          }
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "timelines",
          "items": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false
          }
        },
        {
          "kind": "array",
          "type": "array",
          "required": true,
          "nullable": false,
          "name": "ringSizes",
          "items": {
            "kind": "object",
            "type": "object",
            "required": false,
            "nullable": false,
            "properties": [
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": false,
                "name": "value"
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": false,
                "name": "label"
              }
            ]
          }
        },
        {
          "kind": "primitive",
          "type": "integer",
          "required": true,
          "nullable": false,
          "name": "maxUploads"
        }
      ],
      "description": "The custom design intake form; null when the store turned it off"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "pendingApprovals",
      "description": "Orders of the signed-in customer (X-Customer-Token) waiting for them to approve a design, with the signed approval link; empty for guests",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "orderId",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "orderName"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "approvalUrl"
          }
        ]
      }
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "help",
      "description": "Help centre in the widget: the search card and the article suggestions above the composer; both false while the store has no live article",
      "properties": [
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "search"
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "suggestions"
        }
      ]
    },
    { ...schema_ChatTriggerConfig, required: true, name: "triggers" }
  ],
  "ref": "ChatConfig"
};
const schema_CreateChatSessionRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "visitorToken",
      "description": "A token from an earlier session; resumes that visitor",
      "constraints": {
        "maxLength": 80
      }
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": false,
      "nullable": false,
      "name": "consent",
      "description": "Required true when the store shows a chat privacy notice"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "locale",
      "description": "BCP 47 language tag, language or language-REGION",
      "example": "en-US",
      "constraints": {
        "pattern": "^[a-z]{2}(?:-[A-Z]{2})?$"
      }
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "name": "attributes",
      "description": "Free key/value pairs shown to staff, merged into what the visitor already has",
      "additionalProperties": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false,
        "constraints": {
          "maxLength": 255
        }
      }
    }
  ],
  "ref": "CreateChatSessionRequest"
};
const schema_ConversationKind: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "chat",
    "offline",
    "ticket"
  ],
  "ref": "ConversationKind"
};
const schema_ConversationStatus: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "description": "open: waiting for staff. pending: staff answered, waiting for the shopper. closed: done",
  "enum": [
    "open",
    "pending",
    "closed"
  ],
  "ref": "ConversationStatus"
};
const schema_ShopperConversation: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    { ...schema_ConversationKind, required: true, name: "kind" },
    { ...schema_ConversationStatus, required: true, name: "status" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "subject"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "departmentId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "agent",
      "description": "The assigned staff member as the shopper sees them",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "displayName"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "avatarUrl"
        }
      ]
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": true,
      "name": "rating"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "ratingComment"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "unreadCount",
      "description": "Staff messages the shopper has not read"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "lastMessageAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "closedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "createdAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "ShopperConversation"
};
const schema_ChatTriggerFacts: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "The visitor facts trigger conditions read; the API checks them again when a trigger fires",
  "properties": [
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "visits"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "previousChats",
      "description": "Earlier conversations in which the shopper wrote, up to 100"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "isCustomer",
      "description": "Linked to a customer account"
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "hasOrderInProduction"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "country"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "region"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "city"
    }
  ],
  "ref": "ChatTriggerFacts"
};
const schema_ChatSession: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "visitorToken",
      "description": "Send it as X-Chat-Visitor on every chat call. Store it only after the shopper opened the widget or consented, unless consent.identifyOnLoad is on"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "visitor",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "id",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "displayName"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "email"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "phone"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "locale"
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "signedIn",
          "description": "Linked to the signed-in customer, so the history follows them to other devices"
        }
      ]
    },
    { ...schema_ShopperConversation, required: true, nullable: true, name: "openConversation", description: "The visitor's most recent conversation that is not closed" },
    { ...schema_ChatTriggerFacts, required: true, name: "triggerFacts" }
  ],
  "ref": "ChatSession"
};
const schema_StartChatConversationRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "enum",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "kind",
      "description": "offline is the offline form: an email is required and the answer goes out by email",
      "default": "chat",
      "enum": [
        "chat",
        "offline"
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "message",
      "constraints": {
        "minLength": 1,
        "maxLength": 4000
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": false,
      "nullable": false,
      "name": "attachments",
      "description": "Upload tokens (upl_…) from the upload endpoint, at most 5",
      "constraints": {
        "maxItems": 5
      },
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false,
        "constraints": {
          "minLength": 20,
          "maxLength": 80
        }
      }
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "name": "preChat",
      "description": "Answers keyed by the form field key; the department field carries a department id",
      "additionalProperties": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false,
        "constraints": {
          "maxLength": 1000
        }
      }
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "name": "context",
      "description": "Where the shopper was when the conversation started; shown in the staff sidebar",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "pageUrl",
          "format": "uri",
          "constraints": {
            "maxLength": 2000
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "pageTitle",
          "constraints": {
            "maxLength": 300
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "referrer",
          "constraints": {
            "maxLength": 2000
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "productId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "variantId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "cartToken",
          "constraints": {
            "maxLength": 100
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "orderId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "auctionId",
          "format": "uuid",
          "description": "The lot a condition-report request or question is about (D-180); the inbox sidebar shows it",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "draftOrderId",
          "format": "uuid",
          "description": "The latest draft order staff built from this conversation",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "object",
          "type": "object",
          "required": false,
          "nullable": true,
          "name": "utm",
          "additionalProperties": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "constraints": {
              "maxLength": 200
            }
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "anonymousId",
          "constraints": {
            "maxLength": 100
          },
          "description": "The storefront analytics browser id, so chat_started, chat_rated and chat_closed join the shopper's other events"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "sessionId",
          "constraints": {
            "maxLength": 100
          },
          "description": "The storefront analytics session id"
        }
      ]
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": false,
      "nullable": false,
      "name": "showProduct",
      "description": "Posts a product card for context.productId (and variantId) before the message, for the product page's \"Ask about this piece\"",
      "default": false
    }
  ],
  "ref": "StartChatConversationRequest"
};
const schema_MessageAuthorType: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "visitor",
    "staff",
    "system",
    "bot"
  ],
  "ref": "MessageAuthorType"
};
const schema_MessageKind: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "text",
    "product",
    "order_status",
    "form",
    "file",
    "event",
    "discount",
    "invoice",
    "size_guide"
  ],
  "ref": "MessageKind"
};
const schema_ShopperChatMessage: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7; also the cursor for `after`",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "conversationId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    { ...schema_MessageAuthorType, required: true, name: "authorType" },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "author",
      "description": "Set for staff messages and for bot messages sent under an alias; null for the shopper's own, system and other bot messages (show the store)",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "displayName"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "avatarUrl"
        }
      ]
    },
    { ...schema_MessageKind, required: true, name: "kind" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "body",
      "description": "Staff text may use basic markdown (bold, italic, lists, links); shopper text is plain"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "payload",
      "description": "Card data by kind: product { productId, variantId?, product, variant, needsOptions } with product (a StorefrontProductSummary, null once unpublished), variant { id, title, price, compareAt, isAvailable } priced in the shopper's market when read, and needsOptions when a variant or a required customization (ring size) must be picked on the product page first; order_status a ChatOrderStatusCard; form { answers } or { preset: custom_design, answers: [{ key, label, value }] }; discount { discountId, code, title, summary, endsAt }; invoice { draftOrderId, name, total, lines, email, sentAt }; size_guide { sizeGuideHandle, sizeSetId, sizes, freeSizer, freeSizerText }; event { event, ... }",
      "additionalProperties": {
        "kind": "primitive",
        "type": "any",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "attachments",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "uploadId",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "filename"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "contentType"
          },
          {
            "kind": "primitive",
            "type": "integer",
            "required": true,
            "nullable": false,
            "name": "bytes"
          }
        ]
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "readAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "createdAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "ShopperChatMessage"
};
const schema_StartedChatConversation: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_ShopperConversation, required: true, name: "conversation" },
    { ...schema_ShopperChatMessage, required: true, name: "message" }
  ],
  "ref": "StartedChatConversation"
};
const schema_ShopperChatMessagePage: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "items",
      "description": "Oldest first",
      "items": schema_ShopperChatMessage
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "hasMore",
      "description": "More messages in the direction asked for"
    }
  ],
  "ref": "ShopperChatMessagePage"
};
const schema_SendShopperChatMessageRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "body",
      "constraints": {
        "minLength": 1,
        "maxLength": 4000
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": false,
      "nullable": false,
      "name": "attachments",
      "description": "Upload tokens (upl_…) from the upload endpoint, at most 5",
      "constraints": {
        "maxItems": 5
      },
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false,
        "constraints": {
          "minLength": 20,
          "maxLength": 80
        }
      }
    }
  ],
  "ref": "SendShopperChatMessageRequest"
};
const schema_ReadChatMessagesRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "upToMessageId",
      "format": "uuid",
      "description": "Marks this message and every earlier one from the other side as read",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    }
  ],
  "ref": "ReadChatMessagesRequest"
};
const schema_ChatTypingRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "draft",
      "description": "What the shopper has typed so far; relayed to staff only when the store has sneak peek on, never stored",
      "constraints": {
        "maxLength": 4000
      }
    }
  ],
  "ref": "ChatTypingRequest"
};
const schema_ChatPresenceRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "pageUrl",
      "format": "uri",
      "constraints": {
        "maxLength": 2000
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "pageTitle",
      "constraints": {
        "maxLength": 300
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "referrer",
      "constraints": {
        "maxLength": 2000
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "cartToken",
      "constraints": {
        "maxLength": 100
      },
      "description": "The shopper's cart, so staff see its total"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "locale",
      "description": "BCP 47 language tag, language or language-REGION",
      "example": "en-US",
      "constraints": {
        "pattern": "^[a-z]{2}(?:-[A-Z]{2})?$"
      }
    },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": false,
      "nullable": false,
      "name": "visible",
      "description": "false while the tab is in the background; the visitor then shows as idle",
      "default": true
    }
  ],
  "ref": "ChatPresenceRequest"
};
const schema_RateChatConversationRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "oneOf",
      "type": "oneOf",
      "required": true,
      "nullable": false,
      "name": "rating",
      "description": "-1 bad, 0 neutral, 1 good",
      "variants": [
        {
          "kind": "enum",
          "type": "number",
          "required": false,
          "nullable": false,
          "enum": [
            -1
          ]
        },
        {
          "kind": "enum",
          "type": "number",
          "required": false,
          "nullable": false,
          "enum": [
            0
          ]
        },
        {
          "kind": "enum",
          "type": "number",
          "required": false,
          "nullable": false,
          "enum": [
            1
          ]
        }
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "comment",
      "constraints": {
        "maxLength": 1000
      }
    }
  ],
  "ref": "RateChatConversationRequest"
};
const schema_ContinuedChatConversation: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "The browser now holds the conversation's visitor; a browser that held that visitor's earlier token starts a new session",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "visitorToken"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": false,
      "name": "visitor",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "id",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "displayName"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "email"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "phone"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "locale"
        },
        {
          "kind": "primitive",
          "type": "boolean",
          "required": true,
          "nullable": false,
          "name": "signedIn",
          "description": "Linked to the signed-in customer, so the history follows them to other devices"
        }
      ]
    },
    { ...schema_ShopperConversation, required: true, name: "conversation" }
  ],
  "ref": "ContinuedChatConversation"
};
const schema_ChatOrderLookupRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "orderNumber",
      "description": "As printed on the confirmation, with or without the #",
      "constraints": {
        "minLength": 1,
        "maxLength": 20
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "email",
      "description": "The email the order was placed with",
      "constraints": {
        "minLength": 3,
        "maxLength": 320
      }
    }
  ],
  "ref": "ChatOrderLookupRequest"
};
const schema_ChatOrderStatusCard: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "Where an order is, as the widget shows it: also the payload of order_status messages",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "orderId",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "orderName"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "placedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "status",
      "enum": [
        "open",
        "completed",
        "cancelled",
        "archived"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "paymentStatus",
      "enum": [
        "pending",
        "authorized",
        "paid",
        "partially_paid",
        "partially_refunded",
        "refunded",
        "voided",
        "cod_pending",
        "unpaid"
      ]
    },
    {
      "kind": "enum",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "fulfilmentStatus",
      "enum": [
        "unfulfilled",
        "partially_fulfilled",
        "fulfilled",
        "on_hold",
        "in_production"
      ]
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "items",
      "description": "The first 5 lines",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "title"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "variantTitle"
          },
          {
            "kind": "primitive",
            "type": "integer",
            "required": true,
            "nullable": false,
            "name": "quantity"
          }
        ]
      }
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "itemCount"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "productionStage",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "name"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "startedAt",
          "format": "date-time",
          "description": "ISO 8601 timestamp in UTC",
          "example": "2026-09-27T10:15:30.000Z"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": true,
          "name": "etaAt",
          "format": "date-time",
          "description": "ISO 8601 timestamp in UTC",
          "example": "2026-09-27T10:15:30.000Z"
        }
      ],
      "description": "The production stage the order is at; null before payment or once production is over"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "progress",
      "description": "Production stages the shopper may see, in order",
      "items": schema_OrderProgressStep
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "shipByAt",
      "description": "Latest estimated ship date, YYYY-MM-DD"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "tracking",
      "items": {
        "kind": "object",
        "type": "object",
        "required": false,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "carrier"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "number"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": true,
            "name": "url"
          }
        ]
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "statusUrl",
      "description": "The signed order status page; null when the store has no domain or status template"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "statusToken",
      "description": "Signed for this order; send it with POST /chat/requests"
    }
  ],
  "ref": "ChatOrderStatusCard"
};
const schema_ChatOrderLookup: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_ChatOrderStatusCard, required: true, name: "card" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "conversationId",
      "format": "uuid",
      "description": "The open conversation the card was also posted into, so staff see what the shopper saw",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    }
  ],
  "ref": "ChatOrderLookup"
};
const schema_ChatRequestKind: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "resize",
    "repair",
    "engraving",
    "warranty",
    "other"
  ],
  "ref": "ChatRequestKind"
};
const schema_CreateChatRequestRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "statusToken",
      "description": "statusToken of the order status card",
      "constraints": {
        "minLength": 40,
        "maxLength": 100
      }
    },
    { ...schema_ChatRequestKind, required: true, name: "kind" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "details",
      "constraints": {
        "minLength": 1,
        "maxLength": 4000
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": false,
      "nullable": false,
      "name": "attachments",
      "description": "Upload tokens (upl_…) from the upload endpoint, at most 5",
      "constraints": {
        "maxItems": 5
      },
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false,
        "constraints": {
          "minLength": 20,
          "maxLength": 80
        }
      }
    }
  ],
  "ref": "CreateChatRequestRequest"
};
const schema_StartCustomDesignRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "metal",
      "constraints": {
        "minLength": 1,
        "maxLength": 80
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "stoneType",
      "constraints": {
        "minLength": 1,
        "maxLength": 80
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "shape",
      "constraints": {
        "minLength": 1,
        "maxLength": 80
      }
    },
    {
      "kind": "primitive",
      "type": "number",
      "required": false,
      "nullable": true,
      "name": "carat",
      "constraints": {
        "minimum": 0.05,
        "maximum": 30
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "ringSize",
      "constraints": {
        "maxLength": 40
      },
      "description": "A value of the store's ring size set"
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": true,
      "name": "budget",
      "properties": [
        {
          "kind": "primitive",
          "type": "integer",
          "required": true,
          "nullable": true,
          "name": "min",
          "constraints": {
            "minimum": 0
          }
        },
        {
          "kind": "primitive",
          "type": "integer",
          "required": true,
          "nullable": true,
          "name": "max",
          "constraints": {
            "minimum": 0
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "currency",
          "description": "ISO 4217 currency code",
          "example": "USD",
          "constraints": {
            "pattern": "^[A-Z]{3}$"
          }
        }
      ],
      "description": "Minor units in the shopper's currency"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "timeline",
      "constraints": {
        "maxLength": 80
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "message",
      "description": "Anything else: stories, references, links",
      "constraints": {
        "maxLength": 4000
      }
    },
    {
      "kind": "array",
      "type": "array",
      "required": false,
      "nullable": false,
      "name": "attachments",
      "description": "Inspiration images or sketches, upload tokens from POST /chat/uploads, at most 5",
      "constraints": {
        "maxItems": 5
      },
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false,
        "constraints": {
          "minLength": 20,
          "maxLength": 80
        }
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "name",
      "constraints": {
        "minLength": 1,
        "maxLength": 120
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "email",
      "format": "email",
      "description": "Required unless the visitor already left one",
      "constraints": {
        "maxLength": 320
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": false,
      "name": "phone",
      "constraints": {
        "maxLength": 40
      }
    },
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "name": "context",
      "description": "Where the shopper was when the conversation started; shown in the staff sidebar",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "pageUrl",
          "format": "uri",
          "constraints": {
            "maxLength": 2000
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "pageTitle",
          "constraints": {
            "maxLength": 300
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "referrer",
          "constraints": {
            "maxLength": 2000
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "productId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "variantId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "cartToken",
          "constraints": {
            "maxLength": 100
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "orderId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "auctionId",
          "format": "uuid",
          "description": "The lot a condition-report request or question is about (D-180); the inbox sidebar shows it",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "draftOrderId",
          "format": "uuid",
          "description": "The latest draft order staff built from this conversation",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "object",
          "type": "object",
          "required": false,
          "nullable": true,
          "name": "utm",
          "additionalProperties": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "constraints": {
              "maxLength": 200
            }
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "anonymousId",
          "constraints": {
            "maxLength": 100
          },
          "description": "The storefront analytics browser id, so chat_started, chat_rated and chat_closed join the shopper's other events"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "sessionId",
          "constraints": {
            "maxLength": 100
          },
          "description": "The storefront analytics session id"
        }
      ]
    }
  ],
  "ref": "StartCustomDesignRequest"
};
const schema_FireChatTriggerRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "object",
      "type": "object",
      "required": false,
      "nullable": false,
      "name": "context",
      "description": "Where the shopper is; becomes the context of a conversation the trigger opens",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "pageUrl",
          "format": "uri",
          "constraints": {
            "maxLength": 2000
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "pageTitle",
          "constraints": {
            "maxLength": 300
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "referrer",
          "constraints": {
            "maxLength": 2000
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "productId",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "cartToken",
          "constraints": {
            "maxLength": 100
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "anonymousId",
          "constraints": {
            "maxLength": 100
          }
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": false,
          "nullable": true,
          "name": "sessionId",
          "constraints": {
            "maxLength": 100
          }
        }
      ]
    }
  ],
  "ref": "FireChatTriggerRequest"
};
const schema_FiredChatTrigger: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    { ...schema_ShopperConversation, required: true, name: "conversation" },
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "created",
      "description": "The trigger opened this conversation; false when it wrote into the visitor's open one"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "messages",
      "description": "What the trigger posted, oldest first",
      "items": schema_ShopperChatMessage
    }
  ],
  "ref": "FiredChatTrigger"
};
const schema_StorefrontHelpCategory: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "description"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "position"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "articleCount",
      "description": "Live articles in the category"
    }
  ],
  "ref": "StorefrontHelpCategory"
};
const schema_StorefrontHelpCategoryDetail: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "name"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "description"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "position"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "articleCount",
      "description": "Live articles in the category"
    },
    { ...schema_ResolvedSeo, required: true, name: "seo" },
    { ...schema_JsonLd, required: true, name: "jsonld" },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "StorefrontHelpCategoryDetail"
};
const schema_StorefrontHelpArticleSummary: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "summary",
      "description": "The excerpt, or the start of the body when there is none"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "category",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "id",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "handle"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "name"
        }
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "StorefrontHelpArticleSummary"
};
const schema_StorefrontHelpArticle: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "id",
      "format": "uuid",
      "description": "UUID v7",
      "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "handle"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "title"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "summary",
      "description": "The excerpt, or the start of the body when there is none"
    },
    {
      "kind": "object",
      "type": "object",
      "required": true,
      "nullable": true,
      "name": "category",
      "properties": [
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "id",
          "format": "uuid",
          "description": "UUID v7",
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "handle"
        },
        {
          "kind": "primitive",
          "type": "string",
          "required": true,
          "nullable": false,
          "name": "name"
        }
      ]
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "updatedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "bodyHtml"
    },
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "keywords",
      "items": {
        "kind": "primitive",
        "type": "string",
        "required": false,
        "nullable": false
      }
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": true,
      "name": "publishedAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    },
    { ...schema_ResolvedSeo, required: true, name: "seo" },
    { ...schema_JsonLd, required: true, name: "jsonld" }
  ],
  "ref": "StorefrontHelpArticle"
};
const schema_StorefrontHelpSearchResponse: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "array",
      "type": "array",
      "required": true,
      "nullable": false,
      "name": "hits",
      "items": schema_StorefrontHelpArticleSummary
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "total"
    },
    {
      "kind": "primitive",
      "type": "integer",
      "required": true,
      "nullable": false,
      "name": "processingTimeMs"
    }
  ],
  "ref": "StorefrontHelpSearchResponse"
};
const schema_HelpFeedbackSourceInput: SchemaNode = {
  "kind": "enum",
  "type": "string",
  "required": false,
  "nullable": false,
  "enum": [
    "page",
    "widget"
  ],
  "ref": "HelpFeedbackSourceInput"
};
const schema_HelpFeedbackRequest: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "properties": [
    {
      "kind": "primitive",
      "type": "boolean",
      "required": true,
      "nullable": false,
      "name": "helpful"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": false,
      "nullable": true,
      "name": "comment",
      "constraints": {
        "maxLength": 1000
      }
    },
    { ...schema_HelpFeedbackSourceInput, name: "source", description: "widget: \"Did this answer your question?\" in the chat widget, which counts as a deflection when helpful" }
  ],
  "ref": "HelpFeedbackRequest"
};
const schema_ChatSocketTicket: SchemaNode = {
  "kind": "object",
  "type": "object",
  "required": false,
  "nullable": false,
  "description": "Browsers cannot send headers on a WebSocket handshake, so the socket authenticates with this ticket instead",
  "properties": [
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "ticket",
      "description": "Single use, valid for 30 seconds"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "url",
      "description": "wss:// URL with the ticket in the query string; open it before expiresAt"
    },
    {
      "kind": "primitive",
      "type": "string",
      "required": true,
      "nullable": false,
      "name": "expiresAt",
      "format": "date-time",
      "description": "ISO 8601 timestamp in UTC",
      "example": "2026-09-27T10:15:30.000Z"
    }
  ],
  "ref": "ChatSocketTicket"
};
const example_getStore_200: unknown = {
  "id": "01a16987-4bf6-7e55-baf0-cd133a59cae0",
  "name": "Aurora Jewels",
  "slug": "main",
  "status": "active",
  "acceptsOrders": true,
  "logo": null,
  "markets": [
    {
      "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
      "name": "Default",
      "countries": [
        "US"
      ],
      "currency": "USD",
      "isDefault": true
    }
  ],
  "defaultCurrency": "USD",
  "supportedCurrencies": [
    "USD"
  ],
  "defaultLocale": "en-US",
  "supportedLocales": [
    "en-US"
  ],
  "timezone": "America/New_York",
  "countryCode": "US",
  "contactEmail": null,
  "supportEmail": null,
  "supportPhone": null,
  "primaryDomain": "docs.example",
  "checkout": {
    "guestCheckout": true,
    "requirePhone": false,
    "termsUrl": null,
    "requireTermsAcceptance": false,
    "codEnabled": false,
    "codMaxAmount": null,
    "codFeeAmount": 0,
    "unpaidOrderHoldDays": 7,
    "abandonmentMinutes": 60,
    "recoveryUrlTemplate": null,
    "orderStatusUrlTemplate": null,
    "customerLinkUrlTemplate": null
  },
  "tax": {
    "provider": "none",
    "pricesIncludeTax": false
  },
  "returns": {
    "windowDays": 30,
    "allowedByDefault": true,
    "restockingFeePercent": 0,
    "returnShippingPaidBy": "customer"
  },
  "tracking": {
    "ga4Id": null,
    "metaPixelId": null,
    "tiktokPixelId": null,
    "pinterestTagId": null,
    "googleAdsId": null
  },
  "seo": {
    "titleTemplate": "{title} | {store}",
    "defaultMetaDescription": null,
    "robots": null,
    "indexable": true,
    "organizationLegalName": null,
    "socialProfiles": [],
    "twitterHandle": null,
    "logoMediaId": null,
    "indexNowKey": "c7c4ed6403bc4adda46adb3f9cf0f477"
  },
  "crawlers": {
    "allowTraining": true
  },
  "policies": {
    "shipping": {
      "freeOverCents": 50000,
      "processingDays": {
        "min": 2,
        "max": 5
      },
      "regionsNote": "Ships worldwide from New York"
    },
    "returns": {
      "exclusions": [
        "Engraved pieces",
        "Custom designs"
      ],
      "refundType": "full_refund"
    },
    "warranty": {
      "kind": "lifetime",
      "years": null,
      "exclusions": [
        "Damage from wear",
        "Stone loss through impact"
      ]
    },
    "resizing": {
      "freeWithinMonths": 12,
      "exclusions": [
        "Eternity bands",
        "Pavé bands"
      ]
    }
  },
  "auctions": {
    "conditionScale": [
      {
        "key": "unworn",
        "label": "Unworn"
      },
      {
        "key": "excellent",
        "label": "Excellent"
      },
      {
        "key": "very_good",
        "label": "Very good"
      },
      {
        "key": "good",
        "label": "Good"
      },
      {
        "key": "fair",
        "label": "Fair"
      }
    ],
    "privateAttributeKeys": []
  },
  "policyHighlights": [
    "Free shipping over $500",
    "Ships in 2 to 5 business days",
    "30-day returns",
    "Lifetime warranty",
    "Free resizing within 12 months"
  ],
  "policyLinks": [
    {
      "kind": "terms",
      "handle": "terms",
      "title": "Terms of sale"
    },
    {
      "kind": "privacy",
      "handle": "privacy",
      "title": "Privacy policy"
    },
    {
      "kind": "shipping",
      "handle": "shipping",
      "title": "Shipping"
    },
    {
      "kind": "returns",
      "handle": "returns",
      "title": "Returns and exchanges"
    },
    {
      "kind": "warranty",
      "handle": "warranty",
      "title": "Lifetime warranty"
    },
    {
      "kind": "resizing",
      "handle": "resizing",
      "title": "Free resizing"
    }
  ],
  "signInProviders": {
    "password": true,
    "magicLink": true,
    "google": true
  },
  "jsonld": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://docs.example/#organization",
        "name": "Aurora Jewels",
        "url": "https://docs.example",
        "hasMerchantReturnPolicy": {
          "@type": "MerchantReturnPolicy",
          "applicableCountry": "US",
          "returnPolicyCountry": "US",
          "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
          "merchantReturnDays": 30,
          "returnMethod": "https://schema.org/ReturnByMail",
          "returnFees": "https://schema.org/ReturnShippingFees",
          "refundType": "https://schema.org/FullRefund"
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://docs.example/#website",
        "name": "Aurora Jewels",
        "url": "https://docs.example",
        "potentialAction": {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": "https://docs.example/search?q={search_term_string}"
          },
          "query-input": "required name=search_term_string"
        }
      }
    ]
  }
};
const example_pickStones_200: unknown = {
  "items": [
    {
      "id": "01a15379-812f-7ed6-a5d9-f8f5297c31fc",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.81,
      "color": "H",
      "clarity": "VS1",
      "cut": null,
      "polish": "Excellent",
      "symmetry": "Very Good",
      "fluorescence": "None",
      "measurements": "7.40 x 5.29 x 3.19",
      "lab": "IGI",
      "certificateNumber": "SAMPLE-IGI-LG6906502",
      "certificateUrl": null,
      "price": {
        "amount": 41000,
        "currency": "USD"
      },
      "media": null
    },
    {
      "id": "01a15379-812a-7d9d-8a55-f4dadb7fd886",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.88,
      "color": "H",
      "clarity": "VS1",
      "cut": null,
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.80 x 5.30 x 3.34",
      "lab": "IGI",
      "certificateNumber": "SAMPLE-IGI-LG9368784",
      "certificateUrl": null,
      "price": {
        "amount": 44000,
        "currency": "USD"
      },
      "media": null
    },
    {
      "id": "01a15379-812d-7ead-adc7-a7583aaebdec",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.73,
      "color": "E",
      "clarity": "VVS1",
      "cut": null,
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.38 x 4.94 x 2.94",
      "lab": "IGI",
      "certificateNumber": "SAMPLE-IGI-LG8166711",
      "certificateUrl": null,
      "price": {
        "amount": 48250,
        "currency": "USD"
      },
      "media": null
    },
    {
      "id": "01a15379-812a-73f5-ab76-83f2de5a3393",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.86,
      "color": "G",
      "clarity": "VS1",
      "cut": null,
      "polish": "Excellent",
      "symmetry": "Very Good",
      "fluorescence": "None",
      "measurements": "7.51 x 5.42 x 3.36",
      "lab": "IGI",
      "certificateNumber": "SAMPLE-IGI-LG4832348",
      "certificateUrl": null,
      "price": {
        "amount": 48500,
        "currency": "USD"
      },
      "media": null
    },
    {
      "id": "01a15379-8134-7e8a-85d7-0965fca08939",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.74,
      "color": "E",
      "clarity": "VVS1",
      "cut": null,
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "Faint",
      "measurements": "7.11 x 5.18 x 3.13",
      "lab": "IGI",
      "certificateNumber": "SAMPLE-IGI-LG7210260",
      "certificateUrl": null,
      "price": {
        "amount": 51750,
        "currency": "USD"
      },
      "media": null
    },
    {
      "id": "01a15379-812f-7232-8087-06522afe07b4",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.88,
      "color": "G",
      "clarity": "VVS1",
      "cut": null,
      "polish": "Excellent",
      "symmetry": "Very Good",
      "fluorescence": "None",
      "measurements": "7.64 x 5.41 x 3.41",
      "lab": "IGI",
      "certificateNumber": "SAMPLE-IGI-LG3367341",
      "certificateUrl": null,
      "price": {
        "amount": 52000,
        "currency": "USD"
      },
      "media": null
    },
    {
      "id": "01a15379-8133-71c3-ae3d-636fece71de9",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.82,
      "color": "F",
      "clarity": "VVS2",
      "cut": null,
      "polish": "Excellent",
      "symmetry": "Very Good",
      "fluorescence": "None",
      "measurements": "7.69 x 5.13 x 3.23",
      "lab": "IGI",
      "certificateNumber": "SAMPLE-IGI-LG7543674",
      "certificateUrl": null,
      "price": {
        "amount": 54250,
        "currency": "USD"
      },
      "media": null
    },
    {
      "id": "01a10061-5591-772e-8067-f30c1f95aa61",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.76,
      "color": "H",
      "clarity": "VS2",
      "cut": "Excellent",
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.53 x 4.91 x 2.97",
      "lab": "IGI",
      "certificateNumber": "LG636427707",
      "certificateUrl": null,
      "price": {
        "amount": 85365,
        "currency": "USD"
      },
      "media": {
        "image": "https://assets.example/LG636427707.jpg",
        "v360": "https://loupe360.com/diamond/LG636427707"
      }
    },
    {
      "id": "01a10077-3f09-7997-85e8-45ad76eb03bd",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.76,
      "color": "H",
      "clarity": "VS2",
      "cut": "Excellent",
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.53 x 4.91 x 2.97",
      "lab": "IGI",
      "certificateNumber": "LG636427707",
      "certificateUrl": null,
      "price": {
        "amount": 85365,
        "currency": "USD"
      },
      "media": {
        "image": "https://assets.example/LG636427707.jpg",
        "v360": "https://loupe360.com/diamond/LG636427707"
      }
    },
    {
      "id": "01a10138-24d6-7f45-9f04-ec2e6de49589",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.76,
      "color": "H",
      "clarity": "VS2",
      "cut": "Excellent",
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.53 x 4.91 x 2.97",
      "lab": "IGI",
      "certificateNumber": "LG636427707",
      "certificateUrl": null,
      "price": {
        "amount": 85365,
        "currency": "USD"
      },
      "media": {
        "image": "https://assets.example/LG636427707.jpg",
        "v360": "https://loupe360.com/diamond/LG636427707"
      }
    },
    {
      "id": "01a11011-a0ed-7748-aa21-bfac3a73cfea",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.76,
      "color": "H",
      "clarity": "VS2",
      "cut": "Excellent",
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.53 x 4.91 x 2.97",
      "lab": "IGI",
      "certificateNumber": "LG636427707",
      "certificateUrl": null,
      "price": {
        "amount": 85365,
        "currency": "USD"
      },
      "media": {
        "image": "https://assets.example/LG636427707.jpg",
        "v360": "https://loupe360.com/diamond/LG636427707"
      }
    },
    {
      "id": "01a11013-3b7b-762a-be33-6ccb26bcb335",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.76,
      "color": "H",
      "clarity": "VS2",
      "cut": "Excellent",
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.53 x 4.91 x 2.97",
      "lab": "IGI",
      "certificateNumber": "LG636427707",
      "certificateUrl": null,
      "price": {
        "amount": 85365,
        "currency": "USD"
      },
      "media": {
        "image": "https://assets.example/LG636427707.jpg",
        "v360": "https://loupe360.com/diamond/LG636427707"
      }
    },
    {
      "id": "01a11014-8deb-7ecd-854a-5c5b086ee01b",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.76,
      "color": "H",
      "clarity": "VS2",
      "cut": "Excellent",
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.53 x 4.91 x 2.97",
      "lab": "IGI",
      "certificateNumber": "LG636427707",
      "certificateUrl": null,
      "price": {
        "amount": 85365,
        "currency": "USD"
      },
      "media": {
        "image": "https://assets.example/LG636427707.jpg",
        "v360": "https://loupe360.com/diamond/LG636427707"
      }
    },
    {
      "id": "01a1102c-08b0-773a-8135-0cb5997d2c3a",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.76,
      "color": "H",
      "clarity": "VS2",
      "cut": "Excellent",
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.53 x 4.91 x 2.97",
      "lab": "IGI",
      "certificateNumber": "LG636427707",
      "certificateUrl": null,
      "price": {
        "amount": 85365,
        "currency": "USD"
      },
      "media": {
        "image": "https://assets.example/LG636427707.jpg",
        "v360": "https://loupe360.com/diamond/LG636427707"
      }
    },
    {
      "id": "01a11032-2110-7c94-9ee2-2c9a34b39ff9",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.76,
      "color": "H",
      "clarity": "VS2",
      "cut": "Excellent",
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.53 x 4.91 x 2.97",
      "lab": "IGI",
      "certificateNumber": "LG636427707",
      "certificateUrl": null,
      "price": {
        "amount": 85365,
        "currency": "USD"
      },
      "media": {
        "image": "https://assets.example/LG636427707.jpg",
        "v360": "https://loupe360.com/diamond/LG636427707"
      }
    },
    {
      "id": "01a11f52-e84d-7bee-a112-05ae58abe37d",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.76,
      "color": "H",
      "clarity": "VS2",
      "cut": "Excellent",
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.53 x 4.91 x 2.97",
      "lab": "IGI",
      "certificateNumber": "LG636427707",
      "certificateUrl": null,
      "price": {
        "amount": 85365,
        "currency": "USD"
      },
      "media": {
        "image": "https://assets.example/LG636427707.jpg",
        "v360": "https://loupe360.com/diamond/LG636427707"
      }
    },
    {
      "id": "01a134df-ceb3-7beb-b2c7-4e63b6eaa2a2",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.76,
      "color": "H",
      "clarity": "VS2",
      "cut": "Excellent",
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.53 x 4.91 x 2.97",
      "lab": "IGI",
      "certificateNumber": "LG636427707",
      "certificateUrl": null,
      "price": {
        "amount": 85365,
        "currency": "USD"
      },
      "media": {
        "image": "https://assets.example/LG636427707.jpg",
        "v360": "https://loupe360.com/diamond/LG636427707"
      }
    },
    {
      "id": "01a13c4d-f7f4-75f9-8cbb-35e8b7d5e623",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.76,
      "color": "H",
      "clarity": "VS2",
      "cut": "Excellent",
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.53 x 4.91 x 2.97",
      "lab": "IGI",
      "certificateNumber": "LG636427707",
      "certificateUrl": null,
      "price": {
        "amount": 85365,
        "currency": "USD"
      },
      "media": {
        "image": "https://assets.example/LG636427707.jpg",
        "v360": "https://loupe360.com/diamond/LG636427707"
      }
    },
    {
      "id": "01a152ce-8df8-7055-a84e-d05a77ef4ac0",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.76,
      "color": "H",
      "clarity": "VS2",
      "cut": "Excellent",
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.53 x 4.91 x 2.97",
      "lab": "IGI",
      "certificateNumber": "LG636427707",
      "certificateUrl": null,
      "price": {
        "amount": 85365,
        "currency": "USD"
      },
      "media": {
        "image": "https://assets.example/LG636427707.jpg",
        "v360": "https://loupe360.com/diamond/LG636427707"
      }
    },
    {
      "id": "01a152ce-f259-7b2d-8dcb-85450edb5e35",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.76,
      "color": "H",
      "clarity": "VS2",
      "cut": "Excellent",
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.53 x 4.91 x 2.97",
      "lab": "IGI",
      "certificateNumber": "LG636427707",
      "certificateUrl": null,
      "price": {
        "amount": 85365,
        "currency": "USD"
      },
      "media": {
        "image": "https://assets.example/LG636427707.jpg",
        "v360": "https://loupe360.com/diamond/LG636427707"
      }
    }
  ],
  "nextCursor": "Wzg1MzY1LCIwMWExNTJjZS1mMjU5LTdiMmQtOGRjYi04NTQ1MGVkYjVlMzUiXQ",
  "facets": {
    "shapes": [
      "oval"
    ],
    "colors": [
      "H",
      "G",
      "F",
      "E"
    ],
    "clarities": [
      "VS2",
      "VS1",
      "VVS2",
      "VVS1"
    ],
    "cuts": [
      "Excellent"
    ],
    "caratRange": {
      "min": 0.73,
      "max": 0.88
    },
    "priceRange": {
      "min": {
        "amount": 41000,
        "currency": "USD"
      },
      "max": {
        "amount": 85365,
        "currency": "USD"
      }
    }
  }
};
const example_shopStones_200: unknown = {
  "items": [
    {
      "id": "01a15379-812f-7ed6-a5d9-f8f5297c31fc",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.81,
      "color": "H",
      "clarity": "VS1",
      "cut": null,
      "polish": "Excellent",
      "symmetry": "Very Good",
      "fluorescence": "None",
      "measurements": "7.40 x 5.29 x 3.19",
      "lab": "IGI",
      "certificateNumber": "SAMPLE-IGI-LG6906502",
      "certificateUrl": null,
      "price": {
        "amount": 41000,
        "currency": "USD"
      },
      "media": null
    },
    {
      "id": "01a15379-812a-7d9d-8a55-f4dadb7fd886",
      "stoneType": "lab_diamond",
      "shape": "oval",
      "carat": 0.88,
      "color": "H",
      "clarity": "VS1",
      "cut": null,
      "polish": "Excellent",
      "symmetry": "Excellent",
      "fluorescence": "None",
      "measurements": "7.80 x 5.30 x 3.34",
      "lab": "IGI",
      "certificateNumber": "SAMPLE-IGI-LG9368784",
      "certificateUrl": null,
      "price": {
        "amount": 44000,
        "currency": "USD"
      },
      "media": null
    }
  ],
  "nextCursor": "WzQ0MDAwLCIwMWExNTM3OS04MTJhLTdkOWQtOGE1NS1mNGRhZGI3ZmQ4ODYiXQ",
  "facets": {
    "shapes": [
      "oval"
    ],
    "colors": [
      "H",
      "G",
      "F",
      "E"
    ],
    "clarities": [
      "VS2",
      "VS1",
      "VVS2",
      "VVS1"
    ],
    "cuts": [
      "Excellent"
    ],
    "caratRange": {
      "min": 0.73,
      "max": 0.88
    },
    "priceRange": {
      "min": {
        "amount": 41000,
        "currency": "USD"
      },
      "max": {
        "amount": 85365,
        "currency": "USD"
      }
    }
  },
  "accepts": {
    "acceptedShapes": [
      "oval"
    ],
    "acceptedStoneTypes": [
      "natural_diamond",
      "lab_diamond"
    ],
    "caratMin": 0.5,
    "caratMax": 5
  }
};
const example_listStoneSettings_200: unknown = {
  "stone": {
    "id": "01a15379-812f-7ed6-a5d9-f8f5297c31fc",
    "stoneType": "lab_diamond",
    "shape": "oval",
    "carat": 0.81,
    "color": "H",
    "clarity": "VS1",
    "cut": null,
    "polish": "Excellent",
    "symmetry": "Very Good",
    "fluorescence": "None",
    "measurements": "7.40 x 5.29 x 3.19",
    "lab": "IGI",
    "certificateNumber": "SAMPLE-IGI-LG6906502",
    "certificateUrl": null,
    "price": {
      "amount": 41000,
      "currency": "USD"
    },
    "media": null
  },
  "items": [
    {
      "product": {
        "id": "01a16987-5d6c-70f7-9fd5-fd6736b240b7",
        "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
        "handle": "aurora-oval-solitaire",
        "title": "Aurora Oval Solitaire",
        "subtitle": null,
        "tags": [
          "engagement",
          "solitaire",
          "bestseller"
        ],
        "vendor": "Aurora Jewels",
        "productType": {
          "slug": "engagement-ring",
          "name": "Engagement Ring"
        },
        "categoryCollection": null,
        "designCollection": null,
        "featuredMedia": {
          "id": "01a16987-4d56-73a8-b6ca-12aedaee71ca",
          "kind": "image",
          "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4d56-73a8-b6ca-12aedaee71ca/original.png",
          "mimeType": "image/png",
          "renditions": null,
          "alt": "Aurora Oval Solitaire, view 1",
          "width": 1200,
          "height": 1200
        },
        "price": {
          "min": {
            "amount": 189000,
            "currency": "USD"
          },
          "max": {
            "amount": 519750,
            "currency": "USD"
          }
        },
        "compareAtMin": null,
        "fulfillmentMode": "made_to_order",
        "availability": "made_to_order",
        "leadTimeDaysMin": 14,
        "leadTimeDaysMax": 21,
        "publishedAt": "2026-10-23T16:10:41.384Z"
      },
      "total": {
        "amount": 230000,
        "currency": "USD"
      }
    }
  ]
};
const example_getStorefrontStone_200: unknown = {
  "id": "01a15379-812f-7ed6-a5d9-f8f5297c31fc",
  "stoneType": "lab_diamond",
  "shape": "oval",
  "carat": 0.81,
  "color": "H",
  "clarity": "VS1",
  "cut": null,
  "polish": "Excellent",
  "symmetry": "Very Good",
  "fluorescence": "None",
  "measurements": "7.40 x 5.29 x 3.19",
  "lab": "IGI",
  "certificateNumber": "SAMPLE-IGI-LG6906502",
  "certificateUrl": null,
  "price": {
    "amount": 41000,
    "currency": "USD"
  },
  "media": null
};
const example_listProducts_200: unknown = {
  "items": [
    {
      "id": "01a16987-5d6c-78a2-bc44-ca0bc65b4bb5",
      "productId": "01a16987-5ba2-762c-a3f6-5ae54988b4a3",
      "handle": "line-tennis-bracelet",
      "title": "Line Tennis Bracelet",
      "subtitle": null,
      "tags": [
        "bracelet",
        "tennis",
        "bestseller"
      ],
      "vendor": "Aurora Jewels",
      "productType": {
        "slug": "bracelet",
        "name": "Bracelet"
      },
      "categoryCollection": null,
      "designCollection": null,
      "featuredMedia": {
        "id": "01a16987-5be5-737b-a27f-58b1dd4bd31a",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5be5-737b-a27f-58b1dd4bd31a/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Line Tennis Bracelet, view 1",
        "width": 1200,
        "height": 1200
      },
      "price": {
        "min": {
          "amount": 289000,
          "currency": "USD"
        },
        "max": {
          "amount": 390150,
          "currency": "USD"
        }
      },
      "compareAtMin": null,
      "fulfillmentMode": "made_to_order",
      "availability": "made_to_order",
      "leadTimeDaysMin": 14,
      "leadTimeDaysMax": 21,
      "publishedAt": "2026-10-23T16:10:41.384Z"
    },
    {
      "id": "01a16987-5d6c-77dc-bca8-274f2773fca8",
      "productId": "01a16987-5884-7a3b-b523-de372806d47e",
      "handle": "spark-diamond-studs",
      "title": "Spark Diamond Studs",
      "subtitle": null,
      "tags": [
        "earrings",
        "studs",
        "bestseller",
        "gift"
      ],
      "vendor": "Aurora Jewels",
      "productType": {
        "slug": "earrings",
        "name": "Earrings"
      },
      "categoryCollection": null,
      "designCollection": null,
      "featuredMedia": {
        "id": "01a16987-596f-733b-a52a-2163095d1de7",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-596f-733b-a52a-2163095d1de7/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Spark Diamond Studs, view 1",
        "width": 1200,
        "height": 1200
      },
      "price": {
        "min": {
          "amount": 119000,
          "currency": "USD"
        },
        "max": {
          "amount": 160650,
          "currency": "USD"
        }
      },
      "compareAtMin": null,
      "fulfillmentMode": "stocked",
      "availability": "in_stock",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "publishedAt": "2026-10-23T16:10:41.384Z"
    },
    {
      "id": "01a16987-5d6c-75da-bee8-56e81a1c4ae5",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "subtitle": null,
      "tags": [
        "band",
        "classic",
        "bestseller"
      ],
      "vendor": "Aurora Jewels",
      "productType": {
        "slug": "wedding-band",
        "name": "Wedding Band"
      },
      "categoryCollection": null,
      "designCollection": null,
      "featuredMedia": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "price": {
        "min": {
          "amount": 42000,
          "currency": "USD"
        },
        "max": {
          "amount": 56700,
          "currency": "USD"
        }
      },
      "compareAtMin": null,
      "fulfillmentMode": "stocked",
      "availability": "in_stock",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "publishedAt": "2026-10-23T16:10:41.384Z"
    }
  ],
  "nextCursor": "eyJwIjoiMjAyNi0xMC0yMyAxNjoxMDo0MS4zODQrMDAiLCJpZCI6IjAxYTE2OTg3LTVkNmMtNzVkYS1iZWU4LTU2ZTgxYTFjNGFlNSJ9",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  }
};
const example_listProducts_400: unknown = {
  "error": {
    "code": "VALIDATION_ERROR",
    "message": "Request validation failed",
    "requestId": "req_example",
    "details": [
      {
        "field": "query.limit",
        "code": "too_big",
        "message": "Too big: expected number to be <=100"
      }
    ]
  }
};
const example_getProduct_200: unknown = {
  "id": "01a16987-5d6c-75da-bee8-56e81a1c4ae5",
  "productId": "01a16987-50db-7646-87e5-e664112f2660",
  "handle": "orbit-comfort-fit-band",
  "title": "Orbit Comfort-Fit Band",
  "subtitle": null,
  "tags": [
    "band",
    "classic",
    "bestseller"
  ],
  "vendor": "Aurora Jewels",
  "productType": {
    "slug": "wedding-band",
    "name": "Wedding Band"
  },
  "categoryCollection": null,
  "designCollection": null,
  "featuredMedia": {
    "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
    "kind": "image",
    "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
    "mimeType": "image/png",
    "renditions": null,
    "alt": "Orbit Comfort-Fit Band, view 1",
    "width": 1200,
    "height": 1200
  },
  "price": {
    "min": {
      "amount": 42000,
      "currency": "USD"
    },
    "max": {
      "amount": 56700,
      "currency": "USD"
    }
  },
  "compareAtMin": null,
  "fulfillmentMode": "stocked",
  "availability": "in_stock",
  "leadTimeDaysMin": null,
  "leadTimeDaysMax": null,
  "publishedAt": "2026-10-23T16:10:41.384Z",
  "descriptionHtml": "<p>Rounded inside so it slides over the knuckle. Available in every metal we work with.</p>",
  "summary": "A 3 mm comfort-fit band with a soft dome.",
  "faq": [
    {
      "question": "Is the stone lab-grown?",
      "answer": "This piece has no stone."
    },
    {
      "question": "Can I return it?",
      "answer": "Yes, within 30 days in its original condition. Engraved and custom-sized pieces are exchange only."
    }
  ],
  "specifications": [
    {
      "attributeKey": "metal",
      "label": "Metal",
      "value": "14K Yellow Gold",
      "unit": null
    }
  ],
  "policyHighlights": [
    "Free shipping over $500",
    "Ships in 2 to 5 business days",
    "30-day returns",
    "Lifetime warranty",
    "Free resizing within 12 months"
  ],
  "careGuideHandle": null,
  "seo": {
    "title": "Orbit Comfort-Fit Band | Aurora Jewels",
    "description": "A 3 mm comfort-fit band with a soft dome.",
    "canonical": "https://docs.example/products/orbit-comfort-fit-band",
    "robots": "index, follow",
    "openGraph": {
      "title": "Orbit Comfort-Fit Band",
      "description": "A 3 mm comfort-fit band with a soft dome.",
      "image": {
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "width": 1200,
        "height": 1200,
        "alt": "Orbit Comfort-Fit Band, view 1"
      },
      "type": "product"
    },
    "twitter": {
      "card": "summary_large_image",
      "site": null
    },
    "warnings": []
  },
  "jsonld": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "ProductGroup",
        "@id": "https://docs.example/products/orbit-comfort-fit-band#group",
        "productGroupID": "01a16987-50db-7646-87e5-e664112f2660",
        "name": "Orbit Comfort-Fit Band",
        "description": "A 3 mm comfort-fit band with a soft dome.",
        "url": "https://docs.example/products/orbit-comfort-fit-band",
        "image": [
          "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
          "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51fc-7cd8-920d-b5137caacb3f/original.png"
        ],
        "brand": {
          "@type": "Brand",
          "name": "Aurora Jewels"
        },
        "variesBy": [
          "Metal"
        ],
        "additionalProperty": [
          {
            "@type": "PropertyValue",
            "name": "Metal",
            "value": "14K Yellow Gold",
            "propertyID": "metal"
          }
        ],
        "hasVariant": [
          {
            "@type": "Product",
            "@id": "https://docs.example/products/orbit-comfort-fit-band?variant=01a16987-5105-7906-9884-95b7eafae1ac",
            "name": "Orbit Comfort-Fit Band – 14K Yellow Gold",
            "image": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
            "material": "14k_yellow_gold",
            "offers": {
              "@type": "Offer",
              "url": "https://docs.example/products/orbit-comfort-fit-band?variant=01a16987-5105-7906-9884-95b7eafae1ac",
              "price": "420.00",
              "priceCurrency": "USD",
              "availability": "https://schema.org/InStock",
              "itemCondition": "https://schema.org/NewCondition",
              "seller": {
                "@type": "Organization",
                "name": "Aurora Jewels",
                "url": "https://docs.example"
              },
              "shippingDetails": {
                "@type": "OfferShippingDetails",
                "shippingDestination": {
                  "@type": "DefinedRegion",
                  "addressCountry": "US"
                },
                "deliveryTime": {
                  "@type": "ShippingDeliveryTime",
                  "handlingTime": {
                    "@type": "QuantitativeValue",
                    "minValue": 2,
                    "maxValue": 5,
                    "unitCode": "DAY"
                  }
                }
              },
              "hasMerchantReturnPolicy": {
                "@type": "MerchantReturnPolicy",
                "applicableCountry": "US",
                "returnPolicyCountry": "US",
                "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
                "merchantReturnDays": 30,
                "returnMethod": "https://schema.org/ReturnByMail",
                "returnFees": "https://schema.org/ReturnShippingFees",
                "refundType": "https://schema.org/FullRefund"
              }
            }
          },
          {
            "@type": "Product",
            "@id": "https://docs.example/products/orbit-comfort-fit-band?variant=01a16987-5105-7a4a-9986-e2e19a63728f",
            "name": "Orbit Comfort-Fit Band – 14K White Gold",
            "image": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
            "material": "14k_white_gold",
            "offers": {
              "@type": "Offer",
              "url": "https://docs.example/products/orbit-comfort-fit-band?variant=01a16987-5105-7a4a-9986-e2e19a63728f",
              "price": "441.00",
              "priceCurrency": "USD",
              "availability": "https://schema.org/InStock",
              "itemCondition": "https://schema.org/NewCondition",
              "seller": {
                "@type": "Organization",
                "name": "Aurora Jewels",
                "url": "https://docs.example"
              },
              "shippingDetails": {
                "@type": "OfferShippingDetails",
                "shippingDestination": {
                  "@type": "DefinedRegion",
                  "addressCountry": "US"
                },
                "deliveryTime": {
                  "@type": "ShippingDeliveryTime",
                  "handlingTime": {
                    "@type": "QuantitativeValue",
                    "minValue": 2,
                    "maxValue": 5,
                    "unitCode": "DAY"
                  }
                }
              },
              "hasMerchantReturnPolicy": {
                "@type": "MerchantReturnPolicy",
                "applicableCountry": "US",
                "returnPolicyCountry": "US",
                "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
                "merchantReturnDays": 30,
                "returnMethod": "https://schema.org/ReturnByMail",
                "returnFees": "https://schema.org/ReturnShippingFees",
                "refundType": "https://schema.org/FullRefund"
              }
            }
          },
          {
            "@type": "Product",
            "@id": "https://docs.example/products/orbit-comfort-fit-band?variant=01a16987-5105-7a93-a0c0-071fd9b1a5ff",
            "name": "Orbit Comfort-Fit Band – 14K Rose Gold",
            "image": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
            "material": "14k_rose_gold",
            "offers": {
              "@type": "Offer",
              "url": "https://docs.example/products/orbit-comfort-fit-band?variant=01a16987-5105-7a93-a0c0-071fd9b1a5ff",
              "price": "420.00",
              "priceCurrency": "USD",
              "availability": "https://schema.org/InStock",
              "itemCondition": "https://schema.org/NewCondition",
              "seller": {
                "@type": "Organization",
                "name": "Aurora Jewels",
                "url": "https://docs.example"
              },
              "shippingDetails": {
                "@type": "OfferShippingDetails",
                "shippingDestination": {
                  "@type": "DefinedRegion",
                  "addressCountry": "US"
                },
                "deliveryTime": {
                  "@type": "ShippingDeliveryTime",
                  "handlingTime": {
                    "@type": "QuantitativeValue",
                    "minValue": 2,
                    "maxValue": 5,
                    "unitCode": "DAY"
                  }
                }
              },
              "hasMerchantReturnPolicy": {
                "@type": "MerchantReturnPolicy",
                "applicableCountry": "US",
                "returnPolicyCountry": "US",
                "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
                "merchantReturnDays": 30,
                "returnMethod": "https://schema.org/ReturnByMail",
                "returnFees": "https://schema.org/ReturnShippingFees",
                "refundType": "https://schema.org/FullRefund"
              }
            }
          },
          {
            "@type": "Product",
            "@id": "https://docs.example/products/orbit-comfort-fit-band?variant=01a16987-5105-7abe-9a5f-0116f79cdf43",
            "name": "Orbit Comfort-Fit Band – Platinum 950",
            "image": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
            "material": "platinum_950",
            "offers": {
              "@type": "Offer",
              "url": "https://docs.example/products/orbit-comfort-fit-band?variant=01a16987-5105-7abe-9a5f-0116f79cdf43",
              "price": "567.00",
              "priceCurrency": "USD",
              "availability": "https://schema.org/InStock",
              "itemCondition": "https://schema.org/NewCondition",
              "seller": {
                "@type": "Organization",
                "name": "Aurora Jewels",
                "url": "https://docs.example"
              },
              "shippingDetails": {
                "@type": "OfferShippingDetails",
                "shippingDestination": {
                  "@type": "DefinedRegion",
                  "addressCountry": "US"
                },
                "shippingRate": {
                  "@type": "MonetaryAmount",
                  "value": 0,
                  "currency": "USD"
                },
                "deliveryTime": {
                  "@type": "ShippingDeliveryTime",
                  "handlingTime": {
                    "@type": "QuantitativeValue",
                    "minValue": 2,
                    "maxValue": 5,
                    "unitCode": "DAY"
                  }
                }
              },
              "hasMerchantReturnPolicy": {
                "@type": "MerchantReturnPolicy",
                "applicableCountry": "US",
                "returnPolicyCountry": "US",
                "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
                "merchantReturnDays": 30,
                "returnMethod": "https://schema.org/ReturnByMail",
                "returnFees": "https://schema.org/ReturnShippingFees",
                "refundType": "https://schema.org/FullRefund"
              }
            }
          }
        ]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Is the stone lab-grown?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "This piece has no stone."
            }
          },
          {
            "@type": "Question",
            "name": "Can I return it?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, within 30 days in its original condition. Engraved and custom-sized pieces are exchange only."
            }
          }
        ]
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Aurora Jewels",
            "item": "https://docs.example"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Orbit Comfort-Fit Band",
            "item": "https://docs.example/products/orbit-comfort-fit-band"
          }
        ]
      },
      {
        "@type": "Organization",
        "@id": "https://docs.example/#organization",
        "name": "Aurora Jewels",
        "url": "https://docs.example",
        "hasMerchantReturnPolicy": {
          "@type": "MerchantReturnPolicy",
          "applicableCountry": "US",
          "returnPolicyCountry": "US",
          "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
          "merchantReturnDays": 30,
          "returnMethod": "https://schema.org/ReturnByMail",
          "returnFees": "https://schema.org/ReturnShippingFees",
          "refundType": "https://schema.org/FullRefund"
        }
      }
    ]
  },
  "attributes": [
    {
      "key": "metal",
      "label": "Metal",
      "dataType": "select",
      "unit": null,
      "value": null,
      "values": [
        {
          "value": "14k_yellow_gold",
          "label": "14K Yellow Gold",
          "swatch": null
        }
      ]
    }
  ],
  "options": [
    {
      "id": "01a16987-50e2-786f-b45a-f8f3085d23d6",
      "key": "metal",
      "name": "Metal",
      "values": [
        {
          "value": "14k_yellow_gold",
          "label": "14K Yellow Gold",
          "swatch": null
        },
        {
          "value": "14k_white_gold",
          "label": "14K White Gold",
          "swatch": null
        },
        {
          "value": "14k_rose_gold",
          "label": "14K Rose Gold",
          "swatch": null
        },
        {
          "value": "platinum_950",
          "label": "Platinum 950",
          "swatch": null
        }
      ]
    }
  ],
  "variants": [
    {
      "id": "01a16987-5105-7906-9884-95b7eafae1ac",
      "sku": null,
      "title": "14K Yellow Gold",
      "optionValues": {
        "metal": "14k_yellow_gold"
      },
      "price": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "isAvailable": true,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "mediaId": null
    },
    {
      "id": "01a16987-5105-7a4a-9986-e2e19a63728f",
      "sku": null,
      "title": "14K White Gold",
      "optionValues": {
        "metal": "14k_white_gold"
      },
      "price": {
        "amount": 44100,
        "currency": "USD"
      },
      "compareAt": null,
      "isAvailable": true,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "mediaId": null
    },
    {
      "id": "01a16987-5105-7a93-a0c0-071fd9b1a5ff",
      "sku": null,
      "title": "14K Rose Gold",
      "optionValues": {
        "metal": "14k_rose_gold"
      },
      "price": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "isAvailable": true,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "mediaId": null
    },
    {
      "id": "01a16987-5105-7abe-9a5f-0116f79cdf43",
      "sku": null,
      "title": "Platinum 950",
      "optionValues": {
        "metal": "platinum_950"
      },
      "price": {
        "amount": 56700,
        "currency": "USD"
      },
      "compareAt": null,
      "isAvailable": true,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "mediaId": null
    }
  ],
  "media": [
    {
      "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
      "kind": "image",
      "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
      "mimeType": "image/png",
      "renditions": null,
      "alt": "Orbit Comfort-Fit Band, view 1",
      "width": 1200,
      "height": 1200,
      "position": 0,
      "variantIds": []
    },
    {
      "id": "01a16987-51fc-7cd8-920d-b5137caacb3f",
      "kind": "image",
      "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51fc-7cd8-920d-b5137caacb3f/original.png",
      "mimeType": "image/png",
      "renditions": null,
      "alt": "Orbit Comfort-Fit Band, view 2",
      "width": 1200,
      "height": 1200,
      "position": 1,
      "variantIds": []
    }
  ],
  "customizations": [
    {
      "id": "01a16987-4c34-7913-a8a4-8a782175ec55",
      "key": "ring_size",
      "label": "Ring size",
      "inputType": "select",
      "sizeSetId": "01a16987-4c2a-7222-b256-474f3818b89a",
      "options": [
        {
          "value": "3",
          "label": "3"
        },
        {
          "value": "3.25",
          "label": "3.25"
        },
        {
          "value": "3.5",
          "label": "3.5"
        },
        {
          "value": "3.75",
          "label": "3.75"
        },
        {
          "value": "4",
          "label": "4"
        },
        {
          "value": "4.25",
          "label": "4.25"
        },
        {
          "value": "4.5",
          "label": "4.5"
        },
        {
          "value": "4.75",
          "label": "4.75"
        },
        {
          "value": "5",
          "label": "5"
        },
        {
          "value": "5.25",
          "label": "5.25"
        },
        {
          "value": "5.5",
          "label": "5.5"
        },
        {
          "value": "5.75",
          "label": "5.75"
        },
        {
          "value": "6",
          "label": "6"
        },
        {
          "value": "6.25",
          "label": "6.25"
        },
        {
          "value": "6.5",
          "label": "6.5"
        },
        {
          "value": "6.75",
          "label": "6.75"
        },
        {
          "value": "7",
          "label": "7"
        },
        {
          "value": "7.25",
          "label": "7.25"
        },
        {
          "value": "7.5",
          "label": "7.5"
        },
        {
          "value": "7.75",
          "label": "7.75"
        },
        {
          "value": "8",
          "label": "8"
        },
        {
          "value": "8.25",
          "label": "8.25"
        },
        {
          "value": "8.5",
          "label": "8.5"
        },
        {
          "value": "8.75",
          "label": "8.75"
        },
        {
          "value": "9",
          "label": "9"
        },
        {
          "value": "9.25",
          "label": "9.25"
        },
        {
          "value": "9.5",
          "label": "9.5"
        },
        {
          "value": "9.75",
          "label": "9.75"
        },
        {
          "value": "10",
          "label": "10"
        },
        {
          "value": "10.25",
          "label": "10.25"
        },
        {
          "value": "10.5",
          "label": "10.5"
        },
        {
          "value": "10.75",
          "label": "10.75"
        },
        {
          "value": "11",
          "label": "11"
        },
        {
          "value": "11.25",
          "label": "11.25"
        },
        {
          "value": "11.5",
          "label": "11.5"
        },
        {
          "value": "11.75",
          "label": "11.75"
        },
        {
          "value": "12",
          "label": "12"
        },
        {
          "value": "12.25",
          "label": "12.25"
        },
        {
          "value": "12.5",
          "label": "12.5"
        },
        {
          "value": "12.75",
          "label": "12.75"
        },
        {
          "value": "13",
          "label": "13"
        }
      ],
      "isRequired": true,
      "priceDeltaCents": 0,
      "maxLength": null,
      "pattern": null,
      "accept": null,
      "helpText": "US sizes 3 to 13 in quarter steps. Free resizing within a year.",
      "affectsLeadTimeDays": 0,
      "position": 0,
      "createdAt": "2026-10-23T16:10:36.912Z",
      "updatedAt": "2026-10-23T16:10:36.912Z"
    },
    {
      "id": "01a16987-4c34-7d05-98cb-9190b9b1fa65",
      "key": "engraving",
      "label": "Engraving",
      "inputType": "text",
      "sizeSetId": null,
      "options": null,
      "isRequired": false,
      "priceDeltaCents": 0,
      "maxLength": 20,
      "pattern": "^[A-Za-z0-9 ♥&.]*$",
      "accept": null,
      "helpText": "Up to 20 characters: letters, digits, spaces, ♥, & and .",
      "affectsLeadTimeDays": 2,
      "position": 1,
      "createdAt": "2026-10-23T16:10:36.912Z",
      "updatedAt": "2026-10-23T16:10:36.912Z"
    },
    {
      "id": "01a16987-4c34-7d73-84e6-c992049e834a",
      "key": "gift_message",
      "label": "Gift message",
      "inputType": "text",
      "sizeSetId": null,
      "options": null,
      "isRequired": false,
      "priceDeltaCents": 0,
      "maxLength": 200,
      "pattern": null,
      "accept": null,
      "helpText": null,
      "affectsLeadTimeDays": 0,
      "position": 3,
      "createdAt": "2026-10-23T16:10:36.912Z",
      "updatedAt": "2026-10-23T16:10:36.912Z"
    }
  ],
  "configurator": null,
  "related": [],
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "auction": null
};
const example_getProduct_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Product not found",
    "requestId": "req_example"
  }
};
const example_getSizeSet_200: unknown = {
  "id": "01a16987-4c2a-7222-b256-474f3818b89a",
  "key": "us_ring_sizes",
  "name": "US ring sizes",
  "system": "us",
  "unit": null,
  "sizeGuideHandle": null,
  "values": [
    {
      "id": "01a16987-4c2e-7c2c-969e-969f4818966f",
      "value": "3",
      "label": "3",
      "numericValue": 3,
      "equivalents": {
        "eu": "44",
        "uk": "F",
        "diameterMm": 14.07,
        "circumferenceMm": 44.2
      },
      "position": 0
    },
    {
      "id": "01a16987-4c2f-701b-a495-3099d9e4db7c",
      "value": "3.25",
      "label": "3.25",
      "numericValue": 3.25,
      "equivalents": {
        "eu": "45",
        "uk": "F½",
        "diameterMm": 14.26,
        "circumferenceMm": 44.8
      },
      "position": 1
    },
    {
      "id": "01a16987-4c2f-7069-8030-7f0915854437",
      "value": "3.5",
      "label": "3.5",
      "numericValue": 3.5,
      "equivalents": {
        "eu": "46",
        "uk": "G",
        "diameterMm": 14.48,
        "circumferenceMm": 45.5
      },
      "position": 2
    },
    {
      "id": "01a16987-4c2f-709a-b0ee-45d8500cb75c",
      "value": "3.75",
      "label": "3.75",
      "numericValue": 3.75,
      "equivalents": {
        "eu": "46",
        "uk": "G½",
        "diameterMm": 14.67,
        "circumferenceMm": 46.1
      },
      "position": 3
    },
    {
      "id": "01a16987-4c2f-70b1-b945-0bf4e30e863e",
      "value": "4",
      "label": "4",
      "numericValue": 4,
      "equivalents": {
        "eu": "47",
        "uk": "H",
        "diameterMm": 14.9,
        "circumferenceMm": 46.8
      },
      "position": 4
    },
    {
      "id": "01a16987-4c2f-70c3-b492-f95faf29aa8b",
      "value": "4.25",
      "label": "4.25",
      "numericValue": 4.25,
      "equivalents": {
        "eu": "47",
        "uk": "H½",
        "diameterMm": 15.09,
        "circumferenceMm": 47.4
      },
      "position": 5
    },
    {
      "id": "01a16987-4c2f-70d4-9ecb-bfa26cf0ae87",
      "value": "4.5",
      "label": "4.5",
      "numericValue": 4.5,
      "equivalents": {
        "eu": "48",
        "uk": "I",
        "diameterMm": 15.28,
        "circumferenceMm": 48
      },
      "position": 6
    },
    {
      "id": "01a16987-4c2f-70e6-89bb-34ea7d1caa1f",
      "value": "4.75",
      "label": "4.75",
      "numericValue": 4.75,
      "equivalents": {
        "eu": "49",
        "uk": "J",
        "diameterMm": 15.5,
        "circumferenceMm": 48.7
      },
      "position": 7
    },
    {
      "id": "01a16987-4c2f-70f6-a693-2f35b2cfe7c3",
      "value": "5",
      "label": "5",
      "numericValue": 5,
      "equivalents": {
        "eu": "49",
        "uk": "J½",
        "diameterMm": 15.69,
        "circumferenceMm": 49.3
      },
      "position": 8
    },
    {
      "id": "01a16987-4c2f-7107-9d90-296db2fbd739",
      "value": "5.25",
      "label": "5.25",
      "numericValue": 5.25,
      "equivalents": {
        "eu": "50",
        "uk": "K",
        "diameterMm": 15.88,
        "circumferenceMm": 49.9
      },
      "position": 9
    },
    {
      "id": "01a16987-4c2f-7169-8254-db7f1815580b",
      "value": "5.5",
      "label": "5.5",
      "numericValue": 5.5,
      "equivalents": {
        "eu": "51",
        "uk": "K½",
        "diameterMm": 16.11,
        "circumferenceMm": 50.6
      },
      "position": 10
    },
    {
      "id": "01a16987-4c2f-7187-ac16-4eca7989b1d0",
      "value": "5.75",
      "label": "5.75",
      "numericValue": 5.75,
      "equivalents": {
        "eu": "51",
        "uk": "L",
        "diameterMm": 16.3,
        "circumferenceMm": 51.2
      },
      "position": 11
    },
    {
      "id": "01a16987-4c2f-7199-9cd1-dad084818c94",
      "value": "6",
      "label": "6",
      "numericValue": 6,
      "equivalents": {
        "eu": "52",
        "uk": "L½",
        "diameterMm": 16.52,
        "circumferenceMm": 51.9
      },
      "position": 12
    },
    {
      "id": "01a16987-4c2f-71aa-914e-9ff7edb75c17",
      "value": "6.25",
      "label": "6.25",
      "numericValue": 6.25,
      "equivalents": {
        "eu": "53",
        "uk": "M",
        "diameterMm": 16.71,
        "circumferenceMm": 52.5
      },
      "position": 13
    },
    {
      "id": "01a16987-4c2f-71ba-ab39-dbf63c0d5992",
      "value": "6.5",
      "label": "6.5",
      "numericValue": 6.5,
      "equivalents": {
        "eu": "53",
        "uk": "M½",
        "diameterMm": 16.9,
        "circumferenceMm": 53.1
      },
      "position": 14
    },
    {
      "id": "01a16987-4c2f-7c5a-bcc0-96d4993f8a63",
      "value": "6.75",
      "label": "6.75",
      "numericValue": 6.75,
      "equivalents": {
        "eu": "54",
        "uk": "N",
        "diameterMm": 17.13,
        "circumferenceMm": 53.8
      },
      "position": 15
    },
    {
      "id": "01a16987-4c2f-7ca1-addc-69f739fccb5f",
      "value": "7",
      "label": "7",
      "numericValue": 7,
      "equivalents": {
        "eu": "54",
        "uk": "N½",
        "diameterMm": 17.32,
        "circumferenceMm": 54.4
      },
      "position": 16
    },
    {
      "id": "01a16987-4c2f-7cb9-9af4-9a0c85e91ccf",
      "value": "7.25",
      "label": "7.25",
      "numericValue": 7.25,
      "equivalents": {
        "eu": "55",
        "uk": "O",
        "diameterMm": 17.51,
        "circumferenceMm": 55
      },
      "position": 17
    },
    {
      "id": "01a16987-4c2f-7ccc-94d4-9cca872df737",
      "value": "7.5",
      "label": "7.5",
      "numericValue": 7.5,
      "equivalents": {
        "eu": "56",
        "uk": "O½",
        "diameterMm": 17.73,
        "circumferenceMm": 55.7
      },
      "position": 18
    },
    {
      "id": "01a16987-4c2f-7d3e-be57-de3eb65cc07f",
      "value": "7.75",
      "label": "7.75",
      "numericValue": 7.75,
      "equivalents": {
        "eu": "56",
        "uk": "P",
        "diameterMm": 17.92,
        "circumferenceMm": 56.3
      },
      "position": 19
    },
    {
      "id": "01a16987-4c2f-7d5c-aeab-5959247d72f2",
      "value": "8",
      "label": "8",
      "numericValue": 8,
      "equivalents": {
        "eu": "57",
        "uk": "P½",
        "diameterMm": 18.14,
        "circumferenceMm": 57
      },
      "position": 20
    },
    {
      "id": "01a16987-4c2f-7d6f-bfb0-83fffdc96a46",
      "value": "8.25",
      "label": "8.25",
      "numericValue": 8.25,
      "equivalents": {
        "eu": "58",
        "uk": "Q",
        "diameterMm": 18.33,
        "circumferenceMm": 57.6
      },
      "position": 21
    },
    {
      "id": "01a16987-4c2f-7d82-8ac7-ad2eb88d7780",
      "value": "8.5",
      "label": "8.5",
      "numericValue": 8.5,
      "equivalents": {
        "eu": "58",
        "uk": "Q½",
        "diameterMm": 18.53,
        "circumferenceMm": 58.2
      },
      "position": 22
    },
    {
      "id": "01a16987-4c2f-7d94-84e0-b496680ac92f",
      "value": "8.75",
      "label": "8.75",
      "numericValue": 8.75,
      "equivalents": {
        "eu": "59",
        "uk": "R",
        "diameterMm": 18.75,
        "circumferenceMm": 58.9
      },
      "position": 23
    },
    {
      "id": "01a16987-4c2f-7da5-b442-0bf7a6022000",
      "value": "9",
      "label": "9",
      "numericValue": 9,
      "equivalents": {
        "eu": "60",
        "uk": "R½",
        "diameterMm": 18.94,
        "circumferenceMm": 59.5
      },
      "position": 24
    },
    {
      "id": "01a16987-4c2f-7db7-8562-043e2e051804",
      "value": "9.25",
      "label": "9.25",
      "numericValue": 9.25,
      "equivalents": {
        "eu": "60",
        "uk": "S",
        "diameterMm": 19.13,
        "circumferenceMm": 60.1
      },
      "position": 25
    },
    {
      "id": "01a16987-4c2f-7dc8-ab46-62abe6336dd3",
      "value": "9.5",
      "label": "9.5",
      "numericValue": 9.5,
      "equivalents": {
        "eu": "61",
        "uk": "S½",
        "diameterMm": 19.35,
        "circumferenceMm": 60.8
      },
      "position": 26
    },
    {
      "id": "01a16987-4c2f-7dd9-918a-42186f1245ac",
      "value": "9.75",
      "label": "9.75",
      "numericValue": 9.75,
      "equivalents": {
        "eu": "61",
        "uk": "T",
        "diameterMm": 19.54,
        "circumferenceMm": 61.4
      },
      "position": 27
    },
    {
      "id": "01a16987-4c2f-7dea-9cbe-31a425529330",
      "value": "10",
      "label": "10",
      "numericValue": 10,
      "equivalents": {
        "eu": "62",
        "uk": "T½",
        "diameterMm": 19.77,
        "circumferenceMm": 62.1
      },
      "position": 28
    },
    {
      "id": "01a16987-4c2f-7dfc-adb5-d0b3ebdeae4f",
      "value": "10.25",
      "label": "10.25",
      "numericValue": 10.25,
      "equivalents": {
        "eu": "63",
        "uk": "U",
        "diameterMm": 19.96,
        "circumferenceMm": 62.7
      },
      "position": 29
    },
    {
      "id": "01a16987-4c2f-7e4e-89a0-7ec5edb6ad3c",
      "value": "10.5",
      "label": "10.5",
      "numericValue": 10.5,
      "equivalents": {
        "eu": "63",
        "uk": "U½",
        "diameterMm": 20.15,
        "circumferenceMm": 63.3
      },
      "position": 30
    },
    {
      "id": "01a16987-4c2f-7e6f-99cd-5dcd8861ab71",
      "value": "10.75",
      "label": "10.75",
      "numericValue": 10.75,
      "equivalents": {
        "eu": "64",
        "uk": "V",
        "diameterMm": 20.37,
        "circumferenceMm": 64
      },
      "position": 31
    },
    {
      "id": "01a16987-4c2f-7e88-ae38-ab7c5608ef33",
      "value": "11",
      "label": "11",
      "numericValue": 11,
      "equivalents": {
        "eu": "65",
        "uk": "V½",
        "diameterMm": 20.56,
        "circumferenceMm": 64.6
      },
      "position": 32
    },
    {
      "id": "01a16987-4c2f-7e9b-82de-ea38ae689708",
      "value": "11.25",
      "label": "11.25",
      "numericValue": 11.25,
      "equivalents": {
        "eu": "65",
        "uk": "W",
        "diameterMm": 20.75,
        "circumferenceMm": 65.2
      },
      "position": 33
    },
    {
      "id": "01a16987-4c2f-7eae-a0f5-259b8abab504",
      "value": "11.5",
      "label": "11.5",
      "numericValue": 11.5,
      "equivalents": {
        "eu": "66",
        "uk": "W½",
        "diameterMm": 20.98,
        "circumferenceMm": 65.9
      },
      "position": 34
    },
    {
      "id": "01a16987-4c2f-7ec0-9ab2-9d44cb4e63ab",
      "value": "11.75",
      "label": "11.75",
      "numericValue": 11.75,
      "equivalents": {
        "eu": "67",
        "uk": "X",
        "diameterMm": 21.17,
        "circumferenceMm": 66.5
      },
      "position": 35
    },
    {
      "id": "01a16987-4c2f-7ed1-a6a1-2166bf63fc05",
      "value": "12",
      "label": "12",
      "numericValue": 12,
      "equivalents": {
        "eu": "67",
        "uk": "X½",
        "diameterMm": 21.39,
        "circumferenceMm": 67.2
      },
      "position": 36
    },
    {
      "id": "01a16987-4c2f-7ee2-b384-11064e2b0c8c",
      "value": "12.25",
      "label": "12.25",
      "numericValue": 12.25,
      "equivalents": {
        "eu": "68",
        "uk": "Y",
        "diameterMm": 21.58,
        "circumferenceMm": 67.8
      },
      "position": 37
    },
    {
      "id": "01a16987-4c2f-7ef3-8550-e78159ba7658",
      "value": "12.5",
      "label": "12.5",
      "numericValue": 12.5,
      "equivalents": {
        "eu": "68",
        "uk": "Y½",
        "diameterMm": 21.77,
        "circumferenceMm": 68.4
      },
      "position": 38
    },
    {
      "id": "01a16987-4c2f-7f03-9e64-fae441715c09",
      "value": "12.75",
      "label": "12.75",
      "numericValue": 12.75,
      "equivalents": {
        "eu": "69",
        "uk": "Z",
        "diameterMm": 22,
        "circumferenceMm": 69.1
      },
      "position": 39
    },
    {
      "id": "01a16987-4c2f-7f14-b33d-db7e06c9e1f0",
      "value": "13",
      "label": "13",
      "numericValue": 13,
      "equivalents": {
        "eu": "70",
        "uk": "Z½",
        "diameterMm": 22.19,
        "circumferenceMm": 69.7
      },
      "position": 40
    }
  ]
};
const example_getSizeSet_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Size set not found",
    "requestId": "req_example"
  }
};
const example_getPage_200: unknown = {
  "id": "01a16987-5eb9-7437-939d-a55fa51f00fb",
  "handle": "about",
  "title": "About Aurora Jewels",
  "bodyHtml": "<p>Aurora Jewels makes lab-grown diamond and moissanite bridal jewelry to order. Every piece is designed in-house and set by hand.</p>",
  "template": "default",
  "blocks": null,
  "seo": {
    "title": "About Aurora Jewels | Aurora Jewels",
    "description": "Aurora Jewels makes lab-grown diamond and moissanite bridal jewelry to order. Every piece is designed in-house and set by hand.",
    "canonical": "https://docs.example/pages/about",
    "robots": "index, follow",
    "openGraph": {
      "title": "About Aurora Jewels",
      "description": "Aurora Jewels makes lab-grown diamond and moissanite bridal jewelry to order. Every piece is designed in-house and set by hand.",
      "image": null,
      "type": "website"
    },
    "twitter": {
      "card": "summary",
      "site": null
    },
    "warnings": []
  },
  "jsonld": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "name": "About Aurora Jewels",
        "description": "Aurora Jewels makes lab-grown diamond and moissanite bridal jewelry to order. Every piece is designed in-house and set by hand.",
        "url": "https://docs.example/pages/about",
        "dateModified": "2026-10-23T16:10:41.718Z",
        "datePublished": "2026-10-23T16:10:41.719Z"
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Aurora Jewels",
            "item": "https://docs.example"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "About Aurora Jewels",
            "item": "https://docs.example/pages/about"
          }
        ]
      },
      {
        "@type": "Organization",
        "@id": "https://docs.example/#organization",
        "name": "Aurora Jewels",
        "url": "https://docs.example",
        "hasMerchantReturnPolicy": {
          "@type": "MerchantReturnPolicy",
          "applicableCountry": "US",
          "returnPolicyCountry": "US",
          "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
          "merchantReturnDays": 30,
          "returnMethod": "https://schema.org/ReturnByMail",
          "returnFees": "https://schema.org/ReturnShippingFees",
          "refundType": "https://schema.org/FullRefund"
        }
      }
    ]
  },
  "publishedAt": "2026-10-23T16:10:41.719Z",
  "updatedAt": "2026-10-23T16:10:41.718Z"
};
const example_getPage_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Page not found",
    "requestId": "req_example"
  }
};
const example_lookupRedirect_200: unknown = {
  "toPath": "/products/aurora-oval-solitaire",
  "statusCode": 301
};
const example_lookupRedirect_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "No redirect for this path",
    "requestId": "req_example"
  }
};
const example_getSitemapIndex_200: unknown = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<sitemapindex xmlns=\"http://www.sitemaps.org/schemas/sitemap/0.9\">\n  <sitemap><loc>https://docs.example/sitemaps/products-1.xml</loc></sitemap>\n  <sitemap><loc>https://docs.example/sitemaps/collections-1.xml</loc></sitemap>\n  <sitemap><loc>https://docs.example/sitemaps/sales-1.xml</loc></sitemap>\n  <sitemap><loc>https://docs.example/sitemaps/pages-1.xml</loc></sitemap>\n  <sitemap><loc>https://docs.example/sitemaps/policies-1.xml</loc></sitemap>\n  <sitemap><loc>https://docs.example/sitemaps/blog-1.xml</loc></sitemap>\n  <sitemap><loc>https://docs.example/sitemaps/help-1.xml</loc></sitemap>\n</sitemapindex>\n";
const example_getSitemap_200: unknown = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<urlset xmlns=\"http://www.sitemaps.org/schemas/sitemap/0.9\" xmlns:image=\"http://www.google.com/schemas/sitemap-image/1.1\">\n  <url>\n    <loc>https://docs.example/products/arc-curved-contour-band</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-546f-7634-82da-2ee2ccdc1e2d/original.png</image:loc><image:caption>Arc Curved Contour Band, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/aurora-bridal-set</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5524-707d-9ee7-1fac6816ef63/original.png</image:loc><image:caption>Aurora Bridal Set, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/aurora-oval-solitaire</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4d56-73a8-b6ca-12aedaee71ca/original.png</image:loc><image:caption>Aurora Oval Solitaire, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/cascade-drop-earrings</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5b4b-71ec-b1fc-5c6d4120c8ee/original.png</image:loc><image:caption>Cascade Drop Earrings, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/celeste-pear-trilogy</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4f13-7a99-8350-a1b89c575ba9/original.png</image:loc><image:caption>Celeste Pear Trilogy, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/drift-diamond-pendant</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png</image:loc><image:caption>Drift Diamond Pendant, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/ember-sapphire-pendant</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5831-79ee-9d9d-263cebc09016/original.png</image:loc><image:caption>Ember Sapphire Pendant, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/halo-pave-eternity</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5284-71b8-b596-12f6f07f574c/original.png</image:loc><image:caption>Halo Pavé Eternity, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/line-tennis-bracelet</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5be5-737b-a27f-58b1dd4bd31a/original.png</image:loc><image:caption>Line Tennis Bracelet, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/loop-paperclip-bracelet</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5d21-71bf-8239-5f610a2e02f3/original.png</image:loc><image:caption>Loop Paperclip Bracelet, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/luna-round-halo</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4e5a-799b-bab4-c098b5b9fea8/original.png</image:loc><image:caption>Luna Round Halo, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/meridian-station-necklace</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5792-797e-9784-46c6b523a509/original.png</image:loc><image:caption>Meridian Station Necklace, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/nova-moissanite-cushion</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4fce-7e74-9494-9e5478b562fd/original.png</image:loc><image:caption>Nova Moissanite Cushion, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/orbit-comfort-fit-band</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png</image:loc><image:caption>Orbit Comfort-Fit Band, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/petal-huggie-hoops</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5aae-7894-b2e9-0a29486997ee/original.png</image:loc><image:caption>Petal Huggie Hoops, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/spark-diamond-studs</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-596f-733b-a52a-2163095d1de7/original.png</image:loc><image:caption>Spark Diamond Studs, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/tide-hammered-band</loc>\n    <lastmod>2026-10-23T16:10:41.383Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-53cd-7516-8d4a-7ec5f812d37d/original.png</image:loc><image:caption>Tide Hammered Band, view 1</image:caption></image:image>\n  </url>\n  <url>\n    <loc>https://docs.example/products/vela-emerald-cut-bezel</loc>\n    <lastmod>2026-10-23T16:10:42.381Z</lastmod>\n    <image:image><image:loc>http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-507a-75aa-96d9-57c2f566149c/original.png</image:loc><image:caption>Vela Emerald-Cut Bezel, view 1</image:caption></image:image>\n  </url>\n</urlset>\n";
const example_getSitemap_400: unknown = {
  "error": {
    "code": "VALIDATION_ERROR",
    "message": "Request validation failed",
    "requestId": "req_example",
    "details": [
      {
        "field": "params.name",
        "code": "invalid_format",
        "message": "Invalid string: must match pattern /^(products|collections|sales|pages|policies|blog|help)-1\\.xml$/"
      }
    ]
  }
};
const example_getRobots_200: unknown = "User-agent: *\nDisallow: /cart\nDisallow: /checkout\nDisallow: /account\nDisallow: /search\nAllow: /\n\nSitemap: https://docs.example/sitemap.xml\n";
const example_listPolicies_200: unknown = {
  "items": [
    {
      "kind": "terms",
      "handle": "terms",
      "title": "Terms of sale",
      "summary": "Prices include the stone, setting and a certificate; made-to-order pieces ship within the quoted lead time.",
      "updatedAt": "2026-10-23T16:10:41.741Z"
    },
    {
      "kind": "privacy",
      "handle": "privacy",
      "title": "Privacy policy",
      "summary": "We keep only what an order needs and never sell personal data.",
      "updatedAt": "2026-10-23T16:10:41.760Z"
    },
    {
      "kind": "shipping",
      "handle": "shipping",
      "title": "Shipping",
      "summary": "Insured shipping on every order; free over the threshold shown at checkout.",
      "updatedAt": "2026-10-23T16:10:41.777Z"
    },
    {
      "kind": "returns",
      "handle": "returns",
      "title": "Returns and exchanges",
      "summary": "Thirty days to return an unworn piece; engraved and custom pieces are final sale.",
      "updatedAt": "2026-10-23T16:10:41.793Z"
    },
    {
      "kind": "warranty",
      "handle": "warranty",
      "title": "Lifetime warranty",
      "summary": "Manufacturing defects are repaired free for life.",
      "updatedAt": "2026-10-23T16:10:41.809Z"
    },
    {
      "kind": "resizing",
      "handle": "resizing",
      "title": "Free resizing",
      "summary": "One free resize within twelve months.",
      "updatedAt": "2026-10-23T16:10:41.825Z"
    }
  ]
};
const example_getPolicy_200: unknown = {
  "kind": "returns",
  "handle": "returns",
  "title": "Returns and exchanges",
  "summary": "Thirty days to return an unworn piece; engraved and custom pieces are final sale.",
  "bodyHtml": "<p>Return an unworn piece within thirty days for a refund to the original payment method. Engraved and custom-designed pieces are made for you and cannot be returned.</p>",
  "seo": {
    "title": "Returns and exchanges | Aurora Jewels",
    "description": "Thirty days to return an unworn piece; engraved and custom pieces are final sale.",
    "canonical": "https://docs.example/policies/returns",
    "robots": "index, follow",
    "openGraph": {
      "title": "Returns and exchanges",
      "description": "Thirty days to return an unworn piece; engraved and custom pieces are final sale.",
      "image": null,
      "type": "website"
    },
    "twitter": {
      "card": "summary",
      "site": null
    },
    "warnings": []
  },
  "jsonld": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "name": "Returns and exchanges",
        "description": "Thirty days to return an unworn piece; engraved and custom pieces are final sale.",
        "url": "https://docs.example/policies/returns",
        "dateModified": "2026-10-23T16:10:41.793Z",
        "datePublished": "2026-10-23T16:10:41.794Z"
      },
      {
        "@type": "MerchantReturnPolicy",
        "applicableCountry": "US",
        "returnPolicyCountry": "US",
        "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
        "merchantReturnDays": 30,
        "returnMethod": "https://schema.org/ReturnByMail",
        "returnFees": "https://schema.org/ReturnShippingFees",
        "refundType": "https://schema.org/FullRefund"
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Aurora Jewels",
            "item": "https://docs.example"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Returns and exchanges",
            "item": "https://docs.example/policies/returns"
          }
        ]
      },
      {
        "@type": "Organization",
        "@id": "https://docs.example/#organization",
        "name": "Aurora Jewels",
        "url": "https://docs.example",
        "hasMerchantReturnPolicy": {
          "@type": "MerchantReturnPolicy",
          "applicableCountry": "US",
          "returnPolicyCountry": "US",
          "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
          "merchantReturnDays": 30,
          "returnMethod": "https://schema.org/ReturnByMail",
          "returnFees": "https://schema.org/ReturnShippingFees",
          "refundType": "https://schema.org/FullRefund"
        }
      }
    ]
  },
  "publishedAt": "2026-10-23T16:10:41.794Z",
  "updatedAt": "2026-10-23T16:10:41.793Z"
};
const example_getPolicy_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Policy not found",
    "requestId": "req_example"
  }
};
const example_listBlogCategories_200: unknown = {
  "items": [
    {
      "id": "01a16987-6040-7dae-a74a-5acc1965adf4",
      "handle": "guides",
      "title": "Guides",
      "description": "Sizing, care and buying guides",
      "position": 0,
      "postCount": 1
    }
  ]
};
const example_listBlogPosts_200: unknown = {
  "items": [
    {
      "id": "01a16987-6057-7ca5-9e07-86eedd63a802",
      "handle": "caring-for-lab-grown-diamonds",
      "title": "Caring for lab-grown diamonds",
      "excerpt": "Warm water, a soft brush and nothing else.",
      "featuredMedia": null,
      "authorName": null,
      "category": {
        "id": "01a16987-6040-7dae-a74a-5acc1965adf4",
        "handle": "guides",
        "title": "Guides"
      },
      "tags": [
        "care"
      ],
      "publishedAt": "2026-10-23T16:10:42.120Z"
    },
    {
      "id": "01a16987-5f4a-7661-9b64-6f401113df06",
      "handle": "how-to-find-your-ring-size",
      "title": "How to find your ring size at home",
      "excerpt": "Three ways to measure, and which one to trust.",
      "featuredMedia": null,
      "authorName": "Aurora Jewels",
      "category": null,
      "tags": [
        "guides"
      ],
      "publishedAt": "2026-10-23T16:10:41.858Z"
    }
  ],
  "nextCursor": null
};
const example_getBlogPost_200: unknown = {
  "id": "01a16987-6057-7ca5-9e07-86eedd63a802",
  "handle": "caring-for-lab-grown-diamonds",
  "title": "Caring for lab-grown diamonds",
  "excerpt": "Warm water, a soft brush and nothing else.",
  "featuredMedia": null,
  "authorName": null,
  "category": {
    "id": "01a16987-6040-7dae-a74a-5acc1965adf4",
    "handle": "guides",
    "title": "Guides"
  },
  "tags": [
    "care"
  ],
  "publishedAt": "2026-10-23T16:10:42.120Z",
  "bodyHtml": "<p>Soak the ring in warm water with a drop of dish soap, brush behind the stone and rinse.</p>",
  "seo": {
    "title": "Caring for lab-grown diamonds | Aurora Jewels",
    "description": "Warm water, a soft brush and nothing else.",
    "canonical": "https://docs.example/blog/caring-for-lab-grown-diamonds",
    "robots": "index, follow",
    "openGraph": {
      "title": "Caring for lab-grown diamonds",
      "description": "Warm water, a soft brush and nothing else.",
      "image": null,
      "type": "article"
    },
    "twitter": {
      "card": "summary",
      "site": null
    },
    "warnings": [
      "image_missing"
    ]
  },
  "jsonld": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BlogPosting",
        "headline": "Caring for lab-grown diamonds",
        "description": "Warm water, a soft brush and nothing else.",
        "url": "https://docs.example/blog/caring-for-lab-grown-diamonds",
        "mainEntityOfPage": "https://docs.example/blog/caring-for-lab-grown-diamonds",
        "author": {
          "@type": "Organization",
          "name": "Aurora Jewels",
          "url": "https://docs.example"
        },
        "publisher": {
          "@type": "Organization",
          "name": "Aurora Jewels",
          "url": "https://docs.example"
        },
        "datePublished": "2026-10-23T16:10:42.120Z",
        "dateModified": "2026-10-23T16:10:42.134Z",
        "keywords": "care",
        "articleSection": "Guides"
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Aurora Jewels",
            "item": "https://docs.example"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Blog",
            "item": "https://docs.example/blog"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Guides",
            "item": "https://docs.example/blog/category/guides"
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": "Caring for lab-grown diamonds",
            "item": "https://docs.example/blog/caring-for-lab-grown-diamonds"
          }
        ]
      },
      {
        "@type": "Organization",
        "@id": "https://docs.example/#organization",
        "name": "Aurora Jewels",
        "url": "https://docs.example",
        "hasMerchantReturnPolicy": {
          "@type": "MerchantReturnPolicy",
          "applicableCountry": "US",
          "returnPolicyCountry": "US",
          "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
          "merchantReturnDays": 30,
          "returnMethod": "https://schema.org/ReturnByMail",
          "returnFees": "https://schema.org/ReturnShippingFees",
          "refundType": "https://schema.org/FullRefund"
        }
      }
    ]
  },
  "updatedAt": "2026-10-23T16:10:42.134Z"
};
const example_getMenu_200: unknown = {
  "handle": "main",
  "title": "Main menu",
  "items": [
    {
      "id": "01a16987-607e-789e-8949-7792594e388d",
      "title": "Engagement rings",
      "url": "/collections/engagement-rings",
      "openInNewTab": false,
      "children": [
        {
          "id": "01a16987-6082-7421-9457-04158b12c21a",
          "title": "Under $1,000",
          "url": "/collections/under-1000",
          "openInNewTab": false,
          "children": []
        }
      ]
    },
    {
      "id": "01a16987-6080-717c-bc75-5218bffbaf8d",
      "title": "Wedding bands",
      "url": "/collections/wedding-bands",
      "openInNewTab": false,
      "children": []
    },
    {
      "id": "01a16987-6080-71e5-ae71-550fd24da560",
      "title": "About",
      "url": "/pages/about",
      "openInNewTab": false,
      "children": []
    }
  ]
};
const example_getIndexNowKey_200: unknown = "c7c4ed6403bc4adda46adb3f9cf0f477";
const example_trackEvents_202: unknown = {
  "accepted": 1
};
const example_listCollections_200: unknown = {
  "items": [
    {
      "id": "01a16987-5e14-7ee4-b776-c1b368508592",
      "handle": "bestsellers",
      "title": "Bestsellers",
      "descriptionHtml": null,
      "role": "merchandising",
      "eyebrow": null,
      "productType": null,
      "media": null,
      "seo": {
        "title": "Bestsellers | Aurora Jewels",
        "description": null,
        "canonical": "https://docs.example/collections/bestsellers",
        "robots": "index, follow",
        "openGraph": {
          "title": "Bestsellers",
          "description": null,
          "image": null,
          "type": "website"
        },
        "twitter": {
          "card": "summary",
          "site": null
        },
        "warnings": [
          "description_missing",
          "image_missing"
        ]
      },
      "jsonld": {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "CollectionPage",
            "name": "Bestsellers",
            "url": "https://docs.example/collections/bestsellers",
            "mainEntity": {
              "@type": "ItemList",
              "numberOfItems": 5,
              "itemListElement": []
            }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Aurora Jewels",
                "item": "https://docs.example"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Bestsellers",
                "item": "https://docs.example/collections/bestsellers"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://docs.example/#organization",
            "name": "Aurora Jewels",
            "url": "https://docs.example",
            "hasMerchantReturnPolicy": {
              "@type": "MerchantReturnPolicy",
              "applicableCountry": "US",
              "returnPolicyCountry": "US",
              "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
              "merchantReturnDays": 30,
              "returnMethod": "https://schema.org/ReturnByMail",
              "returnFees": "https://schema.org/ReturnShippingFees",
              "refundType": "https://schema.org/FullRefund"
            }
          }
        ]
      },
      "sortOrder": "manual",
      "sortBasis": "manual",
      "productCount": 5
    },
    {
      "id": "01a16987-5d96-74f6-8129-85adae941585",
      "handle": "engagement-rings",
      "title": "Engagement Rings",
      "descriptionHtml": null,
      "role": "merchandising",
      "eyebrow": null,
      "productType": null,
      "media": null,
      "seo": {
        "title": "Engagement Rings | Aurora Jewels",
        "description": null,
        "canonical": "https://docs.example/collections/engagement-rings",
        "robots": "index, follow",
        "openGraph": {
          "title": "Engagement Rings",
          "description": null,
          "image": null,
          "type": "website"
        },
        "twitter": {
          "card": "summary",
          "site": null
        },
        "warnings": [
          "description_missing",
          "image_missing"
        ]
      },
      "jsonld": {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "CollectionPage",
            "name": "Engagement Rings",
            "url": "https://docs.example/collections/engagement-rings",
            "mainEntity": {
              "@type": "ItemList",
              "numberOfItems": 6,
              "itemListElement": []
            }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Aurora Jewels",
                "item": "https://docs.example"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Engagement Rings",
                "item": "https://docs.example/collections/engagement-rings"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://docs.example/#organization",
            "name": "Aurora Jewels",
            "url": "https://docs.example",
            "hasMerchantReturnPolicy": {
              "@type": "MerchantReturnPolicy",
              "applicableCountry": "US",
              "returnPolicyCountry": "US",
              "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
              "merchantReturnDays": 30,
              "returnMethod": "https://schema.org/ReturnByMail",
              "returnFees": "https://schema.org/ReturnShippingFees",
              "refundType": "https://schema.org/FullRefund"
            }
          }
        ]
      },
      "sortOrder": "manual",
      "sortBasis": "manual",
      "productCount": 6
    },
    {
      "id": "01a16987-5df1-717d-a8c6-b031e6c62703",
      "handle": "under-1000",
      "title": "Under $1,000",
      "descriptionHtml": null,
      "role": "merchandising",
      "eyebrow": null,
      "productType": null,
      "media": null,
      "seo": {
        "title": "Under $1,000 | Aurora Jewels",
        "description": null,
        "canonical": "https://docs.example/collections/under-1000",
        "robots": "index, follow",
        "openGraph": {
          "title": "Under $1,000",
          "description": null,
          "image": null,
          "type": "website"
        },
        "twitter": {
          "card": "summary",
          "site": null
        },
        "warnings": [
          "description_missing",
          "image_missing"
        ]
      },
      "jsonld": {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "CollectionPage",
            "name": "Under $1,000",
            "url": "https://docs.example/collections/under-1000",
            "mainEntity": {
              "@type": "ItemList",
              "numberOfItems": 9,
              "itemListElement": []
            }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Aurora Jewels",
                "item": "https://docs.example"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Under $1,000",
                "item": "https://docs.example/collections/under-1000"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://docs.example/#organization",
            "name": "Aurora Jewels",
            "url": "https://docs.example",
            "hasMerchantReturnPolicy": {
              "@type": "MerchantReturnPolicy",
              "applicableCountry": "US",
              "returnPolicyCountry": "US",
              "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
              "merchantReturnDays": 30,
              "returnMethod": "https://schema.org/ReturnByMail",
              "returnFees": "https://schema.org/ReturnShippingFees",
              "refundType": "https://schema.org/FullRefund"
            }
          }
        ]
      },
      "sortOrder": "manual",
      "sortBasis": "manual",
      "productCount": 9
    },
    {
      "id": "01a16987-5dcd-7a9f-81ef-0b9df1f5a187",
      "handle": "wedding-bands",
      "title": "Wedding Bands",
      "descriptionHtml": null,
      "role": "merchandising",
      "eyebrow": null,
      "productType": null,
      "media": null,
      "seo": {
        "title": "Wedding Bands | Aurora Jewels",
        "description": null,
        "canonical": "https://docs.example/collections/wedding-bands",
        "robots": "index, follow",
        "openGraph": {
          "title": "Wedding Bands",
          "description": null,
          "image": null,
          "type": "website"
        },
        "twitter": {
          "card": "summary",
          "site": null
        },
        "warnings": [
          "description_missing",
          "image_missing"
        ]
      },
      "jsonld": {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "CollectionPage",
            "name": "Wedding Bands",
            "url": "https://docs.example/collections/wedding-bands",
            "mainEntity": {
              "@type": "ItemList",
              "numberOfItems": 5,
              "itemListElement": []
            }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Aurora Jewels",
                "item": "https://docs.example"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Wedding Bands",
                "item": "https://docs.example/collections/wedding-bands"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://docs.example/#organization",
            "name": "Aurora Jewels",
            "url": "https://docs.example",
            "hasMerchantReturnPolicy": {
              "@type": "MerchantReturnPolicy",
              "applicableCountry": "US",
              "returnPolicyCountry": "US",
              "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
              "merchantReturnDays": 30,
              "returnMethod": "https://schema.org/ReturnByMail",
              "returnFees": "https://schema.org/ReturnShippingFees",
              "refundType": "https://schema.org/FullRefund"
            }
          }
        ]
      },
      "sortOrder": "manual",
      "sortBasis": "manual",
      "productCount": 5
    }
  ]
};
const example_getCollection_200: unknown = {
  "id": "01a16987-5d96-74f6-8129-85adae941585",
  "handle": "engagement-rings",
  "title": "Engagement Rings",
  "descriptionHtml": null,
  "role": "merchandising",
  "eyebrow": null,
  "productType": null,
  "media": null,
  "seo": {
    "title": "Engagement Rings | Aurora Jewels",
    "description": null,
    "canonical": "https://docs.example/collections/engagement-rings",
    "robots": "index, follow",
    "openGraph": {
      "title": "Engagement Rings",
      "description": null,
      "image": null,
      "type": "website"
    },
    "twitter": {
      "card": "summary",
      "site": null
    },
    "warnings": [
      "description_missing",
      "image_missing"
    ]
  },
  "jsonld": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        "name": "Engagement Rings",
        "url": "https://docs.example/collections/engagement-rings",
        "mainEntity": {
          "@type": "ItemList",
          "numberOfItems": 6,
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "Product",
                "name": "Aurora Oval Solitaire",
                "url": "https://docs.example/products/aurora-oval-solitaire",
                "image": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4d56-73a8-b6ca-12aedaee71ca/original.png",
                "offers": {
                  "@type": "Offer",
                  "price": "1890.00",
                  "priceCurrency": "USD"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "Product",
                "name": "Luna Round Halo",
                "url": "https://docs.example/products/luna-round-halo",
                "image": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4e5a-799b-bab4-c098b5b9fea8/original.png",
                "offers": {
                  "@type": "Offer",
                  "price": "2190.00",
                  "priceCurrency": "USD"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 3,
              "item": {
                "@type": "Product",
                "name": "Celeste Pear Trilogy",
                "url": "https://docs.example/products/celeste-pear-trilogy",
                "image": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4f13-7a99-8350-a1b89c575ba9/original.png",
                "offers": {
                  "@type": "Offer",
                  "price": "2490.00",
                  "priceCurrency": "USD"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 4,
              "item": {
                "@type": "Product",
                "name": "Nova Moissanite Cushion",
                "url": "https://docs.example/products/nova-moissanite-cushion",
                "image": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4fce-7e74-9494-9e5478b562fd/original.png",
                "offers": {
                  "@type": "Offer",
                  "price": "890.00",
                  "priceCurrency": "USD"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 5,
              "item": {
                "@type": "Product",
                "name": "Vela Emerald-Cut Bezel",
                "url": "https://docs.example/products/vela-emerald-cut-bezel",
                "image": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-507a-75aa-96d9-57c2f566149c/original.png",
                "offers": {
                  "@type": "Offer",
                  "price": "2790.00",
                  "priceCurrency": "USD"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 6,
              "item": {
                "@type": "Product",
                "name": "Aurora Bridal Set",
                "url": "https://docs.example/products/aurora-bridal-set",
                "image": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5524-707d-9ee7-1fac6816ef63/original.png",
                "offers": {
                  "@type": "Offer",
                  "price": "2590.00",
                  "priceCurrency": "USD"
                }
              }
            }
          ]
        }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Aurora Jewels",
            "item": "https://docs.example"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Engagement Rings",
            "item": "https://docs.example/collections/engagement-rings"
          }
        ]
      },
      {
        "@type": "Organization",
        "@id": "https://docs.example/#organization",
        "name": "Aurora Jewels",
        "url": "https://docs.example",
        "hasMerchantReturnPolicy": {
          "@type": "MerchantReturnPolicy",
          "applicableCountry": "US",
          "returnPolicyCountry": "US",
          "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
          "merchantReturnDays": 30,
          "returnMethod": "https://schema.org/ReturnByMail",
          "returnFees": "https://schema.org/ReturnShippingFees",
          "refundType": "https://schema.org/FullRefund"
        }
      }
    ]
  },
  "sortOrder": "manual",
  "sortBasis": "manual",
  "productCount": 6
};
const example_getCollection_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Collection not found",
    "requestId": "req_example"
  }
};
const example_listCollectionProducts_200: unknown = {
  "items": [
    {
      "id": "01a16987-5d6c-70f7-9fd5-fd6736b240b7",
      "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
      "handle": "aurora-oval-solitaire",
      "title": "Aurora Oval Solitaire",
      "subtitle": null,
      "tags": [
        "engagement",
        "solitaire",
        "bestseller"
      ],
      "vendor": "Aurora Jewels",
      "productType": {
        "slug": "engagement-ring",
        "name": "Engagement Ring"
      },
      "categoryCollection": null,
      "designCollection": null,
      "featuredMedia": {
        "id": "01a16987-4d56-73a8-b6ca-12aedaee71ca",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4d56-73a8-b6ca-12aedaee71ca/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Aurora Oval Solitaire, view 1",
        "width": 1200,
        "height": 1200
      },
      "price": {
        "min": {
          "amount": 189000,
          "currency": "USD"
        },
        "max": {
          "amount": 519750,
          "currency": "USD"
        }
      },
      "compareAtMin": null,
      "fulfillmentMode": "made_to_order",
      "availability": "made_to_order",
      "leadTimeDaysMin": 14,
      "leadTimeDaysMax": 21,
      "publishedAt": "2026-10-23T16:10:41.384Z"
    },
    {
      "id": "01a16987-5d6c-7529-92d4-c8b8a3bdb019",
      "productId": "01a16987-4e01-79a6-83a9-45577e621404",
      "handle": "luna-round-halo",
      "title": "Luna Round Halo",
      "subtitle": null,
      "tags": [
        "engagement",
        "halo",
        "bestseller"
      ],
      "vendor": "Aurora Jewels",
      "productType": {
        "slug": "engagement-ring",
        "name": "Engagement Ring"
      },
      "categoryCollection": null,
      "designCollection": null,
      "featuredMedia": {
        "id": "01a16987-4e5a-799b-bab4-c098b5b9fea8",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4e5a-799b-bab4-c098b5b9fea8/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Luna Round Halo, view 1",
        "width": 1200,
        "height": 1200
      },
      "price": {
        "min": {
          "amount": 219000,
          "currency": "USD"
        },
        "max": {
          "amount": 602250,
          "currency": "USD"
        }
      },
      "compareAtMin": null,
      "fulfillmentMode": "made_to_order",
      "availability": "made_to_order",
      "leadTimeDaysMin": 14,
      "leadTimeDaysMax": 21,
      "publishedAt": "2026-10-23T16:10:41.384Z"
    }
  ],
  "nextCursor": "Mg",
  "total": 6
};
const example_getSection_200: unknown = {
  "id": "01a16987-610e-7010-9469-a87f8e610613",
  "handle": "home",
  "title": null,
  "description": null,
  "status": "active",
  "custom": {},
  "blocks": [
    {
      "id": "01a16987-60be-7b0b-bc79-c72bed9d5d4b",
      "key": "home-hero",
      "kind": "banner",
      "status": "active",
      "startsAt": null,
      "endsAt": null,
      "custom": {},
      "banner": {
        "items": [
          {
            "media": null,
            "mobileMedia": null,
            "eyebrow": "Lab-grown, set by hand",
            "title": "Bridal, reimagined",
            "subtitle": null,
            "descriptionHtml": "<p>Rings made to order in four weeks.</p>",
            "ctas": [
              {
                "label": "Shop engagement rings",
                "href": "/products/aurora-oval-solitaire",
                "target": {
                  "type": "product",
                  "id": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
                  "handle": "aurora-oval-solitaire",
                  "title": "Aurora Oval Solitaire"
                },
                "openInNewTab": false,
                "style": "primary"
              }
            ],
            "custom": {}
          }
        ]
      },
      "rail": null,
      "updatedAt": "2026-10-23T16:10:42.236Z"
    },
    {
      "id": "01a16987-60e8-7ab5-95d6-1aa4cce61d9f",
      "key": "bestsellers",
      "kind": "rail",
      "status": "active",
      "startsAt": null,
      "endsAt": null,
      "custom": {},
      "banner": null,
      "rail": {
        "header": null,
        "source": {
          "type": "products"
        },
        "limit": 3,
        "products": [
          {
            "id": "01a16987-5d6c-70f7-9fd5-fd6736b240b7",
            "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
            "handle": "aurora-oval-solitaire",
            "title": "Aurora Oval Solitaire",
            "subtitle": null,
            "tags": [
              "engagement",
              "solitaire",
              "bestseller"
            ],
            "vendor": "Aurora Jewels",
            "productType": {
              "slug": "engagement-ring",
              "name": "Engagement Ring"
            },
            "categoryCollection": null,
            "designCollection": null,
            "featuredMedia": {
              "id": "01a16987-4d56-73a8-b6ca-12aedaee71ca",
              "kind": "image",
              "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4d56-73a8-b6ca-12aedaee71ca/original.png",
              "mimeType": "image/png",
              "renditions": null,
              "alt": "Aurora Oval Solitaire, view 1",
              "width": 1200,
              "height": 1200
            },
            "price": {
              "min": {
                "amount": 189000,
                "currency": "USD"
              },
              "max": {
                "amount": 519750,
                "currency": "USD"
              }
            },
            "compareAtMin": null,
            "fulfillmentMode": "made_to_order",
            "availability": "made_to_order",
            "leadTimeDaysMin": 14,
            "leadTimeDaysMax": 21,
            "publishedAt": "2026-10-23T16:10:41.384Z"
          },
          {
            "id": "01a16987-5d6c-7529-92d4-c8b8a3bdb019",
            "productId": "01a16987-4e01-79a6-83a9-45577e621404",
            "handle": "luna-round-halo",
            "title": "Luna Round Halo",
            "subtitle": null,
            "tags": [
              "engagement",
              "halo",
              "bestseller"
            ],
            "vendor": "Aurora Jewels",
            "productType": {
              "slug": "engagement-ring",
              "name": "Engagement Ring"
            },
            "categoryCollection": null,
            "designCollection": null,
            "featuredMedia": {
              "id": "01a16987-4e5a-799b-bab4-c098b5b9fea8",
              "kind": "image",
              "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4e5a-799b-bab4-c098b5b9fea8/original.png",
              "mimeType": "image/png",
              "renditions": null,
              "alt": "Luna Round Halo, view 1",
              "width": 1200,
              "height": 1200
            },
            "price": {
              "min": {
                "amount": 219000,
                "currency": "USD"
              },
              "max": {
                "amount": 602250,
                "currency": "USD"
              }
            },
            "compareAtMin": null,
            "fulfillmentMode": "made_to_order",
            "availability": "made_to_order",
            "leadTimeDaysMin": 14,
            "leadTimeDaysMax": 21,
            "publishedAt": "2026-10-23T16:10:41.384Z"
          },
          {
            "id": "01a16987-5d6c-777d-8abe-0c3d8ef216f2",
            "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
            "handle": "drift-diamond-pendant",
            "title": "Drift Diamond Pendant",
            "subtitle": null,
            "tags": [
              "necklace",
              "pendant",
              "gift"
            ],
            "vendor": "Aurora Jewels",
            "productType": {
              "slug": "necklace",
              "name": "Necklace"
            },
            "categoryCollection": null,
            "designCollection": null,
            "featuredMedia": {
              "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
              "kind": "image",
              "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
              "mimeType": "image/png",
              "renditions": null,
              "alt": "Drift Diamond Pendant, view 1",
              "width": 1200,
              "height": 1200
            },
            "price": {
              "min": {
                "amount": 99000,
                "currency": "USD"
              },
              "max": {
                "amount": 133650,
                "currency": "USD"
              }
            },
            "compareAtMin": null,
            "fulfillmentMode": "stocked",
            "availability": "in_stock",
            "leadTimeDaysMin": null,
            "leadTimeDaysMax": null,
            "publishedAt": "2026-10-23T16:10:41.384Z"
          }
        ]
      },
      "updatedAt": "2026-10-23T16:10:42.278Z"
    }
  ],
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "updatedAt": "2026-10-23T16:10:42.315Z"
};
const example_getBlock_200: unknown = {
  "id": "01a16987-60be-7b0b-bc79-c72bed9d5d4b",
  "key": "home-hero",
  "kind": "banner",
  "status": "active",
  "startsAt": null,
  "endsAt": null,
  "custom": {},
  "banner": {
    "items": [
      {
        "media": null,
        "mobileMedia": null,
        "eyebrow": "Lab-grown, set by hand",
        "title": "Bridal, reimagined",
        "subtitle": null,
        "descriptionHtml": "<p>Rings made to order in four weeks.</p>",
        "ctas": [
          {
            "label": "Shop engagement rings",
            "href": "/products/aurora-oval-solitaire",
            "target": {
              "type": "product",
              "id": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
              "handle": "aurora-oval-solitaire",
              "title": "Aurora Oval Solitaire"
            },
            "openInNewTab": false,
            "style": "primary"
          }
        ],
        "custom": {}
      }
    ]
  },
  "rail": null,
  "updatedAt": "2026-10-23T16:10:42.236Z"
};
const example_listBlocks_200: unknown = {
  "items": [
    {
      "id": "01a16987-60be-7b0b-bc79-c72bed9d5d4b",
      "key": "home-hero",
      "kind": "banner",
      "status": "active",
      "startsAt": null,
      "endsAt": null,
      "custom": {},
      "banner": {
        "items": [
          {
            "media": null,
            "mobileMedia": null,
            "eyebrow": "Lab-grown, set by hand",
            "title": "Bridal, reimagined",
            "subtitle": null,
            "descriptionHtml": "<p>Rings made to order in four weeks.</p>",
            "ctas": [
              {
                "label": "Shop engagement rings",
                "href": "/products/aurora-oval-solitaire",
                "target": {
                  "type": "product",
                  "id": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
                  "handle": "aurora-oval-solitaire",
                  "title": "Aurora Oval Solitaire"
                },
                "openInNewTab": false,
                "style": "primary"
              }
            ],
            "custom": {}
          }
        ]
      },
      "rail": null,
      "updatedAt": "2026-10-23T16:10:42.236Z"
    },
    {
      "id": "01a16987-60e8-7ab5-95d6-1aa4cce61d9f",
      "key": "bestsellers",
      "kind": "rail",
      "status": "active",
      "startsAt": null,
      "endsAt": null,
      "custom": {},
      "banner": null,
      "rail": {
        "header": null,
        "source": {
          "type": "products"
        },
        "limit": 3,
        "products": [
          {
            "id": "01a16987-5d6c-70f7-9fd5-fd6736b240b7",
            "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
            "handle": "aurora-oval-solitaire",
            "title": "Aurora Oval Solitaire",
            "subtitle": null,
            "tags": [
              "engagement",
              "solitaire",
              "bestseller"
            ],
            "vendor": "Aurora Jewels",
            "productType": {
              "slug": "engagement-ring",
              "name": "Engagement Ring"
            },
            "categoryCollection": null,
            "designCollection": null,
            "featuredMedia": {
              "id": "01a16987-4d56-73a8-b6ca-12aedaee71ca",
              "kind": "image",
              "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4d56-73a8-b6ca-12aedaee71ca/original.png",
              "mimeType": "image/png",
              "renditions": null,
              "alt": "Aurora Oval Solitaire, view 1",
              "width": 1200,
              "height": 1200
            },
            "price": {
              "min": {
                "amount": 189000,
                "currency": "USD"
              },
              "max": {
                "amount": 519750,
                "currency": "USD"
              }
            },
            "compareAtMin": null,
            "fulfillmentMode": "made_to_order",
            "availability": "made_to_order",
            "leadTimeDaysMin": 14,
            "leadTimeDaysMax": 21,
            "publishedAt": "2026-10-23T16:10:41.384Z"
          },
          {
            "id": "01a16987-5d6c-7529-92d4-c8b8a3bdb019",
            "productId": "01a16987-4e01-79a6-83a9-45577e621404",
            "handle": "luna-round-halo",
            "title": "Luna Round Halo",
            "subtitle": null,
            "tags": [
              "engagement",
              "halo",
              "bestseller"
            ],
            "vendor": "Aurora Jewels",
            "productType": {
              "slug": "engagement-ring",
              "name": "Engagement Ring"
            },
            "categoryCollection": null,
            "designCollection": null,
            "featuredMedia": {
              "id": "01a16987-4e5a-799b-bab4-c098b5b9fea8",
              "kind": "image",
              "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4e5a-799b-bab4-c098b5b9fea8/original.png",
              "mimeType": "image/png",
              "renditions": null,
              "alt": "Luna Round Halo, view 1",
              "width": 1200,
              "height": 1200
            },
            "price": {
              "min": {
                "amount": 219000,
                "currency": "USD"
              },
              "max": {
                "amount": 602250,
                "currency": "USD"
              }
            },
            "compareAtMin": null,
            "fulfillmentMode": "made_to_order",
            "availability": "made_to_order",
            "leadTimeDaysMin": 14,
            "leadTimeDaysMax": 21,
            "publishedAt": "2026-10-23T16:10:41.384Z"
          },
          {
            "id": "01a16987-5d6c-777d-8abe-0c3d8ef216f2",
            "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
            "handle": "drift-diamond-pendant",
            "title": "Drift Diamond Pendant",
            "subtitle": null,
            "tags": [
              "necklace",
              "pendant",
              "gift"
            ],
            "vendor": "Aurora Jewels",
            "productType": {
              "slug": "necklace",
              "name": "Necklace"
            },
            "categoryCollection": null,
            "designCollection": null,
            "featuredMedia": {
              "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
              "kind": "image",
              "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
              "mimeType": "image/png",
              "renditions": null,
              "alt": "Drift Diamond Pendant, view 1",
              "width": 1200,
              "height": 1200
            },
            "price": {
              "min": {
                "amount": 99000,
                "currency": "USD"
              },
              "max": {
                "amount": 133650,
                "currency": "USD"
              }
            },
            "compareAtMin": null,
            "fulfillmentMode": "stocked",
            "availability": "in_stock",
            "leadTimeDaysMin": null,
            "leadTimeDaysMax": null,
            "publishedAt": "2026-10-23T16:10:41.384Z"
          }
        ]
      },
      "updatedAt": "2026-10-23T16:10:42.278Z"
    }
  ]
};
const example_suggestSearch_200: unknown = {
  "query": "eng",
  "products": [
    {
      "id": "01a16987-5d6c-70f7-9fd5-fd6736b240b7",
      "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
      "handle": "aurora-oval-solitaire",
      "title": "Aurora Oval Solitaire",
      "image": {
        "id": "01a16987-4d56-73a8-b6ca-12aedaee71ca",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4d56-73a8-b6ca-12aedaee71ca/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Aurora Oval Solitaire, view 1",
        "width": 1200,
        "height": 1200
      },
      "price": {
        "amount": 189000,
        "currency": "USD"
      }
    },
    {
      "id": "01a16987-5d6c-7529-92d4-c8b8a3bdb019",
      "productId": "01a16987-4e01-79a6-83a9-45577e621404",
      "handle": "luna-round-halo",
      "title": "Luna Round Halo",
      "image": {
        "id": "01a16987-4e5a-799b-bab4-c098b5b9fea8",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4e5a-799b-bab4-c098b5b9fea8/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Luna Round Halo, view 1",
        "width": 1200,
        "height": 1200
      },
      "price": {
        "amount": 219000,
        "currency": "USD"
      }
    },
    {
      "id": "01a16987-5d6c-7570-9b8f-df2e248812c2",
      "productId": "01a16987-4ebe-7c5b-a4f2-d142e21030c4",
      "handle": "celeste-pear-trilogy",
      "title": "Celeste Pear Trilogy",
      "image": {
        "id": "01a16987-4f13-7a99-8350-a1b89c575ba9",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4f13-7a99-8350-a1b89c575ba9/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Celeste Pear Trilogy, view 1",
        "width": 1200,
        "height": 1200
      },
      "price": {
        "amount": 249000,
        "currency": "USD"
      }
    },
    {
      "id": "01a16987-5d6c-7598-b1dc-dbe5f5e9cc7b",
      "productId": "01a16987-4f77-72bb-91bb-06a3358bfa81",
      "handle": "nova-moissanite-cushion",
      "title": "Nova Moissanite Cushion",
      "image": {
        "id": "01a16987-4fce-7e74-9494-9e5478b562fd",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4fce-7e74-9494-9e5478b562fd/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Nova Moissanite Cushion, view 1",
        "width": 1200,
        "height": 1200
      },
      "price": {
        "amount": 89000,
        "currency": "USD"
      }
    },
    {
      "id": "01a16987-5d6c-75b9-b3c9-5e69732adb75",
      "productId": "01a16987-5029-703d-b716-e12838e96fdd",
      "handle": "vela-emerald-cut-bezel",
      "title": "Vela Emerald-Cut Bezel",
      "image": {
        "id": "01a16987-507a-75aa-96d9-57c2f566149c",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-507a-75aa-96d9-57c2f566149c/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Vela Emerald-Cut Bezel, view 1",
        "width": 1200,
        "height": 1200
      },
      "price": {
        "amount": 279000,
        "currency": "USD"
      }
    }
  ],
  "collections": [
    {
      "handle": "engagement-rings",
      "title": "Engagement Rings"
    }
  ],
  "pages": [],
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "processingTimeMs": 63
};
const example_suggestSearch_400: unknown = {
  "error": {
    "code": "VALIDATION_ERROR",
    "message": "Request validation failed",
    "requestId": "req_example",
    "details": [
      {
        "field": "query.q",
        "code": "too_small",
        "message": "Too small: expected string to have >=1 characters"
      }
    ]
  }
};
const example_searchProducts_200: unknown = {
  "hits": [
    {
      "id": "01a16987-5d6c-75fb-824b-ec76c584e0ef",
      "productId": "01a16987-5238-7b1d-8680-5a8010381a4f",
      "handle": "halo-pave-eternity",
      "title": "Halo Pavé Eternity",
      "subtitle": null,
      "tags": [
        "band",
        "eternity",
        "diamond"
      ],
      "vendor": "Aurora Jewels",
      "productType": {
        "slug": "wedding-band",
        "name": "Wedding Band"
      },
      "categoryCollection": null,
      "designCollection": null,
      "featuredMedia": {
        "id": "01a16987-5284-71b8-b596-12f6f07f574c",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5284-71b8-b596-12f6f07f574c/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Halo Pavé Eternity, view 1",
        "width": 1200,
        "height": 1200
      },
      "price": {
        "min": {
          "amount": 129000,
          "currency": "USD"
        },
        "max": {
          "amount": 174150,
          "currency": "USD"
        }
      },
      "compareAtMin": null,
      "fulfillmentMode": "made_to_order",
      "availability": "made_to_order",
      "leadTimeDaysMin": 14,
      "leadTimeDaysMax": 21,
      "publishedAt": "2026-10-23T16:10:41.384Z"
    },
    {
      "id": "01a16987-5d6c-7529-92d4-c8b8a3bdb019",
      "productId": "01a16987-4e01-79a6-83a9-45577e621404",
      "handle": "luna-round-halo",
      "title": "Luna Round Halo",
      "subtitle": null,
      "tags": [
        "engagement",
        "halo",
        "bestseller"
      ],
      "vendor": "Aurora Jewels",
      "productType": {
        "slug": "engagement-ring",
        "name": "Engagement Ring"
      },
      "categoryCollection": null,
      "designCollection": null,
      "featuredMedia": {
        "id": "01a16987-4e5a-799b-bab4-c098b5b9fea8",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4e5a-799b-bab4-c098b5b9fea8/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Luna Round Halo, view 1",
        "width": 1200,
        "height": 1200
      },
      "price": {
        "min": {
          "amount": 219000,
          "currency": "USD"
        },
        "max": {
          "amount": 602250,
          "currency": "USD"
        }
      },
      "compareAtMin": null,
      "fulfillmentMode": "made_to_order",
      "availability": "made_to_order",
      "leadTimeDaysMin": 14,
      "leadTimeDaysMax": 21,
      "publishedAt": "2026-10-23T16:10:41.384Z"
    }
  ],
  "total": 2,
  "page": 1,
  "limit": 2,
  "facets": [
    {
      "field": "attr.metal",
      "label": "Metal",
      "values": [
        {
          "value": "14k_white_gold",
          "label": "14K White Gold",
          "count": 2
        }
      ]
    },
    {
      "field": "attr.stone_shape",
      "label": "Stone shape",
      "values": [
        {
          "value": "round",
          "label": "Round",
          "count": 1
        }
      ]
    },
    {
      "field": "attr.stone_type",
      "label": "Stone type",
      "values": [
        {
          "value": "lab_diamond",
          "label": "Lab-Grown Diamond",
          "count": 2
        }
      ]
    },
    {
      "field": "collections",
      "label": "Collections",
      "values": [
        {
          "value": "bestsellers",
          "label": "bestsellers",
          "count": 1
        },
        {
          "value": "engagement-rings",
          "label": "engagement-rings",
          "count": 1
        },
        {
          "value": "wedding-bands",
          "label": "wedding-bands",
          "count": 1
        }
      ]
    },
    {
      "field": "product_type",
      "label": "Product type",
      "values": [
        {
          "value": "engagement-ring",
          "label": "engagement-ring",
          "count": 1
        },
        {
          "value": "wedding-band",
          "label": "wedding-band",
          "count": 1
        }
      ]
    },
    {
      "field": "tags",
      "label": "Tags",
      "values": [
        {
          "value": "band",
          "label": "band",
          "count": 1
        },
        {
          "value": "bestseller",
          "label": "bestseller",
          "count": 1
        },
        {
          "value": "diamond",
          "label": "diamond",
          "count": 1
        },
        {
          "value": "engagement",
          "label": "engagement",
          "count": 1
        },
        {
          "value": "eternity",
          "label": "eternity",
          "count": 1
        },
        {
          "value": "halo",
          "label": "halo",
          "count": 1
        }
      ]
    }
  ],
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "processingTimeMs": 14
};
const example_getProductAvailability_200: unknown = {
  "items": [
    {
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "trackInventory": true,
      "available": 6,
      "inStock": true,
      "backorder": false,
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null
    },
    {
      "variantId": "01a16987-5105-7a4a-9986-e2e19a63728f",
      "trackInventory": true,
      "available": 6,
      "inStock": true,
      "backorder": false,
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null
    },
    {
      "variantId": "01a16987-5105-7a93-a0c0-071fd9b1a5ff",
      "trackInventory": true,
      "available": 6,
      "inStock": true,
      "backorder": false,
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null
    },
    {
      "variantId": "01a16987-5105-7abe-9a5f-0116f79cdf43",
      "trackInventory": true,
      "available": 6,
      "inStock": true,
      "backorder": false,
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null
    }
  ]
};
const example_listShippingZones_200: unknown = {
  "items": [
    {
      "id": "01a16987-5e3e-732a-90a9-74845ab8a2c6",
      "name": "United States",
      "countries": [
        "US"
      ],
      "regions": null
    }
  ]
};
const example_registerCustomer_201: unknown = {
  "accessToken": "<customerAccessToken>",
  "tokenType": "Bearer",
  "expiresIn": 900,
  "refreshToken": "<customerRefreshToken>",
  "refreshExpiresAt": "2026-11-22T16:10:44.888Z",
  "customer": {
    "id": "01a16987-6b14-7d6f-867c-40a519894a64",
    "email": "shopper@example.com",
    "firstName": "Asha",
    "lastName": "Mehta",
    "phone": null,
    "status": "active",
    "acceptsMarketing": false,
    "locale": null,
    "currency": null,
    "savedRingSize": null,
    "defaultAddressId": null,
    "doNotSell": false,
    "createdAt": "2026-10-23T16:10:44.882Z"
  }
};
const example_registerCustomer_409: unknown = {
  "error": {
    "code": "ALREADY_EXISTS",
    "message": "An account with this email already exists",
    "requestId": "req_example",
    "details": [
      {
        "field": "body.email",
        "code": "ALREADY_EXISTS",
        "message": "An account with this email already exists"
      }
    ]
  }
};
const example_loginCustomer_200: unknown = {
  "accessToken": "<customerAccessToken>",
  "tokenType": "Bearer",
  "expiresIn": 900,
  "refreshToken": "<customerRefreshToken>",
  "refreshExpiresAt": "2026-11-22T16:10:44.946Z",
  "customer": {
    "id": "01a16987-6b14-7d6f-867c-40a519894a64",
    "email": "shopper@example.com",
    "firstName": "Asha",
    "lastName": "Mehta",
    "phone": null,
    "status": "active",
    "acceptsMarketing": false,
    "locale": null,
    "currency": null,
    "savedRingSize": null,
    "defaultAddressId": null,
    "doNotSell": false,
    "createdAt": "2026-10-23T16:10:44.882Z"
  }
};
const example_loginCustomer_401: unknown = {
  "error": {
    "code": "INVALID_CREDENTIALS",
    "message": "Invalid email or password",
    "requestId": "req_example"
  }
};
const example_refreshCustomerSession_200: unknown = {
  "accessToken": "<customerAccessToken>",
  "tokenType": "Bearer",
  "expiresIn": 900,
  "refreshToken": "<customerRefreshToken>",
  "refreshExpiresAt": "2026-11-22T16:10:45.049Z",
  "customer": {
    "id": "01a16987-6b14-7d6f-867c-40a519894a64",
    "email": "shopper@example.com",
    "firstName": "Asha",
    "lastName": "Mehta",
    "phone": null,
    "status": "active",
    "acceptsMarketing": false,
    "locale": null,
    "currency": null,
    "savedRingSize": null,
    "defaultAddressId": null,
    "doNotSell": false,
    "createdAt": "2026-10-23T16:10:44.882Z"
  }
};
const example_startGoogleSignIn_200: unknown = {
  "url": "http://localhost:3000/storefront/v1/customers/oauth/google/callback?dev=1&state=<signedState>"
};
const example_completeGoogleSignIn_200: unknown = {
  "accessToken": "<customerAccessToken>",
  "tokenType": "Bearer",
  "expiresIn": 900,
  "refreshToken": "<customerRefreshToken>",
  "refreshExpiresAt": "2026-11-22T16:10:47.661Z",
  "customer": {
    "id": "01a16987-6b14-7d6f-867c-40a519894a64",
    "email": "shopper@example.com",
    "firstName": "Asha",
    "lastName": "Mehta",
    "phone": "+12125550100",
    "status": "active",
    "acceptsMarketing": true,
    "locale": null,
    "currency": null,
    "savedRingSize": "6",
    "defaultAddressId": "01a16987-6c29-7526-b3a5-6d25a9ec6f85",
    "doNotSell": false,
    "createdAt": "2026-10-23T16:10:44.882Z"
  }
};
const example_verifyMagicLink_200: unknown = {
  "accessToken": "<customerAccessToken>",
  "tokenType": "Bearer",
  "expiresIn": 900,
  "refreshToken": "<customerRefreshToken>",
  "refreshExpiresAt": "2026-11-22T16:10:47.601Z",
  "customer": {
    "id": "01a16987-6b14-7d6f-867c-40a519894a64",
    "email": "shopper@example.com",
    "firstName": "Asha",
    "lastName": "Mehta",
    "phone": "+12125550100",
    "status": "active",
    "acceptsMarketing": true,
    "locale": null,
    "currency": null,
    "savedRingSize": "6",
    "defaultAddressId": "01a16987-6c29-7526-b3a5-6d25a9ec6f85",
    "doNotSell": false,
    "createdAt": "2026-10-23T16:10:44.882Z"
  }
};
const example_verifyMagicLink_401: unknown = {
  "error": {
    "code": "TOKEN_INVALID",
    "message": "This link is invalid or has expired",
    "requestId": "req_example"
  }
};
const example_getCustomerProfile_200: unknown = {
  "id": "01a16987-6b14-7d6f-867c-40a519894a64",
  "email": "shopper@example.com",
  "firstName": "Asha",
  "lastName": "Mehta",
  "phone": null,
  "status": "active",
  "acceptsMarketing": false,
  "locale": null,
  "currency": null,
  "savedRingSize": null,
  "defaultAddressId": null,
  "doNotSell": false,
  "createdAt": "2026-10-23T16:10:44.882Z"
};
const example_getCustomerProfile_401: unknown = {
  "error": {
    "code": "UNAUTHORIZED",
    "message": "A customer token is required",
    "requestId": "req_example"
  }
};
const example_updateCustomerProfile_200: unknown = {
  "id": "01a16987-6b14-7d6f-867c-40a519894a64",
  "email": "shopper@example.com",
  "firstName": "Asha",
  "lastName": "Mehta",
  "phone": "+12125550100",
  "status": "active",
  "acceptsMarketing": true,
  "locale": null,
  "currency": null,
  "savedRingSize": "6",
  "defaultAddressId": null,
  "doNotSell": false,
  "createdAt": "2026-10-23T16:10:44.882Z"
};
const example_listCustomerAddresses_200: unknown = {
  "items": [
    {
      "id": "01a16987-6c29-7526-b3a5-6d25a9ec6f85",
      "label": "Home",
      "firstName": "Asha",
      "lastName": "Mehta",
      "company": null,
      "line1": "350 Fifth Avenue",
      "line2": null,
      "city": "New York",
      "region": "NY",
      "postalCode": "10118",
      "countryCode": "US",
      "phone": "+12125550100",
      "isDefaultShipping": true,
      "isDefaultBilling": true,
      "createdAt": "2026-10-23T16:10:45.159Z",
      "updatedAt": "2026-10-23T16:10:45.159Z"
    }
  ]
};
const example_createCustomerAddress_201: unknown = {
  "id": "01a16987-6c29-7526-b3a5-6d25a9ec6f85",
  "label": "Home",
  "firstName": "Asha",
  "lastName": "Mehta",
  "company": null,
  "line1": "350 Fifth Avenue",
  "line2": null,
  "city": "New York",
  "region": "NY",
  "postalCode": "10118",
  "countryCode": "US",
  "phone": "+12125550100",
  "isDefaultShipping": true,
  "isDefaultBilling": true,
  "createdAt": "2026-10-23T16:10:45.159Z",
  "updatedAt": "2026-10-23T16:10:45.159Z"
};
const example_updateCustomerAddress_200: unknown = {
  "id": "01a16987-6c29-7526-b3a5-6d25a9ec6f85",
  "label": "Home",
  "firstName": "Asha",
  "lastName": "Mehta",
  "company": null,
  "line1": "350 Fifth Avenue",
  "line2": "Suite 2100",
  "city": "New York",
  "region": "NY",
  "postalCode": "10118",
  "countryCode": "US",
  "phone": "+12125550100",
  "isDefaultShipping": true,
  "isDefaultBilling": true,
  "createdAt": "2026-10-23T16:10:45.159Z",
  "updatedAt": "2026-10-23T16:10:45.194Z"
};
const example_getWishlist_200: unknown = {
  "id": "01a16987-6c7e-7171-baff-f36ad9d4cc6f",
  "name": "Wishlist",
  "isDefault": true,
  "shareToken": null,
  "itemCount": 0,
  "items": [],
  "createdAt": "2026-10-23T16:10:45.244Z",
  "updatedAt": "2026-10-23T16:10:45.244Z"
};
const example_updateWishlist_200: unknown = {
  "id": "01a16987-6c7e-7171-baff-f36ad9d4cc6f",
  "name": "Our wedding",
  "isDefault": true,
  "shareToken": null,
  "itemCount": 0,
  "items": [],
  "createdAt": "2026-10-23T16:10:45.244Z",
  "updatedAt": "2026-10-23T16:10:45.267Z"
};
const example_addWishlistItem_201: unknown = {
  "id": "01a16987-6cb5-7d69-9405-d9f2a8ba0263",
  "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
  "variantId": null,
  "customizations": [],
  "product": {
    "id": "01a16987-5d6c-70f7-9fd5-fd6736b240b7",
    "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
    "handle": "aurora-oval-solitaire",
    "title": "Aurora Oval Solitaire",
    "subtitle": null,
    "tags": [
      "engagement",
      "solitaire",
      "bestseller"
    ],
    "vendor": "Aurora Jewels",
    "productType": {
      "slug": "engagement-ring",
      "name": "Engagement Ring"
    },
    "categoryCollection": null,
    "designCollection": null,
    "featuredMedia": {
      "id": "01a16987-4d56-73a8-b6ca-12aedaee71ca",
      "kind": "image",
      "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4d56-73a8-b6ca-12aedaee71ca/original.png",
      "mimeType": "image/png",
      "renditions": null,
      "alt": "Aurora Oval Solitaire, view 1",
      "width": 1200,
      "height": 1200
    },
    "price": {
      "min": {
        "amount": 189000,
        "currency": "USD"
      },
      "max": {
        "amount": 519750,
        "currency": "USD"
      }
    },
    "compareAtMin": null,
    "fulfillmentMode": "made_to_order",
    "availability": "made_to_order",
    "leadTimeDaysMin": 14,
    "leadTimeDaysMax": 21,
    "publishedAt": "2026-10-23T16:10:41.384Z"
  },
  "variant": null,
  "available": true,
  "position": 0,
  "createdAt": "2026-10-23T16:10:45.300Z"
};
const example_shareWishlist_200: unknown = {
  "id": "01a16987-6c7e-7171-baff-f36ad9d4cc6f",
  "name": "Our wedding",
  "isDefault": true,
  "shareToken": "xWFhAGESxzCg4_7IEVJMQRRe",
  "itemCount": 1,
  "items": [
    {
      "id": "01a16987-6cb5-7d69-9405-d9f2a8ba0263",
      "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
      "variantId": null,
      "customizations": [],
      "product": {
        "id": "01a16987-5d6c-70f7-9fd5-fd6736b240b7",
        "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
        "handle": "aurora-oval-solitaire",
        "title": "Aurora Oval Solitaire",
        "subtitle": null,
        "tags": [
          "engagement",
          "solitaire",
          "bestseller"
        ],
        "vendor": "Aurora Jewels",
        "productType": {
          "slug": "engagement-ring",
          "name": "Engagement Ring"
        },
        "categoryCollection": null,
        "designCollection": null,
        "featuredMedia": {
          "id": "01a16987-4d56-73a8-b6ca-12aedaee71ca",
          "kind": "image",
          "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4d56-73a8-b6ca-12aedaee71ca/original.png",
          "mimeType": "image/png",
          "renditions": null,
          "alt": "Aurora Oval Solitaire, view 1",
          "width": 1200,
          "height": 1200
        },
        "price": {
          "min": {
            "amount": 189000,
            "currency": "USD"
          },
          "max": {
            "amount": 519750,
            "currency": "USD"
          }
        },
        "compareAtMin": null,
        "fulfillmentMode": "made_to_order",
        "availability": "made_to_order",
        "leadTimeDaysMin": 14,
        "leadTimeDaysMax": 21,
        "publishedAt": "2026-10-23T16:10:41.384Z"
      },
      "variant": null,
      "available": true,
      "position": 0,
      "createdAt": "2026-10-23T16:10:45.300Z"
    }
  ],
  "createdAt": "2026-10-23T16:10:45.244Z",
  "updatedAt": "2026-10-23T16:10:45.390Z"
};
const example_unshareWishlist_200: unknown = {
  "id": "01a16987-6c7e-7171-baff-f36ad9d4cc6f",
  "name": "Our wedding",
  "isDefault": true,
  "shareToken": null,
  "itemCount": 1,
  "items": [
    {
      "id": "01a16987-6cb5-7d69-9405-d9f2a8ba0263",
      "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
      "variantId": null,
      "customizations": [],
      "product": {
        "id": "01a16987-5d6c-70f7-9fd5-fd6736b240b7",
        "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
        "handle": "aurora-oval-solitaire",
        "title": "Aurora Oval Solitaire",
        "subtitle": null,
        "tags": [
          "engagement",
          "solitaire",
          "bestseller"
        ],
        "vendor": "Aurora Jewels",
        "productType": {
          "slug": "engagement-ring",
          "name": "Engagement Ring"
        },
        "categoryCollection": null,
        "designCollection": null,
        "featuredMedia": {
          "id": "01a16987-4d56-73a8-b6ca-12aedaee71ca",
          "kind": "image",
          "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4d56-73a8-b6ca-12aedaee71ca/original.png",
          "mimeType": "image/png",
          "renditions": null,
          "alt": "Aurora Oval Solitaire, view 1",
          "width": 1200,
          "height": 1200
        },
        "price": {
          "min": {
            "amount": 189000,
            "currency": "USD"
          },
          "max": {
            "amount": 519750,
            "currency": "USD"
          }
        },
        "compareAtMin": null,
        "fulfillmentMode": "made_to_order",
        "availability": "made_to_order",
        "leadTimeDaysMin": 14,
        "leadTimeDaysMax": 21,
        "publishedAt": "2026-10-23T16:10:41.384Z"
      },
      "variant": null,
      "available": true,
      "position": 0,
      "createdAt": "2026-10-23T16:10:45.300Z"
    }
  ],
  "createdAt": "2026-10-23T16:10:45.244Z",
  "updatedAt": "2026-10-23T16:10:45.438Z"
};
const example_getSharedWishlist_200: unknown = {
  "name": "Our wedding",
  "ownerFirstName": "Asha",
  "itemCount": 1,
  "items": [
    {
      "id": "01a16987-6cb5-7d69-9405-d9f2a8ba0263",
      "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
      "variantId": null,
      "customizations": [],
      "product": {
        "id": "01a16987-5d6c-70f7-9fd5-fd6736b240b7",
        "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
        "handle": "aurora-oval-solitaire",
        "title": "Aurora Oval Solitaire",
        "subtitle": null,
        "tags": [
          "engagement",
          "solitaire",
          "bestseller"
        ],
        "vendor": "Aurora Jewels",
        "productType": {
          "slug": "engagement-ring",
          "name": "Engagement Ring"
        },
        "categoryCollection": null,
        "designCollection": null,
        "featuredMedia": {
          "id": "01a16987-4d56-73a8-b6ca-12aedaee71ca",
          "kind": "image",
          "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4d56-73a8-b6ca-12aedaee71ca/original.png",
          "mimeType": "image/png",
          "renditions": null,
          "alt": "Aurora Oval Solitaire, view 1",
          "width": 1200,
          "height": 1200
        },
        "price": {
          "min": {
            "amount": 189000,
            "currency": "USD"
          },
          "max": {
            "amount": 519750,
            "currency": "USD"
          }
        },
        "compareAtMin": null,
        "fulfillmentMode": "made_to_order",
        "availability": "made_to_order",
        "leadTimeDaysMin": 14,
        "leadTimeDaysMax": 21,
        "publishedAt": "2026-10-23T16:10:41.384Z"
      },
      "variant": null,
      "available": true,
      "position": 0,
      "createdAt": "2026-10-23T16:10:45.300Z"
    }
  ],
  "updatedAt": "2026-10-23T16:10:45.390Z"
};
const example_getSharedWishlist_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Wishlist not found",
    "requestId": "req_example"
  }
};
const example_listPrivacyRequests_200: unknown = {
  "items": [
    {
      "id": "01a16987-6d5c-76c0-84c9-17ddfe793e98",
      "customerId": "01a16987-6b14-7d6f-867c-40a519894a64",
      "email": "shopper@example.com",
      "kind": "export",
      "status": "completed",
      "exportReady": true,
      "requestedAt": "2026-10-23T16:10:45.466Z",
      "completedAt": "2026-10-23T16:10:45.522Z",
      "updatedAt": "2026-10-23T16:10:45.522Z"
    }
  ]
};
const example_createPrivacyRequest_201: unknown = {
  "id": "01a16987-6d5c-76c0-84c9-17ddfe793e98",
  "customerId": "01a16987-6b14-7d6f-867c-40a519894a64",
  "email": "shopper@example.com",
  "kind": "export",
  "status": "received",
  "exportReady": false,
  "requestedAt": "2026-10-23T16:10:45.466Z",
  "completedAt": null,
  "updatedAt": "2026-10-23T16:10:45.466Z"
};
const example_downloadPrivacyExport_200: unknown = {
  "generatedAt": "2026-10-23T16:10:45.519Z",
  "store": {
    "id": "01a16987-4bf6-7e55-baf0-cd133a59cae0",
    "name": "Aurora Jewels"
  },
  "customer": {
    "id": "01a16987-6b14-7d6f-867c-40a519894a64",
    "email": "shopper@example.com",
    "firstName": "Asha",
    "lastName": "Mehta",
    "phone": "+12125550100",
    "status": "active",
    "locale": null,
    "currency": null,
    "savedRingSize": "6",
    "tags": [],
    "ordersCount": 0,
    "totalSpent": {
      "amount": 0,
      "currency": "USD"
    },
    "lastOrderAt": null,
    "createdAt": "2026-10-23T16:10:44.882Z"
  },
  "consents": {
    "acceptsMarketing": true,
    "marketingConsentAt": "2026-10-23T16:10:45.073Z",
    "marketingConsentSource": "account",
    "doNotSell": false
  },
  "addresses": [
    {
      "label": "Home",
      "firstName": "Asha",
      "lastName": "Mehta",
      "company": null,
      "line1": "350 Fifth Avenue",
      "line2": "Suite 2100",
      "city": "New York",
      "region": "NY",
      "postalCode": "10118",
      "countryCode": "US",
      "phone": "+12125550100",
      "isDefaultShipping": true,
      "isDefaultBilling": true
    }
  ],
  "orders": [],
  "wishlistItems": [
    {
      "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2",
      "variantId": null,
      "customizations": [],
      "createdAt": "2026-10-23T16:10:45.300Z"
    }
  ],
  "privacyRequests": [
    {
      "kind": "export",
      "status": "in_progress",
      "requestedAt": "2026-10-23T16:10:45.466Z",
      "completedAt": null
    }
  ],
  "conversations": [],
  "helpFeedback": []
};
const example_downloadPrivacyExport_409: unknown = {
  "error": {
    "code": "CONFLICT",
    "message": "The export is not ready",
    "requestId": "req_example",
    "meta": {
      "status": "received"
    }
  }
};
const example_createCart_201: unknown = {
  "id": "01a16987-6825-7756-a63c-14d53eff17a6",
  "token": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF",
  "status": "active",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": null,
  "customerId": null,
  "locale": null,
  "lines": [
    {
      "id": "01a16987-6836-7ff4-b0a8-cdf63f54b4f3",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    }
  ],
  "lineCount": 1,
  "subtotal": {
    "amount": 42000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "total": {
    "amount": 42000,
    "currency": "USD"
  },
  "discountCodes": [],
  "discountApplications": [],
  "rejectedCodes": [],
  "attributes": {},
  "hasUnavailableLines": false,
  "expiresAt": "2026-11-22T16:10:44.179Z",
  "updatedAt": "2026-10-23T16:10:44.179Z"
};
const example_createCart_400: unknown = {
  "error": {
    "code": "VALIDATION_ERROR",
    "message": "Request validation failed",
    "requestId": "req_example",
    "details": [
      {
        "field": "body.lines.0.quantity",
        "code": "too_small",
        "message": "Too small: expected number to be >=1"
      }
    ]
  }
};
const example_getCart_200: unknown = {
  "id": "01a16987-6825-7756-a63c-14d53eff17a6",
  "token": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF",
  "status": "active",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": null,
  "customerId": null,
  "locale": null,
  "lines": [
    {
      "id": "01a16987-6836-7ff4-b0a8-cdf63f54b4f3",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    }
  ],
  "lineCount": 1,
  "subtotal": {
    "amount": 42000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "total": {
    "amount": 42000,
    "currency": "USD"
  },
  "discountCodes": [],
  "discountApplications": [],
  "rejectedCodes": [],
  "attributes": {},
  "hasUnavailableLines": false,
  "expiresAt": "2026-11-22T16:10:44.179Z",
  "updatedAt": "2026-10-23T16:10:44.179Z"
};
const example_getCart_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Cart not found",
    "requestId": "req_example"
  }
};
const example_updateCart_200: unknown = {
  "id": "01a16987-6825-7756-a63c-14d53eff17a6",
  "token": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF",
  "status": "active",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": null,
  "customerId": null,
  "locale": null,
  "lines": [
    {
      "id": "01a16987-6836-7ff4-b0a8-cdf63f54b4f3",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    },
    {
      "id": "01a16987-68b1-7c3d-8320-f200e998ed3c",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "handle": "drift-diamond-pendant",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Drift Diamond Pendant, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 2,
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 198000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    }
  ],
  "lineCount": 3,
  "subtotal": {
    "amount": 240000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "total": {
    "amount": 240000,
    "currency": "USD"
  },
  "discountCodes": [],
  "discountApplications": [],
  "rejectedCodes": [],
  "attributes": {
    "giftWrap": "yes",
    "deliveryNote": "Leave with the concierge"
  },
  "hasUnavailableLines": false,
  "expiresAt": "2026-11-22T16:10:44.624Z",
  "updatedAt": "2026-10-23T16:10:44.624Z"
};
const example_addCartLine_200: unknown = {
  "id": "01a16987-6825-7756-a63c-14d53eff17a6",
  "token": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF",
  "status": "active",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": null,
  "customerId": null,
  "locale": null,
  "lines": [
    {
      "id": "01a16987-6836-7ff4-b0a8-cdf63f54b4f3",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    },
    {
      "id": "01a16987-68b1-7c3d-8320-f200e998ed3c",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "handle": "drift-diamond-pendant",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Drift Diamond Pendant, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    }
  ],
  "lineCount": 2,
  "subtotal": {
    "amount": 141000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "total": {
    "amount": 141000,
    "currency": "USD"
  },
  "discountCodes": [],
  "discountApplications": [],
  "rejectedCodes": [],
  "attributes": {},
  "hasUnavailableLines": false,
  "expiresAt": "2026-11-22T16:10:44.300Z",
  "updatedAt": "2026-10-23T16:10:44.300Z"
};
const example_addCartLine_422: unknown = {
  "error": {
    "code": "INVALID_INPUT",
    "message": "Ring size is required",
    "requestId": "req_example",
    "details": [
      {
        "field": "body.customizations",
        "code": "INVALID_INPUT",
        "message": "Ring size is required"
      }
    ],
    "meta": {
      "missing": "ring_size"
    }
  }
};
const example_updateCartLine_200: unknown = {
  "id": "01a16987-6825-7756-a63c-14d53eff17a6",
  "token": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF",
  "status": "active",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": null,
  "customerId": null,
  "locale": null,
  "lines": [
    {
      "id": "01a16987-6836-7ff4-b0a8-cdf63f54b4f3",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    },
    {
      "id": "01a16987-68b1-7c3d-8320-f200e998ed3c",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "handle": "drift-diamond-pendant",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Drift Diamond Pendant, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 2,
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 198000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    }
  ],
  "lineCount": 3,
  "subtotal": {
    "amount": 240000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "total": {
    "amount": 240000,
    "currency": "USD"
  },
  "discountCodes": [],
  "discountApplications": [],
  "rejectedCodes": [],
  "attributes": {},
  "hasUnavailableLines": false,
  "expiresAt": "2026-11-22T16:10:44.409Z",
  "updatedAt": "2026-10-23T16:10:44.409Z"
};
const example_removeCartLine_200: unknown = {
  "id": "01a16987-6825-7756-a63c-14d53eff17a6",
  "token": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF",
  "status": "active",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": null,
  "customerId": null,
  "locale": null,
  "lines": [
    {
      "id": "01a16987-6836-7ff4-b0a8-cdf63f54b4f3",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    },
    {
      "id": "01a16987-68b1-7c3d-8320-f200e998ed3c",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "handle": "drift-diamond-pendant",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Drift Diamond Pendant, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 2,
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 198000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    }
  ],
  "lineCount": 3,
  "subtotal": {
    "amount": 240000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "total": {
    "amount": 240000,
    "currency": "USD"
  },
  "discountCodes": [],
  "discountApplications": [],
  "rejectedCodes": [],
  "attributes": {
    "giftWrap": "yes",
    "deliveryNote": "Leave with the concierge"
  },
  "hasUnavailableLines": false,
  "expiresAt": "2026-11-22T16:10:44.760Z",
  "updatedAt": "2026-10-23T16:10:44.760Z"
};
const example_applyCartDiscount_200: unknown = {
  "id": "01a16987-6825-7756-a63c-14d53eff17a6",
  "token": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF",
  "status": "active",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": null,
  "customerId": null,
  "locale": null,
  "lines": [
    {
      "id": "01a16987-6836-7ff4-b0a8-cdf63f54b4f3",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    },
    {
      "id": "01a16987-68b1-7c3d-8320-f200e998ed3c",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "handle": "drift-diamond-pendant",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Drift Diamond Pendant, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 2,
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 198000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    }
  ],
  "lineCount": 3,
  "subtotal": {
    "amount": 240000,
    "currency": "USD"
  },
  "discount": {
    "amount": 24000,
    "currency": "USD"
  },
  "total": {
    "amount": 216000,
    "currency": "USD"
  },
  "discountCodes": [
    "WELCOME10"
  ],
  "discountApplications": [
    {
      "discountId": "01a16987-600f-71ce-b85b-8ecfb48c2efb",
      "title": "Welcome 10",
      "code": "WELCOME10",
      "kind": "code",
      "method": "percentage",
      "percentage": 10,
      "target": "order",
      "amount": {
        "amount": 24000,
        "currency": "USD"
      },
      "allocations": [
        {
          "lineId": "01a16987-6836-7ff4-b0a8-cdf63f54b4f3",
          "amount": {
            "amount": 4200,
            "currency": "USD"
          }
        },
        {
          "lineId": "01a16987-68b1-7c3d-8320-f200e998ed3c",
          "amount": {
            "amount": 19800,
            "currency": "USD"
          }
        }
      ]
    }
  ],
  "rejectedCodes": [],
  "attributes": {},
  "hasUnavailableLines": false,
  "expiresAt": "2026-11-22T16:10:44.498Z",
  "updatedAt": "2026-10-23T16:10:44.498Z"
};
const example_applyCartDiscount_422: unknown = {
  "error": {
    "code": "DISCOUNT_NOT_APPLICABLE",
    "message": "Unknown discount code",
    "requestId": "req_example",
    "details": [
      {
        "field": "body.code",
        "code": "DISCOUNT_NOT_APPLICABLE",
        "message": "Unknown discount code"
      }
    ],
    "meta": {
      "reason": "unknown"
    }
  }
};
const example_removeCartDiscount_200: unknown = {
  "id": "01a16987-6825-7756-a63c-14d53eff17a6",
  "token": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF",
  "status": "active",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": null,
  "customerId": null,
  "locale": null,
  "lines": [
    {
      "id": "01a16987-6836-7ff4-b0a8-cdf63f54b4f3",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    },
    {
      "id": "01a16987-68b1-7c3d-8320-f200e998ed3c",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "handle": "drift-diamond-pendant",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Drift Diamond Pendant, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 2,
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 198000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    }
  ],
  "lineCount": 3,
  "subtotal": {
    "amount": 240000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "total": {
    "amount": 240000,
    "currency": "USD"
  },
  "discountCodes": [],
  "discountApplications": [],
  "rejectedCodes": [],
  "attributes": {},
  "hasUnavailableLines": false,
  "expiresAt": "2026-11-22T16:10:44.568Z",
  "updatedAt": "2026-10-23T16:10:44.568Z"
};
const example_mergeCarts_200: unknown = {
  "id": "01a16987-6db6-79e1-a6f8-7be5b525166f",
  "token": "EOl1wwBEEOzeVvdw_eMqoXXSjz0pZlNw",
  "status": "active",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": null,
  "customerId": "01a16987-6b14-7d6f-867c-40a519894a64",
  "locale": null,
  "lines": [
    {
      "id": "01a16987-6dd7-7606-bb69-828a58a86537",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    },
    {
      "id": "01a16987-6dd7-76d4-a912-be4e7983e898",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "handle": "drift-diamond-pendant",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Drift Diamond Pendant, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    }
  ],
  "lineCount": 2,
  "subtotal": {
    "amount": 141000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "total": {
    "amount": 141000,
    "currency": "USD"
  },
  "discountCodes": [],
  "discountApplications": [],
  "rejectedCodes": [],
  "attributes": {},
  "hasUnavailableLines": false,
  "expiresAt": "2026-11-22T16:10:45.615Z",
  "updatedAt": "2026-10-23T16:10:45.615Z"
};
const example_mergeCarts_401: unknown = {
  "error": {
    "code": "UNAUTHORIZED",
    "message": "A customer token is required",
    "requestId": "req_example"
  }
};
const example_getCustomerCart_200: unknown = {
  "id": "01a16987-6db6-79e1-a6f8-7be5b525166f",
  "token": "EOl1wwBEEOzeVvdw_eMqoXXSjz0pZlNw",
  "status": "active",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": null,
  "customerId": "01a16987-6b14-7d6f-867c-40a519894a64",
  "locale": null,
  "lines": [
    {
      "id": "01a16987-6dd7-7606-bb69-828a58a86537",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    },
    {
      "id": "01a16987-6dd7-76d4-a912-be4e7983e898",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "handle": "drift-diamond-pendant",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Drift Diamond Pendant, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "available": true,
      "unavailableReason": null,
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false
    }
  ],
  "lineCount": 2,
  "subtotal": {
    "amount": 141000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "total": {
    "amount": 141000,
    "currency": "USD"
  },
  "discountCodes": [],
  "discountApplications": [],
  "rejectedCodes": [],
  "attributes": {},
  "hasUnavailableLines": false,
  "expiresAt": "2026-11-22T16:10:45.615Z",
  "updatedAt": "2026-10-23T16:10:45.615Z"
};
const example_getCustomerCart_401: unknown = {
  "error": {
    "code": "UNAUTHORIZED",
    "message": "A customer token is required",
    "requestId": "req_example"
  }
};
const example_uploadCustomerFile_201: unknown = {
  "token": "upl_EXAMPLEUPLOADTOKEN00000000000000",
  "filename": "engraving-artwork.png",
  "contentType": "image/png",
  "bytes": 70,
  "expiresAt": "2026-10-30T16:10:43.918Z"
};
const example_getCustomerUpload_200: unknown = "<image/png file bytes>";
const example_getCustomerUpload_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Upload not found",
    "requestId": "req_example"
  }
};
const example_listRegions_200: unknown = {
  "country": "US",
  "label": "State",
  "regions": [
    {
      "code": "AL",
      "name": "Alabama"
    },
    {
      "code": "AK",
      "name": "Alaska"
    },
    {
      "code": "AZ",
      "name": "Arizona"
    },
    {
      "code": "AR",
      "name": "Arkansas"
    },
    {
      "code": "CA",
      "name": "California"
    },
    {
      "code": "CO",
      "name": "Colorado"
    },
    {
      "code": "CT",
      "name": "Connecticut"
    },
    {
      "code": "DE",
      "name": "Delaware"
    },
    {
      "code": "DC",
      "name": "District of Columbia"
    },
    {
      "code": "FL",
      "name": "Florida"
    },
    {
      "code": "GA",
      "name": "Georgia"
    },
    {
      "code": "HI",
      "name": "Hawaii"
    },
    {
      "code": "ID",
      "name": "Idaho"
    },
    {
      "code": "IL",
      "name": "Illinois"
    },
    {
      "code": "IN",
      "name": "Indiana"
    },
    {
      "code": "IA",
      "name": "Iowa"
    },
    {
      "code": "KS",
      "name": "Kansas"
    },
    {
      "code": "KY",
      "name": "Kentucky"
    },
    {
      "code": "LA",
      "name": "Louisiana"
    },
    {
      "code": "ME",
      "name": "Maine"
    },
    {
      "code": "MD",
      "name": "Maryland"
    },
    {
      "code": "MA",
      "name": "Massachusetts"
    },
    {
      "code": "MI",
      "name": "Michigan"
    },
    {
      "code": "MN",
      "name": "Minnesota"
    },
    {
      "code": "MS",
      "name": "Mississippi"
    },
    {
      "code": "MO",
      "name": "Missouri"
    },
    {
      "code": "MT",
      "name": "Montana"
    },
    {
      "code": "NE",
      "name": "Nebraska"
    },
    {
      "code": "NV",
      "name": "Nevada"
    },
    {
      "code": "NH",
      "name": "New Hampshire"
    },
    {
      "code": "NJ",
      "name": "New Jersey"
    },
    {
      "code": "NM",
      "name": "New Mexico"
    },
    {
      "code": "NY",
      "name": "New York"
    },
    {
      "code": "NC",
      "name": "North Carolina"
    },
    {
      "code": "ND",
      "name": "North Dakota"
    },
    {
      "code": "OH",
      "name": "Ohio"
    },
    {
      "code": "OK",
      "name": "Oklahoma"
    },
    {
      "code": "OR",
      "name": "Oregon"
    },
    {
      "code": "PA",
      "name": "Pennsylvania"
    },
    {
      "code": "RI",
      "name": "Rhode Island"
    },
    {
      "code": "SC",
      "name": "South Carolina"
    },
    {
      "code": "SD",
      "name": "South Dakota"
    },
    {
      "code": "TN",
      "name": "Tennessee"
    },
    {
      "code": "TX",
      "name": "Texas"
    },
    {
      "code": "UT",
      "name": "Utah"
    },
    {
      "code": "VT",
      "name": "Vermont"
    },
    {
      "code": "VA",
      "name": "Virginia"
    },
    {
      "code": "WA",
      "name": "Washington"
    },
    {
      "code": "WV",
      "name": "West Virginia"
    },
    {
      "code": "WI",
      "name": "Wisconsin"
    },
    {
      "code": "WY",
      "name": "Wyoming"
    },
    {
      "code": "AS",
      "name": "American Samoa"
    },
    {
      "code": "GU",
      "name": "Guam"
    },
    {
      "code": "MP",
      "name": "Northern Mariana Islands"
    },
    {
      "code": "PR",
      "name": "Puerto Rico"
    },
    {
      "code": "VI",
      "name": "U.S. Virgin Islands"
    }
  ]
};
const example_listRegions_400: unknown = {
  "error": {
    "code": "VALIDATION_ERROR",
    "message": "Request validation failed",
    "requestId": "req_example",
    "details": [
      {
        "field": "params.country",
        "code": "invalid_format",
        "message": "ISO 3166-1 alpha-2 code in upper case"
      }
    ]
  }
};
const example_createCheckout_201: unknown = {
  "id": "01a16987-6e91-7d61-84cb-f6cbdcadca1e",
  "token": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up",
  "cartToken": "EOl1wwBEEOzeVvdw_eMqoXXSjz0pZlNw",
  "status": "open",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": null,
  "phone": null,
  "customerId": "01a16987-6b14-7d6f-867c-40a519894a64",
  "shippingAddress": null,
  "billingAddress": null,
  "lines": [
    {
      "id": "01a16987-6dd7-7606-bb69-828a58a86537",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "estimatedShipDateMin": null,
      "estimatedShipDateMax": null
    },
    {
      "id": "01a16987-6dd7-76d4-a912-be4e7983e898",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "handle": "drift-diamond-pendant",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Drift Diamond Pendant, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "estimatedShipDateMin": null,
      "estimatedShipDateMax": null
    }
  ],
  "availableShippingRates": [],
  "shippingLine": null,
  "paymentFeeLine": null,
  "subtotal": {
    "amount": 141000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "discountApplications": [],
  "rejectedCodes": [],
  "shipping": {
    "amount": 0,
    "currency": "USD"
  },
  "tax": {
    "amount": 0,
    "currency": "USD"
  },
  "taxLines": [],
  "total": {
    "amount": 141000,
    "currency": "USD"
  },
  "giftCardApplications": [],
  "amountDue": {
    "amount": 141000,
    "currency": "USD"
  },
  "requiresDesignApproval": false,
  "estimatedShipDateMin": null,
  "estimatedShipDateMax": null,
  "readyForPayment": false,
  "shippingRequired": true,
  "blockers": [
    "email",
    "shipping_address"
  ],
  "acceptsMarketing": false,
  "termsAcceptedAt": null,
  "expiresAt": "2026-10-30T17:10:45.776Z",
  "completedOrderId": null,
  "completedOrder": null,
  "updatedAt": "2026-10-23T16:10:45.775Z"
};
const example_createCheckout_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Cart not found",
    "requestId": "req_example"
  }
};
const example_getCheckout_200: unknown = {
  "id": "01a16987-6e91-7d61-84cb-f6cbdcadca1e",
  "token": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up",
  "cartToken": "EOl1wwBEEOzeVvdw_eMqoXXSjz0pZlNw",
  "status": "open",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": null,
  "phone": null,
  "customerId": "01a16987-6b14-7d6f-867c-40a519894a64",
  "shippingAddress": null,
  "billingAddress": null,
  "lines": [
    {
      "id": "01a16987-6dd7-7606-bb69-828a58a86537",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "estimatedShipDateMin": null,
      "estimatedShipDateMax": null
    },
    {
      "id": "01a16987-6dd7-76d4-a912-be4e7983e898",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "handle": "drift-diamond-pendant",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Drift Diamond Pendant, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "estimatedShipDateMin": null,
      "estimatedShipDateMax": null
    }
  ],
  "availableShippingRates": [],
  "shippingLine": null,
  "paymentFeeLine": null,
  "subtotal": {
    "amount": 141000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "discountApplications": [],
  "rejectedCodes": [],
  "shipping": {
    "amount": 0,
    "currency": "USD"
  },
  "tax": {
    "amount": 0,
    "currency": "USD"
  },
  "taxLines": [],
  "total": {
    "amount": 141000,
    "currency": "USD"
  },
  "giftCardApplications": [],
  "amountDue": {
    "amount": 141000,
    "currency": "USD"
  },
  "requiresDesignApproval": false,
  "estimatedShipDateMin": null,
  "estimatedShipDateMax": null,
  "readyForPayment": false,
  "shippingRequired": true,
  "blockers": [
    "email",
    "shipping_address"
  ],
  "acceptsMarketing": false,
  "termsAcceptedAt": null,
  "expiresAt": "2026-10-30T17:10:45.776Z",
  "completedOrderId": null,
  "completedOrder": null,
  "updatedAt": "2026-10-23T16:10:45.775Z"
};
const example_updateCheckout_200: unknown = {
  "id": "01a16987-6e91-7d61-84cb-f6cbdcadca1e",
  "token": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up",
  "cartToken": "EOl1wwBEEOzeVvdw_eMqoXXSjz0pZlNw",
  "status": "open",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": "shopper@example.com",
  "phone": null,
  "customerId": "01a16987-6b14-7d6f-867c-40a519894a64",
  "shippingAddress": {
    "firstName": "Asha",
    "lastName": "Mehta",
    "company": null,
    "line1": "350 Fifth Avenue",
    "line2": null,
    "city": "New York",
    "region": "NY",
    "postalCode": "10118",
    "countryCode": "US",
    "phone": "+12125550100"
  },
  "billingAddress": null,
  "lines": [
    {
      "id": "01a16987-6dd7-7606-bb69-828a58a86537",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "estimatedShipDateMin": null,
      "estimatedShipDateMax": null
    },
    {
      "id": "01a16987-6dd7-76d4-a912-be4e7983e898",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "handle": "drift-diamond-pendant",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Drift Diamond Pendant, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "estimatedShipDateMin": null,
      "estimatedShipDateMax": null
    }
  ],
  "availableShippingRates": [
    {
      "id": "01a16987-5e4c-7231-a66b-3df65f24ad41",
      "name": "Standard (insured)",
      "price": {
        "amount": 0,
        "currency": "USD"
      },
      "deliveryDaysMin": 3,
      "deliveryDaysMax": 5,
      "requiresSignature": true
    },
    {
      "id": "01a16987-5e58-7103-911f-8a28e4a0b7c0",
      "name": "Express",
      "price": {
        "amount": 3500,
        "currency": "USD"
      },
      "deliveryDaysMin": 1,
      "deliveryDaysMax": 2,
      "requiresSignature": true
    }
  ],
  "shippingLine": null,
  "paymentFeeLine": null,
  "subtotal": {
    "amount": 141000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "discountApplications": [],
  "rejectedCodes": [],
  "shipping": {
    "amount": 0,
    "currency": "USD"
  },
  "tax": {
    "amount": 0,
    "currency": "USD"
  },
  "taxLines": [],
  "total": {
    "amount": 141000,
    "currency": "USD"
  },
  "giftCardApplications": [],
  "amountDue": {
    "amount": 141000,
    "currency": "USD"
  },
  "requiresDesignApproval": false,
  "estimatedShipDateMin": null,
  "estimatedShipDateMax": null,
  "readyForPayment": false,
  "shippingRequired": true,
  "blockers": [
    "shipping_rate"
  ],
  "acceptsMarketing": true,
  "termsAcceptedAt": "2026-10-23T16:10:45.872Z",
  "expiresAt": "2026-10-30T17:10:45.873Z",
  "completedOrderId": null,
  "completedOrder": null,
  "updatedAt": "2026-10-23T16:10:45.873Z"
};
const example_updateCheckout_422: unknown = {
  "error": {
    "code": "INVALID_INPUT",
    "message": "\"Atlantis\" is not a state of US; use one of GET /regions/US",
    "requestId": "req_example",
    "details": [
      {
        "field": "body.shippingAddress.region",
        "code": "INVALID_INPUT",
        "message": "\"Atlantis\" is not a state of US; use one of GET /regions/US"
      }
    ],
    "meta": {
      "country": "US",
      "label": "State"
    }
  }
};
const example_listCheckoutPaymentMethods_200: unknown = {
  "items": [
    {
      "type": "stripe",
      "wallets": [
        "apple_pay",
        "google_pay"
      ],
      "publishableKey": "pk_test_STRIPEEXAMPLE0000000000000000"
    },
    {
      "type": "manual",
      "id": "01a16987-5e64-71ff-b703-dc3bb87bb373",
      "key": "bank_transfer",
      "name": "Bank transfer",
      "description": "Pay by wire; we start production once it lands.",
      "instructions": "Transfer the order total to the account in your confirmation email and quote the order number.",
      "fee": {
        "amount": 0,
        "currency": "USD"
      },
      "available": true
    },
    {
      "type": "manual",
      "id": "01a16987-5e71-7a80-9920-aa2e965d9207",
      "key": "cod",
      "name": "Cash on delivery",
      "description": "Pay the courier on delivery (United States only).",
      "instructions": "Have the exact amount ready; the courier cannot give change.",
      "fee": {
        "amount": 0,
        "currency": "USD"
      },
      "available": true
    }
  ]
};
const example_recoverCheckout_200: unknown = {
  "id": "01a16987-73bb-77eb-be34-811c56ac936f",
  "token": "shE9evnOFAwl3tpq-1lvDHFOikQNMjAz",
  "cartToken": "yPcNcXk7TLu7UDz3VkYrOPws_k81efLM",
  "status": "open",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": "shopper@example.com",
  "phone": null,
  "customerId": null,
  "shippingAddress": {
    "firstName": "Asha",
    "lastName": "Mehta",
    "company": null,
    "line1": "350 Fifth Avenue",
    "line2": null,
    "city": "New York",
    "region": "NY",
    "postalCode": "10118",
    "countryCode": "US",
    "phone": "+12125550100"
  },
  "billingAddress": null,
  "lines": [
    {
      "id": "01a16987-7375-7e01-95c3-a0bb56aa58b3",
      "productId": "01a16987-5029-703d-b716-e12838e96fdd",
      "variantId": "01a16987-505a-7362-8e9c-0713cf4861db",
      "handle": "vela-emerald-cut-bezel",
      "title": "Vela Emerald-Cut Bezel",
      "variantTitle": "14K Yellow Gold / 1.00 ct",
      "sku": null,
      "image": {
        "id": "01a16987-507a-75aa-96d9-57c2f566149c",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-507a-75aa-96d9-57c2f566149c/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Vela Emerald-Cut Bezel, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 279000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 279000,
        "currency": "USD"
      },
      "fulfillmentMode": "made_to_order",
      "leadTimeDaysMin": 14,
      "leadTimeDaysMax": 21,
      "requiresDesignApproval": true,
      "estimatedShipDateMin": "2026-11-06",
      "estimatedShipDateMax": "2026-11-13"
    }
  ],
  "availableShippingRates": [
    {
      "id": "01a16987-5e4c-7231-a66b-3df65f24ad41",
      "name": "Standard (insured)",
      "price": {
        "amount": 0,
        "currency": "USD"
      },
      "deliveryDaysMin": 3,
      "deliveryDaysMax": 5,
      "requiresSignature": true
    },
    {
      "id": "01a16987-5e58-7103-911f-8a28e4a0b7c0",
      "name": "Express",
      "price": {
        "amount": 3500,
        "currency": "USD"
      },
      "deliveryDaysMin": 1,
      "deliveryDaysMax": 2,
      "requiresSignature": true
    }
  ],
  "shippingLine": {
    "rateId": "01a16987-5e4c-7231-a66b-3df65f24ad41",
    "title": "Standard (insured)",
    "price": {
      "amount": 0,
      "currency": "USD"
    }
  },
  "paymentFeeLine": null,
  "subtotal": {
    "amount": 279000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "discountApplications": [],
  "rejectedCodes": [],
  "shipping": {
    "amount": 0,
    "currency": "USD"
  },
  "tax": {
    "amount": 0,
    "currency": "USD"
  },
  "taxLines": [],
  "total": {
    "amount": 279000,
    "currency": "USD"
  },
  "giftCardApplications": [],
  "amountDue": {
    "amount": 279000,
    "currency": "USD"
  },
  "requiresDesignApproval": true,
  "estimatedShipDateMin": "2026-11-06",
  "estimatedShipDateMax": "2026-11-13",
  "readyForPayment": true,
  "shippingRequired": true,
  "blockers": [],
  "acceptsMarketing": false,
  "termsAcceptedAt": null,
  "expiresAt": "2026-10-30T17:10:47.228Z",
  "completedOrderId": null,
  "completedOrder": null,
  "updatedAt": "2026-10-23T16:10:47.228Z"
};
const example_applyCheckoutGiftCard_200: unknown = {
  "id": "01a16987-6e91-7d61-84cb-f6cbdcadca1e",
  "token": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up",
  "cartToken": "EOl1wwBEEOzeVvdw_eMqoXXSjz0pZlNw",
  "status": "open",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": "shopper@example.com",
  "phone": null,
  "customerId": "01a16987-6b14-7d6f-867c-40a519894a64",
  "shippingAddress": {
    "firstName": "Asha",
    "lastName": "Mehta",
    "company": null,
    "line1": "350 Fifth Avenue",
    "line2": null,
    "city": "New York",
    "region": "NY",
    "postalCode": "10118",
    "countryCode": "US",
    "phone": "+12125550100"
  },
  "billingAddress": null,
  "lines": [
    {
      "id": "01a16987-6dd7-7606-bb69-828a58a86537",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "estimatedShipDateMin": null,
      "estimatedShipDateMax": null
    },
    {
      "id": "01a16987-6dd7-76d4-a912-be4e7983e898",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "handle": "drift-diamond-pendant",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Drift Diamond Pendant, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "estimatedShipDateMin": null,
      "estimatedShipDateMax": null
    }
  ],
  "availableShippingRates": [
    {
      "id": "01a16987-5e4c-7231-a66b-3df65f24ad41",
      "name": "Standard (insured)",
      "price": {
        "amount": 0,
        "currency": "USD"
      },
      "deliveryDaysMin": 3,
      "deliveryDaysMax": 5,
      "requiresSignature": true
    },
    {
      "id": "01a16987-5e58-7103-911f-8a28e4a0b7c0",
      "name": "Express",
      "price": {
        "amount": 3500,
        "currency": "USD"
      },
      "deliveryDaysMin": 1,
      "deliveryDaysMax": 2,
      "requiresSignature": true
    }
  ],
  "shippingLine": {
    "rateId": "01a16987-5e4c-7231-a66b-3df65f24ad41",
    "title": "Standard (insured)",
    "price": {
      "amount": 0,
      "currency": "USD"
    }
  },
  "paymentFeeLine": null,
  "subtotal": {
    "amount": 141000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "discountApplications": [],
  "rejectedCodes": [],
  "shipping": {
    "amount": 0,
    "currency": "USD"
  },
  "tax": {
    "amount": 0,
    "currency": "USD"
  },
  "taxLines": [],
  "total": {
    "amount": 141000,
    "currency": "USD"
  },
  "giftCardApplications": [
    {
      "last4": "GTQ6",
      "amount": {
        "amount": 5000,
        "currency": "USD"
      }
    }
  ],
  "amountDue": {
    "amount": 136000,
    "currency": "USD"
  },
  "requiresDesignApproval": false,
  "estimatedShipDateMin": null,
  "estimatedShipDateMax": null,
  "readyForPayment": true,
  "shippingRequired": true,
  "blockers": [],
  "acceptsMarketing": true,
  "termsAcceptedAt": "2026-10-23T16:10:45.872Z",
  "expiresAt": "2026-10-30T17:10:46.050Z",
  "completedOrderId": null,
  "completedOrder": null,
  "updatedAt": "2026-10-23T16:10:46.050Z"
};
const example_applyCheckoutGiftCard_422: unknown = {
  "error": {
    "code": "INVALID_INPUT",
    "message": "Gift card not found",
    "requestId": "req_example",
    "details": [
      {
        "field": "body.code",
        "code": "INVALID_INPUT",
        "message": "Gift card not found"
      }
    ],
    "meta": {
      "reason": "unknown"
    }
  }
};
const example_removeCheckoutGiftCard_200: unknown = {
  "id": "01a16987-6e91-7d61-84cb-f6cbdcadca1e",
  "token": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up",
  "cartToken": "EOl1wwBEEOzeVvdw_eMqoXXSjz0pZlNw",
  "status": "open",
  "currency": "USD",
  "market": {
    "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
    "name": "Default",
    "currency": "USD",
    "countries": [
      "US"
    ]
  },
  "email": "shopper@example.com",
  "phone": null,
  "customerId": "01a16987-6b14-7d6f-867c-40a519894a64",
  "shippingAddress": {
    "firstName": "Asha",
    "lastName": "Mehta",
    "company": null,
    "line1": "350 Fifth Avenue",
    "line2": null,
    "city": "New York",
    "region": "NY",
    "postalCode": "10118",
    "countryCode": "US",
    "phone": "+12125550100"
  },
  "billingAddress": null,
  "lines": [
    {
      "id": "01a16987-6dd7-7606-bb69-828a58a86537",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "handle": "orbit-comfort-fit-band",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Orbit Comfort-Fit Band, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "estimatedShipDateMin": null,
      "estimatedShipDateMax": null
    },
    {
      "id": "01a16987-6dd7-76d4-a912-be4e7983e898",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "handle": "drift-diamond-pendant",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "image": {
        "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
        "kind": "image",
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
        "mimeType": "image/png",
        "renditions": null,
        "alt": "Drift Diamond Pendant, view 1",
        "width": 1200,
        "height": 1200
      },
      "quantity": 1,
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "compareAt": null,
      "linePrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "estimatedShipDateMin": null,
      "estimatedShipDateMax": null
    }
  ],
  "availableShippingRates": [
    {
      "id": "01a16987-5e4c-7231-a66b-3df65f24ad41",
      "name": "Standard (insured)",
      "price": {
        "amount": 0,
        "currency": "USD"
      },
      "deliveryDaysMin": 3,
      "deliveryDaysMax": 5,
      "requiresSignature": true
    },
    {
      "id": "01a16987-5e58-7103-911f-8a28e4a0b7c0",
      "name": "Express",
      "price": {
        "amount": 3500,
        "currency": "USD"
      },
      "deliveryDaysMin": 1,
      "deliveryDaysMax": 2,
      "requiresSignature": true
    }
  ],
  "shippingLine": {
    "rateId": "01a16987-5e4c-7231-a66b-3df65f24ad41",
    "title": "Standard (insured)",
    "price": {
      "amount": 0,
      "currency": "USD"
    }
  },
  "paymentFeeLine": null,
  "subtotal": {
    "amount": 141000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "discountApplications": [],
  "rejectedCodes": [],
  "shipping": {
    "amount": 0,
    "currency": "USD"
  },
  "tax": {
    "amount": 0,
    "currency": "USD"
  },
  "taxLines": [],
  "total": {
    "amount": 141000,
    "currency": "USD"
  },
  "giftCardApplications": [],
  "amountDue": {
    "amount": 141000,
    "currency": "USD"
  },
  "requiresDesignApproval": false,
  "estimatedShipDateMin": null,
  "estimatedShipDateMax": null,
  "readyForPayment": true,
  "shippingRequired": true,
  "blockers": [],
  "acceptsMarketing": true,
  "termsAcceptedAt": "2026-10-23T16:10:45.872Z",
  "expiresAt": "2026-10-30T17:10:46.114Z",
  "completedOrderId": null,
  "completedOrder": null,
  "updatedAt": "2026-10-23T16:10:46.114Z"
};
const example_createPaymentIntent_200: unknown = {
  "paymentIntentId": "pi_dev_e5337a66d97646ea911f31c4e667c5eb",
  "clientSecret": "pi_dev_e5337a66d97646ea911f31c4e667c5eb_secret_dev",
  "publishableKey": "pk_test_STRIPEEXAMPLE0000000000000000",
  "amount": {
    "amount": 141000,
    "currency": "USD"
  },
  "captureMethod": "automatic",
  "status": "requires_payment_method"
};
const example_completeCheckout_200: unknown = {
  "id": "01a16987-7094-7033-bc41-daea60af21f3",
  "number": 1001,
  "name": "#1001",
  "email": "shopper@example.com",
  "customerId": "01a16987-6b14-7d6f-867c-40a519894a64",
  "status": "open",
  "financialStatus": "paid",
  "fulfillmentStatus": "unfulfilled",
  "approvalStatus": null,
  "currency": "USD",
  "total": {
    "amount": 141000,
    "currency": "USD"
  },
  "paid": {
    "amount": 141000,
    "currency": "USD"
  },
  "paymentMethod": "card",
  "lineCount": 2,
  "placedAt": "2026-10-23T16:10:46.288Z",
  "estimatedShipDateMin": null,
  "estimatedShipDateMax": null,
  "tags": [],
  "workflow": null,
  "phone": null,
  "shippingAddress": {
    "firstName": "Asha",
    "lastName": "Mehta",
    "company": null,
    "line1": "350 Fifth Avenue",
    "line2": null,
    "city": "New York",
    "region": "NY",
    "postalCode": "10118",
    "countryCode": "US",
    "phone": "+12125550100"
  },
  "billingAddress": {
    "firstName": "Asha",
    "lastName": "Mehta",
    "company": null,
    "line1": "350 Fifth Avenue",
    "line2": null,
    "city": "New York",
    "region": "NY",
    "postalCode": "10118",
    "countryCode": "US",
    "phone": "+12125550100"
  },
  "shippingMethod": {
    "rateId": "01a16987-5e4c-7231-a66b-3df65f24ad41",
    "title": "Standard (insured)",
    "price": {
      "amount": 0,
      "currency": "USD"
    }
  },
  "subtotal": {
    "amount": 141000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "shipping": {
    "amount": 0,
    "currency": "USD"
  },
  "tax": {
    "amount": 0,
    "currency": "USD"
  },
  "refunded": {
    "amount": 0,
    "currency": "USD"
  },
  "lines": [
    {
      "id": "01a16987-7098-7d5c-8f8e-f074098f1f5b",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "optionValues": {
        "metal": "14k_yellow_gold"
      },
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "quantity": 1,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "discount": {
        "amount": 0,
        "currency": "USD"
      },
      "tax": {
        "amount": 0,
        "currency": "USD"
      },
      "total": {
        "amount": 42000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "fulfilledQuantity": 0,
      "cancelledQuantity": 0,
      "mediaUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png"
    },
    {
      "id": "01a16987-7099-772f-815c-80de5232ed11",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "optionValues": {
        "metal": "14k_yellow_gold"
      },
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "quantity": 1,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "discount": {
        "amount": 0,
        "currency": "USD"
      },
      "tax": {
        "amount": 0,
        "currency": "USD"
      },
      "total": {
        "amount": 99000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "fulfilledQuantity": 0,
      "cancelledQuantity": 0,
      "mediaUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png"
    }
  ],
  "payments": [
    {
      "id": "01a16987-70a8-785d-92ca-d0749673e2f7",
      "provider": "stripe",
      "status": "captured",
      "amount": {
        "amount": 141000,
        "currency": "USD"
      },
      "amountCaptured": {
        "amount": 141000,
        "currency": "USD"
      },
      "amountRefunded": {
        "amount": 0,
        "currency": "USD"
      },
      "methodSnapshot": null,
      "manualReference": null,
      "providerPaymentIntentId": "pi_dev_e5337a66d97646ea911f31c4e667c5eb",
      "card": {
        "brand": "visa",
        "last4": "4242",
        "wallet": null,
        "funding": "credit"
      },
      "failure": null,
      "capturedAt": "2026-10-23T16:10:46.288Z",
      "createdAt": "2026-10-23T16:10:46.285Z"
    }
  ],
  "giftCardApplications": [],
  "discountCodes": [],
  "discountApplications": [],
  "taxLines": [],
  "fulfillments": [],
  "refunds": [],
  "returns": [],
  "events": [
    {
      "id": "01a16987-70a5-78f7-893c-1f04b8855e2b",
      "kind": "placed",
      "message": "Order #1001 placed",
      "data": null,
      "actorType": "customer",
      "visibleToCustomer": true,
      "createdAt": "2026-10-23T16:10:46.285Z"
    },
    {
      "id": "01a16987-70ab-761d-b63d-360461054355",
      "kind": "payment_received",
      "message": "Paid 141000 USD by visa ending 4242",
      "data": {
        "provider": "stripe",
        "amountCents": 141000,
        "paymentIntentId": "pi_dev_e5337a66d97646ea911f31c4e667c5eb"
      },
      "actorType": "system",
      "visibleToCustomer": true,
      "createdAt": "2026-10-23T16:10:46.285Z"
    },
    {
      "id": "01a16987-70cb-7a83-855e-77f67c203b23",
      "kind": "workflow_started",
      "message": "Production workflow Standard production started",
      "data": {
        "templateId": "01a16987-4c0b-7f35-83be-39a42b93768c",
        "templateName": "Standard production"
      },
      "actorType": "system",
      "visibleToCustomer": false,
      "createdAt": "2026-10-23T16:10:46.285Z"
    },
    {
      "id": "01a16987-70d0-751b-8fea-afd92a929a12",
      "kind": "workflow_stage_started",
      "message": "Order confirmed",
      "data": {
        "dueAt": "2026-10-24T16:10:46.346Z",
        "stageKey": "confirmation",
        "parentKey": null,
        "stageName": "Order confirmation"
      },
      "actorType": "system",
      "visibleToCustomer": true,
      "createdAt": "2026-10-23T16:10:46.285Z"
    }
  ],
  "note": null,
  "staffNotes": null,
  "termsAcceptedAt": "2026-10-23T16:10:45.872Z",
  "cancelledAt": null,
  "cancelReason": null,
  "paymentInstructions": null,
  "auction": null,
  "progress": [
    {
      "name": "Order confirmed",
      "state": "current",
      "completedAt": null
    },
    {
      "name": "Sourcing your stones",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Certificate issued",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Crafting your ring",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Quality check",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Your review",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Shipped",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Delivered",
      "state": "upcoming",
      "completedAt": null
    }
  ],
  "returnWindow": {
    "closesAt": null,
    "eligible": false,
    "lines": [
      {
        "lineId": "01a16987-7098-7d5c-8f8e-f074098f1f5b",
        "returnableQuantity": 0
      },
      {
        "lineId": "01a16987-7099-772f-815c-80de5232ed11",
        "returnableQuantity": 0
      }
    ]
  },
  "updatedAt": "2026-10-23T16:10:46.285Z",
  "statusToken": "AaFph3CUcDO8QdrqYK8h8w.u658xy.50wFmH8waqJfXAZML1Wzw4kNxmBn3qMxH7UjNUiGv5Q",
  "statusUrl": "https://docs.example/orders/status/AaFph3CUcDO8QdrqYK8h8w.u658xy.50wFmH8waqJfXAZML1Wzw4kNxmBn3qMxH7UjNUiGv5Q"
};
const example_subscribeNewsletter_202: unknown = {
  "received": true
};
const example_confirmNewsletter_200: unknown = {
  "email": "news@example.com",
  "status": "subscribed"
};
const example_confirmNewsletter_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "This link is not valid",
    "requestId": "req_example"
  }
};
const example_unsubscribeNewsletter_200: unknown = {
  "email": "news@example.com",
  "status": "unsubscribed"
};
const example_unsubscribeNewsletter_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "This link is not valid",
    "requestId": "req_example"
  }
};
const example_listAuctions_200: unknown = {
  "items": [
    {
      "id": "01a16987-7ab4-7291-b92e-645c753b7400",
      "status": "live",
      "lot": {
        "storeProductId": "01a16987-5d6c-7529-92d4-c8b8a3bdb019",
        "handle": "luna-round-halo",
        "title": "Luna Round Halo",
        "variantId": "01a16987-4e32-7583-bdc0-f517e600e816",
        "variantTitle": "14K Yellow Gold / 1.00 ct",
        "imageUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4e5a-799b-bab4-c098b5b9fea8/original.png"
      },
      "startsAt": "2026-10-23T16:10:47.864Z",
      "endsAt": "2026-10-26T16:10:48.864Z",
      "startingPrice": {
        "amount": 150000,
        "currency": "USD"
      },
      "currentPrice": null,
      "nextMinimumBid": {
        "amount": 150000,
        "currency": "USD"
      },
      "bidCount": 0,
      "bidderCount": 0,
      "hasReserve": true,
      "reserveMet": false,
      "buyerPremiumBps": 1000,
      "buyNowPrice": null,
      "estimate": null,
      "conditionGrade": null,
      "badges": [],
      "approximatePrice": null,
      "sale": null
    }
  ],
  "nextCursor": null
};
const example_listAuctions_400: unknown = {
  "error": {
    "code": "VALIDATION_ERROR",
    "message": "Request validation failed",
    "requestId": "req_example",
    "details": [
      {
        "field": "query.limit",
        "code": "too_big",
        "message": "Too big: expected number to be <=100"
      }
    ]
  }
};
const example_getAuctionTerms_200: unknown = {
  "version": "default-9f1e551a447d",
  "title": "Auction terms",
  "bodyHtml": "<p>By registering you agree that every bid you place is a binding offer to buy the lot at that price, plus any buyer's premium shown on the auction.</p><p>The highest bid when the auction closes wins, provided any reserve is met. A maximum bid is placed for you one increment at a time, only as far as needed to keep you in the lead; equal maximums go to the bidder who set theirs first.</p><p>A bid in the final minutes of an auction can extend its closing time, so everyone has a fair chance to respond.</p><p>The store may remove a bid or decline a bidder, and may cancel an auction before it closes.</p><p>Won lots are final sale: they cannot be returned because you changed your mind. If a lot is not as described or not authentic, you receive a full refund on its return.</p><p>The winning order is placed for you when the auction closes and the store contacts you about payment, shipping and any customisation the lot offers, such as a size.</p>",
  "source": "default",
  "registration": null
};
const example_registerForAuctions_201: unknown = {
  "termsVersion": "default-9f1e551a447d",
  "acceptedAt": "2026-10-23T16:10:49.096Z",
  "blocked": false
};
const example_registerForAuctions_409: unknown = {
  "error": {
    "code": "AUCTION_TERMS_CHANGED",
    "message": "The auction terms have changed; read and accept the current version",
    "requestId": "req_example",
    "details": [
      {
        "field": "body.termsVersion",
        "code": "AUCTION_TERMS_CHANGED",
        "message": "The auction terms have changed; read and accept the current version"
      }
    ],
    "meta": {
      "version": "default-9f1e551a447d"
    }
  }
};
const example_getAuction_200: unknown = {
  "id": "01a16987-7ab4-7291-b92e-645c753b7400",
  "status": "live",
  "lot": {
    "storeProductId": "01a16987-5d6c-7529-92d4-c8b8a3bdb019",
    "handle": "luna-round-halo",
    "title": "Luna Round Halo",
    "variantId": "01a16987-4e32-7583-bdc0-f517e600e816",
    "variantTitle": "14K Yellow Gold / 1.00 ct",
    "imageUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4e5a-799b-bab4-c098b5b9fea8/original.png"
  },
  "startsAt": "2026-10-23T16:10:47.864Z",
  "endsAt": "2026-10-26T16:10:48.864Z",
  "startingPrice": {
    "amount": 150000,
    "currency": "USD"
  },
  "currentPrice": {
    "amount": 230000,
    "currency": "USD"
  },
  "nextMinimumBid": {
    "amount": 240000,
    "currency": "USD"
  },
  "bidCount": 3,
  "bidderCount": 2,
  "hasReserve": true,
  "reserveMet": true,
  "buyerPremiumBps": 1000,
  "buyNowPrice": null,
  "estimate": null,
  "conditionGrade": null,
  "badges": [],
  "approximatePrice": null,
  "sale": null,
  "serverTime": "2026-10-23T16:10:49.277Z",
  "antiSnipeMinutes": 2,
  "details": {
    "estimateLow": null,
    "estimateHigh": null,
    "conditionGrade": null,
    "conditionLabel": null,
    "conditionReport": null,
    "conditionMediaIds": [],
    "authentication": null,
    "provenance": [],
    "accessories": null,
    "serviceHistory": null,
    "essay": null,
    "literature": null
  },
  "outcome": null,
  "hammerPrice": null,
  "recentBids": [
    {
      "bidderLabel": "Bidder 1",
      "amount": {
        "amount": 230000,
        "currency": "USD"
      },
      "kind": "proxy",
      "createdAt": "2026-10-23T16:10:49.234Z"
    },
    {
      "bidderLabel": "Bidder 2",
      "amount": {
        "amount": 220000,
        "currency": "USD"
      },
      "kind": "bid",
      "createdAt": "2026-10-23T16:10:49.234Z"
    },
    {
      "bidderLabel": "Bidder 1",
      "amount": {
        "amount": 200000,
        "currency": "USD"
      },
      "kind": "max",
      "createdAt": "2026-10-23T16:10:49.160Z"
    }
  ],
  "viewer": {
    "registered": true,
    "blocked": false,
    "bidderLabel": "Bidder 2",
    "state": "outbid",
    "maxAmount": {
      "amount": 220000,
      "currency": "USD"
    },
    "watching": false
  }
};
const example_getAuction_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Auction not found",
    "requestId": "req_example"
  }
};
const example_placeAuctionBid_201: unknown = {
  "auction": {
    "id": "01a16987-7ab4-7291-b92e-645c753b7400",
    "status": "live",
    "lot": {
      "storeProductId": "01a16987-5d6c-7529-92d4-c8b8a3bdb019",
      "handle": "luna-round-halo",
      "title": "Luna Round Halo",
      "variantId": "01a16987-4e32-7583-bdc0-f517e600e816",
      "variantTitle": "14K Yellow Gold / 1.00 ct",
      "imageUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4e5a-799b-bab4-c098b5b9fea8/original.png"
    },
    "startsAt": "2026-10-23T16:10:47.864Z",
    "endsAt": "2026-10-26T16:10:48.864Z",
    "startingPrice": {
      "amount": 150000,
      "currency": "USD"
    },
    "currentPrice": {
      "amount": 200000,
      "currency": "USD"
    },
    "nextMinimumBid": {
      "amount": 210000,
      "currency": "USD"
    },
    "bidCount": 1,
    "bidderCount": 1,
    "hasReserve": true,
    "reserveMet": true,
    "buyerPremiumBps": 1000,
    "buyNowPrice": null,
    "estimate": null,
    "conditionGrade": null,
    "badges": [],
    "approximatePrice": null,
    "sale": null,
    "serverTime": "2026-10-23T16:10:49.188Z",
    "antiSnipeMinutes": 2,
    "details": {
      "estimateLow": null,
      "estimateHigh": null,
      "conditionGrade": null,
      "conditionLabel": null,
      "conditionReport": null,
      "conditionMediaIds": [],
      "authentication": null,
      "provenance": [],
      "accessories": null,
      "serviceHistory": null,
      "essay": null,
      "literature": null
    },
    "outcome": null,
    "hammerPrice": null,
    "recentBids": [
      {
        "bidderLabel": "Bidder 1",
        "amount": {
          "amount": 200000,
          "currency": "USD"
        },
        "kind": "max",
        "createdAt": "2026-10-23T16:10:49.160Z"
      }
    ],
    "viewer": {
      "registered": true,
      "blocked": false,
      "bidderLabel": "Bidder 1",
      "state": "leading",
      "maxAmount": {
        "amount": 250000,
        "currency": "USD"
      },
      "watching": false
    }
  },
  "bid": {
    "id": "01a16987-7bce-7954-bb9b-94815abd915b",
    "kind": "max",
    "amount": {
      "amount": 200000,
      "currency": "USD"
    },
    "maxAmount": {
      "amount": 250000,
      "currency": "USD"
    }
  },
  "leading": true,
  "extended": false
};
const example_placeAuctionBid_422: unknown = {
  "error": {
    "code": "BID_TOO_LOW",
    "message": "The bid is below the next minimum bid",
    "requestId": "req_example",
    "details": [
      {
        "field": "body.amount.amount",
        "code": "BID_TOO_LOW",
        "message": "The bid is below the next minimum bid"
      }
    ],
    "meta": {
      "minimum": {
        "amount": 210000,
        "currency": "USD"
      }
    }
  }
};
const example_listMyAuctions_200: unknown = {
  "items": [
    {
      "auction": {
        "id": "01a16987-7ab4-7291-b92e-645c753b7400",
        "status": "live",
        "lot": {
          "storeProductId": "01a16987-5d6c-7529-92d4-c8b8a3bdb019",
          "handle": "luna-round-halo",
          "title": "Luna Round Halo",
          "variantId": "01a16987-4e32-7583-bdc0-f517e600e816",
          "variantTitle": "14K Yellow Gold / 1.00 ct",
          "imageUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-4e5a-799b-bab4-c098b5b9fea8/original.png"
        },
        "startsAt": "2026-10-23T16:10:47.864Z",
        "endsAt": "2026-10-26T16:10:48.864Z",
        "startingPrice": {
          "amount": 150000,
          "currency": "USD"
        },
        "currentPrice": {
          "amount": 230000,
          "currency": "USD"
        },
        "nextMinimumBid": {
          "amount": 240000,
          "currency": "USD"
        },
        "bidCount": 3,
        "bidderCount": 2,
        "hasReserve": true,
        "reserveMet": true,
        "buyerPremiumBps": 1000,
        "buyNowPrice": null,
        "estimate": null,
        "conditionGrade": null,
        "badges": [],
        "approximatePrice": null,
        "sale": null
      },
      "bidderLabel": "Bidder 2",
      "state": "outbid",
      "myHighestBid": {
        "amount": 220000,
        "currency": "USD"
      },
      "myMaxAmount": null,
      "orderId": null,
      "lastBidAt": "2026-10-23T16:10:49.234Z"
    }
  ],
  "nextCursor": null
};
const example_listMyAuctions_401: unknown = {
  "error": {
    "code": "UNAUTHORIZED",
    "message": "A customer token is required",
    "requestId": "req_example"
  }
};
const example_buyAuctionNow_201: unknown = {
  "auction": {
    "id": "01a15332-5a36-7d56-a629-0c0f8a41ffad",
    "status": "ended",
    "lot": {
      "storeProductId": "01a15332-3594-7575-bf71-70016684f37d",
      "handle": "luna-round-halo",
      "title": "Luna Round Halo",
      "variantId": "01a15332-2886-7d21-9894-21a99458250b",
      "variantTitle": "14K Yellow Gold / 1.00 ct",
      "imageUrl": "http://localhost:3000/media/org/01a15332-25d4-7008-aafd-160be85928ca/media/01a15332-28a7-7b0f-b834-82d0aabdbe06/original.png"
    },
    "startsAt": "2026-10-19T08:06:10.239Z",
    "endsAt": "2026-10-22T08:06:11.239Z",
    "startingPrice": {
      "amount": 150000,
      "currency": "USD"
    },
    "currentPrice": {
      "amount": 450000,
      "currency": "USD"
    },
    "nextMinimumBid": {
      "amount": 475000,
      "currency": "USD"
    },
    "bidCount": 1,
    "bidderCount": 1,
    "hasReserve": true,
    "reserveMet": true,
    "buyerPremiumBps": 1000,
    "serverTime": "2026-10-19T08:06:11.612Z",
    "antiSnipeMinutes": 2,
    "outcome": "sold",
    "hammerPrice": {
      "amount": 450000,
      "currency": "USD"
    },
    "recentBids": [
      {
        "bidderLabel": "Bidder 1",
        "amount": {
          "amount": 450000,
          "currency": "USD"
        },
        "kind": "buy_now",
        "createdAt": "2026-10-19T08:10:00.000Z"
      }
    ],
    "viewer": {
      "registered": true,
      "blocked": false,
      "bidderLabel": "Bidder 1",
      "state": "won",
      "maxAmount": {
        "amount": 450000,
        "currency": "USD"
      },
      "watching": false
    },
    "buyNowPrice": null,
    "estimate": {
      "low": {
        "amount": 380000,
        "currency": "USD"
      },
      "high": {
        "amount": 460000,
        "currency": "USD"
      }
    },
    "conditionGrade": "excellent",
    "badges": [
      "authenticated",
      "papers_match",
      "full_set"
    ],
    "approximatePrice": null,
    "sale": null,
    "details": {
      "estimateLow": {
        "amount": 380000,
        "currency": "USD"
      },
      "estimateHigh": {
        "amount": 460000,
        "currency": "USD"
      },
      "conditionGrade": "excellent",
      "conditionLabel": "Excellent",
      "conditionReport": "<p>Light hairlines on the clasp; dial and hands untouched.</p>",
      "conditionMediaIds": [],
      "authentication": {
        "status": "house_expert",
        "by": "House horologist",
        "at": "2026-10-01",
        "certificateNumber": null,
        "certificateMediaId": null,
        "notes": "Movement opened and checked"
      },
      "provenance": [
        {
          "period": "2021–2026",
          "source": "Original owner, New York",
          "note": null
        }
      ],
      "accessories": {
        "box": true,
        "papers": true,
        "warrantyCard": true,
        "tags": false,
        "dustBag": false,
        "receipt": false,
        "extras": [
          "Hangtag"
        ]
      },
      "serviceHistory": "Serviced by the manufacturer in 2025",
      "essay": "<p>The white-dial reference, full set.</p>",
      "literature": null
    }
  },
  "orderId": "01a15341-2b3c-7d4e-9f50-61728394a5b6"
};
const example_watchAuction_201: unknown = {
  "auctionId": "01a15332-5a36-7d56-a629-0c0f8a41ffad",
  "watching": true
};
const example_listWatchedAuctions_200: unknown = {
  "items": [
    {
      "auction": {
        "id": "01a15332-5a36-7d56-a629-0c0f8a41ffad",
        "status": "live",
        "lot": {
          "storeProductId": "01a15332-3594-7575-bf71-70016684f37d",
          "handle": "luna-round-halo",
          "title": "Luna Round Halo",
          "variantId": "01a15332-2886-7d21-9894-21a99458250b",
          "variantTitle": "14K Yellow Gold / 1.00 ct",
          "imageUrl": "http://localhost:3000/media/org/01a15332-25d4-7008-aafd-160be85928ca/media/01a15332-28a7-7b0f-b834-82d0aabdbe06/original.png"
        },
        "startsAt": "2026-10-19T08:06:10.239Z",
        "endsAt": "2026-10-22T08:06:11.239Z",
        "startingPrice": {
          "amount": 150000,
          "currency": "USD"
        },
        "currentPrice": {
          "amount": 230000,
          "currency": "USD"
        },
        "nextMinimumBid": {
          "amount": 240000,
          "currency": "USD"
        },
        "bidCount": 3,
        "bidderCount": 2,
        "hasReserve": true,
        "reserveMet": true,
        "buyerPremiumBps": 1000,
        "buyNowPrice": null,
        "estimate": {
          "low": {
            "amount": 380000,
            "currency": "USD"
          },
          "high": {
            "amount": 460000,
            "currency": "USD"
          }
        },
        "conditionGrade": "excellent",
        "badges": [
          "authenticated",
          "papers_match"
        ],
        "approximatePrice": null,
        "sale": {
          "id": "01a15340-1a2b-7c3d-8e4f-506172839405",
          "handle": "autumn-horology-sale",
          "title": "The Autumn Horology Sale",
          "lotNumber": 14
        }
      },
      "watchedAt": "2026-10-19T08:05:00.000Z"
    }
  ],
  "nextCursor": null
};
const example_getAuctionOffer_200: unknown = {
  "status": "pending",
  "lot": {
    "storeProductId": "01a15332-3594-7575-bf71-70016684f37d",
    "handle": "luna-round-halo",
    "title": "Luna Round Halo",
    "variantId": "01a15332-2886-7d21-9894-21a99458250b",
    "variantTitle": "14K Yellow Gold / 1.00 ct",
    "imageUrl": "http://localhost:3000/media/org/01a15332-25d4-7008-aafd-160be85928ca/media/01a15332-28a7-7b0f-b834-82d0aabdbe06/original.png"
  },
  "amount": {
    "amount": 220000,
    "currency": "USD"
  },
  "buyerPremium": {
    "amount": 22000,
    "currency": "USD"
  },
  "total": {
    "amount": 242000,
    "currency": "USD"
  },
  "expiresAt": "2026-10-24T08:00:00.000Z",
  "orderId": null
};
const example_acceptAuctionOffer_200: unknown = {
  "offer": {
    "status": "accepted",
    "lot": {
      "storeProductId": "01a15332-3594-7575-bf71-70016684f37d",
      "handle": "luna-round-halo",
      "title": "Luna Round Halo",
      "variantId": "01a15332-2886-7d21-9894-21a99458250b",
      "variantTitle": "14K Yellow Gold / 1.00 ct",
      "imageUrl": "http://localhost:3000/media/org/01a15332-25d4-7008-aafd-160be85928ca/media/01a15332-28a7-7b0f-b834-82d0aabdbe06/original.png"
    },
    "amount": {
      "amount": 220000,
      "currency": "USD"
    },
    "buyerPremium": {
      "amount": 22000,
      "currency": "USD"
    },
    "total": {
      "amount": 242000,
      "currency": "USD"
    },
    "expiresAt": "2026-10-24T08:00:00.000Z",
    "orderId": "01a15342-3c4d-7e5f-a061-728394a5b6c7"
  },
  "orderId": "01a15342-3c4d-7e5f-a061-728394a5b6c7"
};
const example_declineAuctionOffer_200: unknown = {
  "status": "declined",
  "lot": {
    "storeProductId": "01a15332-3594-7575-bf71-70016684f37d",
    "handle": "luna-round-halo",
    "title": "Luna Round Halo",
    "variantId": "01a15332-2886-7d21-9894-21a99458250b",
    "variantTitle": "14K Yellow Gold / 1.00 ct",
    "imageUrl": "http://localhost:3000/media/org/01a15332-25d4-7008-aafd-160be85928ca/media/01a15332-28a7-7b0f-b834-82d0aabdbe06/original.png"
  },
  "amount": {
    "amount": 220000,
    "currency": "USD"
  },
  "buyerPremium": {
    "amount": 22000,
    "currency": "USD"
  },
  "total": {
    "amount": 242000,
    "currency": "USD"
  },
  "expiresAt": "2026-10-24T08:00:00.000Z",
  "orderId": null
};
const example_createAuctionSocketTicket_201: unknown = {
  "ticket": "g3Vb8yQ2mZ0rT1cXkP5wN7eH4sJ6uA9dLfC2bE8iO1q",
  "url": "wss://api.example.com/storefront/v1/auctions/ws?ticket=g3Vb8yQ2mZ0rT1cXkP5wN7eH4sJ6uA9dLfC2bE8iO1q",
  "expiresAt": "2026-10-19T08:06:41.000Z"
};
const example_listAuctionSales_200: unknown = {
  "items": [
    {
      "id": "01a16987-7ceb-7ba6-953e-f0121bef67c5",
      "handle": "autumn-horology-sale",
      "title": "The Autumn Horology Sale",
      "subtitle": "Steel sports watches and a few surprises",
      "cover": null,
      "status": "live",
      "startsAt": "2026-10-23T16:10:48.438Z",
      "firstCloseAt": "2026-10-25T16:10:49.438Z",
      "lastCloseAt": "2026-10-25T16:10:49.438Z",
      "lotIntervalSeconds": 60,
      "lotCount": 1,
      "soldCount": 0,
      "hammerTotal": null,
      "buyerPremiumBps": null
    }
  ],
  "nextCursor": null
};
const example_getAuctionSale_200: unknown = {
  "id": "01a16987-7ceb-7ba6-953e-f0121bef67c5",
  "handle": "autumn-horology-sale",
  "title": "The Autumn Horology Sale",
  "subtitle": "Steel sports watches and a few surprises",
  "cover": null,
  "status": "live",
  "startsAt": "2026-10-23T16:10:48.438Z",
  "firstCloseAt": "2026-10-25T16:10:49.438Z",
  "lastCloseAt": "2026-10-25T16:10:49.438Z",
  "lotIntervalSeconds": 60,
  "lotCount": 1,
  "soldCount": 0,
  "hammerTotal": null,
  "buyerPremiumBps": null,
  "essay": null,
  "viewing": "By appointment, 24 to 29 October",
  "lots": [
    {
      "id": "01a16987-7d0a-737b-b12c-bd177778bd4b",
      "status": "live",
      "lot": {
        "storeProductId": "01a16987-5d6c-78c4-a444-060e0f83ebb2",
        "handle": "loop-paperclip-bracelet",
        "title": "Loop Paperclip Bracelet",
        "variantId": "01a16987-5c62-7e64-8b8f-327cc7a28ec7",
        "variantTitle": "14K Yellow Gold",
        "imageUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5d21-71bf-8239-5f610a2e02f3/original.png"
      },
      "startsAt": "2026-10-23T16:10:48.438Z",
      "endsAt": "2026-10-25T16:10:49.438Z",
      "startingPrice": {
        "amount": 80000,
        "currency": "USD"
      },
      "currentPrice": null,
      "nextMinimumBid": {
        "amount": 80000,
        "currency": "USD"
      },
      "bidCount": 0,
      "bidderCount": 0,
      "hasReserve": false,
      "reserveMet": false,
      "buyerPremiumBps": null,
      "buyNowPrice": null,
      "estimate": {
        "low": {
          "amount": 100000,
          "currency": "USD"
        },
        "high": {
          "amount": 140000,
          "currency": "USD"
        }
      },
      "conditionGrade": "excellent",
      "badges": [
        "full_set",
        "no_reserve"
      ],
      "approximatePrice": null,
      "sale": {
        "id": "01a16987-7ceb-7ba6-953e-f0121bef67c5",
        "handle": "autumn-horology-sale",
        "title": "The Autumn Horology Sale",
        "lotNumber": 1
      }
    }
  ],
  "seo": {
    "title": "The Autumn Horology Sale | Aurora Jewels",
    "description": "Steel sports watches and a few surprises",
    "canonical": "https://docs.example/sales/autumn-horology-sale",
    "robots": "index, follow",
    "openGraph": {
      "title": "The Autumn Horology Sale",
      "description": "Steel sports watches and a few surprises",
      "image": null,
      "type": "website"
    },
    "twitter": {
      "card": "summary",
      "site": null
    },
    "warnings": [
      "image_missing"
    ]
  },
  "jsonld": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "SaleEvent",
        "name": "The Autumn Horology Sale",
        "description": "Steel sports watches and a few surprises",
        "url": "https://docs.example/sales/autumn-horology-sale",
        "startDate": "2026-10-23T16:10:48.438Z",
        "endDate": "2026-10-25T16:10:49.438Z",
        "eventStatus": "https://schema.org/EventScheduled",
        "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",
        "location": {
          "@type": "VirtualLocation",
          "url": "https://docs.example/sales/autumn-horology-sale"
        },
        "organizer": {
          "@type": "Organization",
          "name": "Aurora Jewels",
          "url": "https://docs.example"
        },
        "offers": [
          {
            "@type": "Offer",
            "name": "Lot 1: Loop Paperclip Bracelet",
            "url": "https://docs.example/products/loop-paperclip-bracelet",
            "image": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5d21-71bf-8239-5f610a2e02f3/original.png",
            "price": "800.00",
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock",
            "validThrough": "2026-10-25T16:10:49.438Z"
          }
        ]
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Aurora Jewels",
            "item": "https://docs.example"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "The Autumn Horology Sale",
            "item": "https://docs.example/sales/autumn-horology-sale"
          }
        ]
      },
      {
        "@type": "Organization",
        "@id": "https://docs.example/#organization",
        "name": "Aurora Jewels",
        "url": "https://docs.example",
        "hasMerchantReturnPolicy": {
          "@type": "MerchantReturnPolicy",
          "applicableCountry": "US",
          "returnPolicyCountry": "US",
          "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
          "merchantReturnDays": 30,
          "returnMethod": "https://schema.org/ReturnByMail",
          "returnFees": "https://schema.org/ReturnShippingFees",
          "refundType": "https://schema.org/FullRefund"
        }
      }
    ]
  }
};
const example_getAuctionSale_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Sale not found",
    "requestId": "req_example"
  }
};
const example_getAuctionSaleResults_200: unknown = {
  "sale": {
    "id": "01a16987-7ceb-7ba6-953e-f0121bef67c5",
    "handle": "autumn-horology-sale",
    "title": "The Autumn Horology Sale",
    "subtitle": "Steel sports watches and a few surprises",
    "cover": null,
    "status": "live",
    "startsAt": "2026-10-23T16:10:48.438Z",
    "firstCloseAt": "2026-10-25T16:10:49.438Z",
    "lastCloseAt": "2026-10-25T16:10:49.438Z",
    "lotIntervalSeconds": 60,
    "lotCount": 1,
    "soldCount": 0,
    "hammerTotal": null,
    "buyerPremiumBps": null
  },
  "items": [
    {
      "lotNumber": 1,
      "auction": {
        "id": "01a16987-7d0a-737b-b12c-bd177778bd4b",
        "status": "live",
        "lot": {
          "storeProductId": "01a16987-5d6c-78c4-a444-060e0f83ebb2",
          "handle": "loop-paperclip-bracelet",
          "title": "Loop Paperclip Bracelet",
          "variantId": "01a16987-5c62-7e64-8b8f-327cc7a28ec7",
          "variantTitle": "14K Yellow Gold",
          "imageUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5d21-71bf-8239-5f610a2e02f3/original.png"
        },
        "startsAt": "2026-10-23T16:10:48.438Z",
        "endsAt": "2026-10-25T16:10:49.438Z",
        "startingPrice": {
          "amount": 80000,
          "currency": "USD"
        },
        "currentPrice": null,
        "nextMinimumBid": {
          "amount": 80000,
          "currency": "USD"
        },
        "bidCount": 0,
        "bidderCount": 0,
        "hasReserve": false,
        "reserveMet": false,
        "buyerPremiumBps": null,
        "buyNowPrice": null,
        "estimate": {
          "low": {
            "amount": 100000,
            "currency": "USD"
          },
          "high": {
            "amount": 140000,
            "currency": "USD"
          }
        },
        "conditionGrade": "excellent",
        "badges": [
          "full_set",
          "no_reserve"
        ],
        "approximatePrice": null,
        "sale": {
          "id": "01a16987-7ceb-7ba6-953e-f0121bef67c5",
          "handle": "autumn-horology-sale",
          "title": "The Autumn Horology Sale",
          "lotNumber": 1
        }
      },
      "outcome": "open",
      "hammerPrice": null
    }
  ]
};
const example_listAuctionQuestions_200: unknown = {
  "items": [
    {
      "id": "01a16987-7c6a-7d3d-90a8-528a2f8f06ac",
      "auctionId": "01a16987-7ab4-7291-b92e-645c753b7400",
      "askerLabel": "Bidder 2",
      "question": "Does the lot come with its original box and papers?",
      "answer": "Yes: box, papers and the warranty card are all present.",
      "answeredAt": "2026-10-23T16:10:49.354Z",
      "createdAt": "2026-10-23T16:10:49.320Z"
    }
  ]
};
const example_askAuctionQuestion_201: unknown = {
  "id": "01a16987-7c6a-7d3d-90a8-528a2f8f06ac",
  "lot": {
    "auctionId": "01a16987-7ab4-7291-b92e-645c753b7400",
    "handle": "luna-round-halo",
    "title": "Luna Round Halo"
  },
  "question": "Does the lot come with its original box and papers?",
  "status": "pending",
  "answer": null,
  "answeredAt": null,
  "createdAt": "2026-10-23T16:10:49.320Z"
};
const example_askAuctionQuestion_401: unknown = {
  "error": {
    "code": "UNAUTHORIZED",
    "message": "A customer token is required",
    "requestId": "req_example"
  }
};
const example_listMyAuctionQuestions_200: unknown = {
  "items": [
    {
      "id": "01a16987-7c6a-7d3d-90a8-528a2f8f06ac",
      "lot": {
        "auctionId": "01a16987-7ab4-7291-b92e-645c753b7400",
        "handle": "luna-round-halo",
        "title": "Luna Round Halo"
      },
      "question": "Does the lot come with its original box and papers?",
      "status": "answered",
      "answer": "Yes: box, papers and the warranty card are all present.",
      "answeredAt": "2026-10-23T16:10:49.354Z",
      "createdAt": "2026-10-23T16:10:49.320Z"
    }
  ],
  "nextCursor": null
};
const example_getCustomerPushSettings_200: unknown = {
  "publicKey": "BEl62iUYgUivxIkv69yViEuiBIa-Ib9-SkvMeAtA3LFgDzkrxZJjSgSnfckjBJuBkr3qBUYIHBQFLXYp5Nksh8U",
  "delivery": "push",
  "devices": [
    {
      "id": "01a15343-4d5e-7f60-b172-8394a5b6c7d8",
      "host": "fcm.googleapis.com",
      "userAgent": "Mozilla/5.0 (iPhone)",
      "lastSuccessAt": null,
      "createdAt": "2026-10-19T08:00:00.000Z"
    }
  ]
};
const example_registerCustomerPushDevice_201: unknown = {
  "id": "01a15343-4d5e-7f60-b172-8394a5b6c7d8",
  "host": "fcm.googleapis.com",
  "userAgent": "Mozilla/5.0 (iPhone)",
  "lastSuccessAt": null,
  "createdAt": "2026-10-19T08:00:00.000Z"
};
const example_getOrderStatus_200: unknown = {
  "id": "01a16987-7094-7033-bc41-daea60af21f3",
  "number": 1001,
  "name": "#1001",
  "email": "shopper@example.com",
  "customerId": "01a16987-6b14-7d6f-867c-40a519894a64",
  "status": "open",
  "financialStatus": "paid",
  "fulfillmentStatus": "unfulfilled",
  "approvalStatus": null,
  "currency": "USD",
  "total": {
    "amount": 141000,
    "currency": "USD"
  },
  "paid": {
    "amount": 141000,
    "currency": "USD"
  },
  "paymentMethod": "card",
  "lineCount": 2,
  "placedAt": "2026-10-23T16:10:46.288Z",
  "estimatedShipDateMin": null,
  "estimatedShipDateMax": null,
  "tags": [],
  "workflow": null,
  "phone": null,
  "shippingAddress": {
    "firstName": "Asha",
    "lastName": "Mehta",
    "company": null,
    "line1": "350 Fifth Avenue",
    "line2": null,
    "city": "New York",
    "region": "NY",
    "postalCode": "10118",
    "countryCode": "US",
    "phone": "+12125550100"
  },
  "billingAddress": {
    "firstName": "Asha",
    "lastName": "Mehta",
    "company": null,
    "line1": "350 Fifth Avenue",
    "line2": null,
    "city": "New York",
    "region": "NY",
    "postalCode": "10118",
    "countryCode": "US",
    "phone": "+12125550100"
  },
  "shippingMethod": {
    "rateId": "01a16987-5e4c-7231-a66b-3df65f24ad41",
    "title": "Standard (insured)",
    "price": {
      "amount": 0,
      "currency": "USD"
    }
  },
  "subtotal": {
    "amount": 141000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "shipping": {
    "amount": 0,
    "currency": "USD"
  },
  "tax": {
    "amount": 0,
    "currency": "USD"
  },
  "refunded": {
    "amount": 0,
    "currency": "USD"
  },
  "lines": [
    {
      "id": "01a16987-7098-7d5c-8f8e-f074098f1f5b",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "optionValues": {
        "metal": "14k_yellow_gold"
      },
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "quantity": 1,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "discount": {
        "amount": 0,
        "currency": "USD"
      },
      "tax": {
        "amount": 0,
        "currency": "USD"
      },
      "total": {
        "amount": 42000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "fulfilledQuantity": 0,
      "cancelledQuantity": 0,
      "mediaUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png"
    },
    {
      "id": "01a16987-7099-772f-815c-80de5232ed11",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "optionValues": {
        "metal": "14k_yellow_gold"
      },
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "quantity": 1,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "discount": {
        "amount": 0,
        "currency": "USD"
      },
      "tax": {
        "amount": 0,
        "currency": "USD"
      },
      "total": {
        "amount": 99000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "fulfilledQuantity": 0,
      "cancelledQuantity": 0,
      "mediaUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png"
    }
  ],
  "payments": [
    {
      "id": "01a16987-70a8-785d-92ca-d0749673e2f7",
      "provider": "stripe",
      "status": "captured",
      "amount": {
        "amount": 141000,
        "currency": "USD"
      },
      "amountCaptured": {
        "amount": 141000,
        "currency": "USD"
      },
      "amountRefunded": {
        "amount": 0,
        "currency": "USD"
      },
      "methodSnapshot": null,
      "manualReference": null,
      "providerPaymentIntentId": "pi_dev_e5337a66d97646ea911f31c4e667c5eb",
      "card": {
        "brand": "visa",
        "last4": "4242",
        "wallet": null,
        "funding": "credit"
      },
      "failure": null,
      "capturedAt": "2026-10-23T16:10:46.288Z",
      "createdAt": "2026-10-23T16:10:46.285Z"
    }
  ],
  "giftCardApplications": [],
  "discountCodes": [],
  "discountApplications": [],
  "taxLines": [],
  "fulfillments": [],
  "refunds": [],
  "returns": [],
  "events": [
    {
      "id": "01a16987-70a5-78f7-893c-1f04b8855e2b",
      "kind": "placed",
      "message": "Order #1001 placed",
      "data": null,
      "actorType": "customer",
      "visibleToCustomer": true,
      "createdAt": "2026-10-23T16:10:46.285Z"
    },
    {
      "id": "01a16987-70ab-761d-b63d-360461054355",
      "kind": "payment_received",
      "message": "Paid 141000 USD by visa ending 4242",
      "data": {
        "provider": "stripe",
        "amountCents": 141000,
        "paymentIntentId": "pi_dev_e5337a66d97646ea911f31c4e667c5eb"
      },
      "actorType": "system",
      "visibleToCustomer": true,
      "createdAt": "2026-10-23T16:10:46.285Z"
    },
    {
      "id": "01a16987-70d0-751b-8fea-afd92a929a12",
      "kind": "workflow_stage_started",
      "message": "Order confirmed",
      "data": {
        "dueAt": "2026-10-24T16:10:46.346Z",
        "stageKey": "confirmation",
        "parentKey": null,
        "stageName": "Order confirmation"
      },
      "actorType": "system",
      "visibleToCustomer": true,
      "createdAt": "2026-10-23T16:10:46.285Z"
    }
  ],
  "note": null,
  "staffNotes": null,
  "termsAcceptedAt": "2026-10-23T16:10:45.872Z",
  "cancelledAt": null,
  "cancelReason": null,
  "paymentInstructions": null,
  "auction": null,
  "progress": [
    {
      "name": "Order confirmed",
      "state": "current",
      "completedAt": null
    },
    {
      "name": "Sourcing your stones",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Certificate issued",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Crafting your ring",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Quality check",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Your review",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Shipped",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Delivered",
      "state": "upcoming",
      "completedAt": null
    }
  ],
  "returnWindow": {
    "closesAt": null,
    "eligible": false,
    "lines": [
      {
        "lineId": "01a16987-7098-7d5c-8f8e-f074098f1f5b",
        "returnableQuantity": 0
      },
      {
        "lineId": "01a16987-7099-772f-815c-80de5232ed11",
        "returnableQuantity": 0
      }
    ]
  },
  "updatedAt": "2026-10-23T16:10:46.285Z"
};
const example_getOrderStatus_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Order status link is invalid or has expired",
    "requestId": "req_example"
  }
};
const example_listCustomerOrders_200: unknown = {
  "items": [
    {
      "id": "01a16987-7094-7033-bc41-daea60af21f3",
      "number": 1001,
      "name": "#1001",
      "email": "shopper@example.com",
      "customerId": "01a16987-6b14-7d6f-867c-40a519894a64",
      "status": "open",
      "financialStatus": "paid",
      "fulfillmentStatus": "unfulfilled",
      "approvalStatus": null,
      "currency": "USD",
      "total": {
        "amount": 141000,
        "currency": "USD"
      },
      "paid": {
        "amount": 141000,
        "currency": "USD"
      },
      "paymentMethod": "card",
      "lineCount": 2,
      "placedAt": "2026-10-23T16:10:46.288Z",
      "estimatedShipDateMin": null,
      "estimatedShipDateMax": null,
      "tags": [],
      "workflow": null
    }
  ],
  "nextCursor": null
};
const example_getCustomerOrder_200: unknown = {
  "id": "01a16987-7094-7033-bc41-daea60af21f3",
  "number": 1001,
  "name": "#1001",
  "email": "shopper@example.com",
  "customerId": "01a16987-6b14-7d6f-867c-40a519894a64",
  "status": "open",
  "financialStatus": "paid",
  "fulfillmentStatus": "unfulfilled",
  "approvalStatus": null,
  "currency": "USD",
  "total": {
    "amount": 141000,
    "currency": "USD"
  },
  "paid": {
    "amount": 141000,
    "currency": "USD"
  },
  "paymentMethod": "card",
  "lineCount": 2,
  "placedAt": "2026-10-23T16:10:46.288Z",
  "estimatedShipDateMin": null,
  "estimatedShipDateMax": null,
  "tags": [],
  "workflow": null,
  "phone": null,
  "shippingAddress": {
    "firstName": "Asha",
    "lastName": "Mehta",
    "company": null,
    "line1": "350 Fifth Avenue",
    "line2": null,
    "city": "New York",
    "region": "NY",
    "postalCode": "10118",
    "countryCode": "US",
    "phone": "+12125550100"
  },
  "billingAddress": {
    "firstName": "Asha",
    "lastName": "Mehta",
    "company": null,
    "line1": "350 Fifth Avenue",
    "line2": null,
    "city": "New York",
    "region": "NY",
    "postalCode": "10118",
    "countryCode": "US",
    "phone": "+12125550100"
  },
  "shippingMethod": {
    "rateId": "01a16987-5e4c-7231-a66b-3df65f24ad41",
    "title": "Standard (insured)",
    "price": {
      "amount": 0,
      "currency": "USD"
    }
  },
  "subtotal": {
    "amount": 141000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "shipping": {
    "amount": 0,
    "currency": "USD"
  },
  "tax": {
    "amount": 0,
    "currency": "USD"
  },
  "refunded": {
    "amount": 0,
    "currency": "USD"
  },
  "lines": [
    {
      "id": "01a16987-7098-7d5c-8f8e-f074098f1f5b",
      "productId": "01a16987-50db-7646-87e5-e664112f2660",
      "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "optionValues": {
        "metal": "14k_yellow_gold"
      },
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "quantity": 1,
      "unitPrice": {
        "amount": 42000,
        "currency": "USD"
      },
      "discount": {
        "amount": 0,
        "currency": "USD"
      },
      "tax": {
        "amount": 0,
        "currency": "USD"
      },
      "total": {
        "amount": 42000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "fulfilledQuantity": 0,
      "cancelledQuantity": 0,
      "mediaUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png"
    },
    {
      "id": "01a16987-7099-772f-815c-80de5232ed11",
      "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
      "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "sku": null,
      "optionValues": {
        "metal": "14k_yellow_gold"
      },
      "customizations": [
        {
          "key": "engraving",
          "label": "Engraving",
          "value": "A & R",
          "valueLabel": null,
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 2
        }
      ],
      "stone": null,
      "quantity": 1,
      "unitPrice": {
        "amount": 99000,
        "currency": "USD"
      },
      "discount": {
        "amount": 0,
        "currency": "USD"
      },
      "tax": {
        "amount": 0,
        "currency": "USD"
      },
      "total": {
        "amount": 99000,
        "currency": "USD"
      },
      "fulfillmentMode": "stocked",
      "leadTimeDaysMin": null,
      "leadTimeDaysMax": null,
      "requiresDesignApproval": false,
      "fulfilledQuantity": 0,
      "cancelledQuantity": 0,
      "mediaUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png"
    }
  ],
  "payments": [
    {
      "id": "01a16987-70a8-785d-92ca-d0749673e2f7",
      "provider": "stripe",
      "status": "captured",
      "amount": {
        "amount": 141000,
        "currency": "USD"
      },
      "amountCaptured": {
        "amount": 141000,
        "currency": "USD"
      },
      "amountRefunded": {
        "amount": 0,
        "currency": "USD"
      },
      "methodSnapshot": null,
      "manualReference": null,
      "providerPaymentIntentId": "pi_dev_e5337a66d97646ea911f31c4e667c5eb",
      "card": {
        "brand": "visa",
        "last4": "4242",
        "wallet": null,
        "funding": "credit"
      },
      "failure": null,
      "capturedAt": "2026-10-23T16:10:46.288Z",
      "createdAt": "2026-10-23T16:10:46.285Z"
    }
  ],
  "giftCardApplications": [],
  "discountCodes": [],
  "discountApplications": [],
  "taxLines": [],
  "fulfillments": [],
  "refunds": [],
  "returns": [],
  "events": [
    {
      "id": "01a16987-70a5-78f7-893c-1f04b8855e2b",
      "kind": "placed",
      "message": "Order #1001 placed",
      "data": null,
      "actorType": "customer",
      "visibleToCustomer": true,
      "createdAt": "2026-10-23T16:10:46.285Z"
    },
    {
      "id": "01a16987-70ab-761d-b63d-360461054355",
      "kind": "payment_received",
      "message": "Paid 141000 USD by visa ending 4242",
      "data": {
        "provider": "stripe",
        "amountCents": 141000,
        "paymentIntentId": "pi_dev_e5337a66d97646ea911f31c4e667c5eb"
      },
      "actorType": "system",
      "visibleToCustomer": true,
      "createdAt": "2026-10-23T16:10:46.285Z"
    },
    {
      "id": "01a16987-70d0-751b-8fea-afd92a929a12",
      "kind": "workflow_stage_started",
      "message": "Order confirmed",
      "data": {
        "dueAt": "2026-10-24T16:10:46.346Z",
        "stageKey": "confirmation",
        "parentKey": null,
        "stageName": "Order confirmation"
      },
      "actorType": "system",
      "visibleToCustomer": true,
      "createdAt": "2026-10-23T16:10:46.285Z"
    }
  ],
  "note": null,
  "staffNotes": null,
  "termsAcceptedAt": "2026-10-23T16:10:45.872Z",
  "cancelledAt": null,
  "cancelReason": null,
  "paymentInstructions": null,
  "auction": null,
  "progress": [
    {
      "name": "Order confirmed",
      "state": "current",
      "completedAt": null
    },
    {
      "name": "Sourcing your stones",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Certificate issued",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Crafting your ring",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Quality check",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Your review",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Shipped",
      "state": "upcoming",
      "completedAt": null
    },
    {
      "name": "Delivered",
      "state": "upcoming",
      "completedAt": null
    }
  ],
  "returnWindow": {
    "closesAt": null,
    "eligible": false,
    "lines": [
      {
        "lineId": "01a16987-7098-7d5c-8f8e-f074098f1f5b",
        "returnableQuantity": 0
      },
      {
        "lineId": "01a16987-7099-772f-815c-80de5232ed11",
        "returnableQuantity": 0
      }
    ]
  },
  "updatedAt": "2026-10-23T16:10:46.285Z"
};
const example_reorderCustomerOrder_201: unknown = {
  "cart": {
    "id": "01a16987-71a7-760e-85f1-345a1422e6f6",
    "token": "53he2t7oGaoLaLm7PdTnBr13oFG9BVUj",
    "status": "active",
    "currency": "USD",
    "market": {
      "id": "01a16987-4bfb-7fef-9972-812cf6781c86",
      "name": "Default",
      "currency": "USD",
      "countries": [
        "US"
      ]
    },
    "email": "shopper@example.com",
    "customerId": "01a16987-6b14-7d6f-867c-40a519894a64",
    "locale": null,
    "lines": [
      {
        "id": "01a16987-71b4-7d9c-b689-de7ff7320510",
        "productId": "01a16987-50db-7646-87e5-e664112f2660",
        "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
        "handle": "orbit-comfort-fit-band",
        "title": "Orbit Comfort-Fit Band",
        "variantTitle": "14K Yellow Gold",
        "sku": null,
        "image": {
          "id": "01a16987-51da-7427-9c1a-c48249cdadcf",
          "kind": "image",
          "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
          "mimeType": "image/png",
          "renditions": null,
          "alt": "Orbit Comfort-Fit Band, view 1",
          "width": 1200,
          "height": 1200
        },
        "quantity": 1,
        "customizations": [
          {
            "key": "ring_size",
            "label": "Ring size",
            "value": "6",
            "valueLabel": "6",
            "priceDelta": {
              "amount": 0,
              "currency": "USD"
            },
            "leadTimeDeltaDays": 0
          }
        ],
        "stone": null,
        "unitPrice": {
          "amount": 42000,
          "currency": "USD"
        },
        "compareAt": null,
        "linePrice": {
          "amount": 42000,
          "currency": "USD"
        },
        "available": true,
        "unavailableReason": null,
        "fulfillmentMode": "stocked",
        "leadTimeDaysMin": null,
        "leadTimeDaysMax": null,
        "requiresDesignApproval": false
      },
      {
        "id": "01a16987-71bf-716b-9495-81a92594433d",
        "productId": "01a16987-5581-7e89-b65b-a64515e529bf",
        "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
        "handle": "drift-diamond-pendant",
        "title": "Drift Diamond Pendant",
        "variantTitle": "14K Yellow Gold",
        "sku": null,
        "image": {
          "id": "01a16987-5660-773c-a5e2-dc141ea37e8d",
          "kind": "image",
          "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
          "mimeType": "image/png",
          "renditions": null,
          "alt": "Drift Diamond Pendant, view 1",
          "width": 1200,
          "height": 1200
        },
        "quantity": 1,
        "customizations": [
          {
            "key": "engraving",
            "label": "Engraving",
            "value": "A & R",
            "valueLabel": null,
            "priceDelta": {
              "amount": 0,
              "currency": "USD"
            },
            "leadTimeDeltaDays": 2
          }
        ],
        "stone": null,
        "unitPrice": {
          "amount": 99000,
          "currency": "USD"
        },
        "compareAt": null,
        "linePrice": {
          "amount": 99000,
          "currency": "USD"
        },
        "available": true,
        "unavailableReason": null,
        "fulfillmentMode": "stocked",
        "leadTimeDaysMin": null,
        "leadTimeDaysMax": null,
        "requiresDesignApproval": false
      }
    ],
    "lineCount": 2,
    "subtotal": {
      "amount": 141000,
      "currency": "USD"
    },
    "discount": {
      "amount": 0,
      "currency": "USD"
    },
    "total": {
      "amount": 141000,
      "currency": "USD"
    },
    "discountCodes": [],
    "discountApplications": [],
    "rejectedCodes": [],
    "attributes": {},
    "hasUnavailableLines": false,
    "expiresAt": "2026-11-22T16:10:46.614Z",
    "updatedAt": "2026-10-23T16:10:46.614Z"
  },
  "skipped": []
};
const example_getDesignApproval_200: unknown = {
  "orderId": "01a16987-74bd-7cb1-990e-e5c43b97048c",
  "orderName": "#1002",
  "approvalStatus": "design_sent",
  "state": "open",
  "design": {
    "mediaId": "01a16987-5d40-706f-bde9-5df5bc2611fe",
    "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5d40-706f-bde9-5df5bc2611fe/original.png",
    "mimeType": "image/png",
    "alt": "Loop Paperclip Bracelet, view 2"
  },
  "message": "Here is the first rendering of your ring",
  "sentAt": "2026-10-23T16:10:47.424Z",
  "expiresAt": "2026-11-22T16:10:47.429Z",
  "response": null
};
const example_getDesignApproval_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Approval link is invalid or has expired",
    "requestId": "req_example"
  }
};
const example_submitDesignApproval_200: unknown = {
  "id": "01a16987-74bd-7cb1-990e-e5c43b97048c",
  "number": 1002,
  "name": "#1002",
  "email": "shopper@example.com",
  "customerId": "01a16987-6b14-7d6f-867c-40a519894a64",
  "status": "open",
  "financialStatus": "unpaid",
  "fulfillmentStatus": "in_production",
  "approvalStatus": "approved",
  "currency": "USD",
  "total": {
    "amount": 279000,
    "currency": "USD"
  },
  "paid": {
    "amount": 0,
    "currency": "USD"
  },
  "paymentMethod": "manual",
  "lineCount": 1,
  "placedAt": "2026-10-23T16:10:47.352Z",
  "estimatedShipDateMin": "2026-11-06",
  "estimatedShipDateMax": "2026-11-13",
  "tags": [],
  "workflow": null,
  "phone": null,
  "shippingAddress": {
    "firstName": "Asha",
    "lastName": "Mehta",
    "company": null,
    "line1": "350 Fifth Avenue",
    "line2": null,
    "city": "New York",
    "region": "NY",
    "postalCode": "10118",
    "countryCode": "US",
    "phone": "+12125550100"
  },
  "billingAddress": {
    "firstName": "Asha",
    "lastName": "Mehta",
    "company": null,
    "line1": "350 Fifth Avenue",
    "line2": null,
    "city": "New York",
    "region": "NY",
    "postalCode": "10118",
    "countryCode": "US",
    "phone": "+12125550100"
  },
  "shippingMethod": {
    "rateId": "01a16987-5e4c-7231-a66b-3df65f24ad41",
    "title": "Standard (insured)",
    "price": {
      "amount": 0,
      "currency": "USD"
    }
  },
  "subtotal": {
    "amount": 279000,
    "currency": "USD"
  },
  "discount": {
    "amount": 0,
    "currency": "USD"
  },
  "shipping": {
    "amount": 0,
    "currency": "USD"
  },
  "tax": {
    "amount": 0,
    "currency": "USD"
  },
  "refunded": {
    "amount": 0,
    "currency": "USD"
  },
  "lines": [
    {
      "id": "01a16987-74c0-7396-b104-d9f2a8965491",
      "productId": "01a16987-5029-703d-b716-e12838e96fdd",
      "variantId": "01a16987-505a-7362-8e9c-0713cf4861db",
      "title": "Vela Emerald-Cut Bezel",
      "variantTitle": "14K Yellow Gold / 1.00 ct",
      "sku": null,
      "optionValues": {
        "metal": "14k_yellow_gold",
        "carat_weight": "1.0"
      },
      "customizations": [
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6",
          "valueLabel": "6",
          "priceDelta": {
            "amount": 0,
            "currency": "USD"
          },
          "leadTimeDeltaDays": 0
        }
      ],
      "stone": null,
      "quantity": 1,
      "unitPrice": {
        "amount": 279000,
        "currency": "USD"
      },
      "discount": {
        "amount": 0,
        "currency": "USD"
      },
      "tax": {
        "amount": 0,
        "currency": "USD"
      },
      "total": {
        "amount": 279000,
        "currency": "USD"
      },
      "fulfillmentMode": "made_to_order",
      "leadTimeDaysMin": 14,
      "leadTimeDaysMax": 21,
      "requiresDesignApproval": true,
      "fulfilledQuantity": 0,
      "cancelledQuantity": 0,
      "mediaUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-507a-75aa-96d9-57c2f566149c/original.png"
    }
  ],
  "payments": [
    {
      "id": "01a16987-74c6-7e22-ac4f-cc0528717adc",
      "provider": "manual",
      "status": "pending",
      "amount": {
        "amount": 279000,
        "currency": "USD"
      },
      "amountCaptured": {
        "amount": 0,
        "currency": "USD"
      },
      "amountRefunded": {
        "amount": 0,
        "currency": "USD"
      },
      "methodSnapshot": {
        "id": "01a16987-5e71-7a80-9920-aa2e965d9207",
        "key": "cod",
        "name": "Cash on delivery",
        "description": "Pay the courier on delivery (United States only).",
        "instructions": "Have the exact amount ready; the courier cannot give change.",
        "fee": {
          "amount": 0,
          "currency": "USD"
        }
      },
      "manualReference": null,
      "providerPaymentIntentId": null,
      "card": null,
      "failure": null,
      "capturedAt": null,
      "createdAt": "2026-10-23T16:10:47.349Z"
    }
  ],
  "giftCardApplications": [],
  "discountCodes": [],
  "discountApplications": [],
  "taxLines": [],
  "fulfillments": [],
  "refunds": [],
  "returns": [],
  "events": [
    {
      "id": "01a16987-74c9-76c2-9013-1504e25a0452",
      "kind": "placed",
      "message": "Order #1002 placed",
      "data": null,
      "actorType": "customer",
      "visibleToCustomer": true,
      "createdAt": "2026-10-23T16:10:47.349Z"
    },
    {
      "id": "01a16987-74cb-7208-a4fd-4d7a50a0153b",
      "kind": "awaiting_payment",
      "message": "Awaiting Cash on delivery",
      "data": {
        "methodKey": "cod",
        "amountCents": 279000
      },
      "actorType": "system",
      "visibleToCustomer": true,
      "createdAt": "2026-10-23T16:10:47.349Z"
    },
    {
      "id": "01a16987-7505-7ed4-9921-69026120d7f9",
      "kind": "design_sent",
      "message": "Here is the first rendering of your ring",
      "data": {
        "url": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5d40-706f-bde9-5df5bc2611fe/original.png",
        "mediaId": "01a16987-5d40-706f-bde9-5df5bc2611fe",
        "expiresAt": "2026-11-22T16:10:47.429Z"
      },
      "actorType": "staff",
      "visibleToCustomer": true,
      "createdAt": "2026-10-23T16:10:47.424Z"
    },
    {
      "id": "01a16987-7537-78d9-b815-7ff2c3e14267",
      "kind": "design_approved",
      "message": "Perfect, please go ahead",
      "data": {
        "source": "link",
        "eventId": "01a16987-7505-7ed4-9921-69026120d7f9",
        "stageKey": null
      },
      "actorType": "customer",
      "visibleToCustomer": true,
      "createdAt": "2026-10-23T16:10:47.467Z"
    }
  ],
  "note": null,
  "staffNotes": null,
  "termsAcceptedAt": null,
  "cancelledAt": null,
  "cancelReason": null,
  "paymentInstructions": "Have the exact amount ready; the courier cannot give change.",
  "auction": null,
  "progress": [],
  "returnWindow": {
    "closesAt": null,
    "eligible": false,
    "lines": [
      {
        "lineId": "01a16987-74c0-7396-b104-d9f2a8965491",
        "returnableQuantity": 0
      }
    ]
  },
  "updatedAt": "2026-10-23T16:10:47.476Z"
};
const example_getOrderWorkflowAction_200: unknown = {
  "orderId": "01a16987-7094-7033-bc41-daea60af21f3",
  "orderName": "#1001",
  "stage": {
    "key": "confirmation",
    "name": "Order confirmed",
    "type": "customer_confirmation"
  },
  "state": "open",
  "outcome": null,
  "attempt": 1,
  "respondBy": "2026-10-24T16:10:46.346Z",
  "message": null,
  "files": [],
  "response": null,
  "lines": [
    {
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "quantity": 1,
      "mediaUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
      "customizations": [
        {
          "label": "Ring size",
          "value": "6"
        }
      ]
    },
    {
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "quantity": 1,
      "mediaUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
      "customizations": [
        {
          "label": "Engraving",
          "value": "A & R"
        }
      ]
    }
  ],
  "total": {
    "amount": 141000,
    "currency": "USD"
  }
};
const example_answerOrderWorkflowAction_200: unknown = {
  "orderId": "01a16987-7094-7033-bc41-daea60af21f3",
  "orderName": "#1001",
  "stage": {
    "key": "confirmation",
    "name": "Order confirmed",
    "type": "customer_confirmation"
  },
  "state": "answered",
  "outcome": "confirmed",
  "attempt": 1,
  "respondBy": null,
  "message": null,
  "files": [],
  "response": {
    "action": "confirm",
    "message": null,
    "respondedAt": "2026-10-23T16:10:46.516Z"
  },
  "lines": [
    {
      "title": "Orbit Comfort-Fit Band",
      "variantTitle": "14K Yellow Gold",
      "quantity": 1,
      "mediaUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-51da-7427-9c1a-c48249cdadcf/original.png",
      "customizations": [
        {
          "label": "Ring size",
          "value": "6"
        }
      ]
    },
    {
      "title": "Drift Diamond Pendant",
      "variantTitle": "14K Yellow Gold",
      "quantity": 1,
      "mediaUrl": "http://localhost:3000/media/org/01a16987-4bf3-7caf-9ad4-d77563cbb47a/media/01a16987-5660-773c-a5e2-dc141ea37e8d/original.png",
      "customizations": [
        {
          "label": "Engraving",
          "value": "A & R"
        }
      ]
    }
  ],
  "total": {
    "amount": 141000,
    "currency": "USD"
  }
};
const example_answerOrderWorkflowAction_422: unknown = {
  "error": {
    "code": "INVALID_INPUT",
    "message": "This link takes confirm or request_changes",
    "requestId": "req_example",
    "details": [
      {
        "field": "body.action",
        "code": "INVALID_INPUT",
        "message": "This link takes confirm or request_changes"
      }
    ],
    "meta": {
      "allowed": [
        "confirm",
        "request_changes"
      ]
    }
  }
};
const example_createReturn_201: unknown = {
  "id": "01a16987-7352-781c-a611-5a1e1a6bf231",
  "orderId": "01a16987-7094-7033-bc41-daea60af21f3",
  "orderName": "#1001",
  "rmaNumber": "RMA-1001",
  "status": "requested",
  "reason": "Wrong size",
  "resolution": null,
  "customerNote": "Please send a size 6.5 instead",
  "staffNote": null,
  "returnShippingPaidBy": "customer",
  "restockingFee": {
    "amount": 0,
    "currency": "USD"
  },
  "refundId": null,
  "lines": [
    {
      "orderLineId": "01a16987-7098-7d5c-8f8e-f074098f1f5b",
      "quantity": 1,
      "condition": null,
      "restock": false
    }
  ],
  "requestedAt": "2026-10-23T16:10:46.986Z",
  "resolvedAt": null,
  "updatedAt": "2026-10-23T16:10:46.986Z"
};
const example_createReturn_409: unknown = {
  "error": {
    "code": "CONFLICT",
    "message": "Nothing has shipped on this order yet",
    "requestId": "req_example"
  }
};
const example_getChatConfig_200: unknown = {
  "status": "away",
  "appearance": {
    "shape": "round",
    "position": "right",
    "mobilePosition": "right",
    "primaryColor": null,
    "headerTitle": null,
    "greetingOnline": "Hi! How can we help you today?",
    "greetingAway": "We're a little busy; we'll answer as soon as we can.",
    "greetingOffline": "We're away right now. Leave a message and we'll email you back.",
    "showAgentAvatars": true,
    "logoUrl": null,
    "attentionGrabberUrl": null
  },
  "preChat": {
    "enabled": true,
    "fields": [
      {
        "key": "name",
        "kind": "text",
        "label": "Name",
        "required": false
      },
      {
        "key": "email",
        "kind": "email",
        "label": "Email",
        "required": false
      }
    ]
  },
  "offlineForm": {
    "enabled": true,
    "fields": [
      {
        "key": "name",
        "kind": "text",
        "label": "Name",
        "required": false
      },
      {
        "key": "email",
        "kind": "email",
        "label": "Email",
        "required": true
      }
    ],
    "confirmationText": "Thanks! We'll get back to you by email."
  },
  "consent": {
    "enabled": false,
    "text": null,
    "privacyPolicyHandle": null,
    "usStateNotice": false,
    "identifyOnLoad": true
  },
  "behaviour": {
    "soundEnabled": true,
    "allowUploads": true,
    "allowRating": true,
    "allowTranscript": true,
    "suggestedRepliesEnabled": true,
    "showTypingToStaff": true
  },
  "departments": [],
  "sizeGuide": null,
  "customDesign": {
    "metals": [
      "Yellow gold",
      "White gold",
      "Rose gold",
      "Platinum",
      "Not sure yet"
    ],
    "stoneTypes": [
      "Lab-grown diamond",
      "Natural diamond",
      "Moissanite",
      "Sapphire",
      "Not sure yet"
    ],
    "shapes": [
      "Round",
      "Oval",
      "Cushion",
      "Emerald",
      "Pear",
      "Princess",
      "Radiant",
      "Marquise",
      "Not sure yet"
    ],
    "timelines": [
      "As soon as possible",
      "Within 1 month",
      "1 to 3 months",
      "No rush"
    ],
    "ringSizes": [],
    "maxUploads": 5
  },
  "pendingApprovals": [],
  "help": {
    "search": false,
    "suggestions": false
  },
  "triggers": {
    "timezone": "America/New_York",
    "items": [
      {
        "id": "01a16987-7634-7d7a-bd80-ccaf32bcfc56",
        "kind": "page",
        "conditions": [
          {
            "field": "url",
            "op": "matches",
            "value": "*/products/*-ring"
          },
          {
            "field": "timeOnPageSeconds",
            "op": "gte",
            "value": 20
          }
        ],
        "actions": [
          {
            "type": "message",
            "body": "Hi! Questions about sizing or stones? We're here.",
            "author": {
              "displayName": "Priya",
              "avatarUrl": null
            },
            "suggestedReplies": [
              "Ring sizing",
              "Lab vs natural"
            ]
          }
        ],
        "oncePerVisitor": false
      }
    ]
  }
};
const example_createChatSession_200: unknown = {
  "visitorToken": "<chatVisitorToken>",
  "visitor": {
    "id": "01a16987-765c-76ad-a438-110568ea75c8",
    "displayName": null,
    "email": null,
    "phone": null,
    "locale": "en-US",
    "signedIn": false
  },
  "openConversation": null,
  "triggerFacts": {
    "visits": 1,
    "previousChats": 0,
    "isCustomer": false,
    "hasOrderInProduction": false,
    "country": null,
    "region": null,
    "city": null
  }
};
const example_listChatConversations_200: unknown = {
  "items": [
    {
      "id": "01a16987-76af-7be8-8e6e-0be9a66402a8",
      "kind": "chat",
      "status": "pending",
      "subject": null,
      "departmentId": null,
      "agent": {
        "displayName": "Docs",
        "avatarUrl": null
      },
      "rating": null,
      "ratingComment": null,
      "unreadCount": 1,
      "lastMessageAt": "2026-10-23T16:10:47.932Z",
      "closedAt": null,
      "createdAt": "2026-10-23T16:10:47.854Z"
    }
  ],
  "nextCursor": null
};
const example_startChatConversation_201: unknown = {
  "conversation": {
    "id": "01a16987-76af-7be8-8e6e-0be9a66402a8",
    "kind": "chat",
    "status": "open",
    "subject": null,
    "departmentId": null,
    "agent": null,
    "rating": null,
    "ratingComment": null,
    "unreadCount": 0,
    "lastMessageAt": "2026-10-23T16:10:47.854Z",
    "closedAt": null,
    "createdAt": "2026-10-23T16:10:47.854Z"
  },
  "message": {
    "id": "01a16987-76b2-7451-b367-6d7c12286041",
    "conversationId": "01a16987-76af-7be8-8e6e-0be9a66402a8",
    "authorType": "visitor",
    "author": null,
    "kind": "text",
    "body": "Hi! Can the solitaire be resized to a 6.5?",
    "payload": {},
    "attachments": [],
    "readAt": null,
    "createdAt": "2026-10-23T16:10:47.849Z"
  }
};
const example_listChatMessages_200: unknown = {
  "items": [
    {
      "id": "01a16987-76b2-7451-b367-6d7c12286041",
      "conversationId": "01a16987-76af-7be8-8e6e-0be9a66402a8",
      "authorType": "visitor",
      "author": null,
      "kind": "text",
      "body": "Hi! Can the solitaire be resized to a 6.5?",
      "payload": {},
      "attachments": [],
      "readAt": "2026-10-23T16:10:47.943Z",
      "createdAt": "2026-10-23T16:10:47.849Z"
    },
    {
      "id": "01a16987-76e2-7cd2-b970-7d0086ff32b3",
      "conversationId": "01a16987-76af-7be8-8e6e-0be9a66402a8",
      "authorType": "visitor",
      "author": null,
      "kind": "text",
      "body": "Here is the one I have now",
      "payload": {},
      "attachments": [
        {
          "uploadId": "01a16987-7695-75d5-8b9b-692098cbe157",
          "filename": "my-ring.png",
          "contentType": "image/png",
          "bytes": 70
        }
      ],
      "readAt": "2026-10-23T16:10:47.943Z",
      "createdAt": "2026-10-23T16:10:47.901Z"
    },
    {
      "id": "01a16987-7701-72ec-be91-06cd239e48df",
      "conversationId": "01a16987-76af-7be8-8e6e-0be9a66402a8",
      "authorType": "staff",
      "author": {
        "displayName": "Docs",
        "avatarUrl": null
      },
      "kind": "text",
      "body": "Yes: resizing to 6.5 is **free** within the first year.",
      "payload": {},
      "attachments": [],
      "readAt": null,
      "createdAt": "2026-10-23T16:10:47.932Z"
    }
  ],
  "hasMore": false
};
const example_sendChatMessage_201: unknown = {
  "id": "01a16987-76e2-7cd2-b970-7d0086ff32b3",
  "conversationId": "01a16987-76af-7be8-8e6e-0be9a66402a8",
  "authorType": "visitor",
  "author": null,
  "kind": "text",
  "body": "Here is the one I have now",
  "payload": {},
  "attachments": [
    {
      "uploadId": "01a16987-7695-75d5-8b9b-692098cbe157",
      "filename": "my-ring.png",
      "contentType": "image/png",
      "bytes": 70
    }
  ],
  "readAt": null,
  "createdAt": "2026-10-23T16:10:47.901Z"
};
const example_sendChatMessage_409: unknown = {
  "error": {
    "code": "CONVERSATION_CLOSED",
    "message": "This conversation is closed; start a new one",
    "requestId": "req_example"
  }
};
const example_markChatRead_200: unknown = {
  "id": "01a16987-76af-7be8-8e6e-0be9a66402a8",
  "kind": "chat",
  "status": "pending",
  "subject": null,
  "departmentId": null,
  "agent": {
    "displayName": "Docs",
    "avatarUrl": null
  },
  "rating": null,
  "ratingComment": null,
  "unreadCount": 0,
  "lastMessageAt": "2026-10-23T16:10:47.932Z",
  "closedAt": null,
  "createdAt": "2026-10-23T16:10:47.854Z"
};
const example_rateChatConversation_200: unknown = {
  "id": "01a16987-76af-7be8-8e6e-0be9a66402a8",
  "kind": "chat",
  "status": "closed",
  "subject": null,
  "departmentId": null,
  "agent": {
    "displayName": "Docs",
    "avatarUrl": null
  },
  "rating": 1,
  "ratingComment": "Quick and helpful",
  "unreadCount": 0,
  "lastMessageAt": "2026-10-23T16:10:47.932Z",
  "closedAt": "2026-10-23T16:10:48.071Z",
  "createdAt": "2026-10-23T16:10:47.854Z"
};
const example_requestChatTranscript_202: unknown = {
  "queued": true
};
const example_closeChatConversation_200: unknown = {
  "id": "01a16987-76af-7be8-8e6e-0be9a66402a8",
  "kind": "chat",
  "status": "closed",
  "subject": null,
  "departmentId": null,
  "agent": {
    "displayName": "Docs",
    "avatarUrl": null
  },
  "rating": null,
  "ratingComment": null,
  "unreadCount": 0,
  "lastMessageAt": "2026-10-23T16:10:47.932Z",
  "closedAt": "2026-10-23T16:10:48.071Z",
  "createdAt": "2026-10-23T16:10:47.854Z"
};
const example_getChatAttachment_200: unknown = "<image/png file bytes>";
const example_uploadChatFile_201: unknown = {
  "token": "upl_EXAMPLEUPLOADTOKEN00000000000000",
  "filename": "my-ring.png",
  "contentType": "image/png",
  "bytes": 70,
  "expiresAt": "2026-10-30T16:10:47.830Z"
};
const example_continueChatConversation_200: unknown = {
  "visitorToken": "<continuedVisitorToken>",
  "visitor": {
    "id": "01a16987-765c-76ad-a438-110568ea75c8",
    "displayName": "Asha Mehta",
    "email": "shopper@example.com",
    "phone": null,
    "locale": "en-US",
    "signedIn": false
  },
  "conversation": {
    "id": "01a16987-76af-7be8-8e6e-0be9a66402a8",
    "kind": "chat",
    "status": "closed",
    "subject": null,
    "departmentId": null,
    "agent": {
      "displayName": "Docs",
      "avatarUrl": null
    },
    "rating": 1,
    "ratingComment": "Quick and helpful",
    "unreadCount": 0,
    "lastMessageAt": "2026-10-23T16:10:47.932Z",
    "closedAt": "2026-10-23T16:10:48.071Z",
    "createdAt": "2026-10-23T16:10:47.854Z"
  }
};
const example_lookupChatOrder_200: unknown = {
  "card": {
    "orderId": "01a16987-7094-7033-bc41-daea60af21f3",
    "orderName": "#1001",
    "placedAt": "2026-10-23T16:10:46.288Z",
    "status": "completed",
    "paymentStatus": "paid",
    "fulfilmentStatus": "fulfilled",
    "items": [
      {
        "title": "Orbit Comfort-Fit Band",
        "variantTitle": "14K Yellow Gold",
        "quantity": 1
      },
      {
        "title": "Drift Diamond Pendant",
        "variantTitle": "14K Yellow Gold",
        "quantity": 1
      }
    ],
    "itemCount": 2,
    "productionStage": {
      "name": "Shipped",
      "startedAt": "2026-10-23T16:10:46.851Z",
      "etaAt": null
    },
    "progress": [
      {
        "name": "Order confirmed",
        "state": "done",
        "completedAt": "2026-10-23T16:10:46.516Z"
      },
      {
        "name": "Sourcing your stones",
        "state": "skipped",
        "completedAt": null
      },
      {
        "name": "Certificate issued",
        "state": "skipped",
        "completedAt": null
      },
      {
        "name": "Crafting your ring",
        "state": "skipped",
        "completedAt": null
      },
      {
        "name": "Quality check",
        "state": "skipped",
        "completedAt": null
      },
      {
        "name": "Your review",
        "state": "skipped",
        "completedAt": null
      },
      {
        "name": "Shipped",
        "state": "current",
        "completedAt": null
      },
      {
        "name": "Delivered",
        "state": "upcoming",
        "completedAt": null
      }
    ],
    "shipByAt": null,
    "tracking": [
      {
        "carrier": "UPS",
        "number": "1Z999AA10123456784",
        "url": null
      }
    ],
    "statusUrl": "https://docs.example/orders/status/AaFph3CUcDO8QdrqYK8h8w.u658y0.eNduMBMRdiyOZzuPcAP7IFejDUUYFDcYaxVcJsgSKOI",
    "statusToken": "AaFph3CUcDO8QdrqYK8h8w.u658y0.eNduMBMRdiyOZzuPcAP7IFejDUUYFDcYaxVcJsgSKOI"
  },
  "conversationId": null
};
const example_lookupChatOrder_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "No order matches that number and email",
    "requestId": "req_example"
  }
};
const example_createChatRequest_201: unknown = {
  "conversation": {
    "id": "01a16987-788a-70be-9e1c-6992d156f42f",
    "kind": "ticket",
    "status": "open",
    "subject": "Resize · #1001",
    "departmentId": null,
    "agent": null,
    "rating": null,
    "ratingComment": null,
    "unreadCount": 0,
    "lastMessageAt": "2026-10-23T16:10:48.329Z",
    "closedAt": null,
    "createdAt": "2026-10-23T16:10:48.329Z"
  },
  "message": {
    "id": "01a16987-788e-72da-a9cc-aa931feaece2",
    "conversationId": "01a16987-788a-70be-9e1c-6992d156f42f",
    "authorType": "visitor",
    "author": null,
    "kind": "text",
    "body": "Could you size it down to a 6?",
    "payload": {},
    "attachments": [],
    "readAt": null,
    "createdAt": "2026-10-23T16:10:48.324Z"
  }
};
const example_createChatRequest_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Order status link is invalid or has expired",
    "requestId": "req_example"
  }
};
const example_startCustomDesign_201: unknown = {
  "conversation": {
    "id": "01a16987-78b3-7ad5-993a-09c91ccc4553",
    "kind": "chat",
    "status": "open",
    "subject": "Custom design",
    "departmentId": null,
    "agent": null,
    "rating": null,
    "ratingComment": null,
    "unreadCount": 0,
    "lastMessageAt": "2026-10-23T16:10:48.370Z",
    "closedAt": null,
    "createdAt": "2026-10-23T16:10:48.370Z"
  },
  "message": {
    "id": "01a16987-78b5-7866-b40d-e2cdf3067621",
    "conversationId": "01a16987-78b3-7ad5-993a-09c91ccc4553",
    "authorType": "visitor",
    "author": null,
    "kind": "form",
    "body": "A hidden halo, please",
    "payload": {
      "budget": {
        "max": 500000,
        "min": 300000,
        "currency": "USD"
      },
      "preset": "custom_design",
      "answers": [
        {
          "key": "metal",
          "label": "Metal",
          "value": "Platinum"
        },
        {
          "key": "stone_type",
          "label": "Stone",
          "value": "Lab-grown diamond"
        },
        {
          "key": "shape",
          "label": "Shape",
          "value": "Oval"
        },
        {
          "key": "carat",
          "label": "Carat",
          "value": "1.5 ct"
        },
        {
          "key": "ring_size",
          "label": "Ring size",
          "value": "6.5"
        },
        {
          "key": "budget",
          "label": "Budget",
          "value": "$3,000 to $5,000"
        },
        {
          "key": "timeline",
          "label": "Timeline",
          "value": "1 to 3 months"
        }
      ]
    },
    "attachments": [],
    "readAt": null,
    "createdAt": "2026-10-23T16:10:48.366Z"
  }
};
const example_startCustomDesign_422: unknown = {
  "error": {
    "code": "INVALID_INPUT",
    "message": "Metal is not one of the choices",
    "requestId": "req_example",
    "details": [
      {
        "field": "body.metal",
        "code": "INVALID_INPUT",
        "message": "Metal is not one of the choices"
      }
    ]
  }
};
const example_fireChatTrigger_200: unknown = {
  "conversation": {
    "id": "01a16987-77f7-7622-a5a7-9354cfd76f11",
    "kind": "chat",
    "status": "pending",
    "subject": null,
    "departmentId": null,
    "agent": null,
    "rating": null,
    "ratingComment": null,
    "unreadCount": 1,
    "lastMessageAt": "2026-10-23T16:10:48.173Z",
    "closedAt": null,
    "createdAt": "2026-10-23T16:10:48.173Z"
  },
  "created": true,
  "messages": [
    {
      "id": "01a16987-77fb-7071-b012-3cbd44b113e1",
      "conversationId": "01a16987-77f7-7622-a5a7-9354cfd76f11",
      "authorType": "bot",
      "author": {
        "displayName": "Priya",
        "avatarUrl": null
      },
      "kind": "text",
      "body": "Hi! Questions about sizing or stones? We're here.",
      "payload": {
        "alias": "Priya",
        "trigger": "01a16987-7634-7d7a-bd80-ccaf32bcfc56",
        "suggestedReplies": [
          "Ring sizing",
          "Lab vs natural"
        ]
      },
      "attachments": [],
      "readAt": null,
      "createdAt": "2026-10-23T16:10:48.173Z"
    }
  ]
};
const example_listHelpCategories_200: unknown = {
  "items": [
    {
      "id": "01a16987-78d2-7a07-a15f-306c4b313f58",
      "handle": "sizing",
      "name": "Sizing and fit",
      "description": "Finding your ring size and what resizing costs.",
      "position": 0,
      "articleCount": 2
    },
    {
      "id": "01a16987-78eb-77eb-99ac-b6c08c1ae9c4",
      "handle": "orders",
      "name": "Orders and delivery",
      "description": null,
      "position": 1,
      "articleCount": 0
    }
  ]
};
const example_getHelpCategory_200: unknown = {
  "id": "01a16987-78d2-7a07-a15f-306c4b313f58",
  "handle": "sizing",
  "name": "Sizing and fit",
  "description": "Finding your ring size and what resizing costs.",
  "position": 0,
  "articleCount": 2,
  "seo": {
    "title": "Sizing and fit | Aurora Jewels",
    "description": "Finding your ring size and what resizing costs.",
    "canonical": "https://docs.example/help/sizing",
    "robots": "index, follow",
    "openGraph": {
      "title": "Sizing and fit",
      "description": "Finding your ring size and what resizing costs.",
      "image": null,
      "type": "website"
    },
    "twitter": {
      "card": "summary",
      "site": null
    },
    "warnings": [
      "image_missing"
    ]
  },
  "jsonld": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        "name": "Sizing and fit",
        "description": "Finding your ring size and what resizing costs.",
        "url": "https://docs.example/help/sizing",
        "dateModified": "2026-10-23T16:10:48.400Z"
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Aurora Jewels",
            "item": "https://docs.example"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Help",
            "item": "https://docs.example/help"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Sizing and fit",
            "item": "https://docs.example/help/sizing"
          }
        ]
      },
      {
        "@type": "Organization",
        "@id": "https://docs.example/#organization",
        "name": "Aurora Jewels",
        "url": "https://docs.example",
        "hasMerchantReturnPolicy": {
          "@type": "MerchantReturnPolicy",
          "applicableCountry": "US",
          "returnPolicyCountry": "US",
          "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
          "merchantReturnDays": 30,
          "returnMethod": "https://schema.org/ReturnByMail",
          "returnFees": "https://schema.org/ReturnShippingFees",
          "refundType": "https://schema.org/FullRefund"
        }
      }
    ]
  },
  "updatedAt": "2026-10-23T16:10:48.400Z"
};
const example_getHelpCategory_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Help category not found",
    "requestId": "req_example"
  }
};
const example_listHelpArticles_200: unknown = {
  "items": [
    {
      "id": "01a16987-7904-7cd7-8ce4-cabe910197ce",
      "handle": "find-your-ring-size",
      "title": "How do I find my ring size?",
      "summary": "Measure a ring that already fits, or ask us for a free sizer.",
      "category": {
        "id": "01a16987-78d2-7a07-a15f-306c4b313f58",
        "handle": "sizing",
        "name": "Sizing and fit"
      },
      "updatedAt": "2026-10-23T16:10:48.450Z"
    },
    {
      "id": "01a16987-7924-70eb-a5c9-929848c944e8",
      "handle": "resizing-costs",
      "title": "What does resizing cost?",
      "summary": "Resizing within a year of delivery is free.",
      "category": {
        "id": "01a16987-78d2-7a07-a15f-306c4b313f58",
        "handle": "sizing",
        "name": "Sizing and fit"
      },
      "updatedAt": "2026-10-23T16:10:48.482Z"
    }
  ],
  "nextCursor": null
};
const example_getHelpArticle_200: unknown = {
  "id": "01a16987-7904-7cd7-8ce4-cabe910197ce",
  "handle": "find-your-ring-size",
  "title": "How do I find my ring size?",
  "summary": "Measure a ring that already fits, or ask us for a free sizer.",
  "category": {
    "id": "01a16987-78d2-7a07-a15f-306c4b313f58",
    "handle": "sizing",
    "name": "Sizing and fit"
  },
  "updatedAt": "2026-10-23T16:10:48.450Z",
  "bodyHtml": "<p>Measure the inside diameter of a ring that already fits and compare it with our size guide.</p><p>Not sure? Ask for a free ring sizer in chat.</p>",
  "keywords": [
    "measure finger",
    "ring sizer"
  ],
  "publishedAt": "2026-10-23T16:10:48.452Z",
  "seo": {
    "title": "How do I find my ring size? | Aurora Jewels",
    "description": "Measure a ring that already fits, or ask us for a free sizer.",
    "canonical": "https://docs.example/help/a/find-your-ring-size",
    "robots": "index, follow",
    "openGraph": {
      "title": "How do I find my ring size?",
      "description": "Measure a ring that already fits, or ask us for a free sizer.",
      "image": null,
      "type": "article"
    },
    "twitter": {
      "card": "summary",
      "site": null
    },
    "warnings": [
      "image_missing"
    ]
  },
  "jsonld": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Article",
        "headline": "How do I find my ring size?",
        "description": "Measure a ring that already fits, or ask us for a free sizer.",
        "url": "https://docs.example/help/a/find-your-ring-size",
        "mainEntityOfPage": "https://docs.example/help/a/find-your-ring-size",
        "author": {
          "@type": "Organization",
          "name": "Aurora Jewels",
          "url": "https://docs.example"
        },
        "publisher": {
          "@type": "Organization",
          "name": "Aurora Jewels",
          "url": "https://docs.example"
        },
        "datePublished": "2026-10-23T16:10:48.452Z",
        "dateModified": "2026-10-23T16:10:48.450Z",
        "keywords": "measure finger, ring sizer",
        "articleSection": "Sizing and fit"
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Aurora Jewels",
            "item": "https://docs.example"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Help",
            "item": "https://docs.example/help"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Sizing and fit",
            "item": "https://docs.example/help/sizing"
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": "How do I find my ring size?",
            "item": "https://docs.example/help/a/find-your-ring-size"
          }
        ]
      },
      {
        "@type": "Organization",
        "@id": "https://docs.example/#organization",
        "name": "Aurora Jewels",
        "url": "https://docs.example",
        "hasMerchantReturnPolicy": {
          "@type": "MerchantReturnPolicy",
          "applicableCountry": "US",
          "returnPolicyCountry": "US",
          "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
          "merchantReturnDays": 30,
          "returnMethod": "https://schema.org/ReturnByMail",
          "returnFees": "https://schema.org/ReturnShippingFees",
          "refundType": "https://schema.org/FullRefund"
        }
      }
    ]
  }
};
const example_getHelpArticle_404: unknown = {
  "error": {
    "code": "NOT_FOUND",
    "message": "Help article not found",
    "requestId": "req_example"
  }
};
const example_searchHelpArticles_200: unknown = {
  "hits": [
    {
      "id": "01a16987-7904-7cd7-8ce4-cabe910197ce",
      "handle": "find-your-ring-size",
      "title": "How do I find my ring size?",
      "summary": "Measure a ring that already fits, or ask us for a free sizer.",
      "category": {
        "id": "01a16987-78d2-7a07-a15f-306c4b313f58",
        "handle": "sizing",
        "name": "Sizing and fit"
      },
      "updatedAt": "2026-10-23T16:10:48.450Z"
    }
  ],
  "total": 1,
  "processingTimeMs": 0
};
const example_searchHelpArticles_400: unknown = {
  "error": {
    "code": "VALIDATION_ERROR",
    "message": "Request validation failed",
    "requestId": "req_example",
    "details": [
      {
        "field": "query.q",
        "code": "too_small",
        "message": "Too small: expected string to have >=1 characters"
      }
    ]
  }
};
const example_sendHelpFeedback_400: unknown = {
  "error": {
    "code": "VALIDATION_ERROR",
    "message": "Request validation failed",
    "requestId": "req_example",
    "details": [
      {
        "field": "body.helpful",
        "code": "invalid_type",
        "message": "Invalid input: expected boolean, received string"
      }
    ]
  }
};
const example_createChatSocketTicket_201: unknown = {
  "ticket": "<socketTicket>",
  "url": "ws://localhost:3000/storefront/v1/chat/ws?ticket=<socketTicket>",
  "expiresAt": "2026-10-23T16:11:17.818Z"
};

export const reference: DocsReference = {
  "tags": [
    {
      "key": "store",
      "title": "Store",
      "description": "Public profile and settings of the store bound to the API key",
      "operations": [
        "getStore"
      ]
    },
    {
      "key": "catalog",
      "title": "Catalog",
      "description": "Published products of the store, priced for the shopper's market. Read-only, cacheable",
      "operations": [
        "pickStones",
        "shopStones",
        "listStoneSettings",
        "getStorefrontStone",
        "listProducts",
        "getProduct",
        "getSizeSet",
        "listCollections",
        "getCollection",
        "listCollectionProducts",
        "suggestSearch",
        "searchProducts",
        "getProductAvailability"
      ]
    },
    {
      "key": "content",
      "title": "Content",
      "description": "Published pages with resolved SEO and JSON-LD, blog posts and menus, redirect lookup, sitemaps and robots.txt for the store, and sections and blocks defined in the admin, fully resolved: media with renditions, product cards priced for the market, CTA links as paths. Sections and blocks are cacheable with ETag",
      "operations": [
        "getPage",
        "lookupRedirect",
        "getSitemapIndex",
        "getSitemap",
        "getRobots",
        "listBlogCategories",
        "listBlogPosts",
        "getBlogPost",
        "getMenu",
        "getIndexNowKey",
        "getSection",
        "getBlock",
        "listBlocks"
      ]
    },
    {
      "key": "policies",
      "title": "Policies",
      "description": "Published policy documents with resolved SEO and JSON-LD; the returns document carries MerchantReturnPolicy. Footer links come with GET /store as policyLinks",
      "operations": [
        "listPolicies",
        "getPolicy"
      ]
    },
    {
      "key": "cart",
      "title": "Cart",
      "description": "Shopping carts: opaque token, lines with validated customizations, always returned fully priced for the cart market",
      "operations": [
        "createCart",
        "getCart",
        "updateCart",
        "addCartLine",
        "updateCartLine",
        "removeCartLine",
        "applyCartDiscount",
        "removeCartDiscount",
        "mergeCarts",
        "getCustomerCart"
      ]
    },
    {
      "key": "uploads",
      "title": "Uploads",
      "description": "Files a shopper attaches to a `file` customization: raw upload answered with a token, the token goes into the cart line, the same token reads the file back for a preview. Sniffed by content, swept when no order takes them",
      "operations": [
        "uploadCustomerFile",
        "getCustomerUpload"
      ]
    },
    {
      "key": "checkout",
      "title": "Checkout",
      "description": "Checkout: one attempt to pay for a cart. Contact and addresses, shipping rates, payment methods, then place the order",
      "operations": [
        "listShippingZones",
        "listRegions",
        "createCheckout",
        "getCheckout",
        "updateCheckout",
        "listCheckoutPaymentMethods",
        "recoverCheckout",
        "applyCheckoutGiftCard",
        "removeCheckoutGiftCard",
        "createPaymentIntent",
        "completeCheckout"
      ]
    },
    {
      "key": "customers",
      "title": "Customers",
      "description": "Shopper accounts: register, sign in with a password or a magic link, rotating refresh tokens, profile, addresses, wishlist and privacy requests. Customer calls send the store key as Bearer and the customer access token as X-Customer-Token",
      "operations": [
        "registerCustomer",
        "loginCustomer",
        "refreshCustomerSession",
        "logoutCustomer",
        "forgotPassword",
        "resetPassword",
        "startGoogleSignIn",
        "completeGoogleSignIn",
        "requestMagicLink",
        "verifyMagicLink",
        "getCustomerProfile",
        "updateCustomerProfile",
        "changeCustomerPassword",
        "listCustomerAddresses",
        "createCustomerAddress",
        "updateCustomerAddress",
        "deleteCustomerAddress",
        "getWishlist",
        "updateWishlist",
        "addWishlistItem",
        "removeWishlistItem",
        "shareWishlist",
        "unshareWishlist",
        "getSharedWishlist",
        "listPrivacyRequests",
        "createPrivacyRequest",
        "downloadPrivacyExport",
        "subscribeNewsletter",
        "confirmNewsletter",
        "unsubscribeNewsletter",
        "getCustomerPushSettings",
        "registerCustomerPushDevice",
        "deleteCustomerPushDevice"
      ]
    },
    {
      "key": "orders",
      "title": "Orders",
      "description": "Order history of the signed-in shopper",
      "operations": [
        "getOrderStatus",
        "listCustomerOrders",
        "getCustomerOrder",
        "reorderCustomerOrder",
        "getDesignApproval",
        "submitDesignApproval",
        "getOrderWorkflowAction",
        "answerOrderWorkflowAction",
        "createReturn"
      ]
    },
    {
      "key": "auctions",
      "title": "Auctions",
      "description": "Live and upcoming auctions with masked bidders, the auction terms and registration, bidding with a single amount or a proxy maximum, buy now, the watchlist, second-chance offers from their emailed link, and the shopper's own auctions. Reads (and the socket ticket) under catalog:read; registration, bids, buy now, watching and offers under auctions:write. Follow lots live over the WebSocket from POST /auctions/ws-ticket, or poll GET /auctions/{id} with If-None-Match",
      "operations": [
        "listAuctions",
        "getAuctionTerms",
        "registerForAuctions",
        "getAuction",
        "placeAuctionBid",
        "listMyAuctions",
        "buyAuctionNow",
        "watchAuction",
        "unwatchAuction",
        "listWatchedAuctions",
        "getAuctionOffer",
        "acceptAuctionOffer",
        "declineAuctionOffer",
        "createAuctionSocketTicket",
        "listAuctionSales",
        "getAuctionSale",
        "getAuctionSaleResults",
        "listAuctionQuestions",
        "askAuctionQuestion",
        "listMyAuctionQuestions"
      ]
    },
    {
      "key": "analytics",
      "title": "Analytics",
      "description": "Batched storefront events, stored and forwarded server-side with consent",
      "operations": [
        "trackEvents"
      ]
    },
    {
      "key": "chat",
      "title": "Chat",
      "description": "The live chat widget: config, a visitor session (`vis_` token sent as X-Chat-Visitor), conversations, messages with attachments, read receipts, rating, transcript and close. Answers 404 CHAT_DISABLED until settings.chat.enabled is on. Postgres holds every message; reconnecting clients resume with `after=<last message id>`",
      "operations": [
        "getChatConfig",
        "createChatSession",
        "listChatConversations",
        "startChatConversation",
        "listChatMessages",
        "sendChatMessage",
        "markChatRead",
        "sendChatTyping",
        "sendChatPresence",
        "rateChatConversation",
        "requestChatTranscript",
        "closeChatConversation",
        "getChatAttachment",
        "uploadChatFile",
        "continueChatConversation",
        "lookupChatOrder",
        "createChatRequest",
        "startCustomDesign",
        "fireChatTrigger",
        "createChatSocketTicket"
      ]
    },
    {
      "key": "help-centre",
      "title": "Help centre",
      "description": "The help centre: public categories, published articles with resolved SEO and an Article graph (ETag), search over the store's help index, and \"was this helpful?\" votes from help pages and the chat widget. Internal articles never appear here. Works with the chat widget off. Scope content:read",
      "operations": [
        "listHelpCategories",
        "getHelpCategory",
        "listHelpArticles",
        "getHelpArticle",
        "searchHelpArticles",
        "sendHelpFeedback"
      ]
    }
  ],
  "operations": {
    "getStore": {
      "id": "getStore",
      "slug": "get-store",
      "method": "GET",
      "path": "/storefront/v1/store",
      "tag": "store",
      "summary": "Profile and public settings of the store bound to the API key",
      "description": "Carries the markets (countries and currencies) a shopper can switch to, the resolved logo, and status: a draft or paused store still answers here and on every read, but refuses carts, checkouts and sign-ups with 409 STORE_NOT_ACCEPTING_ORDERS",
      "descriptionHtml": "<p>Carries the markets (countries and currencies) a shopper can switch to, the resolved logo, and status: a draft or paused store still answers here and on every read, but refuses carts, checkouts and sign-ups with 409 STORE_NOT_ACCEPTING_ORDERS</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontStore, required: true },
          "example": example_getStore_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getStore_200
        }
      }
    },
    "pickStones": {
      "id": "pickStones",
      "slug": "pick-stones",
      "method": "GET",
      "path": "/storefront/v1/configurator/settings/{productId}/stones",
      "tag": "catalog",
      "summary": "Diamonds that fit a setting, priced for this store",
      "description": "Accepted shapes and stone types come from the setting; the shopper narrows shape (within those), carat, color, clarity, cut and sort. Only stones one of the store's markup bands prices are offered. facets lists what the whole fitting pool still offers so the picker can draw its controls",
      "descriptionHtml": "<p>Accepted shapes and stone types come from the setting; the shopper narrows shape (within those), carat, color, clarity, cut and sort. Only stones one of the store&#39;s markup bands prices are offered. facets lists what the whole fitting pool still offers so the picker can draw its controls</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "Page size, 1 to 100",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 20,
            "constraints": {
              "minimum": 1,
              "maximum": 100
            }
          }
        },
        {
          "name": "cursor",
          "in": "query",
          "required": false,
          "description": "Opaque cursor taken from nextCursor of the previous page",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cursor",
            "constraints": {
              "maxLength": 200
            }
          }
        },
        {
          "name": "stoneType",
          "in": "query",
          "required": false,
          "description": "Narrow to one of the setting's accepted types",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "stoneType",
            "enum": [
              "natural_diamond",
              "lab_diamond",
              "gemstone"
            ]
          }
        },
        {
          "name": "shape",
          "in": "query",
          "required": false,
          "description": "Comma-separated shapes, each one the setting accepts; others are ignored",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "shape",
            "constraints": {
              "maxLength": 200
            }
          }
        },
        {
          "name": "caratMin",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "number",
            "required": false,
            "nullable": false,
            "name": "caratMin",
            "constraints": {
              "minimum": 0,
              "maximum": 100
            }
          }
        },
        {
          "name": "caratMax",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "number",
            "required": false,
            "nullable": false,
            "name": "caratMax",
            "constraints": {
              "maximum": 100
            }
          }
        },
        {
          "name": "colorMin",
          "in": "query",
          "required": false,
          "description": "Lowest color grade to show",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "colorMin",
            "enum": [
              "Champagne",
              "J",
              "I",
              "H",
              "G",
              "F",
              "E",
              "D"
            ]
          }
        },
        {
          "name": "clarityMin",
          "in": "query",
          "required": false,
          "description": "Lowest clarity grade to show",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "clarityMin",
            "enum": [
              "I3",
              "I2",
              "I1",
              "SI2",
              "SI1",
              "VS2",
              "VS1",
              "VVS2",
              "VVS1",
              "IF",
              "FL"
            ]
          }
        },
        {
          "name": "cutMin",
          "in": "query",
          "required": false,
          "description": "Lowest cut grade to show; stones with no cut grade are dropped",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cutMin",
            "enum": [
              "Poor",
              "Fair",
              "Good",
              "Very Good",
              "Excellent"
            ]
          }
        },
        {
          "name": "colorMax",
          "in": "query",
          "required": false,
          "description": "Highest color grade to show",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "colorMax",
            "enum": [
              "Champagne",
              "J",
              "I",
              "H",
              "G",
              "F",
              "E",
              "D"
            ]
          }
        },
        {
          "name": "clarityMax",
          "in": "query",
          "required": false,
          "description": "Highest clarity grade to show",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "clarityMax",
            "enum": [
              "I3",
              "I2",
              "I1",
              "SI2",
              "SI1",
              "VS2",
              "VS1",
              "VVS2",
              "VVS1",
              "IF",
              "FL"
            ]
          }
        },
        {
          "name": "cutMax",
          "in": "query",
          "required": false,
          "description": "Highest cut grade to show; stones with no cut grade are dropped",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cutMax",
            "enum": [
              "Poor",
              "Fair",
              "Good",
              "Very Good",
              "Excellent"
            ]
          }
        },
        {
          "name": "priceMin",
          "in": "query",
          "required": false,
          "description": "Lowest shopper price in minor units of the stones' currency",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "priceMin",
            "constraints": {
              "minimum": 0
            }
          }
        },
        {
          "name": "priceMax",
          "in": "query",
          "required": false,
          "description": "Highest shopper price in minor units of the stones' currency",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "priceMax",
            "constraints": {
              "minimum": 0
            }
          }
        },
        {
          "name": "sort",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "sort",
            "default": "price_asc",
            "enum": [
              "carat_asc",
              "carat_desc",
              "price_asc",
              "price_desc"
            ]
          },
          "example": "price_asc"
        },
        {
          "name": "productId",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "productId",
            "format": "uuid"
          },
          "example": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_StorefrontStone
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": true,
                "name": "nextCursor",
                "description": "Cursor for the next page, null on the last page"
              },
              { ...schema_StonePickerFacets, required: true, name: "facets" }
            ]
          },
          "example": example_pickStones_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2"
          },
          "query": {
            "sort": "price_asc"
          },
          "headers": {}
        },
        "responses": {
          "200": example_pickStones_200
        }
      }
    },
    "shopStones": {
      "id": "shopStones",
      "slug": "shop-stones",
      "method": "GET",
      "path": "/storefront/v1/configurator/stones",
      "tag": "catalog",
      "summary": "Every diamond the store sells, for shopping by diamond first",
      "description": "Stones that one of the store's markup bands prices and at least one of its published settings takes, with the same filters, sort, cursor and facets as pickStones. accepts is what those settings take together, so the page can draw its type, shape and carat controls",
      "descriptionHtml": "<p>Stones that one of the store&#39;s markup bands prices and at least one of its published settings takes, with the same filters, sort, cursor and facets as pickStones. accepts is what those settings take together, so the page can draw its type, shape and carat controls</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "Page size, 1 to 100",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 20,
            "constraints": {
              "minimum": 1,
              "maximum": 100
            }
          },
          "example": "2"
        },
        {
          "name": "cursor",
          "in": "query",
          "required": false,
          "description": "Opaque cursor taken from nextCursor of the previous page",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cursor",
            "constraints": {
              "maxLength": 200
            }
          }
        },
        {
          "name": "stoneType",
          "in": "query",
          "required": false,
          "description": "Narrow to one of the setting's accepted types",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "stoneType",
            "enum": [
              "natural_diamond",
              "lab_diamond",
              "gemstone"
            ]
          }
        },
        {
          "name": "shape",
          "in": "query",
          "required": false,
          "description": "Comma-separated shapes, each one the setting accepts; others are ignored",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "shape",
            "constraints": {
              "maxLength": 200
            }
          },
          "example": "oval"
        },
        {
          "name": "caratMin",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "number",
            "required": false,
            "nullable": false,
            "name": "caratMin",
            "constraints": {
              "minimum": 0,
              "maximum": 100
            }
          }
        },
        {
          "name": "caratMax",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "number",
            "required": false,
            "nullable": false,
            "name": "caratMax",
            "constraints": {
              "maximum": 100
            }
          }
        },
        {
          "name": "colorMin",
          "in": "query",
          "required": false,
          "description": "Lowest color grade to show",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "colorMin",
            "enum": [
              "Champagne",
              "J",
              "I",
              "H",
              "G",
              "F",
              "E",
              "D"
            ]
          }
        },
        {
          "name": "clarityMin",
          "in": "query",
          "required": false,
          "description": "Lowest clarity grade to show",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "clarityMin",
            "enum": [
              "I3",
              "I2",
              "I1",
              "SI2",
              "SI1",
              "VS2",
              "VS1",
              "VVS2",
              "VVS1",
              "IF",
              "FL"
            ]
          }
        },
        {
          "name": "cutMin",
          "in": "query",
          "required": false,
          "description": "Lowest cut grade to show; stones with no cut grade are dropped",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cutMin",
            "enum": [
              "Poor",
              "Fair",
              "Good",
              "Very Good",
              "Excellent"
            ]
          }
        },
        {
          "name": "colorMax",
          "in": "query",
          "required": false,
          "description": "Highest color grade to show",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "colorMax",
            "enum": [
              "Champagne",
              "J",
              "I",
              "H",
              "G",
              "F",
              "E",
              "D"
            ]
          }
        },
        {
          "name": "clarityMax",
          "in": "query",
          "required": false,
          "description": "Highest clarity grade to show",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "clarityMax",
            "enum": [
              "I3",
              "I2",
              "I1",
              "SI2",
              "SI1",
              "VS2",
              "VS1",
              "VVS2",
              "VVS1",
              "IF",
              "FL"
            ]
          }
        },
        {
          "name": "cutMax",
          "in": "query",
          "required": false,
          "description": "Highest cut grade to show; stones with no cut grade are dropped",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cutMax",
            "enum": [
              "Poor",
              "Fair",
              "Good",
              "Very Good",
              "Excellent"
            ]
          }
        },
        {
          "name": "priceMin",
          "in": "query",
          "required": false,
          "description": "Lowest shopper price in minor units of the stones' currency",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "priceMin",
            "constraints": {
              "minimum": 0
            }
          }
        },
        {
          "name": "priceMax",
          "in": "query",
          "required": false,
          "description": "Highest shopper price in minor units of the stones' currency",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "priceMax",
            "constraints": {
              "minimum": 0
            }
          }
        },
        {
          "name": "sort",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "sort",
            "default": "price_asc",
            "enum": [
              "carat_asc",
              "carat_desc",
              "price_asc",
              "price_desc"
            ]
          },
          "example": "price_asc"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StoneShopResponse, required: true },
          "example": example_shopStones_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {
            "limit": "2",
            "shape": "oval",
            "sort": "price_asc"
          },
          "headers": {}
        },
        "responses": {
          "200": example_shopStones_200
        }
      }
    },
    "listStoneSettings": {
      "id": "listStoneSettings",
      "slug": "list-stone-settings",
      "method": "GET",
      "path": "/storefront/v1/configurator/stones/{id}/settings",
      "tag": "catalog",
      "summary": "The published settings that take one diamond",
      "description": "Each setting as a product card with the ring's lowest total (setting plus this diamond). A diamond the store does not price answers 404",
      "descriptionHtml": "<p>Each setting as a product card with the ring&#39;s lowest total (setting plus this diamond). A diamond the store does not price answers 404</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": true,
      "parameters": [
        {
          "name": "country",
          "in": "query",
          "required": false,
          "description": "Shopper country for market and currency; the X-Nucleus-Country header does the same",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "country",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          "example": "US"
        },
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a15379-812f-7ed6-a5d9-f8f5297c31fc"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StoneSettingsResponse, required: true },
          "example": example_listStoneSettings_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a15379-812f-7ed6-a5d9-f8f5297c31fc"
          },
          "query": {
            "country": "US"
          },
          "headers": {}
        },
        "responses": {
          "200": example_listStoneSettings_200
        }
      }
    },
    "getStorefrontStone": {
      "id": "getStorefrontStone",
      "slug": "get-storefront-stone",
      "method": "GET",
      "path": "/storefront/v1/configurator/stones/{id}",
      "tag": "catalog",
      "summary": "One diamond, priced for this store",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a15379-812f-7ed6-a5d9-f8f5297c31fc"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontStone, required: true },
          "example": example_getStorefrontStone_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a15379-812f-7ed6-a5d9-f8f5297c31fc"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getStorefrontStone_200
        }
      }
    },
    "listProducts": {
      "id": "listProducts",
      "slug": "list-products",
      "method": "GET",
      "path": "/storefront/v1/products",
      "tag": "catalog",
      "summary": "Published products of the store, filtered, sorted and priced for the shopper's market",
      "description": "Only published store products whose master product is active. Filters are OR within a field and AND across fields; `attr` takes `key:value` (select code, `true`/`false`, number or `min-max` range). Sorts: `newest` (default), `price_asc`, `price_desc`, `title_asc`, `title_desc`; price sorts and `priceMin`/`priceMax` use the store's base prices. `facets=true` adds counts over the whole filtered set. Prices follow the market matched by `country` (query or X-Nucleus-Country header), else the default market",
      "descriptionHtml": "<p>Only published store products whose master product is active. Filters are OR within a field and AND across fields; <code>attr</code> takes <code>key:value</code> (select code, <code>true</code>/<code>false</code>, number or <code>min-max</code> range). Sorts: <code>newest</code> (default), <code>price_asc</code>, <code>price_desc</code>, <code>title_asc</code>, <code>title_desc</code>; price sorts and <code>priceMin</code>/<code>priceMax</code> use the store&#39;s base prices. <code>facets=true</code> adds counts over the whole filtered set. Prices follow the market matched by <code>country</code> (query or X-Nucleus-Country header), else the default market</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": true,
      "parameters": [
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "Page size, 1 to 100",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 20,
            "constraints": {
              "minimum": 1,
              "maximum": 100
            }
          },
          "example": "3"
        },
        {
          "name": "cursor",
          "in": "query",
          "required": false,
          "description": "Opaque cursor taken from nextCursor of the previous page",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cursor",
            "constraints": {
              "maxLength": 200
            }
          }
        },
        {
          "name": "q",
          "in": "query",
          "required": false,
          "description": "Case-insensitive match on title or handle; full search comes with the search index",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "q",
            "constraints": {
              "maxLength": 120
            }
          }
        },
        {
          "name": "country",
          "in": "query",
          "required": false,
          "description": "Shopper country for market and currency; the X-Nucleus-Country header does the same",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "country",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          "example": "US"
        },
        {
          "name": "productType",
          "in": "query",
          "required": false,
          "description": "Product type slugs",
          "schema": {
            "kind": "oneOf",
            "type": "oneOf",
            "required": false,
            "nullable": false,
            "name": "productType",
            "variants": [
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxLength": 120
                }
              },
              {
                "kind": "array",
                "type": "array",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxItems": 10
                },
                "items": {
                  "kind": "primitive",
                  "type": "string",
                  "required": false,
                  "nullable": false,
                  "constraints": {
                    "maxLength": 120
                  }
                }
              }
            ]
          }
        },
        {
          "name": "tag",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "oneOf",
            "type": "oneOf",
            "required": false,
            "nullable": false,
            "name": "tag",
            "variants": [
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxLength": 60
                }
              },
              {
                "kind": "array",
                "type": "array",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxItems": 10
                },
                "items": {
                  "kind": "primitive",
                  "type": "string",
                  "required": false,
                  "nullable": false,
                  "constraints": {
                    "maxLength": 60
                  }
                }
              }
            ]
          },
          "example": "bestseller"
        },
        {
          "name": "vendor",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "oneOf",
            "type": "oneOf",
            "required": false,
            "nullable": false,
            "name": "vendor",
            "variants": [
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxLength": 120
                }
              },
              {
                "kind": "array",
                "type": "array",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxItems": 10
                },
                "items": {
                  "kind": "primitive",
                  "type": "string",
                  "required": false,
                  "nullable": false,
                  "constraints": {
                    "maxLength": 120
                  }
                }
              }
            ]
          }
        },
        {
          "name": "fulfillmentMode",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "oneOf",
            "type": "oneOf",
            "required": false,
            "nullable": false,
            "name": "fulfillmentMode",
            "variants": [
              {
                "kind": "enum",
                "type": "string",
                "required": false,
                "nullable": false,
                "enum": [
                  "stocked",
                  "made_to_order",
                  "mixed"
                ]
              },
              {
                "kind": "array",
                "type": "array",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxItems": 3
                },
                "items": {
                  "kind": "enum",
                  "type": "string",
                  "required": false,
                  "nullable": false,
                  "enum": [
                    "stocked",
                    "made_to_order",
                    "mixed"
                  ]
                }
              }
            ]
          }
        },
        {
          "name": "attr",
          "in": "query",
          "required": false,
          "description": "`key:value` per attribute; the same key repeated is OR, different keys AND. Select attributes take the value code, booleans `true`/`false`, numbers a value or a `min-max` range (`100-`, `-250`)",
          "schema": {
            "kind": "oneOf",
            "type": "oneOf",
            "required": false,
            "nullable": false,
            "name": "attr",
            "variants": [
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": false,
                "example": "metal:14k_yellow_gold",
                "constraints": {
                  "pattern": "^[a-z][a-z0-9_]*:[^\\s]{1,120}$"
                }
              },
              {
                "kind": "array",
                "type": "array",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxItems": 20
                },
                "items": {
                  "kind": "primitive",
                  "type": "string",
                  "required": false,
                  "nullable": false,
                  "example": "metal:14k_yellow_gold",
                  "constraints": {
                    "pattern": "^[a-z][a-z0-9_]*:[^\\s]{1,120}$"
                  }
                }
              }
            ]
          }
        },
        {
          "name": "priceMin",
          "in": "query",
          "required": false,
          "description": "Lowest variant price at or above this, in minor units of the market currency",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "priceMin",
            "constraints": {
              "minimum": 0
            }
          }
        },
        {
          "name": "priceMax",
          "in": "query",
          "required": false,
          "description": "Lowest variant price at or below this, in minor units of the market currency",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "priceMax",
            "constraints": {
              "minimum": 0
            }
          }
        },
        {
          "name": "sort",
          "in": "query",
          "required": false,
          "description": "`featured` is the collection's own order (newest on the catalog list); defaults to newest on the catalog list and featured on a collection",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "sort",
            "enum": [
              "featured",
              "newest",
              "price_asc",
              "price_desc",
              "title_asc",
              "title_desc"
            ]
          }
        },
        {
          "name": "facets",
          "in": "query",
          "required": false,
          "description": "Include `facets` counted over the whole filtered set",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "facets"
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontProductListResponse, required: true },
          "example": example_listProducts_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_listProducts_400
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {
            "limit": "3",
            "country": "US",
            "tag": "bestseller"
          },
          "headers": {}
        },
        "responses": {
          "200": example_listProducts_200,
          "400": example_listProducts_400
        }
      }
    },
    "getProduct": {
      "id": "getProduct",
      "slug": "get-product",
      "method": "GET",
      "path": "/storefront/v1/products/{handle}",
      "tag": "catalog",
      "summary": "One published product by its store handle, with variants, media, attributes, customizations and related products",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": true,
      "parameters": [
        {
          "name": "country",
          "in": "query",
          "required": false,
          "description": "ISO 3166-1 alpha-2 country code",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "country",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          "example": "US"
        },
        {
          "name": "handle",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "handle",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          "example": "orbit-comfort-fit-band"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontProduct, required: true },
          "example": example_getProduct_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getProduct_404
        }
      },
      "examples": {
        "request": {
          "params": {
            "handle": "orbit-comfort-fit-band"
          },
          "query": {
            "country": "US"
          },
          "headers": {}
        },
        "responses": {
          "200": example_getProduct_200,
          "404": example_getProduct_404
        }
      }
    },
    "getSizeSet": {
      "id": "getSizeSet",
      "slug": "get-size-set",
      "method": "GET",
      "path": "/storefront/v1/size-sets/{key}",
      "tag": "catalog",
      "summary": "A size set by key or id, with each size's equivalents and its size guide page",
      "description": "Size customizations name their set through sizeSetId, which this route accepts as well as the set's key. Gives the full table (US, UK, EU equivalents) for a size chart and the handle of the set's own size guide page, else the store's published size_guide page, for a \"find your size\" link",
      "descriptionHtml": "<p>Size customizations name their set through sizeSetId, which this route accepts as well as the set&#39;s key. Gives the full table (US, UK, EU equivalents) for a size chart and the handle of the set&#39;s own size guide page, else the store&#39;s published size_guide page, for a &quot;find your size&quot; link</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "key",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "key",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          "example": "us_ring_sizes"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontSizeSet, required: true },
          "example": example_getSizeSet_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getSizeSet_404
        }
      },
      "examples": {
        "request": {
          "params": {
            "key": "us_ring_sizes"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getSizeSet_200,
          "404": example_getSizeSet_404
        }
      }
    },
    "getPage": {
      "id": "getPage",
      "slug": "get-page",
      "method": "GET",
      "path": "/storefront/v1/pages/{handle}",
      "tag": "content",
      "summary": "A published page with resolved SEO and JSON-LD",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "handle",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "handle",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          "example": "about"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontPage, required: true },
          "example": example_getPage_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getPage_404
        }
      },
      "examples": {
        "request": {
          "params": {
            "handle": "about"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getPage_200,
          "404": example_getPage_404
        }
      }
    },
    "lookupRedirect": {
      "id": "lookupRedirect",
      "slug": "lookup-redirect",
      "method": "GET",
      "path": "/storefront/v1/redirects/lookup",
      "tag": "content",
      "summary": "Where a path moved to, for the storefront's 404 middleware",
      "description": "Counts the hit. 404 when nothing redirects from the path",
      "descriptionHtml": "<p>Counts the hit. 404 when nothing redirects from the path</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "path",
          "in": "query",
          "required": true,
          "description": "The path the storefront received, without query string",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "path",
            "constraints": {
              "minLength": 1,
              "maxLength": 500,
              "pattern": "^\\/[^\\s]*$"
            }
          },
          "example": "/products/aurora-oval"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_RedirectLookup, required: true },
          "example": example_lookupRedirect_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_lookupRedirect_404
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {
            "path": "/products/aurora-oval"
          },
          "headers": {}
        },
        "responses": {
          "200": example_lookupRedirect_200,
          "404": example_lookupRedirect_404
        }
      }
    },
    "getSitemapIndex": {
      "id": "getSitemapIndex",
      "slug": "get-sitemap-index",
      "method": "GET",
      "path": "/storefront/v1/sitemap.xml",
      "tag": "content",
      "summary": "Sitemap index for the store's primary domain",
      "description": "Empty until the store has a primary domain or while `settings.seo.indexable` is off. The storefront proxies it at /sitemap.xml",
      "descriptionHtml": "<p>Empty until the store has a primary domain or while <code>settings.seo.indexable</code> is off. The storefront proxies it at /sitemap.xml</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "XML",
          "body": "text",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "description": "XML"
          },
          "example": example_getSitemapIndex_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getSitemapIndex_200
        }
      }
    },
    "getSitemap": {
      "id": "getSitemap",
      "slug": "get-sitemap",
      "method": "GET",
      "path": "/storefront/v1/sitemaps/{name}",
      "tag": "content",
      "summary": "One sitemap file: products (with images), collections, sales, pages, policies, blog or help",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "name",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "name",
            "constraints": {
              "pattern": "^(products|collections|sales|pages|policies|blog|help)-1\\.xml$"
            }
          },
          "example": "products-1.xml"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "XML",
          "body": "text",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "description": "XML"
          },
          "example": example_getSitemap_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getSitemap_400
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "name": "products-1.xml"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getSitemap_200,
          "400": example_getSitemap_400
        }
      }
    },
    "getRobots": {
      "id": "getRobots",
      "slug": "get-robots",
      "method": "GET",
      "path": "/storefront/v1/robots.txt",
      "tag": "content",
      "summary": "Crawler policy for the store from settings.crawlers",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "text/plain",
          "body": "text",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "description": "text/plain"
          },
          "example": example_getRobots_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getRobots_200
        }
      }
    },
    "listPolicies": {
      "id": "listPolicies",
      "slug": "list-policies",
      "method": "GET",
      "path": "/storefront/v1/policies",
      "tag": "policies",
      "summary": "Published policy documents in footer order",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_StorefrontPolicySummary
              }
            ]
          },
          "example": example_listPolicies_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_listPolicies_200
        }
      }
    },
    "getPolicy": {
      "id": "getPolicy",
      "slug": "get-policy",
      "method": "GET",
      "path": "/storefront/v1/policies/{handle}",
      "tag": "policies",
      "summary": "A published policy with resolved SEO and JSON-LD",
      "description": "The returns policy carries a MerchantReturnPolicy built from the store settings, the same node the product offers and the Organization quote",
      "descriptionHtml": "<p>The returns policy carries a MerchantReturnPolicy built from the store settings, the same node the product offers and the Organization quote</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "handle",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "handle",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          "example": "returns"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontPolicy, required: true },
          "example": example_getPolicy_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getPolicy_404
        }
      },
      "examples": {
        "request": {
          "params": {
            "handle": "returns"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getPolicy_200,
          "404": example_getPolicy_404
        }
      }
    },
    "listBlogCategories": {
      "id": "listBlogCategories",
      "slug": "list-blog-categories",
      "method": "GET",
      "path": "/storefront/v1/blog/categories",
      "tag": "content",
      "summary": "Blog categories with live post counts",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_StorefrontBlogCategory
              }
            ]
          },
          "example": example_listBlogCategories_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_listBlogCategories_200
        }
      }
    },
    "listBlogPosts": {
      "id": "listBlogPosts",
      "slug": "list-blog-posts",
      "method": "GET",
      "path": "/storefront/v1/blog/posts",
      "tag": "content",
      "summary": "Live blog posts, newest first",
      "description": "Only published posts whose publish date has passed. Filter by category handle or tag",
      "descriptionHtml": "<p>Only published posts whose publish date has passed. Filter by category handle or tag</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "Page size, 1 to 100",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 20,
            "constraints": {
              "minimum": 1,
              "maximum": 100
            }
          },
          "example": "2"
        },
        {
          "name": "cursor",
          "in": "query",
          "required": false,
          "description": "Opaque cursor taken from nextCursor of the previous page",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cursor",
            "constraints": {
              "maxLength": 200
            }
          }
        },
        {
          "name": "category",
          "in": "query",
          "required": false,
          "description": "Category handle",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "category",
            "constraints": {
              "minLength": 1,
              "maxLength": 120,
              "pattern": "^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$"
            }
          },
          "example": "aurora-jewels"
        },
        {
          "name": "tag",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "tag",
            "constraints": {
              "minLength": 1,
              "maxLength": 40,
              "pattern": "^[a-z0-9]+(?:-[a-z0-9]+)*$"
            }
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_StorefrontBlogPostSummary
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": true,
                "name": "nextCursor",
                "description": "Cursor for the next page, null on the last page"
              }
            ]
          },
          "example": example_listBlogPosts_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {
            "limit": "2",
            "category": "aurora-jewels"
          },
          "headers": {}
        },
        "responses": {
          "200": example_listBlogPosts_200
        }
      }
    },
    "getBlogPost": {
      "id": "getBlogPost",
      "slug": "get-blog-post",
      "method": "GET",
      "path": "/storefront/v1/blog/posts/{handle}",
      "tag": "content",
      "summary": "A live blog post with resolved SEO and a BlogPosting graph",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "handle",
          "in": "path",
          "required": true,
          "description": "URL-safe handle: lowercase letters, digits and hyphens",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "handle",
            "constraints": {
              "minLength": 1,
              "maxLength": 120,
              "pattern": "^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$"
            }
          },
          "example": "caring-for-lab-grown-diamonds"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontBlogPost, required: true },
          "example": example_getBlogPost_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "handle": "caring-for-lab-grown-diamonds"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getBlogPost_200
        }
      }
    },
    "getMenu": {
      "id": "getMenu",
      "slug": "get-menu",
      "method": "GET",
      "path": "/storefront/v1/menus/{handle}",
      "tag": "content",
      "summary": "A menu with resolved links",
      "description": "Items pointing at deleted or unpublished targets are left out. Template storefronts read `main` and `footer`",
      "descriptionHtml": "<p>Items pointing at deleted or unpublished targets are left out. Template storefronts read <code>main</code> and <code>footer</code></p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "handle",
          "in": "path",
          "required": true,
          "description": "URL-safe handle: lowercase letters, digits and hyphens",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "handle",
            "constraints": {
              "minLength": 1,
              "maxLength": 120,
              "pattern": "^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$"
            }
          },
          "example": "main"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontMenu, required: true },
          "example": example_getMenu_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "handle": "main"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getMenu_200
        }
      }
    },
    "getIndexNowKey": {
      "id": "getIndexNowKey",
      "slug": "get-index-now-key",
      "method": "GET",
      "path": "/storefront/v1/indexnow/{file}",
      "tag": "content",
      "summary": "The IndexNow key file, to proxy at /{key}.txt on the store domain",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "file",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "file",
            "constraints": {
              "pattern": "^[a-f0-9]{32}\\.txt$"
            }
          },
          "example": "c7c4ed6403bc4adda46adb3f9cf0f477.txt"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "text/plain",
          "body": "text",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "description": "text/plain"
          },
          "example": example_getIndexNowKey_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "file": "c7c4ed6403bc4adda46adb3f9cf0f477.txt"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getIndexNowKey_200
        }
      }
    },
    "trackEvents": {
      "id": "trackEvents",
      "slug": "track-events",
      "method": "POST",
      "path": "/storefront/v1/events",
      "tag": "analytics",
      "summary": "Record storefront events in a batch",
      "description": "Up to 100 events. Stored at once and forwarded server-side to the store's destinations by the worker, honouring each event's consent flags. Send `checkoutId` in `context` on checkout-stage events so the server-side purchase inherits the session and consent; pixels should use `purchase:{orderId}` as the purchase event id so platforms deduplicate. A signed-in shopper's `X-Customer-Token` attaches the customer",
      "descriptionHtml": "<p>Up to 100 events. Stored at once and forwarded server-side to the store&#39;s destinations by the worker, honouring each event&#39;s consent flags. Send <code>checkoutId</code> in <code>context</code> on checkout-stage events so the server-side purchase inherits the session and consent; pixels should use <code>purchase:{orderId}</code> as the purchase event id so platforms deduplicate. A signed-in shopper&#39;s <code>X-Customer-Token</code> attaches the customer</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "analytics:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": { ...schema_StorefrontEventsRequest, required: true },
      "responses": {
        "202": {
          "description": "Response",
          "body": "json",
          "schema": { ...schema_StorefrontEventsAccepted, required: true },
          "example": example_trackEvents_202
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "events": [
              {
                "name": "view_item",
                "sessionId": "sess_4f1c2a",
                "anonymousId": "anon_9b7e31",
                "items": [
                  {
                    "productId": "01a16987-5d6c-75da-bee8-56e81a1c4ae5",
                    "quantity": 1
                  }
                ],
                "context": {
                  "page": "/products/orbit-comfort-fit-band",
                  "consent": {
                    "analytics": true,
                    "marketing": false
                  }
                }
              }
            ]
          }
        },
        "responses": {
          "202": example_trackEvents_202
        }
      }
    },
    "listCollections": {
      "id": "listCollections",
      "slug": "list-collections",
      "method": "GET",
      "path": "/storefront/v1/collections",
      "tag": "catalog",
      "summary": "Active collections of the store",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_StorefrontCollection
              }
            ]
          },
          "example": example_listCollections_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_listCollections_200
        }
      }
    },
    "getCollection": {
      "id": "getCollection",
      "slug": "get-collection",
      "method": "GET",
      "path": "/storefront/v1/collections/{handle}",
      "tag": "catalog",
      "summary": "One active collection",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "handle",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "handle",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          "example": "engagement-rings"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontCollection, required: true },
          "example": example_getCollection_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getCollection_404
        }
      },
      "examples": {
        "request": {
          "params": {
            "handle": "engagement-rings"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getCollection_200,
          "404": example_getCollection_404
        }
      }
    },
    "listCollectionProducts": {
      "id": "listCollectionProducts",
      "slug": "list-collection-products",
      "method": "GET",
      "path": "/storefront/v1/collections/{handle}/products",
      "tag": "catalog",
      "summary": "Products of a collection, filtered and sorted, priced for the shopper's market",
      "description": "Same filters, sorts and facets as /products over the collection's members. `sort=featured` (default) is the collection's own order; `total` counts the members left after the filters",
      "descriptionHtml": "<p>Same filters, sorts and facets as /products over the collection&#39;s members. <code>sort=featured</code> (default) is the collection&#39;s own order; <code>total</code> counts the members left after the filters</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": true,
      "parameters": [
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "Page size, 1 to 100",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 20,
            "constraints": {
              "minimum": 1,
              "maximum": 100
            }
          },
          "example": "2"
        },
        {
          "name": "cursor",
          "in": "query",
          "required": false,
          "description": "Opaque cursor taken from nextCursor of the previous page",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cursor",
            "constraints": {
              "maxLength": 200
            }
          }
        },
        {
          "name": "country",
          "in": "query",
          "required": false,
          "description": "ISO 3166-1 alpha-2 country code",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "country",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          "example": "US"
        },
        {
          "name": "productType",
          "in": "query",
          "required": false,
          "description": "Product type slugs",
          "schema": {
            "kind": "oneOf",
            "type": "oneOf",
            "required": false,
            "nullable": false,
            "name": "productType",
            "variants": [
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxLength": 120
                }
              },
              {
                "kind": "array",
                "type": "array",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxItems": 10
                },
                "items": {
                  "kind": "primitive",
                  "type": "string",
                  "required": false,
                  "nullable": false,
                  "constraints": {
                    "maxLength": 120
                  }
                }
              }
            ]
          }
        },
        {
          "name": "tag",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "oneOf",
            "type": "oneOf",
            "required": false,
            "nullable": false,
            "name": "tag",
            "variants": [
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxLength": 60
                }
              },
              {
                "kind": "array",
                "type": "array",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxItems": 10
                },
                "items": {
                  "kind": "primitive",
                  "type": "string",
                  "required": false,
                  "nullable": false,
                  "constraints": {
                    "maxLength": 60
                  }
                }
              }
            ]
          }
        },
        {
          "name": "vendor",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "oneOf",
            "type": "oneOf",
            "required": false,
            "nullable": false,
            "name": "vendor",
            "variants": [
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxLength": 120
                }
              },
              {
                "kind": "array",
                "type": "array",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxItems": 10
                },
                "items": {
                  "kind": "primitive",
                  "type": "string",
                  "required": false,
                  "nullable": false,
                  "constraints": {
                    "maxLength": 120
                  }
                }
              }
            ]
          }
        },
        {
          "name": "fulfillmentMode",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "oneOf",
            "type": "oneOf",
            "required": false,
            "nullable": false,
            "name": "fulfillmentMode",
            "variants": [
              {
                "kind": "enum",
                "type": "string",
                "required": false,
                "nullable": false,
                "enum": [
                  "stocked",
                  "made_to_order",
                  "mixed"
                ]
              },
              {
                "kind": "array",
                "type": "array",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxItems": 3
                },
                "items": {
                  "kind": "enum",
                  "type": "string",
                  "required": false,
                  "nullable": false,
                  "enum": [
                    "stocked",
                    "made_to_order",
                    "mixed"
                  ]
                }
              }
            ]
          }
        },
        {
          "name": "attr",
          "in": "query",
          "required": false,
          "description": "`key:value` per attribute; the same key repeated is OR, different keys AND. Select attributes take the value code, booleans `true`/`false`, numbers a value or a `min-max` range (`100-`, `-250`)",
          "schema": {
            "kind": "oneOf",
            "type": "oneOf",
            "required": false,
            "nullable": false,
            "name": "attr",
            "variants": [
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": false,
                "example": "metal:14k_yellow_gold",
                "constraints": {
                  "pattern": "^[a-z][a-z0-9_]*:[^\\s]{1,120}$"
                }
              },
              {
                "kind": "array",
                "type": "array",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxItems": 20
                },
                "items": {
                  "kind": "primitive",
                  "type": "string",
                  "required": false,
                  "nullable": false,
                  "example": "metal:14k_yellow_gold",
                  "constraints": {
                    "pattern": "^[a-z][a-z0-9_]*:[^\\s]{1,120}$"
                  }
                }
              }
            ]
          }
        },
        {
          "name": "priceMin",
          "in": "query",
          "required": false,
          "description": "Lowest variant price at or above this, in minor units of the market currency",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "priceMin",
            "constraints": {
              "minimum": 0
            }
          }
        },
        {
          "name": "priceMax",
          "in": "query",
          "required": false,
          "description": "Lowest variant price at or below this, in minor units of the market currency",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "priceMax",
            "constraints": {
              "minimum": 0
            }
          }
        },
        {
          "name": "sort",
          "in": "query",
          "required": false,
          "description": "`featured` is the collection's own order (newest on the catalog list); defaults to newest on the catalog list and featured on a collection",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "sort",
            "enum": [
              "featured",
              "newest",
              "price_asc",
              "price_desc",
              "title_asc",
              "title_desc"
            ]
          }
        },
        {
          "name": "facets",
          "in": "query",
          "required": false,
          "description": "Include `facets` counted over the whole filtered set",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "facets"
          }
        },
        {
          "name": "handle",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "handle",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          "example": "engagement-rings"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontCollectionProductsResponse, required: true },
          "example": example_listCollectionProducts_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "handle": "engagement-rings"
          },
          "query": {
            "limit": "2",
            "country": "US"
          },
          "headers": {}
        },
        "responses": {
          "200": example_listCollectionProducts_200
        }
      }
    },
    "getSection": {
      "id": "getSection",
      "slug": "get-section",
      "method": "GET",
      "path": "/storefront/v1/sections/{handle}",
      "tag": "content",
      "summary": "A section with every visible block resolved: media, product cards priced for the market, CTA paths",
      "description": "Sends an ETag; repeat the request with If-None-Match for a 304. ?products=false leaves rail products out. ?preview=true (secret keys only) includes drafts and scheduled-out blocks",
      "descriptionHtml": "<p>Sends an ETag; repeat the request with If-None-Match for a 304. ?products=false leaves rail products out. ?preview=true (secret keys only) includes drafts and scheduled-out blocks</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": true,
      "parameters": [
        {
          "name": "country",
          "in": "query",
          "required": false,
          "description": "ISO 3166-1 alpha-2 country code",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "country",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          "example": "US"
        },
        {
          "name": "products",
          "in": "query",
          "required": false,
          "description": "false skips product embedding on rails",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "products"
          }
        },
        {
          "name": "preview",
          "in": "query",
          "required": false,
          "description": "Include drafts and out-of-schedule blocks; honored with a secret key only",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "preview"
          }
        },
        {
          "name": "handle",
          "in": "path",
          "required": true,
          "description": "URL-safe handle: lowercase letters, digits and hyphens",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "handle",
            "constraints": {
              "minLength": 1,
              "maxLength": 120,
              "pattern": "^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$"
            }
          },
          "example": "home"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontContentSection, required: true },
          "example": example_getSection_200
        },
        "304": {
          "description": "Response",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "handle": "home"
          },
          "query": {
            "country": "US"
          },
          "headers": {}
        },
        "responses": {
          "200": example_getSection_200
        }
      }
    },
    "getBlock": {
      "id": "getBlock",
      "slug": "get-block",
      "method": "GET",
      "path": "/storefront/v1/blocks/{key}",
      "tag": "content",
      "summary": "One visible block by key; the store's own block wins over a shared one",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": true,
      "parameters": [
        {
          "name": "country",
          "in": "query",
          "required": false,
          "description": "ISO 3166-1 alpha-2 country code",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "country",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          "example": "US"
        },
        {
          "name": "products",
          "in": "query",
          "required": false,
          "description": "false skips product embedding on rails",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "products"
          }
        },
        {
          "name": "preview",
          "in": "query",
          "required": false,
          "description": "Include drafts and out-of-schedule blocks; honored with a secret key only",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "preview"
          }
        },
        {
          "name": "key",
          "in": "path",
          "required": true,
          "description": "URL-safe handle: lowercase letters, digits and hyphens",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "key",
            "constraints": {
              "minLength": 1,
              "maxLength": 120,
              "pattern": "^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$"
            }
          },
          "example": "home-hero"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontContentBlock, required: true },
          "example": example_getBlock_200
        },
        "304": {
          "description": "Response",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "key": "home-hero"
          },
          "query": {
            "country": "US"
          },
          "headers": {}
        },
        "responses": {
          "200": example_getBlock_200
        }
      }
    },
    "listBlocks": {
      "id": "listBlocks",
      "slug": "list-blocks",
      "method": "GET",
      "path": "/storefront/v1/blocks",
      "tag": "content",
      "summary": "Several visible blocks by key, in the order asked; unknown keys are left out",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": true,
      "parameters": [
        {
          "name": "country",
          "in": "query",
          "required": false,
          "description": "ISO 3166-1 alpha-2 country code",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "country",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          "example": "US"
        },
        {
          "name": "products",
          "in": "query",
          "required": false,
          "description": "false skips product embedding on rails",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "products"
          }
        },
        {
          "name": "preview",
          "in": "query",
          "required": false,
          "description": "Include drafts and out-of-schedule blocks; honored with a secret key only",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "preview"
          }
        },
        {
          "name": "keys",
          "in": "query",
          "required": true,
          "description": "Comma-separated block keys, up to 20",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "keys",
            "constraints": {
              "minLength": 1,
              "maxLength": 2420
            }
          },
          "example": "home-hero,bestsellers"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_StorefrontContentBlock
              }
            ]
          },
          "example": example_listBlocks_200
        },
        "304": {
          "description": "Response",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {
            "country": "US",
            "keys": "home-hero,bestsellers"
          },
          "headers": {}
        },
        "responses": {
          "200": example_listBlocks_200
        }
      }
    },
    "suggestSearch": {
      "id": "suggestSearch",
      "slug": "suggest-search",
      "method": "GET",
      "path": "/storefront/v1/search/suggest",
      "tag": "catalog",
      "summary": "Typeahead: top products, collections and pages for what the shopper typed",
      "description": "Five of each from the search index, answered within a 100 ms budget; a group that misses it comes back empty. Product prices follow the shopper's market like the catalog endpoints. Collections link to /collections/{handle}, pages to /pages/{handle}",
      "descriptionHtml": "<p>Five of each from the search index, answered within a 100 ms budget; a group that misses it comes back empty. Product prices follow the shopper&#39;s market like the catalog endpoints. Collections link to /collections/{handle}, pages to /pages/{handle}</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": true,
      "parameters": [
        {
          "name": "q",
          "in": "query",
          "required": true,
          "description": "What the shopper has typed so far",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "q",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          "example": "eng"
        },
        {
          "name": "country",
          "in": "query",
          "required": false,
          "description": "ISO 3166-1 alpha-2 country code",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "country",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          "example": "US"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_SearchSuggestResponse, required: true },
          "example": example_suggestSearch_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_suggestSearch_400
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "503": {
          "description": "A dependency is unavailable",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {
            "q": "eng",
            "country": "US"
          },
          "headers": {}
        },
        "responses": {
          "200": example_suggestSearch_200,
          "400": example_suggestSearch_400
        }
      }
    },
    "searchProducts": {
      "id": "searchProducts",
      "slug": "search-products",
      "method": "GET",
      "path": "/storefront/v1/search",
      "tag": "catalog",
      "summary": "Full-text search with facets over the store's published products",
      "description": "Filters: `attr.<key>:value` (repeat a field for OR), `product_type:`, `tags:`, `collections:`, `in_stock:true`, `price_cents>=n` / `<=n`. Sort relevance, price_asc, price_desc, newest. Pages of up to 60. Prices follow the shopper's market like the catalog endpoints; facet values carry dictionary labels",
      "descriptionHtml": "<p>Filters: <code>attr.&lt;key&gt;:value</code> (repeat a field for OR), <code>product_type:</code>, <code>tags:</code>, <code>collections:</code>, <code>in_stock:true</code>, <code>price_cents&gt;=n</code> / <code>&lt;=n</code>. Sort relevance, price_asc, price_desc, newest. Pages of up to 60. Prices follow the shopper&#39;s market like the catalog endpoints; facet values carry dictionary labels</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": true,
      "parameters": [
        {
          "name": "q",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "q",
            "default": "",
            "constraints": {
              "maxLength": 200
            }
          },
          "example": "halo"
        },
        {
          "name": "filter",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "oneOf",
            "type": "oneOf",
            "required": false,
            "nullable": false,
            "name": "filter",
            "variants": [
              {
                "kind": "primitive",
                "type": "string",
                "required": false,
                "nullable": false,
                "example": "attr.metal:14k_yellow_gold",
                "constraints": {
                  "maxLength": 200,
                  "pattern": "^(product_type|tags|collections|in_stock|price_cents|fulfillment_mode|attr\\.[a-z][a-z0-9_]*)(:|>=|<=|>|<)[^\\s]{1,120}$"
                }
              },
              {
                "kind": "array",
                "type": "array",
                "required": false,
                "nullable": false,
                "constraints": {
                  "maxItems": 20
                },
                "items": {
                  "kind": "primitive",
                  "type": "string",
                  "required": false,
                  "nullable": false,
                  "example": "attr.metal:14k_yellow_gold",
                  "constraints": {
                    "maxLength": 200,
                    "pattern": "^(product_type|tags|collections|in_stock|price_cents|fulfillment_mode|attr\\.[a-z][a-z0-9_]*)(:|>=|<=|>|<)[^\\s]{1,120}$"
                  }
                }
              }
            ]
          }
        },
        {
          "name": "sort",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "sort",
            "default": "relevance",
            "enum": [
              "relevance",
              "price_asc",
              "price_desc",
              "newest"
            ]
          }
        },
        {
          "name": "page",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "page",
            "default": 1,
            "constraints": {
              "minimum": 1,
              "maximum": 100
            }
          }
        },
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 24,
            "constraints": {
              "minimum": 1,
              "maximum": 60
            }
          },
          "example": "2"
        },
        {
          "name": "country",
          "in": "query",
          "required": false,
          "description": "ISO 3166-1 alpha-2 country code",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "country",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          "example": "US"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontSearchResponse, required: true },
          "example": example_searchProducts_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "503": {
          "description": "A dependency is unavailable",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {
            "q": "halo",
            "limit": "2",
            "country": "US"
          },
          "headers": {}
        },
        "responses": {
          "200": example_searchProducts_200
        }
      }
    },
    "getProductAvailability": {
      "id": "getProductAvailability",
      "slug": "get-product-availability",
      "method": "GET",
      "path": "/storefront/v1/products/{handle}/availability",
      "tag": "catalog",
      "summary": "Stock and lead time per variant of a published product",
      "description": "Not cached: read it when the shopper picks a variant or opens the cart",
      "descriptionHtml": "<p>Not cached: read it when the shopper picks a variant or opens the cart</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "handle",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "handle",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          "example": "orbit-comfort-fit-band"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_VariantAvailability
              }
            ]
          },
          "example": example_getProductAvailability_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "handle": "orbit-comfort-fit-band"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getProductAvailability_200
        }
      }
    },
    "listShippingZones": {
      "id": "listShippingZones",
      "slug": "list-shipping-zones",
      "method": "GET",
      "path": "/storefront/v1/shipping/zones",
      "tag": "checkout",
      "summary": "Countries and regions the store ships to",
      "description": "One entry per shipping zone, in the store's order, without rates: enough for the address form to offer the right countries and regions. Rates come back on the checkout once it has an address",
      "descriptionHtml": "<p>One entry per shipping zone, in the store&#39;s order, without rates: enough for the address form to offer the right countries and regions. Rates come back on the checkout once it has an address</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "checkout:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_StorefrontShippingZone
              }
            ]
          },
          "example": example_listShippingZones_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_listShippingZones_200
        }
      }
    },
    "registerCustomer": {
      "id": "registerCustomer",
      "slug": "register-customer",
      "method": "POST",
      "path": "/storefront/v1/customers/register",
      "tag": "customers",
      "summary": "Create an account with email and password",
      "description": "A guest customer from an earlier order becomes the account. Answers with tokens; the storefront keeps them in memory or its own cookie. With X-Nucleus-Client the refresh token is set as the HttpOnly cookie nucleus_customer (path /storefront/v1/customers) and left out of the body",
      "descriptionHtml": "<p>A guest customer from an earlier order becomes the account. Answers with tokens; the storefront keeps them in memory or its own cookie. With X-Nucleus-Client the refresh token is set as the HttpOnly cookie nucleus_customer (path /storefront/v1/customers) and left out of the body</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": { ...schema_CustomerRegisterRequest, required: true },
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_CustomerTokenResponse, required: true },
          "example": example_registerCustomer_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_registerCustomer_409
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "email": "shopper@example.com",
            "password": "correct-horse-battery-9",
            "firstName": "Asha",
            "lastName": "Mehta",
            "acceptsMarketing": false
          }
        },
        "responses": {
          "201": example_registerCustomer_201,
          "409": example_registerCustomer_409
        }
      }
    },
    "loginCustomer": {
      "id": "loginCustomer",
      "slug": "login-customer",
      "method": "POST",
      "path": "/storefront/v1/customers/login",
      "tag": "customers",
      "summary": "Sign in with email and password",
      "description": "With X-Nucleus-Client the refresh token is set as the HttpOnly cookie nucleus_customer (path /storefront/v1/customers) and left out of the body",
      "descriptionHtml": "<p>With X-Nucleus-Client the refresh token is set as the HttpOnly cookie nucleus_customer (path /storefront/v1/customers) and left out of the body</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": { ...schema_CustomerLoginRequest, required: true },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_CustomerTokenResponse, required: true },
          "example": example_loginCustomer_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_loginCustomer_401
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "email": "shopper@example.com",
            "password": "correct-horse-battery-9"
          }
        },
        "responses": {
          "200": example_loginCustomer_200,
          "401": example_loginCustomer_401
        }
      }
    },
    "refreshCustomerSession": {
      "id": "refreshCustomerSession",
      "slug": "refresh-customer-session",
      "method": "POST",
      "path": "/storefront/v1/customers/refresh",
      "tag": "customers",
      "summary": "Exchange a refresh token for new tokens",
      "description": "The old refresh token is revoked. Presenting an already used token revokes the whole family. The token comes from the body, or from the nucleus_customer cookie when the body has none and X-Nucleus-Client is sent; the cookie is rotated with it. With X-Nucleus-Client the refresh token is set as the HttpOnly cookie nucleus_customer (path /storefront/v1/customers) and left out of the body",
      "descriptionHtml": "<p>The old refresh token is revoked. Presenting an already used token revokes the whole family. The token comes from the body, or from the nucleus_customer cookie when the body has none and X-Nucleus-Client is sent; the cookie is rotated with it. With X-Nucleus-Client the refresh token is set as the HttpOnly cookie nucleus_customer (path /storefront/v1/customers) and left out of the body</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "refreshToken",
            "description": "Omit when the browser holds the nucleus_customer cookie and sends X-Nucleus-Client",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_CustomerTokenResponse, required: true },
          "example": example_refreshCustomerSession_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "refreshToken": "<customerRefreshToken>"
          }
        },
        "responses": {
          "200": example_refreshCustomerSession_200
        }
      }
    },
    "logoutCustomer": {
      "id": "logoutCustomer",
      "slug": "logout-customer",
      "method": "POST",
      "path": "/storefront/v1/customers/logout",
      "tag": "customers",
      "summary": "End the session",
      "description": "With a refresh token (body, or the nucleus_customer cookie with X-Nucleus-Client), ends that session family; without one, every session of the customer. Clears the cookie",
      "descriptionHtml": "<p>With a refresh token (body, or the nucleus_customer cookie with X-Nucleus-Client), ends that session family; without one, every session of the customer. Clears the cookie</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "refreshToken",
            "description": "Omit to end only the current access token's session family when known",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          }
        ]
      },
      "responses": {
        "204": {
          "description": "Deleted",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "refreshToken": "<customerRefreshToken>"
          }
        },
        "responses": {}
      }
    },
    "forgotPassword": {
      "id": "forgotPassword",
      "slug": "forgot-password",
      "method": "POST",
      "path": "/storefront/v1/customers/password/forgot",
      "tag": "customers",
      "summary": "Email a password reset link",
      "description": "Always 202. The link points at resetUrl with ?token=; that URL must be on an origin registered on the key",
      "descriptionHtml": "<p>Always 202. The link points at resetUrl with ?token=; that URL must be on an origin registered on the key</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "email",
            "format": "email",
            "description": "Email address, stored lower-cased"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "resetUrl",
            "format": "uri",
            "description": "Storefront page that will receive ?token=; its origin must be registered on the publishable key"
          }
        ]
      },
      "responses": {
        "202": {
          "description": "Response",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "email": "shopper@example.com",
            "resetUrl": "https://docs.example/account/reset"
          }
        },
        "responses": {}
      }
    },
    "resetPassword": {
      "id": "resetPassword",
      "slug": "reset-password",
      "method": "POST",
      "path": "/storefront/v1/customers/password/reset",
      "tag": "customers",
      "summary": "Set a new password with a reset link; ends every session",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "password",
            "description": "12 to 200 characters",
            "example": "correct-horse-battery-staple",
            "constraints": {
              "minLength": 12,
              "maxLength": 200
            }
          }
        ]
      },
      "responses": {
        "204": {
          "description": "Deleted",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "token": "9qKMfsIGH54JWyOn6MhxSJ2akHApJMhSGHs7o9CN0_Q",
            "password": "a-brand-new-password-7"
          }
        },
        "responses": {}
      }
    },
    "startGoogleSignIn": {
      "id": "startGoogleSignIn",
      "slug": "start-google-sign-in",
      "method": "POST",
      "path": "/storefront/v1/customers/oauth/google/start",
      "tag": "customers",
      "summary": "Where to send the browser to sign in with Google",
      "description": "Answers Google's authorization URL. Google returns the browser to the API, which sends it on to `redirectUrl` with `?code=` (post it to /customers/oauth/google/complete within two minutes) or `?error=` (cancelled, GOOGLE_EMAIL_UNVERIFIED, ACCOUNT_INACTIVE, TOKEN_INVALID, SERVICE_UNAVAILABLE). 409 GOOGLE_SIGN_IN_UNAVAILABLE when the platform has no Google client; the store profile's signInProviders says so up front",
      "descriptionHtml": "<p>Answers Google&#39;s authorization URL. Google returns the browser to the API, which sends it on to <code>redirectUrl</code> with <code>?code=</code> (post it to /customers/oauth/google/complete within two minutes) or <code>?error=</code> (cancelled, GOOGLE_EMAIL_UNVERIFIED, ACCOUNT_INACTIVE, TOKEN_INVALID, SERVICE_UNAVAILABLE). 409 GOOGLE_SIGN_IN_UNAVAILABLE when the platform has no Google client; the store profile&#39;s signInProviders says so up front</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "redirectUrl",
            "format": "uri",
            "description": "Storefront page Google sign-in returns to with ?code= or ?error=; its origin must be registered on the publishable key"
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_CustomerGoogleStart, required: true },
          "example": example_startGoogleSignIn_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "redirectUrl": "https://docs.example/account/google"
          }
        },
        "responses": {
          "200": example_startGoogleSignIn_200
        }
      }
    },
    "completeGoogleSignIn": {
      "id": "completeGoogleSignIn",
      "slug": "complete-google-sign-in",
      "method": "POST",
      "path": "/storefront/v1/customers/oauth/google/complete",
      "tag": "customers",
      "summary": "Exchange the code from the Google return page for tokens",
      "description": "Answers like login. The code works once and only for the store that started the sign-in; 401 TOKEN_INVALID otherwise",
      "descriptionHtml": "<p>Answers like login. The code works once and only for the store that started the sign-in; 401 TOKEN_INVALID otherwise</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "code",
            "description": "The ?code= the return page received",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_CustomerTokenResponse, required: true },
          "example": example_completeGoogleSignIn_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "code": "QIY7qDLNZX8V2gaPXqagf_BHhMfIXZ-NCfJy8Gb5K4c"
          }
        },
        "responses": {
          "200": example_completeGoogleSignIn_200
        }
      }
    },
    "requestMagicLink": {
      "id": "requestMagicLink",
      "slug": "request-magic-link",
      "method": "POST",
      "path": "/storefront/v1/customers/magic-link",
      "tag": "customers",
      "summary": "Email a one-time sign-in link",
      "description": "Always 202. The link points at redirectUrl with ?token=; that URL must be on an origin registered on the key. Only existing customers get mail; a guest from an earlier order becomes an account when the link is verified",
      "descriptionHtml": "<p>Always 202. The link points at redirectUrl with ?token=; that URL must be on an origin registered on the key. Only existing customers get mail; a guest from an earlier order becomes an account when the link is verified</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "email",
            "format": "email",
            "description": "Email address, stored lower-cased"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "redirectUrl",
            "format": "uri",
            "description": "Storefront page that will receive ?token= and call /customers/magic-link/verify; its origin must be registered on the publishable key"
          }
        ]
      },
      "responses": {
        "202": {
          "description": "Response",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "email": "shopper@example.com",
            "redirectUrl": "https://docs.example/account"
          }
        },
        "responses": {}
      }
    },
    "verifyMagicLink": {
      "id": "verifyMagicLink",
      "slug": "verify-magic-link",
      "method": "POST",
      "path": "/storefront/v1/customers/magic-link/verify",
      "tag": "customers",
      "summary": "Exchange a magic link token for tokens",
      "description": "Single use; 401 TOKEN_INVALID when used twice, expired or issued for another store",
      "descriptionHtml": "<p>Single use; 401 TOKEN_INVALID when used twice, expired or issued for another store</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_CustomerTokenResponse, required: true },
          "example": example_verifyMagicLink_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_verifyMagicLink_401
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "token": "TNei1avsrMbO83q6fjD1ilsIHKTapcKGct_oFdc2zrI"
          }
        },
        "responses": {
          "200": example_verifyMagicLink_200,
          "401": example_verifyMagicLink_401
        }
      }
    },
    "getCustomerProfile": {
      "id": "getCustomerProfile",
      "slug": "get-customer-profile",
      "method": "GET",
      "path": "/storefront/v1/customers/me",
      "tag": "customers",
      "summary": "Profile of the signed-in customer",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_CustomerProfile, required: true },
          "example": example_getCustomerProfile_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getCustomerProfile_401
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getCustomerProfile_200,
          "401": example_getCustomerProfile_401
        }
      }
    },
    "updateCustomerProfile": {
      "id": "updateCustomerProfile",
      "slug": "update-customer-profile",
      "method": "PATCH",
      "path": "/storefront/v1/customers/me",
      "tag": "customers",
      "summary": "Update profile and preferences",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "firstName",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "lastName",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "phone",
            "example": "+14155550123",
            "constraints": {
              "pattern": "^\\+[1-9]\\d{6,14}$"
            }
          },
          {
            "kind": "primitive",
            "type": "boolean",
            "required": false,
            "nullable": false,
            "name": "acceptsMarketing"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "locale",
            "description": "BCP 47 language tag, language or language-REGION",
            "example": "en-US",
            "constraints": {
              "pattern": "^[a-z]{2}(?:-[A-Z]{2})?$"
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "currency",
            "description": "ISO 4217 currency code",
            "example": "USD",
            "constraints": {
              "pattern": "^[A-Z]{3}$"
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "savedRingSize",
            "constraints": {
              "maxLength": 20
            }
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_CustomerProfile, required: true },
          "example": example_updateCustomerProfile_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "phone": "+12125550100",
            "savedRingSize": "6",
            "acceptsMarketing": true
          }
        },
        "responses": {
          "200": example_updateCustomerProfile_200
        }
      }
    },
    "changeCustomerPassword": {
      "id": "changeCustomerPassword",
      "slug": "change-customer-password",
      "method": "POST",
      "path": "/storefront/v1/customers/me/password",
      "tag": "customers",
      "summary": "Change password",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "currentPassword",
            "constraints": {
              "minLength": 1,
              "maxLength": 200
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "newPassword",
            "description": "12 to 200 characters",
            "example": "correct-horse-battery-staple",
            "constraints": {
              "minLength": 12,
              "maxLength": 200
            }
          }
        ]
      },
      "responses": {
        "204": {
          "description": "Deleted",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "currentPassword": "correct-horse-battery-9",
            "newPassword": "correct-horse-battery-9-new"
          }
        },
        "responses": {}
      }
    },
    "listCustomerAddresses": {
      "id": "listCustomerAddresses",
      "slug": "list-customer-addresses",
      "method": "GET",
      "path": "/storefront/v1/customers/me/addresses",
      "tag": "customers",
      "summary": "Saved addresses, default shipping first",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_CustomerAddress
              }
            ]
          },
          "example": example_listCustomerAddresses_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_listCustomerAddresses_200
        }
      }
    },
    "createCustomerAddress": {
      "id": "createCustomerAddress",
      "slug": "create-customer-address",
      "method": "POST",
      "path": "/storefront/v1/customers/me/addresses",
      "tag": "customers",
      "summary": "Add an address; the first one becomes the default",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "label",
            "constraints": {
              "maxLength": 60
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "firstName",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "lastName",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "company",
            "constraints": {
              "maxLength": 120
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "line1",
            "constraints": {
              "minLength": 1,
              "maxLength": 200
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "line2",
            "constraints": {
              "maxLength": 200
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "city",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "region",
            "constraints": {
              "maxLength": 120
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "postalCode",
            "constraints": {
              "maxLength": 20
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "countryCode",
            "description": "ISO 3166-1 alpha-2 country code",
            "example": "US",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "phone",
            "example": "+14155550123",
            "constraints": {
              "pattern": "^\\+[1-9]\\d{6,14}$"
            }
          },
          {
            "kind": "primitive",
            "type": "boolean",
            "required": false,
            "nullable": false,
            "name": "isDefaultShipping"
          },
          {
            "kind": "primitive",
            "type": "boolean",
            "required": false,
            "nullable": false,
            "name": "isDefaultBilling"
          }
        ]
      },
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_CustomerAddress, required: true },
          "example": example_createCustomerAddress_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "label": "Home",
            "firstName": "Asha",
            "lastName": "Mehta",
            "line1": "350 Fifth Avenue",
            "city": "New York",
            "region": "NY",
            "postalCode": "10118",
            "countryCode": "US",
            "phone": "+12125550100",
            "isDefaultShipping": true,
            "isDefaultBilling": true
          }
        },
        "responses": {
          "201": example_createCustomerAddress_201
        }
      }
    },
    "updateCustomerAddress": {
      "id": "updateCustomerAddress",
      "slug": "update-customer-address",
      "method": "PATCH",
      "path": "/storefront/v1/customers/me/addresses/{id}",
      "tag": "customers",
      "summary": "Update an address or make it a default",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-6c29-7526-b3a5-6d25a9ec6f85"
        }
      ],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "label",
            "constraints": {
              "maxLength": 60
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "firstName",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "lastName",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "company",
            "constraints": {
              "maxLength": 120
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "line1",
            "constraints": {
              "minLength": 1,
              "maxLength": 200
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "line2",
            "constraints": {
              "maxLength": 200
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "city",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "region",
            "constraints": {
              "maxLength": 120
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "postalCode",
            "constraints": {
              "maxLength": 20
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "countryCode",
            "description": "ISO 3166-1 alpha-2 country code",
            "example": "US",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "phone",
            "example": "+14155550123",
            "constraints": {
              "pattern": "^\\+[1-9]\\d{6,14}$"
            }
          },
          {
            "kind": "primitive",
            "type": "boolean",
            "required": false,
            "nullable": false,
            "name": "isDefaultShipping"
          },
          {
            "kind": "primitive",
            "type": "boolean",
            "required": false,
            "nullable": false,
            "name": "isDefaultBilling"
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_CustomerAddress, required: true },
          "example": example_updateCustomerAddress_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-6c29-7526-b3a5-6d25a9ec6f85"
          },
          "query": {},
          "headers": {},
          "body": {
            "line2": "Suite 2100"
          }
        },
        "responses": {
          "200": example_updateCustomerAddress_200
        }
      }
    },
    "deleteCustomerAddress": {
      "id": "deleteCustomerAddress",
      "slug": "delete-customer-address",
      "method": "DELETE",
      "path": "/storefront/v1/customers/me/addresses/{id}",
      "tag": "customers",
      "summary": "Delete an address",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-6c5d-7a73-bb09-31ef6ea3431c"
        }
      ],
      "requestBody": null,
      "responses": {
        "204": {
          "description": "Deleted",
          "body": "empty",
          "schema": null
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": null,
        "responses": {}
      }
    },
    "getWishlist": {
      "id": "getWishlist",
      "slug": "get-wishlist",
      "method": "GET",
      "path": "/storefront/v1/customers/me/wishlist",
      "tag": "customers",
      "summary": "The shopper's wishlist with live product data",
      "description": "Created on first read. Items whose product left the store stay listed with product null and available false",
      "descriptionHtml": "<p>Created on first read. Items whose product left the store stay listed with product null and available false</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Wishlist, required: true },
          "example": example_getWishlist_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getWishlist_200
        }
      }
    },
    "updateWishlist": {
      "id": "updateWishlist",
      "slug": "update-wishlist",
      "method": "PATCH",
      "path": "/storefront/v1/customers/me/wishlist",
      "tag": "customers",
      "summary": "Rename the wishlist",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "name",
            "constraints": {
              "minLength": 1,
              "maxLength": 80
            }
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Wishlist, required: true },
          "example": example_updateWishlist_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "name": "Our wedding"
          }
        },
        "responses": {
          "200": example_updateWishlist_200
        }
      }
    },
    "addWishlistItem": {
      "id": "addWishlistItem",
      "slug": "add-wishlist-item",
      "method": "POST",
      "path": "/storefront/v1/customers/me/wishlist/items",
      "tag": "customers",
      "summary": "Save a product, optionally a variant with customizations",
      "description": "201 for a new item; saving the same product and variant again updates its customizations and answers 200",
      "descriptionHtml": "<p>201 for a new item; saving the same product and variant again updates its customizations and answers 200</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "productId",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "variantId",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "array",
            "type": "array",
            "required": false,
            "nullable": false,
            "name": "customizations",
            "default": [],
            "constraints": {
              "maxItems": 20
            },
            "items": {
              "kind": "object",
              "type": "object",
              "required": false,
              "nullable": false,
              "description": "A shopper's answer to one product customization",
              "properties": [
                {
                  "kind": "primitive",
                  "type": "string",
                  "required": true,
                  "nullable": false,
                  "name": "key",
                  "example": "ring_size",
                  "constraints": {
                    "minLength": 1,
                    "maxLength": 60
                  }
                },
                {
                  "kind": "oneOf",
                  "type": "oneOf",
                  "required": true,
                  "nullable": false,
                  "name": "value",
                  "example": "6.5",
                  "variants": [
                    {
                      "kind": "primitive",
                      "type": "string",
                      "required": false,
                      "nullable": false,
                      "constraints": {
                        "maxLength": 500
                      }
                    },
                    {
                      "kind": "primitive",
                      "type": "number",
                      "required": false,
                      "nullable": false
                    },
                    {
                      "kind": "primitive",
                      "type": "boolean",
                      "required": false,
                      "nullable": false
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_WishlistItem, required: true }
        },
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_WishlistItem, required: true },
          "example": example_addWishlistItem_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "productId": "01a16987-4cb5-7b24-bc8c-7b490bab1cc2"
          }
        },
        "responses": {
          "201": example_addWishlistItem_201
        }
      }
    },
    "removeWishlistItem": {
      "id": "removeWishlistItem",
      "slug": "remove-wishlist-item",
      "method": "DELETE",
      "path": "/storefront/v1/customers/me/wishlist/items/{id}",
      "tag": "customers",
      "summary": "Remove an item",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-6ce3-72a5-a0de-984bf919d080"
        }
      ],
      "requestBody": null,
      "responses": {
        "204": {
          "description": "Deleted",
          "body": "empty",
          "schema": null
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": null,
        "responses": {}
      }
    },
    "shareWishlist": {
      "id": "shareWishlist",
      "slug": "share-wishlist",
      "method": "POST",
      "path": "/storefront/v1/customers/me/wishlist/share",
      "tag": "customers",
      "summary": "Get a share token for the wishlist",
      "description": "Idempotent; the token stays until DELETE /customers/me/wishlist/share",
      "descriptionHtml": "<p>Idempotent; the token stays until DELETE /customers/me/wishlist/share</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Wishlist, required: true },
          "example": example_shareWishlist_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_shareWishlist_200
        }
      }
    },
    "unshareWishlist": {
      "id": "unshareWishlist",
      "slug": "unshare-wishlist",
      "method": "DELETE",
      "path": "/storefront/v1/customers/me/wishlist/share",
      "tag": "customers",
      "summary": "Stop sharing the wishlist",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Wishlist, required: true },
          "example": example_unshareWishlist_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_unshareWishlist_200
        }
      }
    },
    "getSharedWishlist": {
      "id": "getSharedWishlist",
      "slug": "get-shared-wishlist",
      "method": "GET",
      "path": "/storefront/v1/wishlists/{shareToken}",
      "tag": "customers",
      "summary": "A shared wishlist, no session needed",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "shareToken",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "shareToken",
            "constraints": {
              "minLength": 10,
              "maxLength": 80
            }
          },
          "example": "xWFhAGESxzCg4_7IEVJMQRRe"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_SharedWishlist, required: true },
          "example": example_getSharedWishlist_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getSharedWishlist_404
        }
      },
      "examples": {
        "request": {
          "params": {
            "shareToken": "xWFhAGESxzCg4_7IEVJMQRRe"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getSharedWishlist_200,
          "404": example_getSharedWishlist_404
        }
      }
    },
    "listPrivacyRequests": {
      "id": "listPrivacyRequests",
      "slug": "list-privacy-requests",
      "method": "GET",
      "path": "/storefront/v1/customers/me/privacy-requests",
      "tag": "customers",
      "summary": "Privacy requests of the shopper, newest first",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_PrivacyRequest
              }
            ]
          },
          "example": example_listPrivacyRequests_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_listPrivacyRequests_200
        }
      }
    },
    "createPrivacyRequest": {
      "id": "createPrivacyRequest",
      "slug": "create-privacy-request",
      "method": "POST",
      "path": "/storefront/v1/customers/me/privacy-requests",
      "tag": "customers",
      "summary": "Ask for a data export, account deletion or an opt-out of sale",
      "description": "export and delete wait for staff; do_not_sell completes at once. One open request per kind (409 ALREADY_EXISTS)",
      "descriptionHtml": "<p>export and delete wait for staff; do_not_sell completes at once. One open request per kind (409 ALREADY_EXISTS)</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          { ...schema_PrivacyRequestKindInput, required: true, name: "kind" }
        ]
      },
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_PrivacyRequest, required: true },
          "example": example_createPrivacyRequest_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "kind": "export"
          }
        },
        "responses": {
          "201": example_createPrivacyRequest_201
        }
      }
    },
    "downloadPrivacyExport": {
      "id": "downloadPrivacyExport",
      "slug": "download-privacy-export",
      "method": "GET",
      "path": "/storefront/v1/customers/me/privacy-requests/{id}/export",
      "tag": "customers",
      "summary": "Download the export bundle of a completed export request",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-6d5c-76c0-84c9-17ddfe793e98"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_PrivacyExportBundle, required: true },
          "example": example_downloadPrivacyExport_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_downloadPrivacyExport_409
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-6d5c-76c0-84c9-17ddfe793e98"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_downloadPrivacyExport_200,
          "409": example_downloadPrivacyExport_409
        }
      }
    },
    "createCart": {
      "id": "createCart",
      "slug": "create-cart",
      "method": "POST",
      "path": "/storefront/v1/carts",
      "tag": "cart",
      "summary": "Create a cart, optionally with lines",
      "description": "Returns the token the storefront keeps. A signed-in shopper's cart is attached to their account. 409 STORE_NOT_ACCEPTING_ORDERS while the store is draft or paused; every cart write answers the same",
      "descriptionHtml": "<p>Returns the token the storefront keeps. A signed-in shopper&#39;s cart is attached to their account. 409 STORE_NOT_ACCEPTING_ORDERS while the store is draft or paused; every cart write answers the same</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "cart:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "country",
            "description": "Picks the market and currency; defaults to the store default market",
            "example": "US",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "locale",
            "description": "BCP 47 language tag, language or language-REGION",
            "example": "en-US",
            "constraints": {
              "pattern": "^[a-z]{2}(?:-[A-Z]{2})?$"
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "email",
            "format": "email",
            "description": "Email address, stored lower-cased"
          },
          {
            "kind": "array",
            "type": "array",
            "required": false,
            "nullable": false,
            "name": "lines",
            "default": [],
            "constraints": {
              "maxItems": 50
            },
            "items": {
              "kind": "object",
              "type": "object",
              "required": false,
              "nullable": false,
              "properties": [
                {
                  "kind": "primitive",
                  "type": "string",
                  "required": true,
                  "nullable": false,
                  "name": "variantId",
                  "format": "uuid",
                  "description": "UUID v7",
                  "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
                },
                {
                  "kind": "primitive",
                  "type": "integer",
                  "required": false,
                  "nullable": false,
                  "name": "quantity",
                  "default": 1,
                  "constraints": {
                    "minimum": 1,
                    "maximum": 99
                  }
                },
                {
                  "kind": "array",
                  "type": "array",
                  "required": false,
                  "nullable": false,
                  "name": "customizations",
                  "default": [],
                  "constraints": {
                    "maxItems": 20
                  },
                  "items": {
                    "kind": "object",
                    "type": "object",
                    "required": false,
                    "nullable": false,
                    "description": "A shopper's answer to one product customization",
                    "properties": [
                      {
                        "kind": "primitive",
                        "type": "string",
                        "required": true,
                        "nullable": false,
                        "name": "key",
                        "example": "ring_size",
                        "constraints": {
                          "minLength": 1,
                          "maxLength": 60
                        }
                      },
                      {
                        "kind": "oneOf",
                        "type": "oneOf",
                        "required": true,
                        "nullable": false,
                        "name": "value",
                        "example": "6.5",
                        "variants": [
                          {
                            "kind": "primitive",
                            "type": "string",
                            "required": false,
                            "nullable": false,
                            "constraints": {
                              "maxLength": 500
                            }
                          },
                          {
                            "kind": "primitive",
                            "type": "number",
                            "required": false,
                            "nullable": false
                          },
                          {
                            "kind": "primitive",
                            "type": "boolean",
                            "required": false,
                            "nullable": false
                          }
                        ]
                      }
                    ]
                  }
                },
                {
                  "kind": "primitive",
                  "type": "string",
                  "required": false,
                  "nullable": true,
                  "name": "stoneId",
                  "format": "uuid",
                  "description": "A chosen diamond when the product is a configurator setting; forces quantity 1",
                  "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
                }
              ]
            }
          }
        ]
      },
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_Cart, required: true },
          "example": example_createCart_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_createCart_400
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "country": "US",
            "lines": [
              {
                "variantId": "01a16987-5105-7906-9884-95b7eafae1ac",
                "quantity": 1,
                "customizations": [
                  {
                    "key": "ring_size",
                    "value": "6"
                  }
                ]
              }
            ]
          }
        },
        "responses": {
          "201": example_createCart_201,
          "400": example_createCart_400
        }
      }
    },
    "getCart": {
      "id": "getCart",
      "slug": "get-cart",
      "method": "GET",
      "path": "/storefront/v1/carts/{token}",
      "tag": "cart",
      "summary": "Priced cart",
      "description": "Every line is re-priced from the current publication, store prices and stock; unavailable lines stay flagged",
      "descriptionHtml": "<p>Every line is re-priced from the current publication, store prices and stock; unavailable lines stay flagged</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "cart:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Cart, required: true },
          "example": example_getCart_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getCart_404
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getCart_200,
          "404": example_getCart_404
        }
      }
    },
    "updateCart": {
      "id": "updateCart",
      "slug": "update-cart",
      "method": "PATCH",
      "path": "/storefront/v1/carts/{token}",
      "tag": "cart",
      "summary": "Set email, locale, note attributes or switch country",
      "description": "`country` picks the market that lists it (else the default market) and re-prices every line in that market's currency; the catalog reads take the same value as `country` or X-Nucleus-Country",
      "descriptionHtml": "<p><code>country</code> picks the market that lists it (else the default market) and re-prices every line in that market&#39;s currency; the catalog reads take the same value as <code>country</code> or X-Nucleus-Country</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "cart:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF"
        }
      ],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "email",
            "format": "email",
            "description": "Email address, stored lower-cased"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "locale",
            "description": "BCP 47 language tag, language or language-REGION",
            "example": "en-US",
            "constraints": {
              "pattern": "^[a-z]{2}(?:-[A-Z]{2})?$"
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "country",
            "description": "Switches the market; every line is re-priced",
            "example": "US",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          {
            "kind": "object",
            "type": "object",
            "required": false,
            "nullable": false,
            "name": "attributes",
            "description": "Note attributes such as gift wrap or a delivery note",
            "additionalProperties": {
              "kind": "primitive",
              "type": "any",
              "required": false,
              "nullable": false
            }
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Cart, required: true },
          "example": example_updateCart_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF"
          },
          "query": {},
          "headers": {},
          "body": {
            "attributes": {
              "giftWrap": "yes",
              "deliveryNote": "Leave with the concierge"
            }
          }
        },
        "responses": {
          "200": example_updateCart_200
        }
      }
    },
    "addCartLine": {
      "id": "addCartLine",
      "slug": "add-cart-line",
      "method": "POST",
      "path": "/storefront/v1/carts/{token}/lines",
      "tag": "cart",
      "summary": "Add a line",
      "description": "Customizations are validated against the product's definitions; a line with the same variant and customizations merges",
      "descriptionHtml": "<p>Customizations are validated against the product&#39;s definitions; a line with the same variant and customizations merges</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "cart:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF"
        }
      ],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "variantId",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "quantity",
            "default": 1,
            "constraints": {
              "minimum": 1,
              "maximum": 99
            }
          },
          {
            "kind": "array",
            "type": "array",
            "required": false,
            "nullable": false,
            "name": "customizations",
            "default": [],
            "constraints": {
              "maxItems": 20
            },
            "items": {
              "kind": "object",
              "type": "object",
              "required": false,
              "nullable": false,
              "description": "A shopper's answer to one product customization",
              "properties": [
                {
                  "kind": "primitive",
                  "type": "string",
                  "required": true,
                  "nullable": false,
                  "name": "key",
                  "example": "ring_size",
                  "constraints": {
                    "minLength": 1,
                    "maxLength": 60
                  }
                },
                {
                  "kind": "oneOf",
                  "type": "oneOf",
                  "required": true,
                  "nullable": false,
                  "name": "value",
                  "example": "6.5",
                  "variants": [
                    {
                      "kind": "primitive",
                      "type": "string",
                      "required": false,
                      "nullable": false,
                      "constraints": {
                        "maxLength": 500
                      }
                    },
                    {
                      "kind": "primitive",
                      "type": "number",
                      "required": false,
                      "nullable": false
                    },
                    {
                      "kind": "primitive",
                      "type": "boolean",
                      "required": false,
                      "nullable": false
                    }
                  ]
                }
              ]
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "stoneId",
            "format": "uuid",
            "description": "A chosen diamond when the product is a configurator setting; forces quantity 1",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Cart, required: true },
          "example": example_addCartLine_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_addCartLine_422
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF"
          },
          "query": {},
          "headers": {},
          "body": {
            "variantId": "01a16987-55ab-7cbc-9da8-b71247ed8c19",
            "quantity": 1,
            "customizations": [
              {
                "key": "engraving",
                "value": "A & R"
              }
            ]
          }
        },
        "responses": {
          "200": example_addCartLine_200,
          "422": example_addCartLine_422
        }
      }
    },
    "updateCartLine": {
      "id": "updateCartLine",
      "slug": "update-cart-line",
      "method": "PATCH",
      "path": "/storefront/v1/carts/{token}/lines/{lineId}",
      "tag": "cart",
      "summary": "Change quantity or customizations; quantity 0 removes",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "cart:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF"
        },
        {
          "name": "lineId",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "lineId",
            "format": "uuid"
          },
          "example": "01a16987-68b1-7c3d-8320-f200e998ed3c"
        }
      ],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "quantity",
            "description": "0 removes the line",
            "constraints": {
              "minimum": 0,
              "maximum": 99
            }
          },
          {
            "kind": "array",
            "type": "array",
            "required": false,
            "nullable": false,
            "name": "customizations",
            "constraints": {
              "maxItems": 20
            },
            "items": {
              "kind": "object",
              "type": "object",
              "required": false,
              "nullable": false,
              "description": "A shopper's answer to one product customization",
              "properties": [
                {
                  "kind": "primitive",
                  "type": "string",
                  "required": true,
                  "nullable": false,
                  "name": "key",
                  "example": "ring_size",
                  "constraints": {
                    "minLength": 1,
                    "maxLength": 60
                  }
                },
                {
                  "kind": "oneOf",
                  "type": "oneOf",
                  "required": true,
                  "nullable": false,
                  "name": "value",
                  "example": "6.5",
                  "variants": [
                    {
                      "kind": "primitive",
                      "type": "string",
                      "required": false,
                      "nullable": false,
                      "constraints": {
                        "maxLength": 500
                      }
                    },
                    {
                      "kind": "primitive",
                      "type": "number",
                      "required": false,
                      "nullable": false
                    },
                    {
                      "kind": "primitive",
                      "type": "boolean",
                      "required": false,
                      "nullable": false
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Cart, required: true },
          "example": example_updateCartLine_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF",
            "lineId": "01a16987-68b1-7c3d-8320-f200e998ed3c"
          },
          "query": {},
          "headers": {},
          "body": {
            "quantity": 2
          }
        },
        "responses": {
          "200": example_updateCartLine_200
        }
      }
    },
    "removeCartLine": {
      "id": "removeCartLine",
      "slug": "remove-cart-line",
      "method": "DELETE",
      "path": "/storefront/v1/carts/{token}/lines/{lineId}",
      "tag": "cart",
      "summary": "Remove a line",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "cart:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF"
        },
        {
          "name": "lineId",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "lineId",
            "format": "uuid"
          },
          "example": "01a16987-6a3f-7fe2-930d-b2ca64af9093"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Cart, required: true },
          "example": example_removeCartLine_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF",
            "lineId": "01a16987-6a3f-7fe2-930d-b2ca64af9093"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_removeCartLine_200
        }
      }
    },
    "applyCartDiscount": {
      "id": "applyCartDiscount",
      "slug": "apply-cart-discount",
      "method": "POST",
      "path": "/storefront/v1/carts/{token}/discounts",
      "tag": "cart",
      "summary": "Apply a discount code",
      "description": "422 DISCOUNT_NOT_APPLICABLE with meta.reason (unknown, expired, conditions, does_not_combine, …) when the code does not work for this cart. Free-shipping codes are accepted here and take effect once a shipping rate is chosen",
      "descriptionHtml": "<p>422 DISCOUNT_NOT_APPLICABLE with meta.reason (unknown, expired, conditions, does_not_combine, …) when the code does not work for this cart. Free-shipping codes are accepted here and take effect once a shipping rate is chosen</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "cart:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF"
        }
      ],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "code",
            "description": "Case-insensitive",
            "constraints": {
              "minLength": 3,
              "maxLength": 40,
              "pattern": "^[A-Za-z0-9_-]+$"
            }
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Cart, required: true },
          "example": example_applyCartDiscount_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_applyCartDiscount_422
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF"
          },
          "query": {},
          "headers": {},
          "body": {
            "code": "WELCOME10"
          }
        },
        "responses": {
          "200": example_applyCartDiscount_200,
          "422": example_applyCartDiscount_422
        }
      }
    },
    "removeCartDiscount": {
      "id": "removeCartDiscount",
      "slug": "remove-cart-discount",
      "method": "DELETE",
      "path": "/storefront/v1/carts/{token}/discounts/{code}",
      "tag": "cart",
      "summary": "Remove an applied code",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "cart:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF"
        },
        {
          "name": "code",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "code",
            "constraints": {
              "minLength": 1,
              "maxLength": 40
            }
          },
          "example": "WELCOME10"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Cart, required: true },
          "example": example_removeCartDiscount_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF",
            "code": "WELCOME10"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_removeCartDiscount_200
        }
      }
    },
    "mergeCarts": {
      "id": "mergeCarts",
      "slug": "merge-carts",
      "method": "POST",
      "path": "/storefront/v1/carts/{token}/merge",
      "tag": "cart",
      "summary": "Attach the cart to the signed-in customer, folding in a guest cart",
      "description": "Call after login with the guest cart's token in the path (or a guestToken in the body). When the shopper already has an open cart on this store, the guest lines fold into it and that cart comes back; otherwise the guest cart becomes theirs. Same-signature lines add up and the guest token stops working",
      "descriptionHtml": "<p>Call after login with the guest cart&#39;s token in the path (or a guestToken in the body). When the shopper already has an open cart on this store, the guest lines fold into it and that cart comes back; otherwise the guest cart becomes theirs. Same-signature lines add up and the guest token stops working</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "cart:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "EOl1wwBEEOzeVvdw_eMqoXXSjz0pZlNw"
        }
      ],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "guestToken",
            "description": "The guest cart to fold into the customer's cart; omit to just claim the cart in the path",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Cart, required: true },
          "example": example_mergeCarts_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_mergeCarts_401
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "EOl1wwBEEOzeVvdw_eMqoXXSjz0pZlNw"
          },
          "query": {},
          "headers": {},
          "body": {
            "guestToken": "8Na-i4UlX0kqFQNzhl6qqdo3YbqNLPXF"
          }
        },
        "responses": {
          "200": example_mergeCarts_200,
          "401": example_mergeCarts_401
        }
      }
    },
    "getCustomerCart": {
      "id": "getCustomerCart",
      "slug": "get-customer-cart",
      "method": "GET",
      "path": "/storefront/v1/customers/me/cart",
      "tag": "cart",
      "summary": "The signed-in shopper's open cart",
      "description": "For a sign-in on a new device: the most recently used open cart on this store, re-priced; 404 when there is none. Fold a guest cart into it with POST /carts/{token}/merge",
      "descriptionHtml": "<p>For a sign-in on a new device: the most recently used open cart on this store, re-priced; 404 when there is none. Fold a guest cart into it with POST /carts/{token}/merge</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Cart, required: true },
          "example": example_getCustomerCart_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getCustomerCart_401
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getCustomerCart_200,
          "401": example_getCustomerCart_401
        }
      }
    },
    "uploadCustomerFile": {
      "id": "uploadCustomerFile",
      "slug": "upload-customer-file",
      "method": "POST",
      "path": "/storefront/v1/uploads",
      "tag": "uploads",
      "summary": "Upload a file for a file customization",
      "description": "Raw body with the file's Content-Type (image/jpeg, image/png, image/webp, image/heic, image/heif, application/pdf); the bytes are sniffed and must match. Guests may upload; a signed-in shopper's upload is recorded against them. The answer's token is the customization value for the cart line and expires with the upload unless an order takes it. 20 per minute per IP",
      "descriptionHtml": "<p>Raw body with the file&#39;s Content-Type (image/jpeg, image/png, image/webp, image/heic, image/heif, application/pdf); the bytes are sniffed and must match. Guests may upload; a signed-in shopper&#39;s upload is recorded against them. The answer&#39;s token is the customization value for the cart line and expires with the upload unless an order takes it. 20 per minute per IP</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "cart:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "filename",
          "in": "query",
          "required": true,
          "description": "The shopper's file name; path separators are stripped and the extension is kept only when it matches the detected type",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "filename",
            "constraints": {
              "minLength": 1,
              "maxLength": 255
            }
          },
          "example": "engraving-artwork.png"
        }
      ],
      "requestBody": null,
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_CustomerUpload, required: true },
          "example": example_uploadCustomerFile_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "413": {
          "description": "Request body exceeds the size limit",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "415": {
          "description": "Unsupported Content-Type",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {
            "filename": "engraving-artwork.png"
          },
          "headers": {}
        },
        "responses": {
          "201": example_uploadCustomerFile_201
        }
      }
    },
    "getCustomerUpload": {
      "id": "getCustomerUpload",
      "slug": "get-customer-upload",
      "method": "GET",
      "path": "/storefront/v1/uploads/{token}",
      "tag": "uploads",
      "summary": "Read an upload back with its token",
      "description": "The shopper's own preview. Images are served inline, PDFs as an attachment; never cached. 404 once expired or when the token belongs to another store",
      "descriptionHtml": "<p>The shopper&#39;s own preview. Images are served inline, PDFs as an attachment; never cached. 404 once expired or when the token belongs to another store</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "cart:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 80
            }
          },
          "example": "upl_EXAMPLEUPLOADTOKEN00000000000000"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "The file bytes",
          "body": "text",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "description": "The file bytes"
          },
          "example": example_getCustomerUpload_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getCustomerUpload_404
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "upl_EXAMPLEUPLOADTOKEN00000000000000"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getCustomerUpload_200,
          "404": example_getCustomerUpload_404
        }
      }
    },
    "listRegions": {
      "id": "listRegions",
      "slug": "list-regions",
      "method": "GET",
      "path": "/storefront/v1/regions/{country}",
      "tag": "checkout",
      "summary": "States, provinces or prefectures of a country for the address form",
      "description": "ISO 3166-2 codes with display names for the countries that have a list (US, CA, AU, GB, IN, MX, BR, IT, ES, JP). Addresses sent to the checkout must carry one of these codes in `region`; a typed name is accepted and normalized to its code. An empty list means `region` is free text for that country",
      "descriptionHtml": "<p>ISO 3166-2 codes with display names for the countries that have a list (US, CA, AU, GB, IN, MX, BR, IT, ES, JP). Addresses sent to the checkout must carry one of these codes in <code>region</code>; a typed name is accepted and normalized to its code. An empty list means <code>region</code> is free text for that country</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "checkout:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "country",
          "in": "path",
          "required": true,
          "description": "ISO 3166-1 alpha-2 country code",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "country",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          "example": "US"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontRegions, required: true },
          "example": example_listRegions_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_listRegions_400
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "country": "US"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_listRegions_200,
          "400": example_listRegions_400
        }
      }
    },
    "createCheckout": {
      "id": "createCheckout",
      "slug": "create-checkout",
      "method": "POST",
      "path": "/storefront/v1/checkouts",
      "tag": "checkout",
      "summary": "Start a checkout from a cart",
      "description": "Returns the open checkout of the cart when one exists. 409 STORE_NOT_ACCEPTING_ORDERS while the store is draft or paused; every checkout write answers the same",
      "descriptionHtml": "<p>Returns the open checkout of the cart when one exists. 409 STORE_NOT_ACCEPTING_ORDERS while the store is draft or paused; every checkout write answers the same</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "checkout:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "cartToken",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          }
        ]
      },
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_Checkout, required: true },
          "example": example_createCheckout_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_createCheckout_404
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "cartToken": "EOl1wwBEEOzeVvdw_eMqoXXSjz0pZlNw"
          }
        },
        "responses": {
          "201": example_createCheckout_201,
          "404": example_createCheckout_404
        }
      }
    },
    "getCheckout": {
      "id": "getCheckout",
      "slug": "get-checkout",
      "method": "GET",
      "path": "/storefront/v1/checkouts/{token}",
      "tag": "checkout",
      "summary": "Priced checkout with the shipping rates available for its address",
      "description": "Once the order is placed (by the confirm call or the webhook) status is completed and completedOrder names it; a client returning from a redirect payment polls this until then",
      "descriptionHtml": "<p>Once the order is placed (by the confirm call or the webhook) status is completed and completedOrder names it; a client returning from a redirect payment polls this until then</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "checkout:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Checkout, required: true },
          "example": example_getCheckout_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getCheckout_200
        }
      }
    },
    "updateCheckout": {
      "id": "updateCheckout",
      "slug": "update-checkout",
      "method": "PATCH",
      "path": "/storefront/v1/checkouts/{token}",
      "tag": "checkout",
      "summary": "Set contact, addresses, consent and the shipping rate",
      "description": "Changing the shipping address clears the chosen rate. The rate must be one of availableShippingRates. Address regions are normalized to ISO 3166-2 codes (GET /regions/{country}); an unknown or missing region for a country that has a list is 422 on shippingAddress.region. acceptsTerms records the time the shopper ticked the terms (required before payment when the store's checkout.requireTermsAcceptance is on); acceptsMarketing subscribes the email to the newsletter when the order is placed",
      "descriptionHtml": "<p>Changing the shipping address clears the chosen rate. The rate must be one of availableShippingRates. Address regions are normalized to ISO 3166-2 codes (GET /regions/{country}); an unknown or missing region for a country that has a list is 422 on shippingAddress.region. acceptsTerms records the time the shopper ticked the terms (required before payment when the store&#39;s checkout.requireTermsAcceptance is on); acceptsMarketing subscribes the email to the newsletter when the order is placed</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "checkout:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up"
        }
      ],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "email",
            "format": "email",
            "description": "Email address, stored lower-cased"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "phone",
            "constraints": {
              "maxLength": 40
            }
          },
          { ...schema_PostalAddressInput, name: "shippingAddress" },
          { ...schema_PostalAddressInput, nullable: true, name: "billingAddress", description: "Null means same as shipping" },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "shippingRateId",
            "format": "uuid",
            "description": "UUID v7",
            "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          {
            "kind": "primitive",
            "type": "boolean",
            "required": false,
            "nullable": false,
            "name": "acceptsMarketing",
            "description": "Subscribe the checkout email to the store newsletter when the order is placed"
          },
          {
            "kind": "primitive",
            "type": "boolean",
            "required": false,
            "nullable": false,
            "name": "acceptsTerms",
            "description": "The shopper ticked the terms; true records the time, false clears it"
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Checkout, required: true },
          "example": example_updateCheckout_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_updateCheckout_422
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up"
          },
          "query": {},
          "headers": {},
          "body": {
            "email": "shopper@example.com",
            "shippingAddress": {
              "firstName": "Asha",
              "lastName": "Mehta",
              "line1": "350 Fifth Avenue",
              "city": "New York",
              "region": "New York",
              "postalCode": "10118",
              "countryCode": "US",
              "phone": "+12125550100"
            },
            "billingAddress": null,
            "acceptsTerms": true,
            "acceptsMarketing": true
          }
        },
        "responses": {
          "200": example_updateCheckout_200,
          "422": example_updateCheckout_422
        }
      }
    },
    "listCheckoutPaymentMethods": {
      "id": "listCheckoutPaymentMethods",
      "slug": "list-checkout-payment-methods",
      "method": "GET",
      "path": "/storefront/v1/checkouts/{token}/payment-methods",
      "tag": "checkout",
      "summary": "Payment methods the store accepts for this checkout",
      "description": "Stripe appears once a provider account is connected; manual methods (D-031) are listed in the tenant's order with their fee and whether the total is within their limits",
      "descriptionHtml": "<p>Stripe appears once a provider account is connected; manual methods (D-031) are listed in the tenant&#39;s order with their fee and whether the total is within their limits</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "checkout:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_CheckoutPaymentMethod
              }
            ]
          },
          "example": example_listCheckoutPaymentMethods_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_listCheckoutPaymentMethods_200
        }
      }
    },
    "recoverCheckout": {
      "id": "recoverCheckout",
      "slug": "recover-checkout",
      "method": "GET",
      "path": "/storefront/v1/checkouts/recover/{recoveryToken}",
      "tag": "checkout",
      "summary": "Reopen an abandoned checkout from its recovery email",
      "description": "Returns the priced checkout with its token and pushes the expiry out; 409 once the order was placed",
      "descriptionHtml": "<p>Returns the priced checkout with its token and pushes the expiry out; 409 once the order was placed</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "checkout:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "recoveryToken",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "recoveryToken",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "hd1PjeUbWj_V690Aaf_OAmcoBSioCSsI"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Checkout, required: true },
          "example": example_recoverCheckout_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "recoveryToken": "hd1PjeUbWj_V690Aaf_OAmcoBSioCSsI"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_recoverCheckout_200
        }
      }
    },
    "applyCheckoutGiftCard": {
      "id": "applyCheckoutGiftCard",
      "slug": "apply-checkout-gift-card",
      "method": "POST",
      "path": "/storefront/v1/checkouts/{token}/gift-cards",
      "tag": "checkout",
      "summary": "Apply a gift card",
      "description": "The card is held on the checkout and covers as much of the total as its balance allows, in the order cards were added; 422 with meta.reason (unknown, disabled, expired, depleted, currency) when it cannot be used",
      "descriptionHtml": "<p>The card is held on the checkout and covers as much of the total as its balance allows, in the order cards were added; 422 with meta.reason (unknown, disabled, expired, depleted, currency) when it cannot be used</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "checkout:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up"
        }
      ],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "code",
            "description": "Case and dashes do not matter",
            "constraints": {
              "minLength": 8,
              "maxLength": 40
            }
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Checkout, required: true },
          "example": example_applyCheckoutGiftCard_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_applyCheckoutGiftCard_422
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up"
          },
          "query": {},
          "headers": {},
          "body": {
            "code": "T3UP-GBGP-N3VG-GTQ6"
          }
        },
        "responses": {
          "200": example_applyCheckoutGiftCard_200,
          "422": example_applyCheckoutGiftCard_422
        }
      }
    },
    "removeCheckoutGiftCard": {
      "id": "removeCheckoutGiftCard",
      "slug": "remove-checkout-gift-card",
      "method": "DELETE",
      "path": "/storefront/v1/checkouts/{token}/gift-cards/{last4}",
      "tag": "checkout",
      "summary": "Remove an applied gift card",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "checkout:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up"
        },
        {
          "name": "last4",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "last4",
            "constraints": {
              "minLength": 4,
              "maxLength": 4
            }
          },
          "example": "GTQ6"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Checkout, required: true },
          "example": example_removeCheckoutGiftCard_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up",
            "last4": "GTQ6"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_removeCheckoutGiftCard_200
        }
      }
    },
    "createPaymentIntent": {
      "id": "createPaymentIntent",
      "slug": "create-payment-intent",
      "method": "POST",
      "path": "/storefront/v1/checkouts/{token}/payment-intent",
      "tag": "checkout",
      "summary": "Create or refresh the Stripe PaymentIntent for the balance due",
      "description": "Mount the Payment Element with the client secret, confirm it in the browser, then POST /checkouts/{token}/payment with type stripe and the intent id. Re-priced on every call. When the checkout's current intent was already paid for the amount due (the browser came back from a redirect payment before the webhook), the order is placed and `{ status: \"completed\", orderId, order }` comes back instead of a client secret; a paid intent for another amount is refunded and replaced. 409 with blockers while the checkout is incomplete, 422 TERMS_NOT_ACCEPTED when the store requires the terms and they are not ticked, 409 PAYMENT_PROVIDER_UNAVAILABLE when the store has no Stripe account",
      "descriptionHtml": "<p>Mount the Payment Element with the client secret, confirm it in the browser, then POST /checkouts/{token}/payment with type stripe and the intent id. Re-priced on every call. When the checkout&#39;s current intent was already paid for the amount due (the browser came back from a redirect payment before the webhook), the order is placed and <code>{ status: &quot;completed&quot;, orderId, order }</code> comes back instead of a client secret; a paid intent for another amount is refunded and replaced. 409 with blockers while the checkout is incomplete, 422 TERMS_NOT_ACCEPTED when the store requires the terms and they are not ticked, 409 PAYMENT_PROVIDER_UNAVAILABLE when the store has no Stripe account</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "checkout:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "oneOf",
            "type": "oneOf",
            "required": true,
            "nullable": false,
            "description": "OK",
            "variants": [
              schema_PaymentIntentResponse,
              schema_PaymentIntentCompleted
            ]
          },
          "example": example_createPaymentIntent_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_createPaymentIntent_200
        }
      }
    },
    "completeCheckout": {
      "id": "completeCheckout",
      "slug": "complete-checkout",
      "method": "POST",
      "path": "/storefront/v1/checkouts/{token}/payment",
      "tag": "checkout",
      "summary": "Place the order: a manual method places it unpaid, gift cards settle it at once, a confirmed Stripe intent places it paid (or authorized for design approval)",
      "description": "Idempotent: a completed checkout returns its order again. Applied gift cards are redeemed first; `gift_card` alone is accepted only when they cover the whole total. For `stripe`, pass the intent from /payment-intent after the Payment Element confirmed it; 409 PAYMENT_NOT_COMPLETED with meta.status while it is still processing or failed, in which case the webhook completes the order later. 422 TERMS_NOT_ACCEPTED for a manual or gift-card placement when the store requires the terms and they are not ticked",
      "descriptionHtml": "<p>Idempotent: a completed checkout returns its order again. Applied gift cards are redeemed first; <code>gift_card</code> alone is accepted only when they cover the whole total. For <code>stripe</code>, pass the intent from /payment-intent after the Payment Element confirmed it; 409 PAYMENT_NOT_COMPLETED with meta.status while it is still processing or failed, in which case the webhook completes the order later. 422 TERMS_NOT_ACCEPTED for a manual or gift-card placement when the store requires the terms and they are not ticked</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "checkout:write",
      "customerToken": false,
      "idempotent": true,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          },
          "example": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up"
        },
        {
          "name": "idempotency-key",
          "in": "header",
          "required": true,
          "description": "Client-generated key, 1 to 255 URL-safe characters. Repeating the request with the same key and body replays the stored response instead of running again",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "idempotency-key"
          }
        }
      ],
      "requestBody": { ...schema_StartPaymentRequest, required: true },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_PlacedOrder, required: true },
          "example": example_completeCheckout_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "X8PPBP8MQK1yeI3oNtY6w-tpQyQ0O0up"
          },
          "query": {},
          "headers": {},
          "body": {
            "type": "stripe",
            "paymentIntentId": "pi_dev_e5337a66d97646ea911f31c4e667c5eb"
          }
        },
        "responses": {
          "200": example_completeCheckout_200
        }
      }
    },
    "subscribeNewsletter": {
      "id": "subscribeNewsletter",
      "slug": "subscribe-newsletter",
      "method": "POST",
      "path": "/storefront/v1/newsletter/subscribe",
      "tag": "customers",
      "summary": "Sign an email up for the store newsletter (double opt-in)",
      "description": "Always 202. A confirmation email (template newsletter.confirm) carries a link to confirmUrl with ?token=, valid 48 hours; the address is subscribed once POST /newsletter/confirm receives the token. An address that is already subscribed gets no email. Limited to 10 a minute per IP and 5 a day per email (429 RATE_LIMITED); 409 STORE_NOT_ACCEPTING_ORDERS while the store is draft or paused; 422 STORE_LINK_UNAVAILABLE when no confirmUrl is given and the store has neither a primary domain nor checkout.customerLinkUrlTemplate",
      "descriptionHtml": "<p>Always 202. A confirmation email (template newsletter.confirm) carries a link to confirmUrl with ?token=, valid 48 hours; the address is subscribed once POST /newsletter/confirm receives the token. An address that is already subscribed gets no email. Limited to 10 a minute per IP and 5 a day per email (429 RATE_LIMITED); 409 STORE_NOT_ACCEPTING_ORDERS while the store is draft or paused; 422 STORE_LINK_UNAVAILABLE when no confirmUrl is given and the store has neither a primary domain nor checkout.customerLinkUrlTemplate</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "email",
            "format": "email",
            "description": "Email address, stored lower-cased"
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "source",
            "description": "Where the form lives (footer, popup, blog); stored as given",
            "constraints": {
              "minLength": 1,
              "maxLength": 60
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "confirmUrl",
            "format": "uri",
            "description": "Page that receives ?token= and posts it to /newsletter/confirm; must be on an origin registered on the key. Defaults to the store's customer link template or https://<primaryDomain>/newsletter/confirm",
            "constraints": {
              "maxLength": 500
            }
          }
        ]
      },
      "responses": {
        "202": {
          "description": "Response",
          "body": "json",
          "schema": { ...schema_NewsletterReceived, required: true },
          "example": example_subscribeNewsletter_202
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "email": "news@example.com",
            "source": "footer"
          }
        },
        "responses": {
          "202": example_subscribeNewsletter_202
        }
      }
    },
    "confirmNewsletter": {
      "id": "confirmNewsletter",
      "slug": "confirm-newsletter",
      "method": "POST",
      "path": "/storefront/v1/newsletter/confirm",
      "tag": "customers",
      "summary": "Confirm a sign-up with the emailed token",
      "description": "Idempotent: an already confirmed token answers 200 again. 404 for an unknown token, 401 TOKEN_EXPIRED after 48 hours",
      "descriptionHtml": "<p>Idempotent: an already confirmed token answers 200 again. 404 for an unknown token, 401 TOKEN_EXPIRED after 48 hours</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_NewsletterSubscription, required: true },
          "example": example_confirmNewsletter_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_confirmNewsletter_404
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "token": "nl_EXAMPLETOKEN0000000000000000000"
          }
        },
        "responses": {
          "200": example_confirmNewsletter_200,
          "404": example_confirmNewsletter_404
        }
      }
    },
    "unsubscribeNewsletter": {
      "id": "unsubscribeNewsletter",
      "slug": "unsubscribe-newsletter",
      "method": "POST",
      "path": "/storefront/v1/newsletter/unsubscribe",
      "tag": "customers",
      "summary": "Unsubscribe with the token from any mailing",
      "description": "The token never expires for this call; idempotent",
      "descriptionHtml": "<p>The token never expires for this call; idempotent</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 200
            }
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_NewsletterSubscription, required: true },
          "example": example_unsubscribeNewsletter_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_unsubscribeNewsletter_404
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "token": "nl_EXAMPLETOKEN0000000000000000000"
          }
        },
        "responses": {
          "200": example_unsubscribeNewsletter_200,
          "404": example_unsubscribeNewsletter_404
        }
      }
    },
    "listAuctions": {
      "id": "listAuctions",
      "slug": "list-auctions",
      "method": "GET",
      "path": "/storefront/v1/auctions",
      "tag": "auctions",
      "summary": "Live and upcoming auctions, soonest ending first",
      "description": "Only lots whose store product is published. Prices are in the store currency whatever the shopper's market; approximatePrice shows the current price in the market currency of `country` (or X-Nucleus-Country) for display",
      "descriptionHtml": "<p>Only lots whose store product is published. Prices are in the store currency whatever the shopper&#39;s market; approximatePrice shows the current price in the market currency of <code>country</code> (or X-Nucleus-Country) for display</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": true,
      "parameters": [
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "Page size, 1 to 100",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 20,
            "constraints": {
              "minimum": 1,
              "maximum": 100
            }
          },
          "example": "10"
        },
        {
          "name": "cursor",
          "in": "query",
          "required": false,
          "description": "Opaque cursor taken from nextCursor of the previous page",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cursor",
            "constraints": {
              "maxLength": 200
            }
          }
        },
        {
          "name": "country",
          "in": "query",
          "required": false,
          "description": "Shopper country, for approximatePrice in that market's currency; the X-Nucleus-Country header does the same",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "country",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          "example": "US"
        },
        {
          "name": "status",
          "in": "query",
          "required": false,
          "description": "Live and upcoming by default, soonest ending first; ended lists past results, latest first",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "status",
            "enum": [
              "live",
              "scheduled",
              "ended"
            ]
          }
        },
        {
          "name": "endingWithinHours",
          "in": "query",
          "required": false,
          "description": "Only live auctions ending within this many hours (an ending-soon list); implies status live",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "endingWithinHours",
            "constraints": {
              "minimum": 1,
              "maximum": 168
            }
          }
        },
        {
          "name": "saleId",
          "in": "query",
          "required": false,
          "description": "Only the lots of one sale",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "saleId",
            "format": "uuid"
          },
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "name": "category",
          "in": "query",
          "required": false,
          "description": "Only lots whose product type has this slug (watch, handbag, sneaker, collectible, jewelry)",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "category",
            "constraints": {
              "maxLength": 120
            }
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_StorefrontAuctionSummary
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": true,
                "name": "nextCursor",
                "description": "Cursor for the next page, null on the last page"
              }
            ]
          },
          "example": example_listAuctions_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_listAuctions_400
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {
            "limit": "10",
            "country": "US",
            "saleId": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          "headers": {}
        },
        "responses": {
          "200": example_listAuctions_200,
          "400": example_listAuctions_400
        }
      }
    },
    "getAuctionTerms": {
      "id": "getAuctionTerms",
      "slug": "get-auction-terms",
      "method": "GET",
      "path": "/storefront/v1/auctions/terms",
      "tag": "auctions",
      "summary": "The auction terms a shopper accepts to register",
      "description": "The store's published `auction` policy, else the standard terms (won lots are final sale except a lot not as described or not authentic). With X-Customer-Token also the shopper's registration",
      "descriptionHtml": "<p>The store&#39;s published <code>auction</code> policy, else the standard terms (won lots are final sale except a lot not as described or not authentic). With X-Customer-Token also the shopper&#39;s registration</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_AuctionTerms, required: true },
          "example": example_getAuctionTerms_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getAuctionTerms_200
        }
      }
    },
    "registerForAuctions": {
      "id": "registerForAuctions",
      "slug": "register-for-auctions",
      "method": "POST",
      "path": "/storefront/v1/auctions/register",
      "tag": "auctions",
      "summary": "Register the signed-in shopper to bid in this store",
      "description": "Accepts the terms of termsVersion from GET /auctions/terms: 201 the first time, 200 when re-accepting newer terms. 409 AUCTION_TERMS_CHANGED with meta.version when the terms moved on; 403 BIDDER_IS_STAFF for staff of the organization; 409 STORE_NOT_ACCEPTING_ORDERS while the store is draft or paused",
      "descriptionHtml": "<p>Accepts the terms of termsVersion from GET /auctions/terms: 201 the first time, 200 when re-accepting newer terms. 409 AUCTION_TERMS_CHANGED with meta.version when the terms moved on; 403 BIDDER_IS_STAFF for staff of the organization; 409 STORE_NOT_ACCEPTING_ORDERS while the store is draft or paused</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "auctions:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "enum",
            "type": "boolean",
            "required": true,
            "nullable": false,
            "name": "acceptTerms",
            "description": "The shopper ticked that they accept the auction terms",
            "enum": [
              true
            ]
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "termsVersion",
            "description": "The version from GET /auctions/terms the shopper read",
            "constraints": {
              "minLength": 1,
              "maxLength": 100
            }
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_AuctionRegistrationStatus, required: true }
        },
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_AuctionRegistrationStatus, required: true },
          "example": example_registerForAuctions_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_registerForAuctions_409
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "acceptTerms": true,
            "termsVersion": "default-9f1e551a447d"
          }
        },
        "responses": {
          "201": example_registerForAuctions_201,
          "409": example_registerForAuctions_409
        }
      }
    },
    "getAuction": {
      "id": "getAuction",
      "slug": "get-auction",
      "method": "GET",
      "path": "/storefront/v1/auctions/{id}",
      "tag": "auctions",
      "summary": "One auction as the bid panel shows it",
      "description": "Current price, next minimum bid, bid count, the latest bids with masked bidders, endsAt and serverTime (count down against it), whether a reserve exists and is met (never the amount), and the lot details: estimate, condition with the store's label, report, authentication, provenance, accessories, essay, plus badges. With X-Customer-Token also the viewer's registration, state and own maximum. Poll with If-None-Match: the ETag ignores serverTime, so an unchanged auction answers 304. Draft auctions and unpublished lots are 404",
      "descriptionHtml": "<p>Current price, next minimum bid, bid count, the latest bids with masked bidders, endsAt and serverTime (count down against it), whether a reserve exists and is met (never the amount), and the lot details: estimate, condition with the store&#39;s label, report, authentication, provenance, accessories, essay, plus badges. With X-Customer-Token also the viewer&#39;s registration, state and own maximum. Poll with If-None-Match: the ETag ignores serverTime, so an unchanged auction answers 304. Draft auctions and unpublished lots are 404</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": true,
      "parameters": [
        {
          "name": "country",
          "in": "query",
          "required": false,
          "description": "Shopper country, for approximatePrice in that market's currency; the X-Nucleus-Country header does the same",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "country",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          "example": "US"
        },
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-7ab4-7291-b92e-645c753b7400"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontAuction, required: true },
          "example": example_getAuction_200
        },
        "304": {
          "description": "Response",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getAuction_404
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-7ab4-7291-b92e-645c753b7400"
          },
          "query": {
            "country": "US"
          },
          "headers": {}
        },
        "responses": {
          "200": example_getAuction_200,
          "404": example_getAuction_404
        }
      }
    },
    "placeAuctionBid": {
      "id": "placeAuctionBid",
      "slug": "place-auction-bid",
      "method": "POST",
      "path": "/storefront/v1/auctions/{id}/bids",
      "tag": "auctions",
      "summary": "Bid a single amount, or set a proxy maximum",
      "description": "Exactly one of amount or maxAmount, at least nextMinimumBid (422 BID_TOO_LOW with meta.minimum). A maximum bids for the shopper one increment at a time, only as far as needed; equal maximums go to whoever set theirs first. A leader may only raise their own maximum. A bid that moves the price or the leader inside the anti-sniping window extends the end. 403 AUCTION_REGISTRATION_REQUIRED, BIDDER_BLOCKED or BIDDER_IS_STAFF; 409 AUCTION_NOT_LIVE; 409 STORE_NOT_ACCEPTING_ORDERS while the store is draft or paused. Send Idempotency-Key to retry safely. 20 bids a minute per shopper (429)",
      "descriptionHtml": "<p>Exactly one of amount or maxAmount, at least nextMinimumBid (422 BID_TOO_LOW with meta.minimum). A maximum bids for the shopper one increment at a time, only as far as needed; equal maximums go to whoever set theirs first. A leader may only raise their own maximum. A bid that moves the price or the leader inside the anti-sniping window extends the end. 403 AUCTION_REGISTRATION_REQUIRED, BIDDER_BLOCKED or BIDDER_IS_STAFF; 409 AUCTION_NOT_LIVE; 409 STORE_NOT_ACCEPTING_ORDERS while the store is draft or paused. Send Idempotency-Key to retry safely. 20 bids a minute per shopper (429)</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "auctions:write",
      "customerToken": true,
      "idempotent": true,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-7ab4-7291-b92e-645c753b7400"
        },
        {
          "name": "idempotency-key",
          "in": "header",
          "required": true,
          "description": "Client-generated key, 1 to 255 URL-safe characters. Repeating the request with the same key and body replays the stored response instead of running again",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "idempotency-key"
          }
        }
      ],
      "requestBody": {
        "kind": "oneOf",
        "type": "oneOf",
        "required": true,
        "nullable": false,
        "description": "Exactly one of amount or maxAmount, in the store currency",
        "variants": [
          {
            "kind": "object",
            "type": "object",
            "required": false,
            "nullable": false,
            "properties": [
              { ...schema_MoneyInput, required: true, name: "amount" }
            ]
          },
          {
            "kind": "object",
            "type": "object",
            "required": false,
            "nullable": false,
            "properties": [
              { ...schema_MoneyInput, required: true, name: "maxAmount" }
            ]
          }
        ]
      },
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_PlaceBidResponse, required: true },
          "example": example_placeAuctionBid_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_placeAuctionBid_422
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-7ab4-7291-b92e-645c753b7400"
          },
          "query": {},
          "headers": {},
          "body": {
            "maxAmount": {
              "amount": 250000,
              "currency": "USD"
            }
          }
        },
        "responses": {
          "201": example_placeAuctionBid_201,
          "422": example_placeAuctionBid_422
        }
      }
    },
    "listMyAuctions": {
      "id": "listMyAuctions",
      "slug": "list-my-auctions",
      "method": "GET",
      "path": "/storefront/v1/customers/me/auctions",
      "tag": "auctions",
      "summary": "Auctions the shopper bid on, latest activity first",
      "description": "State per auction: leading, outbid, won (with the order), lost, reserve_not_met or cancelled",
      "descriptionHtml": "<p>State per auction: leading, outbid, won (with the order), lost, reserve_not_met or cancelled</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "Page size, 1 to 100",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 20,
            "constraints": {
              "minimum": 1,
              "maximum": 100
            }
          }
        },
        {
          "name": "cursor",
          "in": "query",
          "required": false,
          "description": "Opaque cursor taken from nextCursor of the previous page",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cursor",
            "constraints": {
              "maxLength": 200
            }
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_MyAuction
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": true,
                "name": "nextCursor",
                "description": "Cursor for the next page, null on the last page"
              }
            ]
          },
          "example": example_listMyAuctions_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_listMyAuctions_401
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_listMyAuctions_200,
          "401": example_listMyAuctions_401
        }
      }
    },
    "buyAuctionNow": {
      "id": "buyAuctionNow",
      "slug": "buy-auction-now",
      "method": "POST",
      "path": "/storefront/v1/auctions/{id}/buy-now",
      "tag": "auctions",
      "summary": "Buy the lot now at the buy-now price",
      "description": "Ends the auction at once and places the shopper's order unpaid, like a won lot. Available while the auction is live and nobody has bid, or with a reserve until the reserve is met (buyNowPrice is then present). Send the price shown: 409 AUCTION_BUY_NOW_UNAVAILABLE with meta.buyNowPrice when it no longer applies; 409 AUCTION_NOT_LIVE; 403 AUCTION_REGISTRATION_REQUIRED, BIDDER_BLOCKED or BIDDER_IS_STAFF. Send Idempotency-Key to retry safely",
      "descriptionHtml": "<p>Ends the auction at once and places the shopper&#39;s order unpaid, like a won lot. Available while the auction is live and nobody has bid, or with a reserve until the reserve is met (buyNowPrice is then present). Send the price shown: 409 AUCTION_BUY_NOW_UNAVAILABLE with meta.buyNowPrice when it no longer applies; 409 AUCTION_NOT_LIVE; 403 AUCTION_REGISTRATION_REQUIRED, BIDDER_BLOCKED or BIDDER_IS_STAFF. Send Idempotency-Key to retry safely</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "auctions:write",
      "customerToken": true,
      "idempotent": true,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a15332-5a36-7d56-a629-0c0f8a41ffad"
        },
        {
          "name": "idempotency-key",
          "in": "header",
          "required": true,
          "description": "Client-generated key, 1 to 255 URL-safe characters. Repeating the request with the same key and body replays the stored response instead of running again",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "idempotency-key"
          }
        }
      ],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          { ...schema_MoneyInput, required: true, name: "price" }
        ]
      },
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_BuyNowResponse, required: true },
          "example": example_buyAuctionNow_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a15332-5a36-7d56-a629-0c0f8a41ffad"
          },
          "query": {},
          "headers": {},
          "body": {
            "price": {
              "amount": 450000,
              "currency": "USD"
            }
          }
        },
        "responses": {
          "201": example_buyAuctionNow_201
        }
      }
    },
    "watchAuction": {
      "id": "watchAuction",
      "slug": "watch-auction",
      "method": "POST",
      "path": "/storefront/v1/auctions/{id}/watch",
      "tag": "auctions",
      "summary": "Watch a scheduled or live lot",
      "description": "201 the first time, 200 when already watching. Watchers hear by email and push when the lot enters its last hour. A sign-in is enough; bidding needs registration. 409 AUCTION_NOT_LIVE for an ended or canceled lot",
      "descriptionHtml": "<p>201 the first time, 200 when already watching. Watchers hear by email and push when the lot enters its last hour. A sign-in is enough; bidding needs registration. 409 AUCTION_NOT_LIVE for an ended or canceled lot</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "auctions:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a15332-5a36-7d56-a629-0c0f8a41ffad"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_AuctionWatch, required: true }
        },
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_AuctionWatch, required: true },
          "example": example_watchAuction_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a15332-5a36-7d56-a629-0c0f8a41ffad"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "201": example_watchAuction_201
        }
      }
    },
    "unwatchAuction": {
      "id": "unwatchAuction",
      "slug": "unwatch-auction",
      "method": "DELETE",
      "path": "/storefront/v1/auctions/{id}/watch",
      "tag": "auctions",
      "summary": "Stop watching a lot",
      "description": "Idempotent",
      "descriptionHtml": "<p>Idempotent</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "auctions:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a15332-5a36-7d56-a629-0c0f8a41ffad"
        }
      ],
      "requestBody": null,
      "responses": {
        "204": {
          "description": "Deleted",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": null,
        "responses": {}
      }
    },
    "listWatchedAuctions": {
      "id": "listWatchedAuctions",
      "slug": "list-watched-auctions",
      "method": "GET",
      "path": "/storefront/v1/customers/me/auctions/watching",
      "tag": "auctions",
      "summary": "Lots the shopper watches, newest first",
      "description": "Ended lots stay in the list with their status until unwatched",
      "descriptionHtml": "<p>Ended lots stay in the list with their status until unwatched</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "Page size, 1 to 100",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 20,
            "constraints": {
              "minimum": 1,
              "maximum": 100
            }
          }
        },
        {
          "name": "cursor",
          "in": "query",
          "required": false,
          "description": "Opaque cursor taken from nextCursor of the previous page",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cursor",
            "constraints": {
              "maxLength": 200
            }
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_WatchedAuction
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": true,
                "name": "nextCursor",
                "description": "Cursor for the next page, null on the last page"
              }
            ]
          },
          "example": example_listWatchedAuctions_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_listWatchedAuctions_200
        }
      }
    },
    "getAuctionOffer": {
      "id": "getAuctionOffer",
      "slug": "get-auction-offer",
      "method": "GET",
      "path": "/storefront/v1/auctions/offers/{token}",
      "tag": "auctions",
      "summary": "A second-chance offer from its email link",
      "description": "The lot, the price with any buyer's premium, the deadline and the status (a pending offer past its deadline reads as expired). The link is the credential; no sign-in needed",
      "descriptionHtml": "<p>The lot, the price with any buyer&#39;s premium, the deadline and the status (a pending offer past its deadline reads as expired). The link is the credential; no sign-in needed</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "From the offer email link",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 96
            }
          },
          "example": "01a15340-1c2d-7e3f-8a4b-5c6d7e8f9a0b.Qm9vYmlkZXJTZWNvbmRDaGFuY2VTaWdu"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontAuctionOffer, required: true },
          "example": example_getAuctionOffer_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "01a15340-1c2d-7e3f-8a4b-5c6d7e8f9a0b.Qm9vYmlkZXJTZWNvbmRDaGFuY2VTaWdu"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getAuctionOffer_200
        }
      }
    },
    "acceptAuctionOffer": {
      "id": "acceptAuctionOffer",
      "slug": "accept-auction-offer",
      "method": "POST",
      "path": "/storefront/v1/auctions/offers/{token}/accept",
      "tag": "auctions",
      "summary": "Accept a second-chance offer",
      "description": "Places the shopper's order for the lot at the offered price, unpaid like a won lot. 409 AUCTION_OFFER_UNAVAILABLE when it expired, was answered, withdrawn or the lot sold; 409 STORE_NOT_ACCEPTING_ORDERS while the store is draft or paused",
      "descriptionHtml": "<p>Places the shopper&#39;s order for the lot at the offered price, unpaid like a won lot. 409 AUCTION_OFFER_UNAVAILABLE when it expired, was answered, withdrawn or the lot sold; 409 STORE_NOT_ACCEPTING_ORDERS while the store is draft or paused</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "auctions:write",
      "customerToken": false,
      "idempotent": true,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "From the offer email link",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 96
            }
          },
          "example": "01a15340-1c2d-7e3f-8a4b-5c6d7e8f9a0b.Qm9vYmlkZXJTZWNvbmRDaGFuY2VTaWdu"
        },
        {
          "name": "idempotency-key",
          "in": "header",
          "required": true,
          "description": "Client-generated key, 1 to 255 URL-safe characters. Repeating the request with the same key and body replays the stored response instead of running again",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "idempotency-key"
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              { ...schema_StorefrontAuctionOffer, required: true, name: "offer" },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": false,
                "name": "orderId",
                "format": "uuid",
                "description": "UUID v7",
                "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
              }
            ]
          },
          "example": example_acceptAuctionOffer_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "01a15340-1c2d-7e3f-8a4b-5c6d7e8f9a0b.Qm9vYmlkZXJTZWNvbmRDaGFuY2VTaWdu"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_acceptAuctionOffer_200
        }
      }
    },
    "declineAuctionOffer": {
      "id": "declineAuctionOffer",
      "slug": "decline-auction-offer",
      "method": "POST",
      "path": "/storefront/v1/auctions/offers/{token}/decline",
      "tag": "auctions",
      "summary": "Decline a second-chance offer",
      "description": "The store may then offer the lot to the next bidder. 409 AUCTION_OFFER_UNAVAILABLE when it is no longer pending",
      "descriptionHtml": "<p>The store may then offer the lot to the next bidder. 409 AUCTION_OFFER_UNAVAILABLE when it is no longer pending</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "auctions:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "From the offer email link",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 96
            }
          },
          "example": "01a15340-1c2d-7e3f-8a4b-5c6d7e8f9a0b.Qm9vYmlkZXJTZWNvbmRDaGFuY2VTaWdu"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontAuctionOffer, required: true },
          "example": example_declineAuctionOffer_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "01a15340-1c2d-7e3f-8a4b-5c6d7e8f9a0b.Qm9vYmlkZXJTZWNvbmRDaGFuY2VTaWdu"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_declineAuctionOffer_200
        }
      }
    },
    "createAuctionSocketTicket": {
      "id": "createAuctionSocketTicket",
      "slug": "create-auction-socket-ticket",
      "method": "POST",
      "path": "/storefront/v1/auctions/ws-ticket",
      "tag": "auctions",
      "summary": "Ticket for the auction WebSocket",
      "description": "Open the returned url within 30 seconds; the ticket works once. Send {type: subscribe, auctionIds} for up to 20 lots; every change arrives as an auction.updated frame (refetch GET /auctions/{id}, which answers 304 when nothing shown moved). With X-Customer-Token the socket also carries auction.outbid for that shopper. Close codes: 4000 reconnect, 4401 ticket refused, 4403 origin not allowed, 4429 server busy (poll instead). Reads under catalog:read. 20 per minute per IP",
      "descriptionHtml": "<p>Open the returned url within 30 seconds; the ticket works once. Send {type: subscribe, auctionIds} for up to 20 lots; every change arrives as an auction.updated frame (refetch GET /auctions/{id}, which answers 304 when nothing shown moved). With X-Customer-Token the socket also carries auction.outbid for that shopper. Close codes: 4000 reconnect, 4401 ticket refused, 4403 origin not allowed, 4429 server busy (poll instead). Reads under catalog:read. 20 per minute per IP</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_AuctionSocketTicket, required: true },
          "example": example_createAuctionSocketTicket_201
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "201": example_createAuctionSocketTicket_201
        }
      }
    },
    "listAuctionSales": {
      "id": "listAuctionSales",
      "slug": "list-auction-sales",
      "method": "GET",
      "path": "/storefront/v1/sales",
      "tag": "auctions",
      "summary": "The sales calendar",
      "description": "Upcoming and live sales by default, first close soonest first; status past lists ended sales latest first. Draft and cancelled sales never appear",
      "descriptionHtml": "<p>Upcoming and live sales by default, first close soonest first; status past lists ended sales latest first. Draft and cancelled sales never appear</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "Page size, 1 to 100",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 20,
            "constraints": {
              "minimum": 1,
              "maximum": 100
            }
          },
          "example": "10"
        },
        {
          "name": "cursor",
          "in": "query",
          "required": false,
          "description": "Opaque cursor taken from nextCursor of the previous page",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cursor",
            "constraints": {
              "maxLength": 200
            }
          }
        },
        {
          "name": "status",
          "in": "query",
          "required": false,
          "description": "Upcoming and live by default, first close soonest first; past lists ended sales, latest first",
          "schema": {
            "kind": "enum",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "status",
            "enum": [
              "upcoming",
              "live",
              "past"
            ]
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_StorefrontAuctionSaleSummary
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": true,
                "name": "nextCursor",
                "description": "Cursor for the next page, null on the last page"
              }
            ]
          },
          "example": example_listAuctionSales_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {
            "limit": "10"
          },
          "headers": {}
        },
        "responses": {
          "200": example_listAuctionSales_200
        }
      }
    },
    "getAuctionSale": {
      "id": "getAuctionSale",
      "slug": "get-auction-sale",
      "method": "GET",
      "path": "/storefront/v1/sales/{handle}",
      "tag": "auctions",
      "summary": "One sale with every lot in lot number order",
      "description": "The sale's cover, essay, viewing note, schedule, counts, its lots as auction summaries (with approximatePrice for `country`), the resolved seo object and a schema.org SaleEvent graph. Poll with If-None-Match for 304s. Draft and cancelled sales are 404; a renamed handle is found through GET /redirects",
      "descriptionHtml": "<p>The sale&#39;s cover, essay, viewing note, schedule, counts, its lots as auction summaries (with approximatePrice for <code>country</code>), the resolved seo object and a schema.org SaleEvent graph. Poll with If-None-Match for 304s. Draft and cancelled sales are 404; a renamed handle is found through GET /redirects</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": true,
      "parameters": [
        {
          "name": "country",
          "in": "query",
          "required": false,
          "description": "Shopper country, for approximatePrice in that market's currency; the X-Nucleus-Country header does the same",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "country",
            "constraints": {
              "pattern": "^[A-Z]{2}$"
            }
          },
          "example": "US"
        },
        {
          "name": "handle",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "handle",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          "example": "autumn-horology-sale"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontAuctionSale, required: true },
          "example": example_getAuctionSale_200
        },
        "304": {
          "description": "Response",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getAuctionSale_404
        }
      },
      "examples": {
        "request": {
          "params": {
            "handle": "autumn-horology-sale"
          },
          "query": {
            "country": "US"
          },
          "headers": {}
        },
        "responses": {
          "200": example_getAuctionSale_200,
          "404": example_getAuctionSale_404
        }
      }
    },
    "getAuctionSaleResults": {
      "id": "getAuctionSaleResults",
      "slug": "get-auction-sale-results",
      "method": "GET",
      "path": "/storefront/v1/sales/{handle}/results",
      "tag": "auctions",
      "summary": "The results of a sale, lot by lot",
      "description": "Each lot with its outcome (sold, no_sale, cancelled, or open while it still runs) and hammer price. Available on scheduled, live and ended sales",
      "descriptionHtml": "<p>Each lot with its outcome (sold, no_sale, cancelled, or open while it still runs) and hammer price. Available on scheduled, live and ended sales</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "handle",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "handle",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          "example": "autumn-horology-sale"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              { ...schema_StorefrontAuctionSaleSummary, required: true, name: "sale" },
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_StorefrontAuctionSaleResult
              }
            ]
          },
          "example": example_getAuctionSaleResults_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "handle": "autumn-horology-sale"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getAuctionSaleResults_200
        }
      }
    },
    "listAuctionQuestions": {
      "id": "listAuctionQuestions",
      "slug": "list-auction-questions",
      "method": "GET",
      "path": "/storefront/v1/auctions/{id}/questions",
      "tag": "auctions",
      "summary": "Answered questions on a lot, newest first",
      "description": "Only questions staff answered; the asker shows as their bidder label or \"A bidder\". At most 50. Weak ETag, poll with If-None-Match",
      "descriptionHtml": "<p>Only questions staff answered; the asker shows as their bidder label or &quot;A bidder&quot;. At most 50. Weak ETag, poll with If-None-Match</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "catalog:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-7ab4-7291-b92e-645c753b7400"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_StorefrontAuctionQuestion
              }
            ]
          },
          "example": example_listAuctionQuestions_200
        },
        "304": {
          "description": "Response",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-7ab4-7291-b92e-645c753b7400"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_listAuctionQuestions_200
        }
      }
    },
    "askAuctionQuestion": {
      "id": "askAuctionQuestion",
      "slug": "ask-auction-question",
      "method": "POST",
      "path": "/storefront/v1/auctions/{id}/questions",
      "tag": "auctions",
      "summary": "Ask the store a question about a lot",
      "description": "Needs the auction registration bidding needs: 403 AUCTION_REGISTRATION_REQUIRED, BIDDER_BLOCKED or BIDDER_IS_STAFF. 409 AUCTION_QUESTIONS_CLOSED once the lot ended or was cancelled. The question is private until staff answer it in public; at most 5 an hour per shopper (429)",
      "descriptionHtml": "<p>Needs the auction registration bidding needs: 403 AUCTION_REGISTRATION_REQUIRED, BIDDER_BLOCKED or BIDDER_IS_STAFF. 409 AUCTION_QUESTIONS_CLOSED once the lot ended or was cancelled. The question is private until staff answer it in public; at most 5 an hour per shopper (429)</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "auctions:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-7ab4-7291-b92e-645c753b7400"
        }
      ],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "question",
            "description": "Plain text",
            "constraints": {
              "minLength": 10,
              "maxLength": 1000
            }
          }
        ]
      },
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_MyAuctionQuestion, required: true },
          "example": example_askAuctionQuestion_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_askAuctionQuestion_401
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-7ab4-7291-b92e-645c753b7400"
          },
          "query": {},
          "headers": {},
          "body": {
            "question": "Does the lot come with its original box and papers?"
          }
        },
        "responses": {
          "201": example_askAuctionQuestion_201,
          "401": example_askAuctionQuestion_401
        }
      }
    },
    "listMyAuctionQuestions": {
      "id": "listMyAuctionQuestions",
      "slug": "list-my-auction-questions",
      "method": "GET",
      "path": "/storefront/v1/customers/me/questions",
      "tag": "auctions",
      "summary": "The shopper's questions, newest first",
      "description": "With the answer once there is one; a hidden question reads as pending",
      "descriptionHtml": "<p>With the answer once there is one; a hidden question reads as pending</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "Page size, 1 to 100",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 20,
            "constraints": {
              "minimum": 1,
              "maximum": 100
            }
          }
        },
        {
          "name": "cursor",
          "in": "query",
          "required": false,
          "description": "Opaque cursor taken from nextCursor of the previous page",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cursor",
            "constraints": {
              "maxLength": 200
            }
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_MyAuctionQuestion
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": true,
                "name": "nextCursor",
                "description": "Cursor for the next page, null on the last page"
              }
            ]
          },
          "example": example_listMyAuctionQuestions_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_listMyAuctionQuestions_200
        }
      }
    },
    "getCustomerPushSettings": {
      "id": "getCustomerPushSettings",
      "slug": "get-customer-push-settings",
      "method": "GET",
      "path": "/storefront/v1/customers/me/push",
      "tag": "customers",
      "summary": "Web push settings of the signed-in shopper",
      "description": "The VAPID key to subscribe with and the shopper's registered browsers. Pushes cover auctions: outbid, won, ending soon and second-chance offers",
      "descriptionHtml": "<p>The VAPID key to subscribe with and the shopper&#39;s registered browsers. Pushes cover auctions: outbid, won, ending soon and second-chance offers</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_PushSettings, required: true },
          "example": example_getCustomerPushSettings_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getCustomerPushSettings_200
        }
      }
    },
    "registerCustomerPushDevice": {
      "id": "registerCustomerPushDevice",
      "slug": "register-customer-push-device",
      "method": "POST",
      "path": "/storefront/v1/customers/me/push/devices",
      "tag": "customers",
      "summary": "Register this browser for push",
      "description": "Send PushSubscription.toJSON() from the browser. Idempotent on the endpoint; a shopper keeps the five most recent browsers. 422 when the endpoint is not a known browser push service",
      "descriptionHtml": "<p>Send PushSubscription.toJSON() from the browser. Idempotent on the endpoint; a shopper keeps the five most recent browsers. 422 when the endpoint is not a known browser push service</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "endpoint",
            "format": "uri",
            "description": "PushSubscription.endpoint from the browser",
            "constraints": {
              "maxLength": 2048
            }
          },
          {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "name": "keys",
            "properties": [
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": false,
                "name": "p256dh",
                "constraints": {
                  "minLength": 1,
                  "maxLength": 256
                }
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": false,
                "name": "auth",
                "constraints": {
                  "minLength": 1,
                  "maxLength": 64
                }
              }
            ]
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "userAgent",
            "constraints": {
              "maxLength": 300
            }
          }
        ]
      },
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_PushDevice, required: true },
          "example": example_registerCustomerPushDevice_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "endpoint": "https://fcm.googleapis.com/fcm/send/dX1example",
            "keys": {
              "p256dh": "BNcRdreALRFXTkOOUHK1EtK2wtaz5Ry4YfYCA_0QTpQtUbVlUls0VJXg7A8u-Ts1XbjhazAkj7I99e8QcYP7DkM",
              "auth": "tBHItJI5svbpez7KI4CCXg"
            },
            "userAgent": "Mozilla/5.0 (iPhone)"
          }
        },
        "responses": {
          "201": example_registerCustomerPushDevice_201
        }
      }
    },
    "deleteCustomerPushDevice": {
      "id": "deleteCustomerPushDevice",
      "slug": "delete-customer-push-device",
      "method": "DELETE",
      "path": "/storefront/v1/customers/me/push/devices/{id}",
      "tag": "customers",
      "summary": "Stop push to one browser",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a15343-4d5e-7f60-b172-8394a5b6c7d8"
        }
      ],
      "requestBody": null,
      "responses": {
        "204": {
          "description": "Deleted",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": null,
        "responses": {}
      }
    },
    "getOrderStatus": {
      "id": "getOrderStatus",
      "slug": "get-order-status",
      "method": "GET",
      "path": "/storefront/v1/orders/status/{token}",
      "tag": "orders",
      "summary": "Guest order status from the emailed link",
      "description": "The confirmation email carries a signed link valid for a year; no customer session needed. Staff notes are never included",
      "descriptionHtml": "<p>The confirmation email carries a signed link valid for a year; no customer session needed. Staff notes are never included</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "orders:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 40,
              "maxLength": 100
            }
          },
          "example": "AaFph3CUcDO8QdrqYK8h8w.u658xy.50wFmH8waqJfXAZML1Wzw4kNxmBn3qMxH7UjNUiGv5Q"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Order, required: true },
          "example": example_getOrderStatus_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getOrderStatus_404
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "AaFph3CUcDO8QdrqYK8h8w.u658xy.50wFmH8waqJfXAZML1Wzw4kNxmBn3qMxH7UjNUiGv5Q"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getOrderStatus_200,
          "404": example_getOrderStatus_404
        }
      }
    },
    "listCustomerOrders": {
      "id": "listCustomerOrders",
      "slug": "list-customer-orders",
      "method": "GET",
      "path": "/storefront/v1/customers/me/orders",
      "tag": "orders",
      "summary": "Orders of the signed-in shopper, newest first",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "Page size, 1 to 100",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 20,
            "constraints": {
              "minimum": 1,
              "maximum": 100
            }
          },
          "example": "10"
        },
        {
          "name": "cursor",
          "in": "query",
          "required": false,
          "description": "Opaque cursor taken from nextCursor of the previous page",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cursor",
            "constraints": {
              "maxLength": 200
            }
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_OrderSummary
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": true,
                "name": "nextCursor",
                "description": "Cursor for the next page, null on the last page"
              }
            ]
          },
          "example": example_listCustomerOrders_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {
            "limit": "10"
          },
          "headers": {}
        },
        "responses": {
          "200": example_listCustomerOrders_200
        }
      }
    },
    "getCustomerOrder": {
      "id": "getCustomerOrder",
      "slug": "get-customer-order",
      "method": "GET",
      "path": "/storefront/v1/customers/me/orders/{id}",
      "tag": "orders",
      "summary": "One order of the shopper with customer-visible timeline",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-7094-7033-bc41-daea60af21f3"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Order, required: true },
          "example": example_getCustomerOrder_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-7094-7033-bc41-daea60af21f3"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getCustomerOrder_200
        }
      }
    },
    "reorderCustomerOrder": {
      "id": "reorderCustomerOrder",
      "slug": "reorder-customer-order",
      "method": "POST",
      "path": "/storefront/v1/customers/me/orders/{id}/reorder",
      "tag": "orders",
      "summary": "Start a new cart from a past order",
      "description": "The cart belongs to the shopper and carries the order's country and email. Lines whose variant is gone, no longer sells or whose customizations no longer validate are listed in skipped instead of failing the call",
      "descriptionHtml": "<p>The cart belongs to the shopper and carries the order&#39;s country and email. Lines whose variant is gone, no longer sells or whose customizations no longer validate are listed in skipped instead of failing the call</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-7094-7033-bc41-daea60af21f3"
        }
      ],
      "requestBody": null,
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_ReorderResult, required: true },
          "example": example_reorderCustomerOrder_201
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-7094-7033-bc41-daea60af21f3"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "201": example_reorderCustomerOrder_201
        }
      }
    },
    "getDesignApproval": {
      "id": "getDesignApproval",
      "slug": "get-design-approval",
      "method": "GET",
      "path": "/storefront/v1/orders/{id}/approval/{token}",
      "tag": "orders",
      "summary": "Design approval page data from the emailed link",
      "description": "The design image, the message and whether this link still takes an answer. 404 when the token is invalid, expired or names an older design",
      "descriptionHtml": "<p>The design image, the message and whether this link still takes an answer. 404 when the token is invalid, expired or names an older design</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "orders:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-74bd-7cb1-990e-e5c43b97048c"
        },
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 40,
              "maxLength": 100
            }
          },
          "example": "AaFph3UFftSZIWkCYSDX-Q.towvlz.6v6NNI3gr3QTYZnouFuWDA9wxN6HVwvvbGp5-fSvsDo"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_DesignApproval, required: true },
          "example": example_getDesignApproval_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getDesignApproval_404
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-74bd-7cb1-990e-e5c43b97048c",
            "token": "AaFph3UFftSZIWkCYSDX-Q.towvlz.6v6NNI3gr3QTYZnouFuWDA9wxN6HVwvvbGp5-fSvsDo"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getDesignApproval_200,
          "404": example_getDesignApproval_404
        }
      }
    },
    "submitDesignApproval": {
      "id": "submitDesignApproval",
      "slug": "submit-design-approval",
      "method": "POST",
      "path": "/storefront/v1/orders/{id}/approval/{token}",
      "tag": "orders",
      "summary": "Approve a design or request changes",
      "description": "The token comes from the design email and only answers the latest design once; 404 when invalid or expired, 409 when already answered",
      "descriptionHtml": "<p>The token comes from the design email and only answers the latest design once; 404 when invalid or expired, 409 when already answered</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "orders:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-74bd-7cb1-990e-e5c43b97048c"
        },
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 40,
              "maxLength": 100
            }
          },
          "example": "AaFph3UFftSZIWkCYSDX-Q.towvlz.6v6NNI3gr3QTYZnouFuWDA9wxN6HVwvvbGp5-fSvsDo"
        }
      ],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "enum",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "decision",
            "enum": [
              "approve",
              "request_changes"
            ]
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "message",
            "constraints": {
              "maxLength": 2000
            }
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_Order, required: true },
          "example": example_submitDesignApproval_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-74bd-7cb1-990e-e5c43b97048c",
            "token": "AaFph3UFftSZIWkCYSDX-Q.towvlz.6v6NNI3gr3QTYZnouFuWDA9wxN6HVwvvbGp5-fSvsDo"
          },
          "query": {},
          "headers": {},
          "body": {
            "decision": "approve",
            "message": "Perfect, please go ahead"
          }
        },
        "responses": {
          "200": example_submitDesignApproval_200
        }
      }
    },
    "getOrderWorkflowAction": {
      "id": "getOrderWorkflowAction",
      "slug": "get-order-workflow-action",
      "method": "GET",
      "path": "/storefront/v1/orders/{id}/workflow/{token}",
      "tag": "orders",
      "summary": "Confirmation or review page data from the emailed link",
      "description": "The token is bound to the stage and its attempt; a resent review makes older links 404. state tells the page whether to show the buttons",
      "descriptionHtml": "<p>The token is bound to the stage and its attempt; a resent review makes older links 404. state tells the page whether to show the buttons</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "orders:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-7094-7033-bc41-daea60af21f3"
        },
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 40,
              "maxLength": 100
            }
          },
          "example": "AaFph3DHc6W1LBCawXMZgA.1.tqgfly.yto5nh-85gPGHuryI0tBN7DQxUcInmeHwdOUCnm2k-U"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_WorkflowAction, required: true },
          "example": example_getOrderWorkflowAction_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-7094-7033-bc41-daea60af21f3",
            "token": "AaFph3DHc6W1LBCawXMZgA.1.tqgfly.yto5nh-85gPGHuryI0tBN7DQxUcInmeHwdOUCnm2k-U"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getOrderWorkflowAction_200
        }
      }
    },
    "answerOrderWorkflowAction": {
      "id": "answerOrderWorkflowAction",
      "slug": "answer-order-workflow-action",
      "method": "POST",
      "path": "/storefront/v1/orders/{id}/workflow/{token}",
      "tag": "orders",
      "summary": "Confirm the order, approve the piece, or request changes",
      "description": "confirm on a confirmation link, approve on a review link, request_changes (with message) on either. 409 when already answered or closed",
      "descriptionHtml": "<p>confirm on a confirmation link, approve on a review link, request_changes (with message) on either. 409 when already answered or closed</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "orders:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-7094-7033-bc41-daea60af21f3"
        },
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 40,
              "maxLength": 100
            }
          },
          "example": "AaFph3DHc6W1LBCawXMZgA.1.tqgfly.yto5nh-85gPGHuryI0tBN7DQxUcInmeHwdOUCnm2k-U"
        }
      ],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "enum",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "action",
            "description": "confirm on a confirmation link, approve on a review link, request_changes on either",
            "enum": [
              "confirm",
              "approve",
              "request_changes"
            ]
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "message",
            "constraints": {
              "minLength": 1,
              "maxLength": 2000
            },
            "description": "Required with request_changes"
          }
        ]
      },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_WorkflowAction, required: true },
          "example": example_answerOrderWorkflowAction_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_answerOrderWorkflowAction_422
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-7094-7033-bc41-daea60af21f3",
            "token": "AaFph3DHc6W1LBCawXMZgA.1.tqgfly.yto5nh-85gPGHuryI0tBN7DQxUcInmeHwdOUCnm2k-U"
          },
          "query": {},
          "headers": {},
          "body": {
            "action": "confirm",
            "message": null
          }
        },
        "responses": {
          "200": example_answerOrderWorkflowAction_200,
          "422": example_answerOrderWorkflowAction_422
        }
      }
    },
    "createReturn": {
      "id": "createReturn",
      "slug": "create-return",
      "method": "POST",
      "path": "/storefront/v1/customers/me/orders/{id}/returns",
      "tag": "orders",
      "summary": "Request a return or resize on a delivered order",
      "description": "Within the store's return window, for shipped units only. The store approves and sends instructions",
      "descriptionHtml": "<p>Within the store&#39;s return window, for shipped units only. The store approves and sends instructions</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "customers:write",
      "customerToken": true,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-7094-7033-bc41-daea60af21f3"
        }
      ],
      "requestBody": {
        "kind": "object",
        "type": "object",
        "required": true,
        "nullable": false,
        "properties": [
          {
            "kind": "array",
            "type": "array",
            "required": true,
            "nullable": false,
            "name": "lines",
            "description": "Only shipped, not yet returned units can be requested",
            "constraints": {
              "minItems": 1,
              "maxItems": 50
            },
            "items": {
              "kind": "object",
              "type": "object",
              "required": false,
              "nullable": false,
              "properties": [
                {
                  "kind": "primitive",
                  "type": "string",
                  "required": true,
                  "nullable": false,
                  "name": "orderLineId",
                  "format": "uuid",
                  "description": "UUID v7",
                  "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
                },
                {
                  "kind": "primitive",
                  "type": "integer",
                  "required": true,
                  "nullable": false,
                  "name": "quantity",
                  "constraints": {
                    "minimum": 1
                  }
                }
              ]
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "reason",
            "constraints": {
              "minLength": 1,
              "maxLength": 500
            }
          },
          {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": true,
            "name": "note",
            "constraints": {
              "maxLength": 2000
            }
          },
          {
            "kind": "primitive",
            "type": "boolean",
            "required": false,
            "nullable": false,
            "name": "resize",
            "description": "A resize request follows the return workflow with the resolution preset and no refund",
            "default": false
          }
        ]
      },
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_Return, required: true },
          "example": example_createReturn_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_createReturn_409
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-7094-7033-bc41-daea60af21f3"
          },
          "query": {},
          "headers": {},
          "body": {
            "lines": [
              {
                "orderLineId": "01a16987-7098-7d5c-8f8e-f074098f1f5b",
                "quantity": 1
              }
            ],
            "reason": "Wrong size",
            "note": "Please send a size 6.5 instead"
          }
        },
        "responses": {
          "201": example_createReturn_201,
          "409": example_createReturn_409
        }
      }
    },
    "getChatConfig": {
      "id": "getChatConfig",
      "slug": "get-chat-config",
      "method": "GET",
      "path": "/storefront/v1/chat/config",
      "tag": "chat",
      "summary": "What the widget shows before the shopper writes",
      "description": "Appearance, business-hours state, pre-chat and offline forms, consent text, departments, ring size help and the custom design form; with X-Customer-Token also the designs waiting for the customer's approval. ETag with private, max-age=30; 404 CHAT_DISABLED while chat is off",
      "descriptionHtml": "<p>Appearance, business-hours state, pre-chat and offline forms, consent text, departments, ring size help and the custom design form; with X-Customer-Token also the designs waiting for the customer&#39;s approval. ETag with private, max-age=30; 404 CHAT_DISABLED while chat is off</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_ChatConfig, required: true },
          "example": example_getChatConfig_200
        },
        "304": {
          "description": "Response",
          "body": "empty",
          "schema": null
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getChatConfig_200
        }
      }
    },
    "createChatSession": {
      "id": "createChatSession",
      "slug": "create-chat-session",
      "method": "POST",
      "path": "/storefront/v1/chat/session",
      "tag": "chat",
      "summary": "Start or resume a chat visitor",
      "description": "Resumes the visitor behind visitorToken, or creates one. With X-Customer-Token the visitor is linked to the customer, so their conversations follow them across devices. consent must be true when the store shows a privacy notice (422 CHAT_CONSENT_REQUIRED). 10 per minute per IP",
      "descriptionHtml": "<p>Resumes the visitor behind visitorToken, or creates one. With X-Customer-Token the visitor is linked to the customer, so their conversations follow them across devices. consent must be true when the store shows a privacy notice (422 CHAT_CONSENT_REQUIRED). 10 per minute per IP</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [],
      "requestBody": { ...schema_CreateChatSessionRequest, required: true },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_ChatSession, required: true },
          "example": example_createChatSession_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "consent": true,
            "locale": "en-US",
            "attributes": {
              "ringSize": "6"
            }
          }
        },
        "responses": {
          "200": example_createChatSession_200
        }
      }
    },
    "listChatConversations": {
      "id": "listChatConversations",
      "slug": "list-chat-conversations",
      "method": "GET",
      "path": "/storefront/v1/chat/conversations",
      "tag": "chat",
      "summary": "The visitor's conversations, latest activity first",
      "description": "A visitor linked to a customer also sees that customer's conversations from other devices",
      "descriptionHtml": "<p>A visitor linked to a customer also sees that customer&#39;s conversations from other devices</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "Page size, 1 to 100",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 20,
            "constraints": {
              "minimum": 1,
              "maximum": 100
            }
          }
        },
        {
          "name": "cursor",
          "in": "query",
          "required": false,
          "description": "Opaque cursor taken from nextCursor of the previous page",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cursor",
            "constraints": {
              "maxLength": 200
            }
          }
        },
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_ShopperConversation
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": true,
                "name": "nextCursor",
                "description": "Cursor for the next page, null on the last page"
              }
            ]
          },
          "example": example_listChatConversations_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_listChatConversations_200
        }
      }
    },
    "startChatConversation": {
      "id": "startChatConversation",
      "slug": "start-chat-conversation",
      "method": "POST",
      "path": "/storefront/v1/chat/conversations",
      "tag": "chat",
      "summary": "Start a chat or leave an offline message",
      "description": "kind chat outside business hours answers 409 CHAT_OFFLINE when the offline form is on; send kind offline with an email instead. Pre-chat answers fill the visitor's name, email and phone, pick the department and become attributes. 20 per minute per IP",
      "descriptionHtml": "<p>kind chat outside business hours answers 409 CHAT_OFFLINE when the offline form is on; send kind offline with an email instead. Pre-chat answers fill the visitor&#39;s name, email and phone, pick the department and become attributes. 20 per minute per IP</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": { ...schema_StartChatConversationRequest, required: true },
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_StartedChatConversation, required: true },
          "example": example_startChatConversation_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "kind": "chat",
            "message": "Hi! Can the solitaire be resized to a 6.5?",
            "preChat": {
              "name": "Asha Mehta",
              "email": "shopper@example.com"
            },
            "context": {
              "pageUrl": "https://docs.example/products/solitaire-ring",
              "pageTitle": "Solitaire ring"
            }
          }
        },
        "responses": {
          "201": example_startChatConversation_201
        }
      }
    },
    "listChatMessages": {
      "id": "listChatMessages",
      "slug": "list-chat-messages",
      "method": "GET",
      "path": "/storefront/v1/chat/conversations/{id}/messages",
      "tag": "chat",
      "summary": "Messages of a conversation, oldest first",
      "description": "Without after or before: the latest page. after=<last id you hold> catches up after a reconnect; before scrolls back. Staff whispers are never included",
      "descriptionHtml": "<p>Without after or before: the latest page. after=<last id you hold> catches up after a reconnect; before scrolls back. Staff whispers are never included</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "after",
          "in": "query",
          "required": false,
          "description": "Messages after this id, oldest first. Without it the latest page is returned",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "after",
            "format": "uuid"
          },
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "name": "before",
          "in": "query",
          "required": false,
          "description": "Messages before this id, for scrolling back",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "before",
            "format": "uuid"
          },
          "example": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
        },
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 50,
            "constraints": {
              "minimum": 1,
              "maximum": 100
            }
          }
        },
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-76af-7be8-8e6e-0be9a66402a8"
        },
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_ShopperChatMessagePage, required: true },
          "example": example_listChatMessages_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-76af-7be8-8e6e-0be9a66402a8"
          },
          "query": {
            "after": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f",
            "before": "01927b3e-5f6a-7c8d-9e0f-1a2b3c4d5e6f"
          },
          "headers": {}
        },
        "responses": {
          "200": example_listChatMessages_200
        }
      }
    },
    "sendChatMessage": {
      "id": "sendChatMessage",
      "slug": "send-chat-message",
      "method": "POST",
      "path": "/storefront/v1/chat/conversations/{id}/messages",
      "tag": "chat",
      "summary": "Send a message",
      "description": "Plain text, URLs are linked when shown. A chat closed for inactivity reopens; one closed by the shopper or staff answers 409 CONVERSATION_CLOSED. 60 per minute per IP and 30 per visitor",
      "descriptionHtml": "<p>Plain text, URLs are linked when shown. A chat closed for inactivity reopens; one closed by the shopper or staff answers 409 CONVERSATION_CLOSED. 60 per minute per IP and 30 per visitor</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-76af-7be8-8e6e-0be9a66402a8"
        },
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": { ...schema_SendShopperChatMessageRequest, required: true },
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_ShopperChatMessage, required: true },
          "example": example_sendChatMessage_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_sendChatMessage_409
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-76af-7be8-8e6e-0be9a66402a8"
          },
          "query": {},
          "headers": {},
          "body": {
            "body": "Here is the one I have now",
            "attachments": [
              "upl_EXAMPLEUPLOADTOKEN00000000000000"
            ]
          }
        },
        "responses": {
          "201": example_sendChatMessage_201,
          "409": example_sendChatMessage_409
        }
      }
    },
    "markChatRead": {
      "id": "markChatRead",
      "slug": "mark-chat-read",
      "method": "POST",
      "path": "/storefront/v1/chat/conversations/{id}/read",
      "tag": "chat",
      "summary": "Mark staff messages read up to an id",
      "description": "",
      "descriptionHtml": "",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-76af-7be8-8e6e-0be9a66402a8"
        },
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": { ...schema_ReadChatMessagesRequest, required: true },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_ShopperConversation, required: true },
          "example": example_markChatRead_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-76af-7be8-8e6e-0be9a66402a8"
          },
          "query": {},
          "headers": {},
          "body": {
            "upToMessageId": "01a16987-7701-72ec-be91-06cd239e48df"
          }
        },
        "responses": {
          "200": example_markChatRead_200
        }
      }
    },
    "sendChatTyping": {
      "id": "sendChatTyping",
      "slug": "send-chat-typing",
      "method": "POST",
      "path": "/storefront/v1/chat/conversations/{id}/typing",
      "tag": "chat",
      "summary": "Tell staff the shopper is typing",
      "description": "For widgets on the polling fallback; a connected widget sends a typing frame on its socket instead. Send at most once a second while the shopper types: extra calls within a second are accepted and dropped. Nothing is stored. draft reaches staff only when the store has sneak peek on. 120 per minute per IP",
      "descriptionHtml": "<p>For widgets on the polling fallback; a connected widget sends a typing frame on its socket instead. Send at most once a second while the shopper types: extra calls within a second are accepted and dropped. Nothing is stored. draft reaches staff only when the store has sneak peek on. 120 per minute per IP</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-76af-7be8-8e6e-0be9a66402a8"
        },
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": { ...schema_ChatTypingRequest, required: true, nullable: true },
      "responses": {
        "204": {
          "description": "Deleted",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-76af-7be8-8e6e-0be9a66402a8"
          },
          "query": {},
          "headers": {},
          "body": {
            "draft": "Here is the one I"
          }
        },
        "responses": {}
      }
    },
    "sendChatPresence": {
      "id": "sendChatPresence",
      "slug": "send-chat-presence",
      "method": "POST",
      "path": "/storefront/v1/chat/presence",
      "tag": "chat",
      "summary": "Tell staff which page the shopper is on",
      "description": "Every 30 seconds and on each route change, once the shopper has a chat visitor; send nothing before that. Feeds the store's live visitor list, the pages in the inbox sidebar and whether the shopper counts as still there. Kept 90 seconds in Redis, never in the database. 120 per minute per IP and 12 per visitor",
      "descriptionHtml": "<p>Every 30 seconds and on each route change, once the shopper has a chat visitor; send nothing before that. Feeds the store&#39;s live visitor list, the pages in the inbox sidebar and whether the shopper counts as still there. Kept 90 seconds in Redis, never in the database. 120 per minute per IP and 12 per visitor</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": { ...schema_ChatPresenceRequest, required: true },
      "responses": {
        "204": {
          "description": "Deleted",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "pageUrl": "https://docs.example/products/solitaire-ring",
            "pageTitle": "Solitaire ring",
            "referrer": "https://www.google.com/",
            "locale": "en-US",
            "visible": true
          }
        },
        "responses": {}
      }
    },
    "rateChatConversation": {
      "id": "rateChatConversation",
      "slug": "rate-chat-conversation",
      "method": "POST",
      "path": "/storefront/v1/chat/conversations/{id}/rating",
      "tag": "chat",
      "summary": "Rate the conversation once",
      "description": "409 when it is already rated; 422 when the store does not take ratings",
      "descriptionHtml": "<p>409 when it is already rated; 422 when the store does not take ratings</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-76af-7be8-8e6e-0be9a66402a8"
        },
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": { ...schema_RateChatConversationRequest, required: true },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_ShopperConversation, required: true },
          "example": example_rateChatConversation_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-76af-7be8-8e6e-0be9a66402a8"
          },
          "query": {},
          "headers": {},
          "body": {
            "rating": 1,
            "comment": "Quick and helpful"
          }
        },
        "responses": {
          "200": example_rateChatConversation_200
        }
      }
    },
    "requestChatTranscript": {
      "id": "requestChatTranscript",
      "slug": "request-chat-transcript",
      "method": "POST",
      "path": "/storefront/v1/chat/conversations/{id}/transcript",
      "tag": "chat",
      "summary": "Email the transcript to the shopper",
      "description": "Goes to the conversation's email, else the visitor's; 422 when neither is known. Sent by the worker. 5 per 10 minutes per IP",
      "descriptionHtml": "<p>Goes to the conversation&#39;s email, else the visitor&#39;s; 422 when neither is known. Sent by the worker. 5 per 10 minutes per IP</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-76af-7be8-8e6e-0be9a66402a8"
        },
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "202": {
          "description": "Response",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "Response",
            "properties": [
              {
                "kind": "enum",
                "type": "boolean",
                "required": true,
                "nullable": false,
                "name": "queued",
                "enum": [
                  true
                ]
              }
            ]
          },
          "example": example_requestChatTranscript_202
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-76af-7be8-8e6e-0be9a66402a8"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "202": example_requestChatTranscript_202
        }
      }
    },
    "closeChatConversation": {
      "id": "closeChatConversation",
      "slug": "close-chat-conversation",
      "method": "POST",
      "path": "/storefront/v1/chat/conversations/{id}/close",
      "tag": "chat",
      "summary": "End the chat",
      "description": "Closing twice is a no-op",
      "descriptionHtml": "<p>Closing twice is a no-op</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-76af-7be8-8e6e-0be9a66402a8"
        },
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_ShopperConversation, required: true },
          "example": example_closeChatConversation_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-76af-7be8-8e6e-0be9a66402a8"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_closeChatConversation_200
        }
      }
    },
    "getChatAttachment": {
      "id": "getChatAttachment",
      "slug": "get-chat-attachment",
      "method": "GET",
      "path": "/storefront/v1/chat/conversations/{id}/attachments/{uploadId}",
      "tag": "chat",
      "summary": "Download a file from the conversation",
      "description": "Images inline, PDFs as an attachment; never cached",
      "descriptionHtml": "<p>Images inline, PDFs as an attachment; never cached</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-76af-7be8-8e6e-0be9a66402a8"
        },
        {
          "name": "uploadId",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "uploadId",
            "format": "uuid"
          },
          "example": "01a16987-7695-75d5-8b9b-692098cbe157"
        },
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "The file bytes",
          "body": "text",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "description": "The file bytes"
          },
          "example": example_getChatAttachment_200
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-76af-7be8-8e6e-0be9a66402a8",
            "uploadId": "01a16987-7695-75d5-8b9b-692098cbe157"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getChatAttachment_200
        }
      }
    },
    "uploadChatFile": {
      "id": "uploadChatFile",
      "slug": "upload-chat-file",
      "method": "POST",
      "path": "/storefront/v1/chat/uploads",
      "tag": "chat",
      "summary": "Upload a file to send in the chat",
      "description": "Raw body with the file's Content-Type (image/jpeg, image/png, image/webp, image/heic, image/heif, application/pdf). Put the token in a message's attachments; it expires unless a message takes it. 422 when the store turned uploads off. 20 per minute per IP",
      "descriptionHtml": "<p>Raw body with the file&#39;s Content-Type (image/jpeg, image/png, image/webp, image/heic, image/heif, application/pdf). Put the token in a message&#39;s attachments; it expires unless a message takes it. 422 when the store turned uploads off. 20 per minute per IP</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "filename",
          "in": "query",
          "required": true,
          "description": "The shopper's file name; path separators are stripped and the extension is kept only when it matches the detected type",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "filename",
            "constraints": {
              "minLength": 1,
              "maxLength": 255
            }
          },
          "example": "my-ring.png"
        },
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_CustomerUpload, required: true },
          "example": example_uploadChatFile_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "413": {
          "description": "Request body exceeds the size limit",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "415": {
          "description": "Unsupported Content-Type",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {
            "filename": "my-ring.png"
          },
          "headers": {}
        },
        "responses": {
          "201": example_uploadChatFile_201
        }
      }
    },
    "continueChatConversation": {
      "id": "continueChatConversation",
      "slug": "continue-chat-conversation",
      "method": "GET",
      "path": "/storefront/v1/chat/continue/{token}",
      "tag": "chat",
      "summary": "Open a conversation from an email link",
      "description": "Exchanges the signed token in a reply or transcript email for a visitor token bound to that conversation. Valid 30 days. 10 per minute per IP",
      "descriptionHtml": "<p>Exchanges the signed token in a reply or transcript email for a visitor token bound to that conversation. Valid 30 days. 10 per minute per IP</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "token",
          "in": "path",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "token",
            "constraints": {
              "minLength": 20,
              "maxLength": 100
            }
          },
          "example": "<conversationContinueToken>"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_ContinuedChatConversation, required: true },
          "example": example_continueChatConversation_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "token": "<conversationContinueToken>"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_continueChatConversation_200
        }
      }
    },
    "lookupChatOrder": {
      "id": "lookupChatOrder",
      "slug": "lookup-chat-order",
      "method": "POST",
      "path": "/storefront/v1/chat/order-status",
      "tag": "chat",
      "summary": "Where is my order: status by order number and email",
      "description": "No sign-in needed. The same 404 for an unknown number and a wrong email; the email is compared in constant time. The card carries the production stage, ship-by date, tracking and a signed status link, and statusToken for POST /chat/requests. With X-Chat-Visitor the card is also posted into the visitor's open conversation. 10 per minute per IP",
      "descriptionHtml": "<p>No sign-in needed. The same 404 for an unknown number and a wrong email; the email is compared in constant time. The card carries the production stage, ship-by date, tracking and a signed status link, and statusToken for POST /chat/requests. With X-Chat-Visitor the card is also posted into the visitor&#39;s open conversation. 10 per minute per IP</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "Optional: the chat visitor; the card is then also posted into their open conversation",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": { ...schema_ChatOrderLookupRequest, required: true },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_ChatOrderLookup, required: true },
          "example": example_lookupChatOrder_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_lookupChatOrder_404
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "orderNumber": "#1001",
            "email": "shopper@example.com"
          }
        },
        "responses": {
          "200": example_lookupChatOrder_200,
          "404": example_lookupChatOrder_404
        }
      }
    },
    "createChatRequest": {
      "id": "createChatRequest",
      "slug": "create-chat-request",
      "method": "POST",
      "path": "/storefront/v1/chat/requests",
      "tag": "chat",
      "summary": "Ask for a resize, repair, engraving change or warranty claim on an order",
      "description": "Opens a ticket linked to the order named by the status card's statusToken, tagged request and request-<kind>. Its first line quotes the store's resizing or warranty rule and links the policy page. Returns go through the returns workflow, not here. 404 for an invalid or expired token. 10 per minute per IP",
      "descriptionHtml": "<p>Opens a ticket linked to the order named by the status card&#39;s statusToken, tagged request and request-<kind>. Its first line quotes the store&#39;s resizing or warranty rule and links the policy page. Returns go through the returns workflow, not here. 404 for an invalid or expired token. 10 per minute per IP</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": { ...schema_CreateChatRequestRequest, required: true },
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_StartedChatConversation, required: true },
          "example": example_createChatRequest_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_createChatRequest_404
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "statusToken": "AaFph3CUcDO8QdrqYK8h8w.u658y0.eNduMBMRdiyOZzuPcAP7IFejDUUYFDcYaxVcJsgSKOI",
            "kind": "resize",
            "details": "Could you size it down to a 6?"
          }
        },
        "responses": {
          "201": example_createChatRequest_201,
          "404": example_createChatRequest_404
        }
      }
    },
    "startCustomDesign": {
      "id": "startCustomDesign",
      "slug": "start-custom-design",
      "method": "POST",
      "path": "/storefront/v1/chat/custom-design",
      "tag": "chat",
      "summary": "Send a custom design request",
      "description": "The form from the chat config's customDesign: metal, stone, shape and timeline must be among the store's choices and ringSize one of its ring sizes. Opens a conversation tagged custom-design with one form message carrying the answers and up to 5 inspiration files; outside business hours it is an offline message answered by email. 422 when the store turned the form off. 10 per minute per IP",
      "descriptionHtml": "<p>The form from the chat config&#39;s customDesign: metal, stone, shape and timeline must be among the store&#39;s choices and ringSize one of its ring sizes. Opens a conversation tagged custom-design with one form message carrying the answers and up to 5 inspiration files; outside business hours it is an offline message answered by email. 422 when the store turned the form off. 10 per minute per IP</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": { ...schema_StartCustomDesignRequest, required: true },
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_StartedChatConversation, required: true },
          "example": example_startCustomDesign_201
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "422": {
          "description": "Well-formed but violates a business rule",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_startCustomDesign_422
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {},
          "body": {
            "metal": "Platinum",
            "stoneType": "Lab-grown diamond",
            "shape": "Oval",
            "carat": 1.5,
            "ringSize": "6.5",
            "budget": {
              "min": 300000,
              "max": 500000,
              "currency": "USD"
            },
            "timeline": "1 to 3 months",
            "message": "A hidden halo, please",
            "name": "Asha Mehta",
            "email": "shopper@example.com"
          }
        },
        "responses": {
          "201": example_startCustomDesign_201,
          "422": example_startCustomDesign_422
        }
      }
    },
    "fireChatTrigger": {
      "id": "fireChatTrigger",
      "slug": "fire-chat-trigger",
      "method": "POST",
      "path": "/storefront/v1/chat/triggers/{id}/fire",
      "tag": "chat",
      "summary": "Run a trigger the widget saw match",
      "description": "Re-checks the conditions the API knows (visits, previous chats, customer, orders in production, location, device, hours, agents online, and the cart total from the presence heartbeat) and the once-per-visitor or once-per-visit rule, then posts the trigger's messages into a new pending conversation, or into the visitor's open one while the shopper has not written in it yet. 409 TRIGGER_NOT_ELIGIBLE with meta.reason conditions, already_fired or chatting (meta.conversationId). 404 for an unknown, disabled or rescuer trigger. 30 per minute per IP, 6 per visitor",
      "descriptionHtml": "<p>Re-checks the conditions the API knows (visits, previous chats, customer, orders in production, location, device, hours, agents online, and the cart total from the presence heartbeat) and the once-per-visitor or once-per-visit rule, then posts the trigger&#39;s messages into a new pending conversation, or into the visitor&#39;s open one while the shopper has not written in it yet. 409 TRIGGER_NOT_ELIGIBLE with meta.reason conditions, already_fired or chatting (meta.conversationId). 404 for an unknown, disabled or rescuer trigger. 30 per minute per IP, 6 per visitor</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-7634-7d7a-bd80-ccaf32bcfc56"
        },
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": { ...schema_FireChatTriggerRequest, required: true, nullable: true },
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_FiredChatTrigger, required: true },
          "example": example_fireChatTrigger_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "409": {
          "description": "Conflicts with the current state of the resource",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-7634-7d7a-bd80-ccaf32bcfc56"
          },
          "query": {},
          "headers": {},
          "body": {
            "context": {
              "pageUrl": "https://docs.example/products/solitaire-ring",
              "pageTitle": "Solitaire ring"
            }
          }
        },
        "responses": {
          "200": example_fireChatTrigger_200
        }
      }
    },
    "listHelpCategories": {
      "id": "listHelpCategories",
      "slug": "list-help-categories",
      "method": "GET",
      "path": "/storefront/v1/help/categories",
      "tag": "help-centre",
      "summary": "Public help categories by position, with their live article counts",
      "description": "Categories with no live article are included with a count of 0 so the storefront decides whether to show them. Cache-Control private, max-age=60",
      "descriptionHtml": "<p>Categories with no live article are included with a count of 0 so the storefront decides whether to show them. Cache-Control private, max-age=60</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "locale",
          "in": "query",
          "required": false,
          "description": "Articles written for this locale plus the ones for every locale; without it every live article",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "locale",
            "constraints": {
              "pattern": "^[a-z]{2}(?:-[A-Z]{2})?$"
            }
          },
          "example": "en-US"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_StorefrontHelpCategory
              }
            ]
          },
          "example": example_listHelpCategories_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {
            "locale": "en-US"
          },
          "headers": {}
        },
        "responses": {
          "200": example_listHelpCategories_200
        }
      }
    },
    "getHelpCategory": {
      "id": "getHelpCategory",
      "slug": "get-help-category",
      "method": "GET",
      "path": "/storefront/v1/help/categories/{handle}",
      "tag": "help-centre",
      "summary": "A public help category with resolved SEO and a CollectionPage graph",
      "description": "List its articles with GET /help/articles?category={handle}. Sends an ETag; repeat with If-None-Match for a 304",
      "descriptionHtml": "<p>List its articles with GET /help/articles?category={handle}. Sends an ETag; repeat with If-None-Match for a 304</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "handle",
          "in": "path",
          "required": true,
          "description": "URL-safe handle: lowercase letters, digits and hyphens",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "handle",
            "constraints": {
              "minLength": 1,
              "maxLength": 120,
              "pattern": "^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$"
            }
          },
          "example": "sizing"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontHelpCategoryDetail, required: true },
          "example": example_getHelpCategory_200
        },
        "304": {
          "description": "Response",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getHelpCategory_404
        }
      },
      "examples": {
        "request": {
          "params": {
            "handle": "sizing"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getHelpCategory_200,
          "404": example_getHelpCategory_404
        }
      }
    },
    "listHelpArticles": {
      "id": "listHelpArticles",
      "slug": "list-help-articles",
      "method": "GET",
      "path": "/storefront/v1/help/articles",
      "tag": "help-centre",
      "summary": "Live help articles by position",
      "description": "Published public articles outside internal categories; filter by category handle and locale. Cache-Control private, max-age=60",
      "descriptionHtml": "<p>Published public articles outside internal categories; filter by category handle and locale. Cache-Control private, max-age=60</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "Page size, 1 to 100",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 20,
            "constraints": {
              "minimum": 1,
              "maximum": 100
            }
          }
        },
        {
          "name": "cursor",
          "in": "query",
          "required": false,
          "description": "Opaque cursor taken from nextCursor of the previous page",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "cursor",
            "constraints": {
              "maxLength": 200
            }
          }
        },
        {
          "name": "category",
          "in": "query",
          "required": false,
          "description": "Category handle",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "category",
            "constraints": {
              "minLength": 1,
              "maxLength": 120,
              "pattern": "^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$"
            }
          },
          "example": "sizing"
        },
        {
          "name": "locale",
          "in": "query",
          "required": false,
          "description": "Articles written for this locale plus the ones for every locale; without it every live article",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "locale",
            "constraints": {
              "pattern": "^[a-z]{2}(?:-[A-Z]{2})?$"
            }
          },
          "example": "en-US"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": {
            "kind": "object",
            "type": "object",
            "required": true,
            "nullable": false,
            "description": "OK",
            "properties": [
              {
                "kind": "array",
                "type": "array",
                "required": true,
                "nullable": false,
                "name": "items",
                "items": schema_StorefrontHelpArticleSummary
              },
              {
                "kind": "primitive",
                "type": "string",
                "required": true,
                "nullable": true,
                "name": "nextCursor",
                "description": "Cursor for the next page, null on the last page"
              }
            ]
          },
          "example": example_listHelpArticles_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {
            "category": "sizing",
            "locale": "en-US"
          },
          "headers": {}
        },
        "responses": {
          "200": example_listHelpArticles_200
        }
      }
    },
    "getHelpArticle": {
      "id": "getHelpArticle",
      "slug": "get-help-article",
      "method": "GET",
      "path": "/storefront/v1/help/articles/{handle}",
      "tag": "help-centre",
      "summary": "A live help article with resolved SEO and an Article graph",
      "description": "Sends an ETag; repeat with If-None-Match for a 304. Counts a view. ?preview=true (secret keys only) also answers for a public draft, with robots noindex and no caching. Internal articles are 404",
      "descriptionHtml": "<p>Sends an ETag; repeat with If-None-Match for a 304. Counts a view. ?preview=true (secret keys only) also answers for a public draft, with robots noindex and no caching. Internal articles are 404</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "preview",
          "in": "query",
          "required": false,
          "description": "Also answer for a public draft, with robots noindex and no caching; honoured with a secret key only",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "preview"
          }
        },
        {
          "name": "handle",
          "in": "path",
          "required": true,
          "description": "URL-safe handle: lowercase letters, digits and hyphens",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "handle",
            "constraints": {
              "minLength": 1,
              "maxLength": 120,
              "pattern": "^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$"
            }
          },
          "example": "find-your-ring-size"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontHelpArticle, required: true },
          "example": example_getHelpArticle_200
        },
        "304": {
          "description": "Response",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_getHelpArticle_404
        }
      },
      "examples": {
        "request": {
          "params": {
            "handle": "find-your-ring-size"
          },
          "query": {},
          "headers": {}
        },
        "responses": {
          "200": example_getHelpArticle_200,
          "404": example_getHelpArticle_404
        }
      }
    },
    "searchHelpArticles": {
      "id": "searchHelpArticles",
      "slug": "search-help-articles",
      "method": "GET",
      "path": "/storefront/v1/help/search",
      "tag": "help-centre",
      "summary": "Search live help articles",
      "description": "Matches title, keywords, excerpt, category and body, best first. The widget calls it for its search card and, debounced, while the first message is typed. 120 per minute per IP",
      "descriptionHtml": "<p>Matches title, keywords, excerpt, category and body, best first. The widget calls it for its search card and, debounced, while the first message is typed. 120 per minute per IP</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": false,
      "country": false,
      "parameters": [
        {
          "name": "q",
          "in": "query",
          "required": true,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "q",
            "constraints": {
              "minLength": 1,
              "maxLength": 120
            }
          },
          "example": "ring size"
        },
        {
          "name": "limit",
          "in": "query",
          "required": false,
          "description": "",
          "schema": {
            "kind": "primitive",
            "type": "integer",
            "required": false,
            "nullable": false,
            "name": "limit",
            "default": 5,
            "constraints": {
              "minimum": 1,
              "maximum": 20
            }
          },
          "example": "5"
        },
        {
          "name": "locale",
          "in": "query",
          "required": false,
          "description": "Articles written for this locale plus the ones for every locale; without it every live article",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "locale",
            "constraints": {
              "pattern": "^[a-z]{2}(?:-[A-Z]{2})?$"
            }
          },
          "example": "en-US"
        }
      ],
      "requestBody": null,
      "responses": {
        "200": {
          "description": "OK",
          "body": "json",
          "schema": { ...schema_StorefrontHelpSearchResponse, required: true },
          "example": example_searchHelpArticles_200
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_searchHelpArticles_400
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "503": {
          "description": "A dependency is unavailable",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {
            "q": "ring size",
            "limit": "5",
            "locale": "en-US"
          },
          "headers": {}
        },
        "responses": {
          "200": example_searchHelpArticles_200,
          "400": example_searchHelpArticles_400
        }
      }
    },
    "sendHelpFeedback": {
      "id": "sendHelpFeedback",
      "slug": "send-help-feedback",
      "method": "POST",
      "path": "/storefront/v1/help/articles/{id}/feedback",
      "tag": "help-centre",
      "summary": "\"Was this helpful?\" on a live article",
      "description": "With X-Chat-Visitor a second vote replaces the first; without it every vote counts. source widget marks a vote from the chat widget, which counts as a deflection when helpful. 20 per minute per IP",
      "descriptionHtml": "<p>With X-Chat-Visitor a second vote replaces the first; without it every vote counts. source widget marks a vote from the chat widget, which counts as a deflection when helpful. 20 per minute per IP</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "content:read",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "id",
          "in": "path",
          "required": true,
          "description": "UUID v7",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": true,
            "nullable": false,
            "name": "id",
            "format": "uuid"
          },
          "example": "01a16987-7904-7cd7-8ce4-cabe910197ce"
        },
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "Optional: the chat visitor, so a second vote replaces the first",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": { ...schema_HelpFeedbackRequest, required: true },
      "responses": {
        "204": {
          "description": "Deleted",
          "body": "empty",
          "schema": null
        },
        "400": {
          "description": "Malformed request or failed schema validation",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true },
          "example": example_sendHelpFeedback_400
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {
            "id": "01a16987-7904-7cd7-8ce4-cabe910197ce"
          },
          "query": {},
          "headers": {},
          "body": {
            "helpful": true,
            "source": "widget"
          }
        },
        "responses": {
          "400": example_sendHelpFeedback_400
        }
      }
    },
    "createChatSocketTicket": {
      "id": "createChatSocketTicket",
      "slug": "create-chat-socket-ticket",
      "method": "POST",
      "path": "/storefront/v1/chat/ws-ticket",
      "tag": "chat",
      "summary": "Ticket for the chat WebSocket",
      "description": "Open the returned url within 30 seconds; the ticket works once. The socket then follows this visitor's conversations: send subscribe frames with the last message id you hold and the server replays what you missed before relaying live events. Close codes: 4000 reconnect, 4401 ticket refused, 4403 origin not allowed, 4429 too many sockets (poll instead). 20 per minute per IP",
      "descriptionHtml": "<p>Open the returned url within 30 seconds; the ticket works once. The socket then follows this visitor&#39;s conversations: send subscribe frames with the last message id you hold and the server replays what you missed before relaying live events. Close codes: 4000 reconnect, 4401 ticket refused, 4403 origin not allowed, 4429 too many sockets (poll instead). 20 per minute per IP</p>",
      "deprecated": false,
      "security": "storeApiKey",
      "scope": "chat:write",
      "customerToken": false,
      "idempotent": false,
      "mutates": true,
      "country": false,
      "parameters": [
        {
          "name": "x-chat-visitor",
          "in": "header",
          "required": false,
          "description": "The vis_ token from POST /chat/session",
          "schema": {
            "kind": "primitive",
            "type": "string",
            "required": false,
            "nullable": false,
            "name": "x-chat-visitor",
            "constraints": {
              "maxLength": 80
            }
          }
        }
      ],
      "requestBody": null,
      "responses": {
        "201": {
          "description": "Created",
          "body": "json",
          "schema": { ...schema_ChatSocketTicket, required: true },
          "example": example_createChatSocketTicket_201
        },
        "401": {
          "description": "Missing, invalid or expired credentials",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "403": {
          "description": "Authenticated but not allowed to do this",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "404": {
          "description": "Not found. Also returned for records that belong to another tenant",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        },
        "429": {
          "description": "Rate limit exceeded",
          "body": "json",
          "schema": { ...schema_ErrorResponse, required: true }
        }
      },
      "examples": {
        "request": {
          "params": {},
          "query": {},
          "headers": {}
        },
        "responses": {
          "201": example_createChatSocketTicket_201
        }
      }
    }
  }
};
